// Generated by Avo VERSION 163.207.0. You should never have to make changes to this file.
// If you find yourself in the situation where you have to edit the file please contact us at hi@avo.app.
// If you encounter a git conflict in this file run `avo pull` and it will be resolved automatically.
/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// fetch() polyfill
(function () {
  if (typeof window === 'undefined') {
    return;
  }
  var support = {
    searchParams: 'URLSearchParams' in self,
    iterable: 'Symbol' in self && 'iterator' in Symbol,
    blob:
      'FileReader' in self &&
      'Blob' in self &&
      (function () {
        try {
          new Blob();
          return true
        } catch (e) {
          return false
        }
      })(),
    formData: 'FormData' in self,
    arrayBuffer: 'ArrayBuffer' in self
  };

  function isDataView(obj: any) {
    return obj && DataView.prototype.isPrototypeOf(obj)
  }

  if (support.arrayBuffer) {
    var viewClasses = [
      '[object Int8Array]',
      '[object Uint8Array]',
      '[object Uint8ClampedArray]',
      '[object Int16Array]',
      '[object Uint16Array]',
      '[object Int32Array]',
      '[object Uint32Array]',
      '[object Float32Array]',
      '[object Float64Array]'
    ];

    var isArrayBufferView =
      ArrayBuffer.isView ||
      function (obj) {
        return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1
      };
  }

  function normalizeName(name: any) {
    if (typeof name !== 'string') {
      name = String(name);
    }
    if (/[^a-z0-9\-#$%&'*+.^_`|~]/i.test(name)) {
      throw new TypeError('Invalid character in header field name')
    }
    return name.toLowerCase()
  }

  function normalizeValue(value: any) {
    if (typeof value !== 'string') {
      value = String(value);
    }
    return value
  }

  // Build a destructive iterator for the value list
  function iteratorFor(items: any) {
    var iterator: any = {
      next: function () {
        var value = items.shift();
        return { done: value === undefined, value: value }
      }
    };

    if (support.iterable) {
      iterator[Symbol.iterator] = function () {
        return iterator
      };
    }

    return iterator
  }

  function Headers(headers: any) {
    // @ts-ignore
    (this as any).map = {};

    if (headers instanceof Headers) {
      (headers as any).forEach(function (value: any, name: any) {
        // @ts-ignore
        this.append(name, value);
        // @ts-ignore
      }, this);
    } else if (Array.isArray(headers)) {
      headers.forEach(function (header: any) {
        // @ts-ignore
        this.append(header[0], header[1]);
        // @ts-ignore
      }, this);
    } else if (headers) {
      Object.getOwnPropertyNames(headers).forEach(function (name: any) {
        // @ts-ignore
        this.append(name, headers[name]);
        // @ts-ignore
      }, this);
    }
  }

  Headers.prototype.append = function (name: any, value: any) {
    name = normalizeName(name);
    value = normalizeValue(value);
    var oldValue = this.map[name];
    this.map[name] = oldValue ? oldValue + ', ' + value : value;
  };

  Headers.prototype['delete'] = function (name: any) {
    delete this.map[normalizeName(name)];
  };

  Headers.prototype.get = function (name: any) {
    name = normalizeName(name);
    return this.has(name) ? this.map[name] : null
  };

  Headers.prototype.has = function (name: any) {
    return this.map.hasOwnProperty(normalizeName(name))
  };

  Headers.prototype.set = function (name: any, value: any) {
    this.map[normalizeName(name)] = normalizeValue(value);
  };

  Headers.prototype.forEach = function (callback: any, thisArg: any) {
    for (var name in this.map) {
      if (this.map.hasOwnProperty(name)) {
        callback.call(thisArg, this.map[name], name, this);
      }
    }
  };

  Headers.prototype.keys = function () {
    var items: any = [];
    this.forEach(function (_value: any, name: any) {
      items.push(name);
    });
    return iteratorFor(items)
  };

  Headers.prototype.values = function () {
    var items: any = [];
    this.forEach(function (value: any) {
      items.push(value);
    });
    return iteratorFor(items)
  };

  Headers.prototype.entries = function () {
    var items: any = [];
    this.forEach(function (value: any, name: any) {
      items.push([name, value]);
    });
    return iteratorFor(items)
  };

  if (support.iterable) {
    Headers.prototype[Symbol.iterator] = Headers.prototype.entries;
  }

  function consumed(body: any) {
    if (body.bodyUsed) {
      return true;
    }
    body.bodyUsed = true;
    return false;
  }

  function fileReaderReady(reader: any) {
    return new Promise(function (resolve: any, reject: any) {
      reader.onload = function () {
        resolve(reader.result);
      };
      reader.onerror = function () {
        reject(reader.error);
      };
    })
  }

  function readBlobAsArrayBuffer(blob: any) {
    var reader = new FileReader();
    var promise = fileReaderReady(reader);
    reader.readAsArrayBuffer(blob);
    return promise
  }

  function readBlobAsText(blob: any) {
    var reader = new FileReader();
    var promise = fileReaderReady(reader);
    reader.readAsText(blob);
    return promise
  }

  function readArrayBufferAsText(buf: any) {
    var view = new Uint8Array(buf);
    var chars = new Array(view.length);

    for (var i = 0; i < view.length; i++) {
      chars[i] = String.fromCharCode(view[i]!);
    }
    return chars.join('')
  }

  function bufferClone(buf: any) {
    if (buf.slice) {
      return buf.slice(0)
    } else {
      var view = new Uint8Array(buf.byteLength);
      view.set(new Uint8Array(buf));
      return view.buffer
    }
  }

  function Body() {
    // @ts-ignore
    (this as any).bodyUsed = false;

    // @ts-ignore
    (this as any)._initBody = function (body: any) {
      this._bodyInit = body;
      if (!body) {
        this._bodyText = '';
      } else if (typeof body === 'string') {
        this._bodyText = body;
      } else if (support.blob && Blob.prototype.isPrototypeOf(body)) {
        this._bodyBlob = body;
      } else if (support.formData && FormData.prototype.isPrototypeOf(body)) {
        this._bodyFormData = body;
      } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
        this._bodyText = body.toString();
      } else if (support.arrayBuffer && support.blob && isDataView(body)) {
        this._bodyArrayBuffer = bufferClone(body.buffer);
        // IE 10-11 can't handle a DataView body.
        this._bodyInit = new Blob([this._bodyArrayBuffer]);
      } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) {
        this._bodyArrayBuffer = bufferClone(body);
      } else {
        this._bodyText = body = Object.prototype.toString.call(body);
      }

      if (!this.headers.get('content-type')) {
        if (typeof body === 'string') {
          this.headers.set('content-type', 'text/plain;charset=UTF-8');
        } else if (this._bodyBlob && this._bodyBlob.type) {
          this.headers.set('content-type', this._bodyBlob.type);
        } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
          this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8');
        }
      }
    };

    if (support.blob) {
      // @ts-ignore
      (this as any).blob = function () {
        var rejected = consumed(this);
        if (rejected) {
          return Promise.reject(new TypeError('Already read'));
        }

        if (this._bodyBlob) {
          return Promise.resolve(this._bodyBlob);
        } else if (this._bodyArrayBuffer) {
          return Promise.resolve(new Blob([this._bodyArrayBuffer]));
        } else if (this._bodyFormData) {
          throw new Error('could not read FormData body as blob');
        } else {
          return Promise.resolve(new Blob([this._bodyText]));
        }
      };

      // @ts-ignore
      (this as any).arrayBuffer = function () {
        if (this._bodyArrayBuffer) {
          if (consumed(this)) {
            return Promise.reject(new TypeError('Already read'));
          } else {
            return Promise.resolve(this._bodyArrayBuffer);
          }
        } else {
          return this.blob().then(readBlobAsArrayBuffer);
        }
      };
    }

    // @ts-ignore
    (this as any).text = function () {
      var rejected = consumed(this);
      if (rejected) {
        return Promise.reject(new TypeError('Already read'));
      }

      if (this._bodyBlob) {
        return readBlobAsText(this._bodyBlob);
      } else if (this._bodyArrayBuffer) {
        return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer));
      } else if (this._bodyFormData) {
        throw new Error('could not read FormData body as text');
      } else {
        return Promise.resolve(this._bodyText);
      }
    };

    if (support.formData) {
      // @ts-ignore
      (this as any).formData = function () {
        return this.text().then(decode)
      };
    }

    // @ts-ignore
    (this as any).json = function () {
      return this.text().then(JSON.parse)
    };

    // @ts-ignore
    return this
  }

  // HTTP methods whose capitalization should be normalized
  var methods = ['DELETE', 'GET', 'HEAD', 'OPTIONS', 'POST', 'PUT'];

  function normalizeMethod(method: any) {
    var upcased = method.toUpperCase();
    return methods.indexOf(upcased) > -1 ? upcased : method
  }

  function Request(input: any, options: any) {
    options = options || {};
    var body = options.body;

    if (input instanceof Request) {
      if ((input as any).bodyUsed) {
        throw new TypeError('Already read')
      }
      // @ts-ignore
      (this as any).url = (input as any).url;
      // @ts-ignore
      this.credentials = (input as any).credentials;
      if (!options.headers) {
        // @ts-ignore
        this.headers = new Headers((input as any).headers);
      }
      // @ts-ignore
      this.method = (input as any).method;
      // @ts-ignore
      this.mode = (input as any).mode;
      // @ts-ignore
      this.signal = (input as any).signal;
      if (!body && (input as any)._bodyInit != null) {
        body = (input as any)._bodyInit;
        (input as any).bodyUsed = true;
      }
    } else {
      // @ts-ignore
      this.url = String(input);
    }

    // @ts-ignore
    this.credentials = options.credentials || this.credentials || 'same-origin';
    // @ts-ignore
    if (options.headers || !this.headers) {
      // @ts-ignore
      this.headers = new Headers(options.headers);
    }
    // @ts-ignore
    this.method = normalizeMethod(options.method || this.method || 'GET');
    // @ts-ignore
    this.mode = options.mode || this.mode || null;
    // @ts-ignore
    this.signal = options.signal || this.signal;
    // @ts-ignore
    this.referrer = null;

    // @ts-ignore
    if ((this.method === 'GET' || this.method === 'HEAD') && body) {
      throw new TypeError('Body not allowed for GET or HEAD requests')
    }
    // @ts-ignore
    this._initBody(body);
  }

  Request.prototype.clone = function () {
    // @ts-ignore
    return new Request(this, { body: this._bodyInit })
  };

  function decode(body: any) {
    var form = new FormData();
    body
      .trim()
      .split('&')
      .forEach(function (bytes: any) {
        if (bytes) {
          var split = bytes.split('=');
          var name = split.shift().replace(/\+/g, ' ');
          var value = split.join('=').replace(/\+/g, ' ');
          form.append(decodeURIComponent(name), decodeURIComponent(value));
        }
      });
    return form
  }

  function parseHeaders(rawHeaders: any) {
    // @ts-ignore
    var headers = new Headers();
    // Replace instances of \r\n and \n followed by at least one space or horizontal tab with a space
    // https://tools.ietf.org/html/rfc7230#section-3.2
    var preProcessedHeaders = rawHeaders.replace(/\r?\n[\t ]+/g, ' ');
    preProcessedHeaders.split(/\r?\n/).forEach(function (line: any) {
      var parts = line.split(':');
      var key = parts.shift().trim();
      if (key) {
        var value = parts.join(':').trim();
        headers.append(key, value);
      }
    });
    return headers
  }

  Body.call(Request.prototype);

  function Response(bodyInit: any, options: any) {
    if (!options) {
      options = {};
    }

    // @ts-ignore
    this.type = 'default';
    // @ts-ignore
    this.status = options.status === undefined ? 200 : options.status;
    // @ts-ignore
    this.ok = this.status >= 200 && this.status < 300;
    // @ts-ignore
    this.statusText = 'statusText' in options ? options.statusText : 'OK';
    // @ts-ignore
    this.headers = new Headers(options.headers);
    // @ts-ignore
    this.url = options.url || '';
    // @ts-ignore
    this._initBody(bodyInit);
  }

  Body.call(Response.prototype);

  Response.prototype.clone = function () {
    // @ts-ignore
    return new Response(this._bodyInit, {
      status: this.status,
      statusText: this.statusText,
      // @ts-ignore
      headers: new Headers(this.headers),
      url: this.url
    })
  };

  Response.error = function () {
    // @ts-ignore
    var response = new Response(null, { status: 0, statusText: '' });
    response.type = 'error';
    return response
  };

  var redirectStatuses = [301, 302, 303, 307, 308];

  Response.redirect = function (url: any, status: any) {
    if (redirectStatuses.indexOf(status) === -1) {
      throw new RangeError('Invalid status code')
    }

    // @ts-ignore
    return new Response(null, { status: status, headers: { location: url } })
  };

  (self as any).DOMException = (self as any).DOMException;
  try {
    new (self as any).DOMException();
  } catch (err) {
    (self as any).DOMException = function (message: any, name: any) {
      this.message = message;
      this.name = name;
      var error = Error(message);
      this.stack = error.stack;
    };
    (self as any).DOMException.prototype = Object.create(Error.prototype);
    (self as any).DOMException.prototype.constructor = (self as any).DOMException;
  }

  function fetch(input: any, init: any) {
    return new Promise(function (resolve, reject) {
      // @ts-ignore
      var request = new Request(input, init);

      if (request.signal && request.signal.aborted) {
        return reject(new (self as any).DOMException('Aborted', 'AbortError'))
      }

      var xhr = new XMLHttpRequest();

      function abortXhr() {
        xhr.abort();
      }

      xhr.onload = function () {
        var options = {
          status: xhr.status,
          statusText: xhr.statusText,
          headers: parseHeaders(xhr.getAllResponseHeaders() || '')
        };
        (options as any).url = 'responseURL' in xhr ? xhr.responseURL : options.headers.get('X-Request-URL');
        var body = 'response' in xhr ? xhr.response : (xhr as any).responseText;
        // @ts-ignore
        resolve(new Response(body, options));
      };

      xhr.onerror = function () {
        reject(new TypeError('Network request failed'));
      };

      xhr.ontimeout = function () {
        reject(new TypeError('Network request failed'));
      };

      xhr.onabort = function () {
        reject(new (self as any).DOMException('Aborted', 'AbortError'));
      };

      xhr.open(request.method, request.url, true);

      if (request.credentials === 'include') {
        xhr.withCredentials = true;
      } else if (request.credentials === 'omit') {
        xhr.withCredentials = false;
      }

      if ('responseType' in xhr && support.blob) {
        xhr.responseType = 'blob';
      }

      request.headers.forEach(function (value: any, name: any) {
        xhr.setRequestHeader(name, value);
      });

      if (request.signal) {
        request.signal.addEventListener('abort', abortXhr);

        xhr.onreadystatechange = function () {
          // DONE (success or failure)
          if (xhr.readyState === 4) {
            request.signal.removeEventListener('abort', abortXhr);
          }
        };
      }

      xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit);
    })
  }

  fetch.polyfill = true;

  if (!self.fetch) {
    (self as any).fetch = fetch;
    (self as any).Headers = Headers;
    (self as any).Request = Request;
    (self as any).Response = Response;
  }
})();

export enum AvoEnv {
  Prod = "prod",
  Dev = "dev",
}

// @ts-ignore
interface AvoAssertMessage {
  eventName?: string;
  tag?: string;
  propertyId?: string;
  message?: string;
  additionalProperties?: string[],
  shape?: any,
  shapeUserProps?: any,
  actualType?: string
}

let __AVO_ENV__: AvoEnv | null = null;
// @ts-ignore
let __AVO_NOOP__: boolean = false;
// @ts-ignore
let __AVO_LOGGER__: AvoLogger | null = null;
// @ts-ignore
let __STRICT__: boolean | null = null;
// @ts-ignore
let __REPORT_FAILURE_AS__: 'error' | 'warn' | 'log' | null = null;

// @ts-ignore
let __WEB_DEBUGGER__: boolean = true;
export const avoInspectorApiKey = "EaLGSQEReMgdOe8MGRaz";
// @ts-ignore
interface AvoInspector {}
let __INSPECTOR__: AvoInspector | null = null;


// polyfill Object.assign
// @ts-ignore
declare interface ObjectConstructor {
  assign: any;
}
// @ts-ignore
if (typeof Object.assign !== 'function') {
  // Must be writable: true, enumerable: false, configurable: true
  Object.defineProperty(Object, "assign", {
    value: function assign(target: any, _varArgs: any) { // .length of function is 2
      if (target == null) { // TypeError if undefined or null
        throw new TypeError('Cannot convert undefined or null to object');
      }

      let to = Object(target);

      for (let index = 1; index < arguments.length; index++) {
        let nextSource = arguments[index];

        if (nextSource != null) { // Skip over if undefined or null
          for (let nextKey in nextSource) {
            // Avoid bugs when hasOwnProperty is shadowed
            if (Object.prototype.hasOwnProperty.call(nextSource, nextKey)) {
              to[nextKey] = nextSource[nextKey];
            }
          }
        }
      }
      return to;
    },
    writable: true,
    configurable: true
  });
}

interface AvoLogger {
  logDebug(env: AvoEnv | null, message: string): boolean;
  logWarn(env: AvoEnv | null, message: string): boolean;
  logError(env: AvoEnv | null, error: string): boolean;
}

enum webDebuggerArea {
  BottomRight = "BottomRight",
  BottomLeft = "BottomLeft",
  TopRight = "TopRight",
  TopLeft = "TopLeft"
}

interface bottomRightParameters {
  bottom: number;
  right: number;
}

interface bottomLeftParameters {
  bottom: number;
  left: number;
}

interface topRightParameters {
  top: number;
  right: number;
}

interface topLeftParameters {
  top: number;
  left: number;
}

interface webDebuggerPosition {
  position: webDebuggerArea;
  top?: number;
  right?: number;
  bottom?: number;
  left?: number;
}

interface webDebuggerOptions {
  position?: webDebuggerPosition;
}

interface WebDebuggerPositionSetter {
  BottomRight(p: bottomRightParameters): webDebuggerPosition;
  BottomLeft(p: bottomLeftParameters): webDebuggerPosition;
  TopRight(p: topRightParameters): webDebuggerPosition;
  TopLeft(p: topLeftParameters): webDebuggerPosition;
}

export const WebDebuggerPosition: WebDebuggerPositionSetter = {
  BottomRight: ({ bottom, right }) => ({
    position: webDebuggerArea.BottomRight,
    bottom,
    right,
  }),
  BottomLeft: ({ bottom, left }) => ({
    position: webDebuggerArea.BottomLeft,
    bottom,
    left,
  }),
  TopRight: ({ top, right }) => ({
    position: webDebuggerArea.TopRight,
    top,
    right,
  }),
  TopLeft: ({ top, left }) => ({
    position: webDebuggerArea.TopLeft,
    top,
    left,
  }),
}


let InternalAvoLogger: any = {
  logEventSent: function logEventSent(eventName: string, eventProperties: any, userProperties: any) {
    const message = "Event Sent:" + eventName + "Event Props:" + JSON.stringify(eventProperties) + "User Props:" + JSON.stringify(userProperties);

    if (__AVO_LOGGER__ && __AVO_LOGGER__.logDebug && __AVO_LOGGER__.logDebug(__AVO_ENV__, message)) {
      return
    }
    typeof console !== 'undefined' && console.log("[avo] Event Sent:", eventName, "Event Props:", eventProperties, "User Props:", userProperties);
  },

  log: function log(message: string) {
    if (__AVO_LOGGER__ && __AVO_LOGGER__.logDebug && __AVO_LOGGER__.logDebug(__AVO_ENV__, message)) {
      return
    }
    typeof console !== 'undefined' && console.log("[avo] " + message);
  },

  warn: function warn(message: string) {
    if (__AVO_LOGGER__ && __AVO_LOGGER__.logWarn && __AVO_LOGGER__.logWarn(__AVO_ENV__, message)) {
      return
    }
    typeof console !== 'undefined' && console.warn("[avo] " + message);
  },

  error: function error(message: string, error: string) {
    if (__AVO_LOGGER__ && __AVO_LOGGER__.logError && __AVO_LOGGER__.logError(__AVO_ENV__, message + error)) {
      return
    }
    typeof console !== 'undefined' && console.error("[avo] " + message, error);
  }
};

function convertPropertiesArrayToMap(propertiesArray: [{id: string, name: string, value: string}]): {string: string | null | undefined} {
    let result: {string: string} = {}

    propertiesArray.forEach(value => {
      result[value.name] = value.value
    })

    return result
}

// @ts-ignore
let array_difference: any;
// @ts-ignore
let AvoAssert: any;
array_difference = function array_difference(a1: any[], a2: any[]) {
  let result: any[] = [];
  for (let i = 0; i < a1.length; i++) {
    if (a2.indexOf(a1[i]) === -1) {
      result.push(a1[i]);
    }
  }
  return result;
}

AvoAssert = {
  assertObject: function assertObject(propertyId: string, propName: string, obj: any) {
    if (typeof obj !== 'object') {
      let message = propName +
          ' should be of type object but you provided type ' +
          typeof obj +
          ' with value ' +
          JSON.stringify(obj);
      return [{tag: 'expectedObjectType', propertyId, message, actualType: typeof obj}];
    } else {
      return [];
    }
  },

  assertString: function assertString(propertyId: string, propName: string, str: string) {
    if (typeof str !== 'string') {
      let message = propName +
          ' should be of type string but you provided type ' +
          typeof str +
          ' with value ' +
          JSON.stringify(str);
      return [{tag: 'expectedStringType', propertyId, message, actualType: typeof str}];
    } else {
      return [];
    }
  },

  assertInt: function assertInt(propertyId: string, propName: string, int: number) {
    if (typeof int === 'number' && int !== Math.round(int)) {
      let message = propName +
          ' should be of type int but you provided type float with value ' +
          JSON.stringify(int);
      return [{tag: 'expectedIntType', propertyId, message, actualType: 'float'}];
    } else if (typeof int !== 'number') {
      let message = propName +
          ' should be of type int but you provided type ' +
          typeof int +
          ' with value ' +
          JSON.stringify(int);
      return [{tag: 'expectedIntType', propertyId, message, actualType: typeof int}];
    } else {
      return [];
    }
  },

  assertLong: function assertLong(propertyId: string, propName: string, long: number) {
    if (typeof long === 'number' && long !== Math.round(long)) {
      let message = propName +
          ' should be of type long but you provided type float with value ' +
          JSON.stringify(long);
      return [{tag: 'expectedLongType', propertyId, message, actualType: 'float'}];
    } else if (typeof long !== 'number') {
      let message = propName +
          ' should be of type long but you provided type ' +
          typeof long +
          ' with value ' +
          JSON.stringify(long);
      return [{tag: 'expectedLongType', propertyId, message, actualType: typeof long}];
    } else {
      return [];
    }
  },

  assertFloat: function assertFloat(propertyId: string, propName: string, float: number) {
    if (typeof float !== 'number') {
      let message = propName +
          ' should be of type float but you provided type ' +
          typeof float +
          ' with value ' +
          JSON.stringify(float);
      return [{tag: 'expectedFloatType', propertyId, message, actualType: typeof float}];
    } else {
      return [];
    }
  },

  assertBool: function assertBool(propertyId: string, propName: string, bool: boolean) {
    if (typeof bool !== 'boolean') {
      let message = propName +
          ' should be of type boolean but you provided type ' +
          typeof bool +
          ' with value ' +
          JSON.stringify(bool);
      return [{tag: 'expectedBoolType', propertyId, message, actualType: typeof bool}];
    } else {
      return [];
    }
  },

  assertMax: function assertMax(
    propertyId: string,
    propName: string,
    max: number,
    value: number
  ) {
    if (value > max) {
      let message = propName +
        ' has a maximum value of ' +
        max +
        ' but you provided the value ' +
        JSON.stringify(value);
      return [{tag: 'expectedMax', propertyId, message}];
    } else {
      return [];
    }
  },

  assertMin: function assertMin(
    propertyId: string,
    propName: string,
    min: number,
    value: number
  ) {
    if (value < min) {
      let message = propName +
        ' has a minimum value of ' +
        min +
        ' but you provided the value ' +
        JSON.stringify(value);
      return [{tag: 'expectedMin', propertyId, message}];
    } else {
      return [];
    }
  },

  assertList: function assertList(propertyId: string, propName: string, value: any) {
    if (!Array.isArray(value)) {
      let message = propName + ' should be of type list but you provided type ' + typeof value;
      return [{tag: 'expectedList', propertyId, message}];
    } else {
      return [];
    }
  },

  assertNoAdditionalProperties: function assertNoAdditionalProperties(eventName: string, input: string[], spec: string[]) {
    let additionalKeys = array_difference(input, spec);
    if (additionalKeys.length) {
      let message = "Additional properties when sending event " + eventName + ": " + JSON.stringify(additionalKeys);
      return [{tag: 'expectedNoAdditionalProperties', additionalProperties: additionalKeys, message: message}];
    } else {
      return [];
    }
  },

  assertNoAdditionalUserProperties: function assertNoAdditionalProperties(eventName: string, input: string[], spec: string[]) {
    let additionalKeys = array_difference(input, spec);
    if (additionalKeys.length) {
      let message = "Additional user properties when sending event " + eventName + ": " + JSON.stringify(additionalKeys);
      return [{tag: 'expectedNoAdditionalUserProperties', additionalProperties: additionalKeys, message: message}];
    } else {
      return [];
    }
  },
};

let _avo_invoke: any;
let _avo_invoke_meta: any;
let _avo_sampling_rate = 1.0;
_avo_invoke = function _avo_invoke(env: AvoEnv, eventId: string, hash: string, messages: {tag: string, propertyId: string}[], origin: string) {
  // @ts-ignore
  if (typeof (window as any) === 'undefined') { return; }
  if (_avo_sampling_rate > 0) {
    if (Math.random() < _avo_sampling_rate) {
      // @ts-ignore
      fetch("https://api.avo.app/i", {
        method: "POST",
        headers: {"Content-Type": "application/json"},
        body: JSON.stringify({
          "ac": "djEbu42vNV0kR53xqpBb",
          "br": "master",
          "en": env,
          "ev": eventId,
          "ha": hash,
          "sc": "Zba2v6MXsSx1EdxPIQKm",
          "se": (new Date()).toISOString(),
          "so": "moZWtrPHl",
          "va": messages.length === 0,
          "me": messages,
          "or": origin
        })
      }).then(function(res: any) { return res.json(); }).then(function(data: any) { _avo_sampling_rate = data.sa; }).catch(function() {});
    }
  }
}

_avo_invoke_meta = function _avo_invoke_meta(env: AvoEnv, type: string, messages: {tag: string, propertyId: string}[], origin: string) {
  // @ts-ignore
  if (typeof (window as any) === 'undefined') { return; }
  if (_avo_sampling_rate > 0) {
    if (Math.random() < _avo_sampling_rate) {
      // @ts-ignore
      fetch("https://api.avo.app/i", {
        method: "POST",
        headers: {"Content-Type": "application/json"},
        body: JSON.stringify({
          "ac": "djEbu42vNV0kR53xqpBb",
          "br": "master",
          "en": env,
          "ty": type,
          "sc": "Zba2v6MXsSx1EdxPIQKm",
          "se": (new Date()).toISOString(),
          "so": "moZWtrPHl",
          "va": messages.length === 0,
          "me": messages,
          "or": origin
        })
      }).then(function(res: any) { return res.json(); }).then(function(data: any) { _avo_sampling_rate = data.sa; }).catch(function() {});
    }
  }
}


let _avo_debugger_log: any;
let _avo_debugger_events_during_boot: any = [];
let _avo_debugger_ready = false;

if (typeof (window as any) !== 'undefined') {
  window.addEventListener("message", function(event) {
    if (event.origin !== "https://www.avo.app") {
      return;
    }
    let iframe: any = document.getElementById("avo-debugger");
    if (iframe && event && event.data && event.data.type_ === "avo-debugger-update-style") {
      iframe.style = event.data.style;
    } else if (iframe && event && event.data && event.data.type_ === "avo-debugger-ready") {
      let message = {
        type_: "avo-debugger-boot-events",
        schemaId: "Zba2v6MXsSx1EdxPIQKm",
        href: window.location.href,
        events: _avo_debugger_events_during_boot
      };
      _avo_debugger_events_during_boot = [];
      _avo_debugger_ready = true;
      iframe.contentWindow.postMessage(message, "https://www.avo.app/_debugger")
    }
  });
}

_avo_debugger_log = function _avo_debugger_log(eventId: string, eventName: string, messages: any[], eventProperties: any[], userProperties: any[], groupProperties: any[]) {
  if (typeof (window as any) === 'undefined') { return; }
  let event = {
    eventId: eventId,
    eventName: eventName,
    messages: messages,
    timestamp: Date.now(),
    eventProperties,
    userProperties,
    groupProperties
  };

  if (_avo_debugger_ready) {
    let message = {type_: "avo-debugger-events", events: [event]};
    (document.getElementById("avo-debugger") as any).contentWindow.postMessage(message, "https://www.avo.app/_debugger")
  } else {
    _avo_debugger_events_during_boot.push(event);
  }
}

function _avo_debugger_send_position(position: webDebuggerPosition) {
  if (typeof window === 'undefined') { return; }
  window.addEventListener("message", function(event) {
    if (event.origin !== "https://www.avo.app") {
      return;
    }
    if (event.data.type_ === "avo-debugger-ready" && position !== null) {
      var message = {type_: "avo-debugger-position", position: position};
      document.getElementById("avo-debugger").contentWindow.postMessage(message, "https://www.avo.app/_debugger")
    }
  })
}


// @ts-ignore
interface Window {
  mixpanel: any;
}

let Mixpanel = {
  make: function make(apiKey: string, options: any) {
    if (typeof (window as any) === 'undefined') { InternalAvoLogger.warn('window.mixpanel is not available in Node.js'); return; }
    if (typeof (window as any).mixpanel === "undefined") {
      // @ts-ignore
      (function(f,b){if(!b.__SV){var e,g,i,h;window.mixpanel=b;b._i=[];b.init=function(e,f,c){function g(a,d){var b=d.split(".");2==b.length&&(a=a[b[0]],d=b[1]);a[d]=function(){a.push([d].concat(Array.prototype.slice.call(arguments,0)))}}var a=b;"undefined"!==typeof c?a=b[c]=[]:c="mixpanel";a.people=a.people||[];a.toString=function(a){var d="mixpanel";"mixpanel"!==c&&(d+="."+c);a||(d+=" (stub)");return d};a.people.toString=function(){return a.toString(1)+".people (stub)"};i="disable time_event track track_pageview track_links track_forms track_with_groups add_group set_group remove_group register register_once alias unregister identify name_tag set_config reset opt_in_tracking opt_out_tracking has_opted_in_tracking has_opted_out_tracking clear_opt_in_out_tracking start_batch_senders people.set people.set_once people.unset people.increment people.append people.union people.track_charge people.clear_charges people.delete_user people.remove".split(" ");
      // @ts-ignore
      for(h=0;h<i.length;h++)g(a,i[h]);var j="set set_once union unset remove delete".split(" ");a.get_group=function(){function b(c){d[c]=function(){var call2_args=arguments;var call2=[c].concat(Array.prototype.slice.call(call2_args,0));a.push([e,call2])}}for(var d={},e=["get_group"].concat(Array.prototype.slice.call(arguments,0)),c=0;c<j.length;c++)b(j[c]);return d};b._i.push([e,f,c])};b.__SV=1.2;e=f.createElement("script");e.type="text/javascript";e.async=!0;e.src="undefined"!==typeof MIXPANEL_CUSTOM_LIB_URL?
      // @ts-ignore
      MIXPANEL_CUSTOM_LIB_URL:"file:"===f.location.protocol&&"//cdn.mxpnl.com/libs/mixpanel-2-latest.min.js".match(/^\/\//)?"https://cdn.mxpnl.com/libs/mixpanel-2-latest.min.js":"//cdn.mxpnl.com/libs/mixpanel-2-latest.min.js";g=f.getElementsByTagName("script")[0];g.parentNode.insertBefore(e,g)}})(document,window.mixpanel||[]);
    }
    (this as any).getInstance = () => (window as any).mixpanel;
    (this as any).getInstance().init(apiKey, options);
  },

  addCurrentUserToGroup: function addCurrentUserToGroup(groupTypeName: string, groupId: string) {
    if (typeof (window as any) === 'undefined') { return; }
    (this as any).getInstance().set_group(groupTypeName, groupId);
  },

  logEvent: function logEvent(eventName: string, eventProperties: {[name: string] : any}) {
    if (typeof (window as any) === 'undefined') { return; }
    (this as any).getInstance().track(eventName, eventProperties);
  },

  logEventWithGroups: function logEventWithGroups(eventName: string, eventProperties: {[name: string] : any}, groupTypeNamesToGroupIds: {[name: string] : string}) {
    if (typeof window === 'undefined') { return; }
    (this as any).getInstance().track_with_groups(eventName, eventProperties, groupTypeNamesToGroupIds);
  },

  setUserProperties: function setUserProperties(userProperties: {[name: string] : any}) {
    if (typeof (window as any) === 'undefined') { return; }
    (this as any).getInstance().people.set(userProperties);
  },

  setGroupProperties: function setGroupProperties(groupTypeName: string, groupId: string, groupProperties: {[name: string] : any}) {
    if (typeof window === 'undefined') { return; }
    (this as any).getInstance().get_group(groupTypeName, groupId).set(groupProperties);
  },

  identify: function identify(userId: string) {
    if (typeof (window as any) === 'undefined') { return; }
    (this as any).getInstance().identify(userId);
  },

  /* @see https://mixpanel.com/help/reference/javascript-full-api-reference#mixpanel.people.track_charge */
  revenue: function revenue(amount: Number, eventProperties: {[name: string] : any}) {
    if (typeof (window as any) === 'undefined') { return; }
    (this as any).getInstance().people.track_charge(amount, eventProperties);
  },

  unidentify: function unidentify() {
    if (typeof (window as any) === 'undefined') { return; }
    (this as any).getInstance().reset();
  },
};

export const OnboardingStep = {
  'EMAIL_CONFIRMATION': 'Email confirmation',
  'CONNECT_EXCHANGE': 'Connect exchange',
  'TRADING_METHOD': 'Trading method',
  'OVERVIEW': 'Overview',
  'METHOD_SETTINGS': 'Method settings',
} as const;
export type OnboardingStepType = typeof OnboardingStep;
export type OnboardingStepValueType = OnboardingStepType[keyof OnboardingStepType];

export const BotType = {
  'DCA': 'DCA',
  'TRADING_VIEW': 'TradingView',
  'SIGNALS': 'Signals',
  'GRID': 'Grid',
} as const;
export type BotTypeType = typeof BotType;
export type BotTypeValueType = BotTypeType[keyof BotTypeType];

export const BotSource = {
  'DISCORD': 'discord',
  'TELEGRAM': 'telegram',
} as const;
export type BotSourceType = typeof BotSource;
export type BotSourceValueType = BotSourceType[keyof BotSourceType];

export const EpUserSubscriptionPlan = {
  'TRIAL': 'Trial',
  'BEGINNER': 'Beginner',
  'INTERMEDIATE': 'Intermediate',
  'PRO': 'Pro',
  'PRE_TRIAL': 'Pre-Trial',
  'STARTER': 'Starter',
  'ADVANCED': 'Advanced',
  'PREMIUM': 'Premium',
} as const;
export type EpUserSubscriptionPlanType = typeof EpUserSubscriptionPlan;
export type EpUserSubscriptionPlanValueType = EpUserSubscriptionPlanType[keyof EpUserSubscriptionPlanType];

export const ExternalAccountType = {
  'DISCORD': 'Discord',
  'TELEGRAM': 'Telegram',
} as const;
export type ExternalAccountTypeType = typeof ExternalAccountType;
export type ExternalAccountTypeValueType = ExternalAccountTypeType[keyof ExternalAccountTypeType];

export const SubscriptionInvoiceType = {
  'EXTENSION': 'Extension',
  'UPGRADE': 'Upgrade',
  'LICENSES': 'Licenses',
  'NEW': 'New',
  'SIGNALS_GROUP_EXTENSION': 'Signals Group - Extension',
} as const;
export type SubscriptionInvoiceTypeType = typeof SubscriptionInvoiceType;
export type SubscriptionInvoiceTypeValueType = SubscriptionInvoiceTypeType[keyof SubscriptionInvoiceTypeType];

export const DcaBotCreateeditOrigin = {
  'COPY_AS_IS': 'copy as is',
  'CREATE': 'create',
  'EDIT': 'edit',
  'EDIT_AND_COPY': 'edit and copy',
  'BULK_EDIT': 'bulk edit',
  'BULK_CREATE': 'bulk create',
} as const;
export type DcaBotCreateeditOriginType = typeof DcaBotCreateeditOrigin;
export type DcaBotCreateeditOriginValueType = DcaBotCreateeditOriginType[keyof DcaBotCreateeditOriginType];

export const NotificationPartClicked = {
  'NOTIFICATION_BOX': 'Notification-Box',
  'NOTIFICATION_C2A_BUTTON': 'Notification-C2A-Button',
} as const;
export type NotificationPartClickedType = typeof NotificationPartClicked;
export type NotificationPartClickedValueType = NotificationPartClickedType[keyof NotificationPartClickedType];

export const TradingMethodCategory = {
  'SIGNALS_GROUP_FREE_TRIAL_GROUP': 'Signals group - Free trial group',
  'SIGNALS_GROUP_MY_GROUP': 'Signals group - My group',
  'DCA_BOT_TRENDING': 'DCA bot - Trending',
  'DCA_BOT_LONG_RUNNING': 'DCA bot - Long-running',
  'DCA_BOT_HIGH_VOLUME': 'DCA bot - High Volume',
  'SIGNALS_GROUP_FREE_GROUP': 'Signals group - Free group',
} as const;
export type TradingMethodCategoryType = typeof TradingMethodCategory;
export type TradingMethodCategoryValueType = TradingMethodCategoryType[keyof TradingMethodCategoryType];

export const Platform = {
  'TELEGRAM_BOT': 'Telegram Bot',
  'MOBILE_APP': 'Mobile App',
  'WEBSITE': 'Website',
  'SYSTEM': 'System',
  'APP_OR_WEB': 'App or Web',
} as const;
export type PlatformType = typeof Platform;
export type PlatformValueType = PlatformType[keyof PlatformType];

export const SubscriptionInvoicePaymentMethod = {
  'PAY_PAL': 'PayPal',
  'BTC': 'BTC',
  'LTC': 'LTC',
  'ETH': 'ETH',
  'XRP': 'XRP',
} as const;
export type SubscriptionInvoicePaymentMethodType = typeof SubscriptionInvoicePaymentMethod;
export type SubscriptionInvoicePaymentMethodValueType = SubscriptionInvoicePaymentMethodType[keyof SubscriptionInvoicePaymentMethodType];

export const WebsiteOriginTimeOfAction = {
  'SIGNALS': 'signals',
  'ADMIN_PANEL': 'admin panel',
} as const;
export type WebsiteOriginTimeOfActionType = typeof WebsiteOriginTimeOfAction;
export type WebsiteOriginTimeOfActionValueType = WebsiteOriginTimeOfActionType[keyof WebsiteOriginTimeOfActionType];

export const TradingMethodType = {
  'DCA_BOT': 'DCA Bot',
  'SIGNALS_GROUP': 'Signals Group',
} as const;
export type TradingMethodTypeType = typeof TradingMethodType;
export type TradingMethodTypeValueType = TradingMethodTypeType[keyof TradingMethodTypeType];

export const MarketsTableView = {
  'TOP_GAINERS': 'top gainers',
  'TOP_LOSERS': 'top losers',
  'VOLUME': 'volume',
  'POPULAR_ON_CORNIX': 'popular on Cornix',
} as const;
export type MarketsTableViewType = typeof MarketsTableView;
export type MarketsTableViewValueType = MarketsTableViewType[keyof MarketsTableViewType];

export const SubscriptionInvoicePlan = {
  'BEGINNER': 'Beginner',
  'INTERMEDIATE': 'Intermediate',
  'PRO': 'Pro',
  'STARTER': 'Starter',
  'ADVANCED': 'Advanced',
  'PREMIUM': 'Premium',
} as const;
export type SubscriptionInvoicePlanType = typeof SubscriptionInvoicePlan;
export type SubscriptionInvoicePlanValueType = SubscriptionInvoicePlanType[keyof SubscriptionInvoicePlanType];

export const SignalsAutoTradingConfiguration = {
  'DEFAULT_CONFIGURATION': 'Default Configuration',
  'GROUP_CONFIGURATION': 'Group Configuration',
  'NONE': 'None',
} as const;
export type SignalsAutoTradingConfigurationType = typeof SignalsAutoTradingConfiguration;
export type SignalsAutoTradingConfigurationValueType = SignalsAutoTradingConfigurationType[keyof SignalsAutoTradingConfigurationType];

export const FollowSignalModalType = {
  'CLOSE_TRADE': 'Close Trade',
  'CREATE_TRADE': 'Create Trade',
  'UPDATE_TRADE': 'Update Trade',
} as const;
export type FollowSignalModalTypeType = typeof FollowSignalModalType;
export type FollowSignalModalTypeValueType = FollowSignalModalTypeType[keyof FollowSignalModalTypeType];

export const AmountPerTradeType = {
  'FIXED_USD': 'Fixed USD',
  'FIXED_BTC': 'Fixed BTC',
  'PERCENTAGE': 'Percentage',
  'RISK_PERCENTAGE': 'Risk Percentage',
} as const;
export type AmountPerTradeTypeType = typeof AmountPerTradeType;
export type AmountPerTradeTypeValueType = AmountPerTradeTypeType[keyof AmountPerTradeTypeType];

let sysPlatform: any;

export function setSystemProperties(properties: {platform: PlatformValueType | null | undefined}) {
  if (properties.platform !== null && properties.platform !== undefined) {
    sysPlatform = properties.platform;
  }
}


export function initAvo(options: {env: AvoEnv;
    webDebugger?: boolean;
    webDebuggerOptions?: webDebuggerOptions;
    strict?: boolean;
    noop?: boolean;
    reportFailureAs?: 'error' | 'warn' | 'log';
    inspector?: AvoInspector;
    avoLogger?: AvoLogger},
    systemProperties: {platform: PlatformValueType | null | undefined},
    destinationOptions: any) {
  if (__AVO_ENV__ !== null) {
    return;
  }
  __AVO_ENV__ = options.env;
  if (options.avoLogger !== undefined) {
    __AVO_LOGGER__ = options.avoLogger;
  }
  if (options.noop === true) {
    __AVO_NOOP__ = true;
  }
  if (__AVO_NOOP__ && __AVO_ENV__ == AvoEnv.Prod) {
    InternalAvoLogger.warn("[avo] ****************************************************");
    InternalAvoLogger.warn("[avo] WARNING Avo cannot be initialized in noop mode in production:");
    InternalAvoLogger.warn("[avo] - Overwriting configuration with noop=false.");
    InternalAvoLogger.warn("[avo] - Please reach out if you want to be able to run Avo in production mode with noop=true");
    InternalAvoLogger.warn("[avo] ****************************************************");
    __AVO_NOOP__ = false;
  }
  if (__AVO_NOOP__) {
    InternalAvoLogger.log("[avo] ****************************************************");
    InternalAvoLogger.log("[avo] Avo is now initialized in noop mode. This means:");
    InternalAvoLogger.log("[avo] - No events will be sent");
    InternalAvoLogger.log("[avo] - No network requests are made");
    InternalAvoLogger.log("[avo] ****************************************************");
  }
  if (options.strict !== undefined) {
    __STRICT__ = options.strict !== false;
  }
  if (options.reportFailureAs !== undefined) {
    __REPORT_FAILURE_AS__ = options.reportFailureAs;
  }
  __WEB_DEBUGGER__ = !__AVO_NOOP__ && ((typeof window !== 'undefined' && (window as any).location.search.indexOf("avo_debug=1") > -1) || (options.webDebugger !== false && __AVO_ENV__ !== AvoEnv.Prod));
  if (!__AVO_NOOP__ && options.inspector !== undefined) {
    __INSPECTOR__ = options.inspector;
  } else if (__AVO_ENV__ !== 'prod') {
    InternalAvoLogger.warn("[avo] Avo Inspector not provided in initAvo() call");
  }
  
  setSystemProperties(systemProperties);
  
  destinationOptions = destinationOptions || {};
  
  if (__WEB_DEBUGGER__ && !__AVO_NOOP__) {
    if (options.webDebuggerOptions?.position) {
      _avo_debugger_send_position(options.webDebuggerOptions.position)
    }

(function() {
  if (typeof (window as any) === 'undefined') { return; }
  let init = function() {
    let iframe: any = document.createElement("iframe");
    document.body.appendChild(iframe);
    iframe.id = "avo-debugger";
    iframe.src = "https://www.avo.app/_debugger";
    iframe.style = "display: none;";
  };

  if (document.body) {
    init();
  } else {
    document.addEventListener('DOMContentLoaded', init);
  }
})();
    
  }
  if (!__AVO_NOOP__) {
    if (__AVO_ENV__ === AvoEnv.Prod) {
      Mixpanel.make("0d7b60716e2e7c893e067e87ab93ccb1", destinationOptions.mixpanel);
    }
    if (__AVO_ENV__ === AvoEnv.Dev) {
      Mixpanel.make("fb34419ab61d090b687e45401c511163", destinationOptions.mixpanel);
    }
    if (__AVO_ENV__ === AvoEnv.Dev) {
      // debug console in Avo
      _avo_invoke_meta(__AVO_ENV__, 'init', [], 'init');
    }
  }
}

export function setAvoLogger(avoLogger: AvoLogger | null) {
  __AVO_LOGGER__ = avoLogger;
}

export interface PortfolioAccountsViewProperties {
  epUserSubscriptionDuration: number | null | undefined;
  epUserSubscriptionPlan: EpUserSubscriptionPlanValueType | null | undefined;
  epUserSubscriptionIsActive: boolean | null | undefined;
  epUserIsMobileAppUser: boolean | null | undefined;
  epUserIsAdmin: boolean | null | undefined;
  epUserIsTelegramConnected: boolean | null | undefined;
  epUserIsDiscordConnected: boolean | null | undefined;
  epUserFeatureFlags: string[] | null | undefined;
  epUserIsDarkMode: boolean | null | undefined;
  isTelegramMiniApp: boolean | null | undefined;
  epUserTotalAutoTradingGroupsCount: number | null | undefined;
  epUserTotalAutoTradingGroupsNames: string[] | null | undefined;
  epUserCurrentAutoTradingGroupsCount: number | null | undefined;
  epUserCurrentAutoTradingGroupsNames: string[] | null | undefined;
  epUserGroupsCount: number | null | undefined;
  epUserGroupsNames: string[] | null | undefined;
}
/**
 * Portfolio Accounts View: Previously: 'Portfolio View (Bot)'
Users view the portfolio 'accounts' page in the Telegram Bot, Website and the App.
 * 
 * @param properties the properties associatied with this event
 * @param properties.epUserSubscriptionDuration: The current subscription duration for the user, in days. Not sent for users with Expired or Trial subscription plans.
 * @param properties.epUserSubscriptionPlan: The current subscription plan for the user. Users without an active subscription should have the value set to Expired.
 * @param properties.epUserSubscriptionIsActive: Set to True if the user has an active subscription (the last subscription expiration date is smaller than the current date).
 * @param properties.epUserIsMobileAppUser: no description
 * @param properties.epUserIsAdmin: no description
 * @param properties.epUserIsTelegramConnected: no description
 * @param properties.epUserIsDiscordConnected: no description
 * @param properties.epUserFeatureFlags: no description
 * @param properties.epUserIsDarkMode: no description
 * @param properties.isTelegramMiniApp: no description
 * @param properties.epUserTotalAutoTradingGroupsCount: The total number of groups the user has ever had connected with auto-trading to any client.
 * @param properties.epUserTotalAutoTradingGroupsNames: The names of the groups that the user has ever had connected with auto-trading to any client.
 * @param properties.epUserCurrentAutoTradingGroupsCount: The number of groups the user currently has connected with auto-trading to an active client. This number represents the number of groups the user is actively following and trading based on. This does not include groups that are connected to clients that have auto-trading disabled.
 * @param properties.epUserCurrentAutoTradingGroupsNames: The names list of the groups the user currently has connected with auto-trading to an active client. This list represents the names of groups the user is actively following and trading based on. This does not include groups that are connected to clients that have auto-trading disabled.
 * @param properties.epUserGroupsCount: The number of Telegram channels the user is currently a member of.
 * @param properties.epUserGroupsNames: The names list of Telegram channels the user is currently a member of.
 * 
 * @see {@link https://www.avo.app/schemas/Zba2v6MXsSx1EdxPIQKm/events/HYFGxezLBC}
 */
export function portfolioAccountsView(properties: PortfolioAccountsViewProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  properties.epUserSubscriptionDuration !== undefined && properties.epUserSubscriptionDuration !== null ?
    eventPropertiesArray.push({id: "BrNPvrBkq", name: "ep_user_subscription_duration", value: properties.epUserSubscriptionDuration}) :
    eventPropertiesArray.push({id: "BrNPvrBkq", name: "ep_user_subscription_duration", value: null});
  properties.epUserSubscriptionPlan !== undefined && properties.epUserSubscriptionPlan !== null ?
    eventPropertiesArray.push({id: "Ak0bD3528L", name: "ep_user_subscription_plan", value: properties.epUserSubscriptionPlan}) :
    eventPropertiesArray.push({id: "Ak0bD3528L", name: "ep_user_subscription_plan", value: null});
  properties.epUserSubscriptionIsActive !== undefined && properties.epUserSubscriptionIsActive !== null ?
    eventPropertiesArray.push({id: "P2zcEByfWK", name: "ep_user_subscription_is_active", value: properties.epUserSubscriptionIsActive}) :
    eventPropertiesArray.push({id: "P2zcEByfWK", name: "ep_user_subscription_is_active", value: null});
  properties.epUserIsMobileAppUser !== undefined && properties.epUserIsMobileAppUser !== null ?
    eventPropertiesArray.push({id: "gkaSZCbXw8", name: "ep_user_is_mobile_app_user", value: properties.epUserIsMobileAppUser}) :
    eventPropertiesArray.push({id: "gkaSZCbXw8", name: "ep_user_is_mobile_app_user", value: null});
  properties.epUserIsAdmin !== undefined && properties.epUserIsAdmin !== null ?
    eventPropertiesArray.push({id: "1NHsnnGVd0", name: "ep_user_is_admin", value: properties.epUserIsAdmin}) :
    eventPropertiesArray.push({id: "1NHsnnGVd0", name: "ep_user_is_admin", value: null});
  properties.epUserIsTelegramConnected !== undefined && properties.epUserIsTelegramConnected !== null ?
    eventPropertiesArray.push({id: "QBh1Ik3rEm", name: "ep_user_is_telegram_connected", value: properties.epUserIsTelegramConnected}) :
    eventPropertiesArray.push({id: "QBh1Ik3rEm", name: "ep_user_is_telegram_connected", value: null});
  properties.epUserIsDiscordConnected !== undefined && properties.epUserIsDiscordConnected !== null ?
    eventPropertiesArray.push({id: "Z5anKuo4On", name: "ep_user_is_discord_connected", value: properties.epUserIsDiscordConnected}) :
    eventPropertiesArray.push({id: "Z5anKuo4On", name: "ep_user_is_discord_connected", value: null});
  properties.epUserFeatureFlags !== undefined && properties.epUserFeatureFlags !== null ?
    eventPropertiesArray.push({id: "ZkS2YBJULL", name: "ep_user_feature_flags", value: properties.epUserFeatureFlags}) :
    eventPropertiesArray.push({id: "ZkS2YBJULL", name: "ep_user_feature_flags", value: null});
  properties.epUserIsDarkMode !== undefined && properties.epUserIsDarkMode !== null ?
    eventPropertiesArray.push({id: "pZYzhjQhIW", name: "ep_user_is_dark_mode", value: properties.epUserIsDarkMode}) :
    eventPropertiesArray.push({id: "pZYzhjQhIW", name: "ep_user_is_dark_mode", value: null});
  properties.isTelegramMiniApp !== undefined && properties.isTelegramMiniApp !== null ?
    eventPropertiesArray.push({id: "vh-KiP-5Q", name: "is_telegram_mini_app", value: properties.isTelegramMiniApp}) :
    eventPropertiesArray.push({id: "vh-KiP-5Q", name: "is_telegram_mini_app", value: null});
  properties.epUserTotalAutoTradingGroupsCount !== undefined && properties.epUserTotalAutoTradingGroupsCount !== null ?
    eventPropertiesArray.push({id: "F33-9bIqF0", name: "ep_user_total_auto_trading_groups_count", value: properties.epUserTotalAutoTradingGroupsCount}) :
    eventPropertiesArray.push({id: "F33-9bIqF0", name: "ep_user_total_auto_trading_groups_count", value: null});
  properties.epUserTotalAutoTradingGroupsNames !== undefined && properties.epUserTotalAutoTradingGroupsNames !== null ?
    eventPropertiesArray.push({id: "VxrddG5osk", name: "ep_user_total_auto_trading_groups_names", value: properties.epUserTotalAutoTradingGroupsNames}) :
    eventPropertiesArray.push({id: "VxrddG5osk", name: "ep_user_total_auto_trading_groups_names", value: null});
  properties.epUserCurrentAutoTradingGroupsCount !== undefined && properties.epUserCurrentAutoTradingGroupsCount !== null ?
    eventPropertiesArray.push({id: "PrQVf8bCQZ", name: "ep_user_current_auto_trading_groups_count", value: properties.epUserCurrentAutoTradingGroupsCount}) :
    eventPropertiesArray.push({id: "PrQVf8bCQZ", name: "ep_user_current_auto_trading_groups_count", value: null});
  properties.epUserCurrentAutoTradingGroupsNames !== undefined && properties.epUserCurrentAutoTradingGroupsNames !== null ?
    eventPropertiesArray.push({id: "S44gtOE_4c", name: "ep_user_current_auto_trading_groups_names", value: properties.epUserCurrentAutoTradingGroupsNames}) :
    eventPropertiesArray.push({id: "S44gtOE_4c", name: "ep_user_current_auto_trading_groups_names", value: null});
  properties.epUserGroupsCount !== undefined && properties.epUserGroupsCount !== null ?
    eventPropertiesArray.push({id: "Daij3OzuMn", name: "ep_user_groups_count", value: properties.epUserGroupsCount}) :
    eventPropertiesArray.push({id: "Daij3OzuMn", name: "ep_user_groups_count", value: null});
  properties.epUserGroupsNames !== undefined && properties.epUserGroupsNames !== null ?
    eventPropertiesArray.push({id: "skk1UTP7Cq", name: "ep_user_groups_names", value: properties.epUserGroupsNames}) :
    eventPropertiesArray.push({id: "skk1UTP7Cq", name: "ep_user_groups_names", value: null});
  eventPropertiesArray.push({id: "WN7yP-IxTA", name: "platform", value: sysPlatform});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "HYFGxezLBC", "0dafa536a3af406e8bbd6117441d86c19f626880dc4a407b10d78a0a260e4d27", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Portfolio Accounts View", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("HYFGxezLBC", "Portfolio Accounts View", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Portfolio Accounts View", eventProperties, "HYFGxezLBC", "0dafa536a3af406e8bbd6117441d86c19f626880dc4a407b10d78a0a260e4d27");
    }
    // destination Mixpanel
    Mixpanel.logEvent("Portfolio Accounts View", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface OnboardingMinusLoginViewProperties {
  epUserSubscriptionDuration: number | null | undefined;
  epUserSubscriptionPlan: EpUserSubscriptionPlanValueType;
  epUserSubscriptionIsActive: boolean | null | undefined;
  epUserIsMobileAppUser: boolean | null | undefined;
  epUserIsAdmin: boolean | null | undefined;
  epUserIsTelegramConnected: boolean | null | undefined;
  epUserIsDiscordConnected: boolean | null | undefined;
  epUserFeatureFlags: string[] | null | undefined;
  epUserIsDarkMode: boolean | null | undefined;
  isTelegramMiniApp: boolean | null | undefined;
}
/**
 * Onboarding - Login View: Triggered when a user views the login page in the app or website.
 * 
 * @param properties the properties associatied with this event
 * @param properties.epUserSubscriptionDuration: The current subscription duration for the user, in days. Not sent for users with Expired or Trial subscription plans.
 * @param properties.epUserSubscriptionPlan: The current subscription plan for the user. Users without an active subscription should have the value set to Expired.
 * @param properties.epUserSubscriptionIsActive: Set to True if the user has an active subscription (the last subscription expiration date is smaller than the current date).
 * @param properties.epUserIsMobileAppUser: no description
 * @param properties.epUserIsAdmin: no description
 * @param properties.epUserIsTelegramConnected: no description
 * @param properties.epUserIsDiscordConnected: no description
 * @param properties.epUserFeatureFlags: no description
 * @param properties.epUserIsDarkMode: no description
 * @param properties.isTelegramMiniApp: no description
 * 
 * @see {@link https://www.avo.app/schemas/Zba2v6MXsSx1EdxPIQKm/events/Fckv7hWNnF}
 */
export function onboardingLoginView(properties: OnboardingMinusLoginViewProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  properties.epUserSubscriptionDuration !== undefined && properties.epUserSubscriptionDuration !== null ?
    eventPropertiesArray.push({id: "BrNPvrBkq", name: "ep_user_subscription_duration", value: properties.epUserSubscriptionDuration}) :
    eventPropertiesArray.push({id: "BrNPvrBkq", name: "ep_user_subscription_duration", value: null});
  eventPropertiesArray.push({id: "Ak0bD3528L", name: "ep_user_subscription_plan", value: properties.epUserSubscriptionPlan});
  properties.epUserSubscriptionIsActive !== undefined && properties.epUserSubscriptionIsActive !== null ?
    eventPropertiesArray.push({id: "P2zcEByfWK", name: "ep_user_subscription_is_active", value: properties.epUserSubscriptionIsActive}) :
    eventPropertiesArray.push({id: "P2zcEByfWK", name: "ep_user_subscription_is_active", value: null});
  properties.epUserIsMobileAppUser !== undefined && properties.epUserIsMobileAppUser !== null ?
    eventPropertiesArray.push({id: "gkaSZCbXw8", name: "ep_user_is_mobile_app_user", value: properties.epUserIsMobileAppUser}) :
    eventPropertiesArray.push({id: "gkaSZCbXw8", name: "ep_user_is_mobile_app_user", value: null});
  properties.epUserIsAdmin !== undefined && properties.epUserIsAdmin !== null ?
    eventPropertiesArray.push({id: "1NHsnnGVd0", name: "ep_user_is_admin", value: properties.epUserIsAdmin}) :
    eventPropertiesArray.push({id: "1NHsnnGVd0", name: "ep_user_is_admin", value: null});
  properties.epUserIsTelegramConnected !== undefined && properties.epUserIsTelegramConnected !== null ?
    eventPropertiesArray.push({id: "QBh1Ik3rEm", name: "ep_user_is_telegram_connected", value: properties.epUserIsTelegramConnected}) :
    eventPropertiesArray.push({id: "QBh1Ik3rEm", name: "ep_user_is_telegram_connected", value: null});
  properties.epUserIsDiscordConnected !== undefined && properties.epUserIsDiscordConnected !== null ?
    eventPropertiesArray.push({id: "Z5anKuo4On", name: "ep_user_is_discord_connected", value: properties.epUserIsDiscordConnected}) :
    eventPropertiesArray.push({id: "Z5anKuo4On", name: "ep_user_is_discord_connected", value: null});
  properties.epUserFeatureFlags !== undefined && properties.epUserFeatureFlags !== null ?
    eventPropertiesArray.push({id: "ZkS2YBJULL", name: "ep_user_feature_flags", value: properties.epUserFeatureFlags}) :
    eventPropertiesArray.push({id: "ZkS2YBJULL", name: "ep_user_feature_flags", value: null});
  properties.epUserIsDarkMode !== undefined && properties.epUserIsDarkMode !== null ?
    eventPropertiesArray.push({id: "pZYzhjQhIW", name: "ep_user_is_dark_mode", value: properties.epUserIsDarkMode}) :
    eventPropertiesArray.push({id: "pZYzhjQhIW", name: "ep_user_is_dark_mode", value: null});
  properties.isTelegramMiniApp !== undefined && properties.isTelegramMiniApp !== null ?
    eventPropertiesArray.push({id: "vh-KiP-5Q", name: "is_telegram_mini_app", value: properties.isTelegramMiniApp}) :
    eventPropertiesArray.push({id: "vh-KiP-5Q", name: "is_telegram_mini_app", value: null});
  eventPropertiesArray.push({id: "WN7yP-IxTA", name: "platform", value: sysPlatform});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "Fckv7hWNnF", "7bdf5f4f1c87c2031660c85fe7c545023a32c07c37cc39d803466b4692e1c608", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Onboarding - Login View", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("Fckv7hWNnF", "Onboarding - Login View", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Onboarding - Login View", eventProperties, "Fckv7hWNnF", "7bdf5f4f1c87c2031660c85fe7c545023a32c07c37cc39d803466b4692e1c608");
    }
    // destination Mixpanel
    Mixpanel.logEvent("Onboarding - Login View", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

/**
 * Forgot Password View: Triggered when the user views the forgot password page in the app or website.
 * 
 * @see {@link https://www.avo.app/schemas/Zba2v6MXsSx1EdxPIQKm/events/_7EDryJMj3}
 */
export function forgotPasswordView() {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({id: "WN7yP-IxTA", name: "platform", value: sysPlatform});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "_7EDryJMj3", "439995861a7d0795cd580aa0258e210c33f8e7dbc98b2d340d8142f4f655d760", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Forgot Password View", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("_7EDryJMj3", "Forgot Password View", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Forgot Password View", eventProperties, "_7EDryJMj3", "439995861a7d0795cd580aa0258e210c33f8e7dbc98b2d340d8142f4f655d760");
    }
    // destination Mixpanel
    Mixpanel.logEvent("Forgot Password View", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface TelegramUUIDSentProperties {
  onboardingStep: OnboardingStepValueType | null | undefined;
  epUserIsOnboarding: boolean;
}
/**
 * Telegram UUID Sent: During onboarding WEB/App - The user clicked on Give_Me_a_UUID during the telegram connection flow.

Previously, The user clicks the Proceed button in the UUID screen and send the UUID. This event should be fired after the app receives a response to know if the provided UUID was valid or not. 
 * 
 * @param properties the properties associatied with this event
 * @param properties.onboardingStep: Contain the onboarding step - Email confirmation, Connect exchange, Trading method, Method settings, Overview
 * @param properties.epUserIsOnboarding: Used to track which events happened during onboarding 
 * 
 * @see {@link https://www.avo.app/schemas/Zba2v6MXsSx1EdxPIQKm/events/4t-Z823rBT}
 */
export function telegramUuidSent(properties: TelegramUUIDSentProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  properties.onboardingStep !== undefined && properties.onboardingStep !== null ?
    eventPropertiesArray.push({id: "-sPjCGnFt", name: "onboarding_step", value: properties.onboardingStep}) :
    eventPropertiesArray.push({id: "-sPjCGnFt", name: "onboarding_step", value: null});
  eventPropertiesArray.push({id: "01c5raMTE", name: "ep_user_is_onboarding", value: properties.epUserIsOnboarding});
  eventPropertiesArray.push({id: "WN7yP-IxTA", name: "platform", value: sysPlatform});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "4t-Z823rBT", "8ba097a34b34ee90d1b547ca307a7dca09263e6f5aac2df497c10d3d07ce08ef", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Telegram UUID Sent", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("4t-Z823rBT", "Telegram UUID Sent", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Telegram UUID Sent", eventProperties, "4t-Z823rBT", "8ba097a34b34ee90d1b547ca307a7dca09263e6f5aac2df497c10d3d07ce08ef");
    }
    // destination Mixpanel
    Mixpanel.logEvent("Telegram UUID Sent", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface OnboardingMinusVerifyEmailViewProperties {
  epUserSubscriptionDuration: number | null | undefined;
  epUserSubscriptionPlan: EpUserSubscriptionPlanValueType;
  epUserSubscriptionIsActive: boolean | null | undefined;
  epUserIsMobileAppUser: boolean | null | undefined;
  epUserIsAdmin: boolean | null | undefined;
  epUserIsTelegramConnected: boolean | null | undefined;
  epUserIsDiscordConnected: boolean | null | undefined;
  epUserFeatureFlags: string[] | null | undefined;
  epUserIsDarkMode: boolean | null | undefined;
  isTelegramMiniApp: boolean | null | undefined;
  botSource: BotSourceValueType | null | undefined;
  onboardingStep: OnboardingStepValueType | null | undefined;
  epUserIsOnboarding: boolean;
}
/**
 * Onboarding - Verify Email View: Triggered when the user views the Verify Email page in the website or app.
 * 
 * @param properties the properties associatied with this event
 * @param properties.epUserSubscriptionDuration: The current subscription duration for the user, in days. Not sent for users with Expired or Trial subscription plans.
 * @param properties.epUserSubscriptionPlan: The current subscription plan for the user. Users without an active subscription should have the value set to Expired.
 * @param properties.epUserSubscriptionIsActive: Set to True if the user has an active subscription (the last subscription expiration date is smaller than the current date).
 * @param properties.epUserIsMobileAppUser: no description
 * @param properties.epUserIsAdmin: no description
 * @param properties.epUserIsTelegramConnected: no description
 * @param properties.epUserIsDiscordConnected: no description
 * @param properties.epUserFeatureFlags: no description
 * @param properties.epUserIsDarkMode: no description
 * @param properties.isTelegramMiniApp: no description
 * @param properties.botSource: Whether the user started the onboarding from the telegram or discord bot.
 * @param properties.onboardingStep: Contain the onboarding step - Email confirmation, Connect exchange, Trading method, Method settings, Overview
 * @param properties.epUserIsOnboarding: Used to track which events happened during onboarding 
 * 
 * @see {@link https://www.avo.app/schemas/Zba2v6MXsSx1EdxPIQKm/events/Gm7JPMiJnz}
 */
export function onboardingVerifyEmailView(properties: OnboardingMinusVerifyEmailViewProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  properties.epUserSubscriptionDuration !== undefined && properties.epUserSubscriptionDuration !== null ?
    eventPropertiesArray.push({id: "BrNPvrBkq", name: "ep_user_subscription_duration", value: properties.epUserSubscriptionDuration}) :
    eventPropertiesArray.push({id: "BrNPvrBkq", name: "ep_user_subscription_duration", value: null});
  eventPropertiesArray.push({id: "Ak0bD3528L", name: "ep_user_subscription_plan", value: properties.epUserSubscriptionPlan});
  properties.epUserSubscriptionIsActive !== undefined && properties.epUserSubscriptionIsActive !== null ?
    eventPropertiesArray.push({id: "P2zcEByfWK", name: "ep_user_subscription_is_active", value: properties.epUserSubscriptionIsActive}) :
    eventPropertiesArray.push({id: "P2zcEByfWK", name: "ep_user_subscription_is_active", value: null});
  properties.epUserIsMobileAppUser !== undefined && properties.epUserIsMobileAppUser !== null ?
    eventPropertiesArray.push({id: "gkaSZCbXw8", name: "ep_user_is_mobile_app_user", value: properties.epUserIsMobileAppUser}) :
    eventPropertiesArray.push({id: "gkaSZCbXw8", name: "ep_user_is_mobile_app_user", value: null});
  properties.epUserIsAdmin !== undefined && properties.epUserIsAdmin !== null ?
    eventPropertiesArray.push({id: "1NHsnnGVd0", name: "ep_user_is_admin", value: properties.epUserIsAdmin}) :
    eventPropertiesArray.push({id: "1NHsnnGVd0", name: "ep_user_is_admin", value: null});
  properties.epUserIsTelegramConnected !== undefined && properties.epUserIsTelegramConnected !== null ?
    eventPropertiesArray.push({id: "QBh1Ik3rEm", name: "ep_user_is_telegram_connected", value: properties.epUserIsTelegramConnected}) :
    eventPropertiesArray.push({id: "QBh1Ik3rEm", name: "ep_user_is_telegram_connected", value: null});
  properties.epUserIsDiscordConnected !== undefined && properties.epUserIsDiscordConnected !== null ?
    eventPropertiesArray.push({id: "Z5anKuo4On", name: "ep_user_is_discord_connected", value: properties.epUserIsDiscordConnected}) :
    eventPropertiesArray.push({id: "Z5anKuo4On", name: "ep_user_is_discord_connected", value: null});
  properties.epUserFeatureFlags !== undefined && properties.epUserFeatureFlags !== null ?
    eventPropertiesArray.push({id: "ZkS2YBJULL", name: "ep_user_feature_flags", value: properties.epUserFeatureFlags}) :
    eventPropertiesArray.push({id: "ZkS2YBJULL", name: "ep_user_feature_flags", value: null});
  properties.epUserIsDarkMode !== undefined && properties.epUserIsDarkMode !== null ?
    eventPropertiesArray.push({id: "pZYzhjQhIW", name: "ep_user_is_dark_mode", value: properties.epUserIsDarkMode}) :
    eventPropertiesArray.push({id: "pZYzhjQhIW", name: "ep_user_is_dark_mode", value: null});
  properties.isTelegramMiniApp !== undefined && properties.isTelegramMiniApp !== null ?
    eventPropertiesArray.push({id: "vh-KiP-5Q", name: "is_telegram_mini_app", value: properties.isTelegramMiniApp}) :
    eventPropertiesArray.push({id: "vh-KiP-5Q", name: "is_telegram_mini_app", value: null});
  properties.botSource !== undefined && properties.botSource !== null ?
    eventPropertiesArray.push({id: "77pb0xYM-Q", name: "bot_source", value: properties.botSource}) :
    eventPropertiesArray.push({id: "77pb0xYM-Q", name: "bot_source", value: null});
  properties.onboardingStep !== undefined && properties.onboardingStep !== null ?
    eventPropertiesArray.push({id: "-sPjCGnFt", name: "onboarding_step", value: properties.onboardingStep}) :
    eventPropertiesArray.push({id: "-sPjCGnFt", name: "onboarding_step", value: null});
  eventPropertiesArray.push({id: "01c5raMTE", name: "ep_user_is_onboarding", value: properties.epUserIsOnboarding});
  eventPropertiesArray.push({id: "WN7yP-IxTA", name: "platform", value: sysPlatform});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "Gm7JPMiJnz", "167a73c9a87812af7a14fb559099908b8b8b3286ba8dde070624185750762d56", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Onboarding - Verify Email View", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("Gm7JPMiJnz", "Onboarding - Verify Email View", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Onboarding - Verify Email View", eventProperties, "Gm7JPMiJnz", "167a73c9a87812af7a14fb559099908b8b8b3286ba8dde070624185750762d56");
    }
    // destination Mixpanel
    Mixpanel.logEvent("Onboarding - Verify Email View", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface RegistrationMinusSendVerifyEmailAgainClickedProperties {
  onboardingStep: OnboardingStepValueType;
  epUserIsOnboarding: boolean;
}
/**
 * Registration - Send Verify Email Again Clicked: The user clicks on the Send Again button to resend the verification email.
 * 
 * @param properties the properties associatied with this event
 * @param properties.onboardingStep: Contain the onboarding step - Email confirmation, Connect exchange, Trading method, Method settings, Overview
 * @param properties.epUserIsOnboarding: Used to track which events happened during onboarding 
 * 
 * @see {@link https://www.avo.app/schemas/Zba2v6MXsSx1EdxPIQKm/events/dNCuEOg47x}
 */
export function registrationSendVerifyEmailAgainClicked(properties: RegistrationMinusSendVerifyEmailAgainClickedProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({id: "-sPjCGnFt", name: "onboarding_step", value: properties.onboardingStep});
  eventPropertiesArray.push({id: "01c5raMTE", name: "ep_user_is_onboarding", value: properties.epUserIsOnboarding});
  eventPropertiesArray.push({id: "WN7yP-IxTA", name: "platform", value: sysPlatform});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "dNCuEOg47x", "cbd5d66579cbff7a33c7945e121acc83113af41e6a75f1594e4e54b6fc4ecfa3", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Registration - Send Verify Email Again Clicked", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("dNCuEOg47x", "Registration - Send Verify Email Again Clicked", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Registration - Send Verify Email Again Clicked", eventProperties, "dNCuEOg47x", "cbd5d66579cbff7a33c7945e121acc83113af41e6a75f1594e4e54b6fc4ecfa3");
    }
    // destination Mixpanel
    Mixpanel.logEvent("Registration - Send Verify Email Again Clicked", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface DashboardViewAppWebProperties {
  epUserSubscriptionDuration: number | null | undefined;
  epUserSubscriptionPlan: EpUserSubscriptionPlanValueType;
  epUserSubscriptionIsActive: boolean | null | undefined;
  epUserIsMobileAppUser: boolean | null | undefined;
  epUserIsAdmin: boolean | null | undefined;
  epUserIsTelegramConnected: boolean | null | undefined;
  epUserIsDiscordConnected: boolean | null | undefined;
  epUserFeatureFlags: string[] | null | undefined;
  epUserIsDarkMode: boolean | null | undefined;
  isTelegramMiniApp: boolean | null | undefined;
}
/**
 * Dashboard View (App & Web): User Clicks to view the Dashboard page.
 * 
 * @param properties the properties associatied with this event
 * @param properties.epUserSubscriptionDuration: The current subscription duration for the user, in days. Not sent for users with Expired or Trial subscription plans.
 * @param properties.epUserSubscriptionPlan: The current subscription plan for the user. Users without an active subscription should have the value set to Expired.
 * @param properties.epUserSubscriptionIsActive: Set to True if the user has an active subscription (the last subscription expiration date is smaller than the current date).
 * @param properties.epUserIsMobileAppUser: no description
 * @param properties.epUserIsAdmin: no description
 * @param properties.epUserIsTelegramConnected: no description
 * @param properties.epUserIsDiscordConnected: no description
 * @param properties.epUserFeatureFlags: no description
 * @param properties.epUserIsDarkMode: no description
 * @param properties.isTelegramMiniApp: no description
 * 
 * @see {@link https://www.avo.app/schemas/Zba2v6MXsSx1EdxPIQKm/events/KQGolChLvn}
 */
export function dashboardViewAppWeb(properties: DashboardViewAppWebProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  properties.epUserSubscriptionDuration !== undefined && properties.epUserSubscriptionDuration !== null ?
    eventPropertiesArray.push({id: "BrNPvrBkq", name: "ep_user_subscription_duration", value: properties.epUserSubscriptionDuration}) :
    eventPropertiesArray.push({id: "BrNPvrBkq", name: "ep_user_subscription_duration", value: null});
  eventPropertiesArray.push({id: "Ak0bD3528L", name: "ep_user_subscription_plan", value: properties.epUserSubscriptionPlan});
  properties.epUserSubscriptionIsActive !== undefined && properties.epUserSubscriptionIsActive !== null ?
    eventPropertiesArray.push({id: "P2zcEByfWK", name: "ep_user_subscription_is_active", value: properties.epUserSubscriptionIsActive}) :
    eventPropertiesArray.push({id: "P2zcEByfWK", name: "ep_user_subscription_is_active", value: null});
  properties.epUserIsMobileAppUser !== undefined && properties.epUserIsMobileAppUser !== null ?
    eventPropertiesArray.push({id: "gkaSZCbXw8", name: "ep_user_is_mobile_app_user", value: properties.epUserIsMobileAppUser}) :
    eventPropertiesArray.push({id: "gkaSZCbXw8", name: "ep_user_is_mobile_app_user", value: null});
  properties.epUserIsAdmin !== undefined && properties.epUserIsAdmin !== null ?
    eventPropertiesArray.push({id: "1NHsnnGVd0", name: "ep_user_is_admin", value: properties.epUserIsAdmin}) :
    eventPropertiesArray.push({id: "1NHsnnGVd0", name: "ep_user_is_admin", value: null});
  properties.epUserIsTelegramConnected !== undefined && properties.epUserIsTelegramConnected !== null ?
    eventPropertiesArray.push({id: "QBh1Ik3rEm", name: "ep_user_is_telegram_connected", value: properties.epUserIsTelegramConnected}) :
    eventPropertiesArray.push({id: "QBh1Ik3rEm", name: "ep_user_is_telegram_connected", value: null});
  properties.epUserIsDiscordConnected !== undefined && properties.epUserIsDiscordConnected !== null ?
    eventPropertiesArray.push({id: "Z5anKuo4On", name: "ep_user_is_discord_connected", value: properties.epUserIsDiscordConnected}) :
    eventPropertiesArray.push({id: "Z5anKuo4On", name: "ep_user_is_discord_connected", value: null});
  properties.epUserFeatureFlags !== undefined && properties.epUserFeatureFlags !== null ?
    eventPropertiesArray.push({id: "ZkS2YBJULL", name: "ep_user_feature_flags", value: properties.epUserFeatureFlags}) :
    eventPropertiesArray.push({id: "ZkS2YBJULL", name: "ep_user_feature_flags", value: null});
  properties.epUserIsDarkMode !== undefined && properties.epUserIsDarkMode !== null ?
    eventPropertiesArray.push({id: "pZYzhjQhIW", name: "ep_user_is_dark_mode", value: properties.epUserIsDarkMode}) :
    eventPropertiesArray.push({id: "pZYzhjQhIW", name: "ep_user_is_dark_mode", value: null});
  properties.isTelegramMiniApp !== undefined && properties.isTelegramMiniApp !== null ?
    eventPropertiesArray.push({id: "vh-KiP-5Q", name: "is_telegram_mini_app", value: properties.isTelegramMiniApp}) :
    eventPropertiesArray.push({id: "vh-KiP-5Q", name: "is_telegram_mini_app", value: null});
  eventPropertiesArray.push({id: "WN7yP-IxTA", name: "platform", value: sysPlatform});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "KQGolChLvn", "45e08229225311282b9bff3224fdc8ead9f8d04f2d0ff8edffcd9df4227d76e9", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Dashboard View (App & Web)", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("KQGolChLvn", "Dashboard View (App & Web)", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Dashboard View (App & Web)", eventProperties, "KQGolChLvn", "45e08229225311282b9bff3224fdc8ead9f8d04f2d0ff8edffcd9df4227d76e9");
    }
    // destination Mixpanel
    Mixpanel.logEvent("Dashboard View (App & Web)", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface MarketplaceViewProperties {
  epUserSubscriptionDuration: number | null | undefined;
  epUserSubscriptionPlan: EpUserSubscriptionPlanValueType | null | undefined;
  epUserSubscriptionIsActive: boolean | null | undefined;
  epUserIsMobileAppUser: boolean | null | undefined;
  epUserIsAdmin: boolean | null | undefined;
  epUserIsTelegramConnected: boolean | null | undefined;
  epUserIsDiscordConnected: boolean | null | undefined;
  epUserFeatureFlags: string[] | null | undefined;
  epUserIsDarkMode: boolean | null | undefined;
  isTelegramMiniApp: boolean | null | undefined;
}
/**
 * Marketplace View: Previously 'Marketplace - All Tab View (App)'
User views the All groups tab in the Marketplace section.
 * 
 * @param properties the properties associatied with this event
 * @param properties.epUserSubscriptionDuration: The current subscription duration for the user, in days. Not sent for users with Expired or Trial subscription plans.
 * @param properties.epUserSubscriptionPlan: The current subscription plan for the user. Users without an active subscription should have the value set to Expired.
 * @param properties.epUserSubscriptionIsActive: Set to True if the user has an active subscription (the last subscription expiration date is smaller than the current date).
 * @param properties.epUserIsMobileAppUser: no description
 * @param properties.epUserIsAdmin: no description
 * @param properties.epUserIsTelegramConnected: no description
 * @param properties.epUserIsDiscordConnected: no description
 * @param properties.epUserFeatureFlags: no description
 * @param properties.epUserIsDarkMode: no description
 * @param properties.isTelegramMiniApp: no description
 * 
 * @see {@link https://www.avo.app/schemas/Zba2v6MXsSx1EdxPIQKm/events/mkN6ltyUu0}
 */
export function marketplaceView(properties: MarketplaceViewProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  properties.epUserSubscriptionDuration !== undefined && properties.epUserSubscriptionDuration !== null ?
    eventPropertiesArray.push({id: "BrNPvrBkq", name: "ep_user_subscription_duration", value: properties.epUserSubscriptionDuration}) :
    eventPropertiesArray.push({id: "BrNPvrBkq", name: "ep_user_subscription_duration", value: null});
  properties.epUserSubscriptionPlan !== undefined && properties.epUserSubscriptionPlan !== null ?
    eventPropertiesArray.push({id: "Ak0bD3528L", name: "ep_user_subscription_plan", value: properties.epUserSubscriptionPlan}) :
    eventPropertiesArray.push({id: "Ak0bD3528L", name: "ep_user_subscription_plan", value: null});
  properties.epUserSubscriptionIsActive !== undefined && properties.epUserSubscriptionIsActive !== null ?
    eventPropertiesArray.push({id: "P2zcEByfWK", name: "ep_user_subscription_is_active", value: properties.epUserSubscriptionIsActive}) :
    eventPropertiesArray.push({id: "P2zcEByfWK", name: "ep_user_subscription_is_active", value: null});
  properties.epUserIsMobileAppUser !== undefined && properties.epUserIsMobileAppUser !== null ?
    eventPropertiesArray.push({id: "gkaSZCbXw8", name: "ep_user_is_mobile_app_user", value: properties.epUserIsMobileAppUser}) :
    eventPropertiesArray.push({id: "gkaSZCbXw8", name: "ep_user_is_mobile_app_user", value: null});
  properties.epUserIsAdmin !== undefined && properties.epUserIsAdmin !== null ?
    eventPropertiesArray.push({id: "1NHsnnGVd0", name: "ep_user_is_admin", value: properties.epUserIsAdmin}) :
    eventPropertiesArray.push({id: "1NHsnnGVd0", name: "ep_user_is_admin", value: null});
  properties.epUserIsTelegramConnected !== undefined && properties.epUserIsTelegramConnected !== null ?
    eventPropertiesArray.push({id: "QBh1Ik3rEm", name: "ep_user_is_telegram_connected", value: properties.epUserIsTelegramConnected}) :
    eventPropertiesArray.push({id: "QBh1Ik3rEm", name: "ep_user_is_telegram_connected", value: null});
  properties.epUserIsDiscordConnected !== undefined && properties.epUserIsDiscordConnected !== null ?
    eventPropertiesArray.push({id: "Z5anKuo4On", name: "ep_user_is_discord_connected", value: properties.epUserIsDiscordConnected}) :
    eventPropertiesArray.push({id: "Z5anKuo4On", name: "ep_user_is_discord_connected", value: null});
  properties.epUserFeatureFlags !== undefined && properties.epUserFeatureFlags !== null ?
    eventPropertiesArray.push({id: "ZkS2YBJULL", name: "ep_user_feature_flags", value: properties.epUserFeatureFlags}) :
    eventPropertiesArray.push({id: "ZkS2YBJULL", name: "ep_user_feature_flags", value: null});
  properties.epUserIsDarkMode !== undefined && properties.epUserIsDarkMode !== null ?
    eventPropertiesArray.push({id: "pZYzhjQhIW", name: "ep_user_is_dark_mode", value: properties.epUserIsDarkMode}) :
    eventPropertiesArray.push({id: "pZYzhjQhIW", name: "ep_user_is_dark_mode", value: null});
  properties.isTelegramMiniApp !== undefined && properties.isTelegramMiniApp !== null ?
    eventPropertiesArray.push({id: "vh-KiP-5Q", name: "is_telegram_mini_app", value: properties.isTelegramMiniApp}) :
    eventPropertiesArray.push({id: "vh-KiP-5Q", name: "is_telegram_mini_app", value: null});
  eventPropertiesArray.push({id: "WN7yP-IxTA", name: "platform", value: sysPlatform});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "mkN6ltyUu0", "67e6ef27ed94afea20825abfbb854aed7367515b5a829d5fc866c877c7996dba", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Marketplace View", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("mkN6ltyUu0", "Marketplace View", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Marketplace View", eventProperties, "mkN6ltyUu0", "67e6ef27ed94afea20825abfbb854aed7367515b5a829d5fc866c877c7996dba");
    }
    // destination Mixpanel
    Mixpanel.logEvent("Marketplace View", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface MarketplaceMinusGroupClickedProperties {
  marketplaceGroupAverageRating: number;
  marketplaceGroupPagePosition: number | null | undefined;
  marketplaceGroupReviewsCount: number;
  marketplaceGroupDiscountOffered: number;
  marketplaceGroupOffersFreeTrial: boolean;
  marketplaceGroupDollarSignsCount: number;
  marketplaceGroupId: number;
  epUserSubscriptionDuration: number | null | undefined;
  epUserSubscriptionPlan: EpUserSubscriptionPlanValueType | null | undefined;
  epUserSubscriptionIsActive: boolean | null | undefined;
  epUserIsMobileAppUser: boolean | null | undefined;
  epUserIsAdmin: boolean | null | undefined;
  epUserIsTelegramConnected: boolean | null | undefined;
  epUserIsDiscordConnected: boolean | null | undefined;
  epUserFeatureFlags: string[] | null | undefined;
  epUserIsDarkMode: boolean | null | undefined;
  isTelegramMiniApp: boolean | null | undefined;
}
/**
 * Marketplace - Group Clicked: Previously: 'Marketplace - Group Clicked (App)'
User clicks on one of the groups in the marketplace.
 * 
 * @param properties the properties associatied with this event
 * @param properties.marketplaceGroupAverageRating: The average rating for the group.
 * @param properties.marketplaceGroupPagePosition: The position of the group in the page. The group on the first row on the left, the right is 2, second row left is 3 etc.
 * @param properties.marketplaceGroupReviewsCount: Number of reviews the group has.
 * @param properties.marketplaceGroupDiscountOffered: The discount percent the group offers.
 * @param properties.marketplaceGroupOffersFreeTrial: True if the group offers free trial.
 * @param properties.marketplaceGroupDollarSignsCount: The number of dollar signs displayed on the group that indicates the relative price.
 * @param properties.marketplaceGroupId: The relevant group_id coming from the backend
 * @param properties.epUserSubscriptionDuration: The current subscription duration for the user, in days. Not sent for users with Expired or Trial subscription plans.
 * @param properties.epUserSubscriptionPlan: The current subscription plan for the user. Users without an active subscription should have the value set to Expired.
 * @param properties.epUserSubscriptionIsActive: Set to True if the user has an active subscription (the last subscription expiration date is smaller than the current date).
 * @param properties.epUserIsMobileAppUser: no description
 * @param properties.epUserIsAdmin: no description
 * @param properties.epUserIsTelegramConnected: no description
 * @param properties.epUserIsDiscordConnected: no description
 * @param properties.epUserFeatureFlags: no description
 * @param properties.epUserIsDarkMode: no description
 * @param properties.isTelegramMiniApp: no description
 * 
 * @see {@link https://www.avo.app/schemas/Zba2v6MXsSx1EdxPIQKm/events/_sZ6mc-Yme}
 */
export function marketplaceGroupClicked(properties: MarketplaceMinusGroupClickedProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({id: "VXcPd2LRRq", name: "marketplace_group_average_rating", value: properties.marketplaceGroupAverageRating});
  properties.marketplaceGroupPagePosition !== undefined && properties.marketplaceGroupPagePosition !== null ?
    eventPropertiesArray.push({id: "dwPshDL5Rt", name: "marketplace_group_page_position", value: properties.marketplaceGroupPagePosition}) :
    eventPropertiesArray.push({id: "dwPshDL5Rt", name: "marketplace_group_page_position", value: null});
  eventPropertiesArray.push({id: "wv18eC5VWO", name: "marketplace_group_reviews_count", value: properties.marketplaceGroupReviewsCount});
  eventPropertiesArray.push({id: "jghmGWrdRr", name: "marketplace_group_discount_offered", value: properties.marketplaceGroupDiscountOffered});
  eventPropertiesArray.push({id: "DSQiHZlxb2", name: "marketplace_group_offers_free_trial", value: properties.marketplaceGroupOffersFreeTrial});
  eventPropertiesArray.push({id: "VCZL8ehjXn", name: "marketplace_group_dollar_signs_count", value: properties.marketplaceGroupDollarSignsCount});
  eventPropertiesArray.push({id: "y40_UtBI0", name: "marketplace_group_id", value: properties.marketplaceGroupId});
  properties.epUserSubscriptionDuration !== undefined && properties.epUserSubscriptionDuration !== null ?
    eventPropertiesArray.push({id: "BrNPvrBkq", name: "ep_user_subscription_duration", value: properties.epUserSubscriptionDuration}) :
    eventPropertiesArray.push({id: "BrNPvrBkq", name: "ep_user_subscription_duration", value: null});
  properties.epUserSubscriptionPlan !== undefined && properties.epUserSubscriptionPlan !== null ?
    eventPropertiesArray.push({id: "Ak0bD3528L", name: "ep_user_subscription_plan", value: properties.epUserSubscriptionPlan}) :
    eventPropertiesArray.push({id: "Ak0bD3528L", name: "ep_user_subscription_plan", value: null});
  properties.epUserSubscriptionIsActive !== undefined && properties.epUserSubscriptionIsActive !== null ?
    eventPropertiesArray.push({id: "P2zcEByfWK", name: "ep_user_subscription_is_active", value: properties.epUserSubscriptionIsActive}) :
    eventPropertiesArray.push({id: "P2zcEByfWK", name: "ep_user_subscription_is_active", value: null});
  properties.epUserIsMobileAppUser !== undefined && properties.epUserIsMobileAppUser !== null ?
    eventPropertiesArray.push({id: "gkaSZCbXw8", name: "ep_user_is_mobile_app_user", value: properties.epUserIsMobileAppUser}) :
    eventPropertiesArray.push({id: "gkaSZCbXw8", name: "ep_user_is_mobile_app_user", value: null});
  properties.epUserIsAdmin !== undefined && properties.epUserIsAdmin !== null ?
    eventPropertiesArray.push({id: "1NHsnnGVd0", name: "ep_user_is_admin", value: properties.epUserIsAdmin}) :
    eventPropertiesArray.push({id: "1NHsnnGVd0", name: "ep_user_is_admin", value: null});
  properties.epUserIsTelegramConnected !== undefined && properties.epUserIsTelegramConnected !== null ?
    eventPropertiesArray.push({id: "QBh1Ik3rEm", name: "ep_user_is_telegram_connected", value: properties.epUserIsTelegramConnected}) :
    eventPropertiesArray.push({id: "QBh1Ik3rEm", name: "ep_user_is_telegram_connected", value: null});
  properties.epUserIsDiscordConnected !== undefined && properties.epUserIsDiscordConnected !== null ?
    eventPropertiesArray.push({id: "Z5anKuo4On", name: "ep_user_is_discord_connected", value: properties.epUserIsDiscordConnected}) :
    eventPropertiesArray.push({id: "Z5anKuo4On", name: "ep_user_is_discord_connected", value: null});
  properties.epUserFeatureFlags !== undefined && properties.epUserFeatureFlags !== null ?
    eventPropertiesArray.push({id: "ZkS2YBJULL", name: "ep_user_feature_flags", value: properties.epUserFeatureFlags}) :
    eventPropertiesArray.push({id: "ZkS2YBJULL", name: "ep_user_feature_flags", value: null});
  properties.epUserIsDarkMode !== undefined && properties.epUserIsDarkMode !== null ?
    eventPropertiesArray.push({id: "pZYzhjQhIW", name: "ep_user_is_dark_mode", value: properties.epUserIsDarkMode}) :
    eventPropertiesArray.push({id: "pZYzhjQhIW", name: "ep_user_is_dark_mode", value: null});
  properties.isTelegramMiniApp !== undefined && properties.isTelegramMiniApp !== null ?
    eventPropertiesArray.push({id: "vh-KiP-5Q", name: "is_telegram_mini_app", value: properties.isTelegramMiniApp}) :
    eventPropertiesArray.push({id: "vh-KiP-5Q", name: "is_telegram_mini_app", value: null});
  eventPropertiesArray.push({id: "WN7yP-IxTA", name: "platform", value: sysPlatform});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "_sZ6mc-Yme", "34792262b0ad808a2e943486ae0eb9ccbcd1abd013edb6d5b7336aa27f22757a", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Marketplace - Group Clicked", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("_sZ6mc-Yme", "Marketplace - Group Clicked", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Marketplace - Group Clicked", eventProperties, "_sZ6mc-Yme", "34792262b0ad808a2e943486ae0eb9ccbcd1abd013edb6d5b7336aa27f22757a");
    }
    // destination Mixpanel
    Mixpanel.logEvent("Marketplace - Group Clicked", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface MarketplaceGroupMinusJoinGroupClickedProperties {
  marketplaceGroupAverageRating: number;
  marketplaceGroupPagePosition: number | null | undefined;
  marketplaceGroupReviewsCount: number;
  marketplaceGroupDiscountOffered: number;
  marketplaceGroupOffersFreeTrial: boolean;
  marketplaceGroupDollarSignsCount: number;
  marketplaceGroupId: number;
  epUserSubscriptionDuration: number | null | undefined;
  epUserSubscriptionPlan: EpUserSubscriptionPlanValueType | null | undefined;
  epUserSubscriptionIsActive: boolean | null | undefined;
  epUserIsMobileAppUser: boolean | null | undefined;
  epUserIsAdmin: boolean | null | undefined;
  epUserIsTelegramConnected: boolean | null | undefined;
  epUserIsDiscordConnected: boolean | null | undefined;
  epUserFeatureFlags: string[] | null | undefined;
  epUserIsDarkMode: boolean | null | undefined;
  isTelegramMiniApp: boolean | null | undefined;
}
/**
 * Marketplace Group - Join Group Clicked: Previously: 'Marketplace Group - Join Group Clicked (App)' 
User clicks on the button that says "Join Group" in the marketplace group page / group drawer on website.
 * 
 * @param properties the properties associatied with this event
 * @param properties.marketplaceGroupAverageRating: The average rating for the group.
 * @param properties.marketplaceGroupPagePosition: The position of the group in the page. The group on the first row on the left, the right is 2, second row left is 3 etc.
 * @param properties.marketplaceGroupReviewsCount: Number of reviews the group has.
 * @param properties.marketplaceGroupDiscountOffered: The discount percent the group offers.
 * @param properties.marketplaceGroupOffersFreeTrial: True if the group offers free trial.
 * @param properties.marketplaceGroupDollarSignsCount: The number of dollar signs displayed on the group that indicates the relative price.
 * @param properties.marketplaceGroupId: The relevant group_id coming from the backend
 * @param properties.epUserSubscriptionDuration: The current subscription duration for the user, in days. Not sent for users with Expired or Trial subscription plans.
 * @param properties.epUserSubscriptionPlan: The current subscription plan for the user. Users without an active subscription should have the value set to Expired.
 * @param properties.epUserSubscriptionIsActive: Set to True if the user has an active subscription (the last subscription expiration date is smaller than the current date).
 * @param properties.epUserIsMobileAppUser: no description
 * @param properties.epUserIsAdmin: no description
 * @param properties.epUserIsTelegramConnected: no description
 * @param properties.epUserIsDiscordConnected: no description
 * @param properties.epUserFeatureFlags: no description
 * @param properties.epUserIsDarkMode: no description
 * @param properties.isTelegramMiniApp: no description
 * 
 * @see {@link https://www.avo.app/schemas/Zba2v6MXsSx1EdxPIQKm/events/Wlrmw9wY2i}
 */
export function marketplaceGroupJoinGroupClicked(properties: MarketplaceGroupMinusJoinGroupClickedProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({id: "VXcPd2LRRq", name: "marketplace_group_average_rating", value: properties.marketplaceGroupAverageRating});
  properties.marketplaceGroupPagePosition !== undefined && properties.marketplaceGroupPagePosition !== null ?
    eventPropertiesArray.push({id: "dwPshDL5Rt", name: "marketplace_group_page_position", value: properties.marketplaceGroupPagePosition}) :
    eventPropertiesArray.push({id: "dwPshDL5Rt", name: "marketplace_group_page_position", value: null});
  eventPropertiesArray.push({id: "wv18eC5VWO", name: "marketplace_group_reviews_count", value: properties.marketplaceGroupReviewsCount});
  eventPropertiesArray.push({id: "jghmGWrdRr", name: "marketplace_group_discount_offered", value: properties.marketplaceGroupDiscountOffered});
  eventPropertiesArray.push({id: "DSQiHZlxb2", name: "marketplace_group_offers_free_trial", value: properties.marketplaceGroupOffersFreeTrial});
  eventPropertiesArray.push({id: "VCZL8ehjXn", name: "marketplace_group_dollar_signs_count", value: properties.marketplaceGroupDollarSignsCount});
  eventPropertiesArray.push({id: "y40_UtBI0", name: "marketplace_group_id", value: properties.marketplaceGroupId});
  properties.epUserSubscriptionDuration !== undefined && properties.epUserSubscriptionDuration !== null ?
    eventPropertiesArray.push({id: "BrNPvrBkq", name: "ep_user_subscription_duration", value: properties.epUserSubscriptionDuration}) :
    eventPropertiesArray.push({id: "BrNPvrBkq", name: "ep_user_subscription_duration", value: null});
  properties.epUserSubscriptionPlan !== undefined && properties.epUserSubscriptionPlan !== null ?
    eventPropertiesArray.push({id: "Ak0bD3528L", name: "ep_user_subscription_plan", value: properties.epUserSubscriptionPlan}) :
    eventPropertiesArray.push({id: "Ak0bD3528L", name: "ep_user_subscription_plan", value: null});
  properties.epUserSubscriptionIsActive !== undefined && properties.epUserSubscriptionIsActive !== null ?
    eventPropertiesArray.push({id: "P2zcEByfWK", name: "ep_user_subscription_is_active", value: properties.epUserSubscriptionIsActive}) :
    eventPropertiesArray.push({id: "P2zcEByfWK", name: "ep_user_subscription_is_active", value: null});
  properties.epUserIsMobileAppUser !== undefined && properties.epUserIsMobileAppUser !== null ?
    eventPropertiesArray.push({id: "gkaSZCbXw8", name: "ep_user_is_mobile_app_user", value: properties.epUserIsMobileAppUser}) :
    eventPropertiesArray.push({id: "gkaSZCbXw8", name: "ep_user_is_mobile_app_user", value: null});
  properties.epUserIsAdmin !== undefined && properties.epUserIsAdmin !== null ?
    eventPropertiesArray.push({id: "1NHsnnGVd0", name: "ep_user_is_admin", value: properties.epUserIsAdmin}) :
    eventPropertiesArray.push({id: "1NHsnnGVd0", name: "ep_user_is_admin", value: null});
  properties.epUserIsTelegramConnected !== undefined && properties.epUserIsTelegramConnected !== null ?
    eventPropertiesArray.push({id: "QBh1Ik3rEm", name: "ep_user_is_telegram_connected", value: properties.epUserIsTelegramConnected}) :
    eventPropertiesArray.push({id: "QBh1Ik3rEm", name: "ep_user_is_telegram_connected", value: null});
  properties.epUserIsDiscordConnected !== undefined && properties.epUserIsDiscordConnected !== null ?
    eventPropertiesArray.push({id: "Z5anKuo4On", name: "ep_user_is_discord_connected", value: properties.epUserIsDiscordConnected}) :
    eventPropertiesArray.push({id: "Z5anKuo4On", name: "ep_user_is_discord_connected", value: null});
  properties.epUserFeatureFlags !== undefined && properties.epUserFeatureFlags !== null ?
    eventPropertiesArray.push({id: "ZkS2YBJULL", name: "ep_user_feature_flags", value: properties.epUserFeatureFlags}) :
    eventPropertiesArray.push({id: "ZkS2YBJULL", name: "ep_user_feature_flags", value: null});
  properties.epUserIsDarkMode !== undefined && properties.epUserIsDarkMode !== null ?
    eventPropertiesArray.push({id: "pZYzhjQhIW", name: "ep_user_is_dark_mode", value: properties.epUserIsDarkMode}) :
    eventPropertiesArray.push({id: "pZYzhjQhIW", name: "ep_user_is_dark_mode", value: null});
  properties.isTelegramMiniApp !== undefined && properties.isTelegramMiniApp !== null ?
    eventPropertiesArray.push({id: "vh-KiP-5Q", name: "is_telegram_mini_app", value: properties.isTelegramMiniApp}) :
    eventPropertiesArray.push({id: "vh-KiP-5Q", name: "is_telegram_mini_app", value: null});
  eventPropertiesArray.push({id: "WN7yP-IxTA", name: "platform", value: sysPlatform});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "Wlrmw9wY2i", "70a2a7765e482db6f6ed969f1833412f1edaaeaeb09c80d2bda7736ba69849aa", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Marketplace Group - Join Group Clicked", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("Wlrmw9wY2i", "Marketplace Group - Join Group Clicked", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Marketplace Group - Join Group Clicked", eventProperties, "Wlrmw9wY2i", "70a2a7765e482db6f6ed969f1833412f1edaaeaeb09c80d2bda7736ba69849aa");
    }
    // destination Mixpanel
    Mixpanel.logEvent("Marketplace Group - Join Group Clicked", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface OpenTradesViewProperties {
  epUserSubscriptionDuration: number | null | undefined;
  epUserSubscriptionPlan: EpUserSubscriptionPlanValueType | null | undefined;
  epUserSubscriptionIsActive: boolean | null | undefined;
  epUserIsMobileAppUser: boolean | null | undefined;
  epUserIsAdmin: boolean | null | undefined;
  epUserIsTelegramConnected: boolean | null | undefined;
  epUserIsDiscordConnected: boolean | null | undefined;
  epUserFeatureFlags: string[] | null | undefined;
  epUserIsDarkMode: boolean | null | undefined;
  isTelegramMiniApp: boolean | null | undefined;
  epUserTotalAutoTradingGroupsCount: number | null | undefined;
  epUserTotalAutoTradingGroupsNames: string[] | null | undefined;
  epUserCurrentAutoTradingGroupsCount: number | null | undefined;
  epUserCurrentAutoTradingGroupsNames: string[] | null | undefined;
  epUserGroupsCount: number | null | undefined;
  epUserGroupsNames: string[] | null | undefined;
}
/**
 * Open Trades View: Previously: "Trades View (App)"
User views the open trades page on the app (filtered on opened - default), website or bot.
 * 
 * @param properties the properties associatied with this event
 * @param properties.epUserSubscriptionDuration: The current subscription duration for the user, in days. Not sent for users with Expired or Trial subscription plans.
 * @param properties.epUserSubscriptionPlan: The current subscription plan for the user. Users without an active subscription should have the value set to Expired.
 * @param properties.epUserSubscriptionIsActive: Set to True if the user has an active subscription (the last subscription expiration date is smaller than the current date).
 * @param properties.epUserIsMobileAppUser: no description
 * @param properties.epUserIsAdmin: no description
 * @param properties.epUserIsTelegramConnected: no description
 * @param properties.epUserIsDiscordConnected: no description
 * @param properties.epUserFeatureFlags: no description
 * @param properties.epUserIsDarkMode: no description
 * @param properties.isTelegramMiniApp: no description
 * @param properties.epUserTotalAutoTradingGroupsCount: The total number of groups the user has ever had connected with auto-trading to any client.
 * @param properties.epUserTotalAutoTradingGroupsNames: The names of the groups that the user has ever had connected with auto-trading to any client.
 * @param properties.epUserCurrentAutoTradingGroupsCount: The number of groups the user currently has connected with auto-trading to an active client. This number represents the number of groups the user is actively following and trading based on. This does not include groups that are connected to clients that have auto-trading disabled.
 * @param properties.epUserCurrentAutoTradingGroupsNames: The names list of the groups the user currently has connected with auto-trading to an active client. This list represents the names of groups the user is actively following and trading based on. This does not include groups that are connected to clients that have auto-trading disabled.
 * @param properties.epUserGroupsCount: The number of Telegram channels the user is currently a member of.
 * @param properties.epUserGroupsNames: The names list of Telegram channels the user is currently a member of.
 * 
 * @see {@link https://www.avo.app/schemas/Zba2v6MXsSx1EdxPIQKm/events/2zC5DzRsb}
 */
export function openTradesView(properties: OpenTradesViewProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  properties.epUserSubscriptionDuration !== undefined && properties.epUserSubscriptionDuration !== null ?
    eventPropertiesArray.push({id: "BrNPvrBkq", name: "ep_user_subscription_duration", value: properties.epUserSubscriptionDuration}) :
    eventPropertiesArray.push({id: "BrNPvrBkq", name: "ep_user_subscription_duration", value: null});
  properties.epUserSubscriptionPlan !== undefined && properties.epUserSubscriptionPlan !== null ?
    eventPropertiesArray.push({id: "Ak0bD3528L", name: "ep_user_subscription_plan", value: properties.epUserSubscriptionPlan}) :
    eventPropertiesArray.push({id: "Ak0bD3528L", name: "ep_user_subscription_plan", value: null});
  properties.epUserSubscriptionIsActive !== undefined && properties.epUserSubscriptionIsActive !== null ?
    eventPropertiesArray.push({id: "P2zcEByfWK", name: "ep_user_subscription_is_active", value: properties.epUserSubscriptionIsActive}) :
    eventPropertiesArray.push({id: "P2zcEByfWK", name: "ep_user_subscription_is_active", value: null});
  properties.epUserIsMobileAppUser !== undefined && properties.epUserIsMobileAppUser !== null ?
    eventPropertiesArray.push({id: "gkaSZCbXw8", name: "ep_user_is_mobile_app_user", value: properties.epUserIsMobileAppUser}) :
    eventPropertiesArray.push({id: "gkaSZCbXw8", name: "ep_user_is_mobile_app_user", value: null});
  properties.epUserIsAdmin !== undefined && properties.epUserIsAdmin !== null ?
    eventPropertiesArray.push({id: "1NHsnnGVd0", name: "ep_user_is_admin", value: properties.epUserIsAdmin}) :
    eventPropertiesArray.push({id: "1NHsnnGVd0", name: "ep_user_is_admin", value: null});
  properties.epUserIsTelegramConnected !== undefined && properties.epUserIsTelegramConnected !== null ?
    eventPropertiesArray.push({id: "QBh1Ik3rEm", name: "ep_user_is_telegram_connected", value: properties.epUserIsTelegramConnected}) :
    eventPropertiesArray.push({id: "QBh1Ik3rEm", name: "ep_user_is_telegram_connected", value: null});
  properties.epUserIsDiscordConnected !== undefined && properties.epUserIsDiscordConnected !== null ?
    eventPropertiesArray.push({id: "Z5anKuo4On", name: "ep_user_is_discord_connected", value: properties.epUserIsDiscordConnected}) :
    eventPropertiesArray.push({id: "Z5anKuo4On", name: "ep_user_is_discord_connected", value: null});
  properties.epUserFeatureFlags !== undefined && properties.epUserFeatureFlags !== null ?
    eventPropertiesArray.push({id: "ZkS2YBJULL", name: "ep_user_feature_flags", value: properties.epUserFeatureFlags}) :
    eventPropertiesArray.push({id: "ZkS2YBJULL", name: "ep_user_feature_flags", value: null});
  properties.epUserIsDarkMode !== undefined && properties.epUserIsDarkMode !== null ?
    eventPropertiesArray.push({id: "pZYzhjQhIW", name: "ep_user_is_dark_mode", value: properties.epUserIsDarkMode}) :
    eventPropertiesArray.push({id: "pZYzhjQhIW", name: "ep_user_is_dark_mode", value: null});
  properties.isTelegramMiniApp !== undefined && properties.isTelegramMiniApp !== null ?
    eventPropertiesArray.push({id: "vh-KiP-5Q", name: "is_telegram_mini_app", value: properties.isTelegramMiniApp}) :
    eventPropertiesArray.push({id: "vh-KiP-5Q", name: "is_telegram_mini_app", value: null});
  properties.epUserTotalAutoTradingGroupsCount !== undefined && properties.epUserTotalAutoTradingGroupsCount !== null ?
    eventPropertiesArray.push({id: "F33-9bIqF0", name: "ep_user_total_auto_trading_groups_count", value: properties.epUserTotalAutoTradingGroupsCount}) :
    eventPropertiesArray.push({id: "F33-9bIqF0", name: "ep_user_total_auto_trading_groups_count", value: null});
  properties.epUserTotalAutoTradingGroupsNames !== undefined && properties.epUserTotalAutoTradingGroupsNames !== null ?
    eventPropertiesArray.push({id: "VxrddG5osk", name: "ep_user_total_auto_trading_groups_names", value: properties.epUserTotalAutoTradingGroupsNames}) :
    eventPropertiesArray.push({id: "VxrddG5osk", name: "ep_user_total_auto_trading_groups_names", value: null});
  properties.epUserCurrentAutoTradingGroupsCount !== undefined && properties.epUserCurrentAutoTradingGroupsCount !== null ?
    eventPropertiesArray.push({id: "PrQVf8bCQZ", name: "ep_user_current_auto_trading_groups_count", value: properties.epUserCurrentAutoTradingGroupsCount}) :
    eventPropertiesArray.push({id: "PrQVf8bCQZ", name: "ep_user_current_auto_trading_groups_count", value: null});
  properties.epUserCurrentAutoTradingGroupsNames !== undefined && properties.epUserCurrentAutoTradingGroupsNames !== null ?
    eventPropertiesArray.push({id: "S44gtOE_4c", name: "ep_user_current_auto_trading_groups_names", value: properties.epUserCurrentAutoTradingGroupsNames}) :
    eventPropertiesArray.push({id: "S44gtOE_4c", name: "ep_user_current_auto_trading_groups_names", value: null});
  properties.epUserGroupsCount !== undefined && properties.epUserGroupsCount !== null ?
    eventPropertiesArray.push({id: "Daij3OzuMn", name: "ep_user_groups_count", value: properties.epUserGroupsCount}) :
    eventPropertiesArray.push({id: "Daij3OzuMn", name: "ep_user_groups_count", value: null});
  properties.epUserGroupsNames !== undefined && properties.epUserGroupsNames !== null ?
    eventPropertiesArray.push({id: "skk1UTP7Cq", name: "ep_user_groups_names", value: properties.epUserGroupsNames}) :
    eventPropertiesArray.push({id: "skk1UTP7Cq", name: "ep_user_groups_names", value: null});
  eventPropertiesArray.push({id: "WN7yP-IxTA", name: "platform", value: sysPlatform});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "2zC5DzRsb", "e9b7ab05294d6f207a2e28c2b506b5c39f73279c69096a7067419a594b8a31c4", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Open Trades View", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("2zC5DzRsb", "Open Trades View", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Open Trades View", eventProperties, "2zC5DzRsb", "e9b7ab05294d6f207a2e28c2b506b5c39f73279c69096a7067419a594b8a31c4");
    }
    // destination Mixpanel
    Mixpanel.logEvent("Open Trades View", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface CreateAccountViewProperties {
  epUserSubscriptionDuration: number | null | undefined;
  epUserSubscriptionPlan: EpUserSubscriptionPlanValueType;
  epUserSubscriptionIsActive: boolean | null | undefined;
  epUserIsMobileAppUser: boolean | null | undefined;
  epUserIsAdmin: boolean | null | undefined;
  epUserIsTelegramConnected: boolean | null | undefined;
  epUserIsDiscordConnected: boolean | null | undefined;
  epUserFeatureFlags: string[] | null | undefined;
  epUserIsDarkMode: boolean | null | undefined;
  isTelegramMiniApp: boolean | null | undefined;
  epUserIsOnboarding: boolean;
  botSource: BotSourceValueType | null | undefined;
}
/**
 * Create Account View: Users view the screen which allows them to create a new account.
 * 
 * @param properties the properties associatied with this event
 * @param properties.epUserSubscriptionDuration: The current subscription duration for the user, in days. Not sent for users with Expired or Trial subscription plans.
 * @param properties.epUserSubscriptionPlan: The current subscription plan for the user. Users without an active subscription should have the value set to Expired.
 * @param properties.epUserSubscriptionIsActive: Set to True if the user has an active subscription (the last subscription expiration date is smaller than the current date).
 * @param properties.epUserIsMobileAppUser: no description
 * @param properties.epUserIsAdmin: no description
 * @param properties.epUserIsTelegramConnected: no description
 * @param properties.epUserIsDiscordConnected: no description
 * @param properties.epUserFeatureFlags: no description
 * @param properties.epUserIsDarkMode: no description
 * @param properties.isTelegramMiniApp: no description
 * @param properties.epUserIsOnboarding: Used to track which events happened during onboarding 
 * @param properties.botSource: Whether the user started the onboarding from the telegram or discord bot.
 * 
 * @see {@link https://www.avo.app/schemas/Zba2v6MXsSx1EdxPIQKm/events/UKmUJFxu-B}
 */
export function createAccountView(properties: CreateAccountViewProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  properties.epUserSubscriptionDuration !== undefined && properties.epUserSubscriptionDuration !== null ?
    eventPropertiesArray.push({id: "BrNPvrBkq", name: "ep_user_subscription_duration", value: properties.epUserSubscriptionDuration}) :
    eventPropertiesArray.push({id: "BrNPvrBkq", name: "ep_user_subscription_duration", value: null});
  eventPropertiesArray.push({id: "Ak0bD3528L", name: "ep_user_subscription_plan", value: properties.epUserSubscriptionPlan});
  properties.epUserSubscriptionIsActive !== undefined && properties.epUserSubscriptionIsActive !== null ?
    eventPropertiesArray.push({id: "P2zcEByfWK", name: "ep_user_subscription_is_active", value: properties.epUserSubscriptionIsActive}) :
    eventPropertiesArray.push({id: "P2zcEByfWK", name: "ep_user_subscription_is_active", value: null});
  properties.epUserIsMobileAppUser !== undefined && properties.epUserIsMobileAppUser !== null ?
    eventPropertiesArray.push({id: "gkaSZCbXw8", name: "ep_user_is_mobile_app_user", value: properties.epUserIsMobileAppUser}) :
    eventPropertiesArray.push({id: "gkaSZCbXw8", name: "ep_user_is_mobile_app_user", value: null});
  properties.epUserIsAdmin !== undefined && properties.epUserIsAdmin !== null ?
    eventPropertiesArray.push({id: "1NHsnnGVd0", name: "ep_user_is_admin", value: properties.epUserIsAdmin}) :
    eventPropertiesArray.push({id: "1NHsnnGVd0", name: "ep_user_is_admin", value: null});
  properties.epUserIsTelegramConnected !== undefined && properties.epUserIsTelegramConnected !== null ?
    eventPropertiesArray.push({id: "QBh1Ik3rEm", name: "ep_user_is_telegram_connected", value: properties.epUserIsTelegramConnected}) :
    eventPropertiesArray.push({id: "QBh1Ik3rEm", name: "ep_user_is_telegram_connected", value: null});
  properties.epUserIsDiscordConnected !== undefined && properties.epUserIsDiscordConnected !== null ?
    eventPropertiesArray.push({id: "Z5anKuo4On", name: "ep_user_is_discord_connected", value: properties.epUserIsDiscordConnected}) :
    eventPropertiesArray.push({id: "Z5anKuo4On", name: "ep_user_is_discord_connected", value: null});
  properties.epUserFeatureFlags !== undefined && properties.epUserFeatureFlags !== null ?
    eventPropertiesArray.push({id: "ZkS2YBJULL", name: "ep_user_feature_flags", value: properties.epUserFeatureFlags}) :
    eventPropertiesArray.push({id: "ZkS2YBJULL", name: "ep_user_feature_flags", value: null});
  properties.epUserIsDarkMode !== undefined && properties.epUserIsDarkMode !== null ?
    eventPropertiesArray.push({id: "pZYzhjQhIW", name: "ep_user_is_dark_mode", value: properties.epUserIsDarkMode}) :
    eventPropertiesArray.push({id: "pZYzhjQhIW", name: "ep_user_is_dark_mode", value: null});
  properties.isTelegramMiniApp !== undefined && properties.isTelegramMiniApp !== null ?
    eventPropertiesArray.push({id: "vh-KiP-5Q", name: "is_telegram_mini_app", value: properties.isTelegramMiniApp}) :
    eventPropertiesArray.push({id: "vh-KiP-5Q", name: "is_telegram_mini_app", value: null});
  eventPropertiesArray.push({id: "01c5raMTE", name: "ep_user_is_onboarding", value: properties.epUserIsOnboarding});
  properties.botSource !== undefined && properties.botSource !== null ?
    eventPropertiesArray.push({id: "77pb0xYM-Q", name: "bot_source", value: properties.botSource}) :
    eventPropertiesArray.push({id: "77pb0xYM-Q", name: "bot_source", value: null});
  eventPropertiesArray.push({id: "WN7yP-IxTA", name: "platform", value: sysPlatform});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "UKmUJFxu-B", "65668d09c8b3c5f2a86296d960d3fce9330738c56f13126f8063083a6744553f", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Create Account View", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("UKmUJFxu-B", "Create Account View", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Create Account View", eventProperties, "UKmUJFxu-B", "65668d09c8b3c5f2a86296d960d3fce9330738c56f13126f8063083a6744553f");
    }
    // destination Mixpanel
    Mixpanel.logEvent("Create Account View", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface AccountTradingConfigViewProperties {
  clientExchange: string;
}
/**
 * Account Trading Config View: Previously: 'Account Trading Config View (App)'
Users view the configuration view for a specific account in the config menu which allows them to set up the trading configuration for the account.
 * 
 * @param properties the properties associatied with this event
 * @param properties.clientExchange: The client's exchange.
 * 
 * @see {@link https://www.avo.app/schemas/Zba2v6MXsSx1EdxPIQKm/events/qcrFc3LoLP}
 */
export function accountTradingConfigView(properties: AccountTradingConfigViewProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({id: "y-0xKVXQIT", name: "client_exchange", value: properties.clientExchange});
  eventPropertiesArray.push({id: "WN7yP-IxTA", name: "platform", value: sysPlatform});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "qcrFc3LoLP", "e3b24c056f8add583a883ceb634c296908bbfcc5a14d983bb3908f8a767cbe00", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Account Trading Config View", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("qcrFc3LoLP", "Account Trading Config View", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Account Trading Config View", eventProperties, "qcrFc3LoLP", "e3b24c056f8add583a883ceb634c296908bbfcc5a14d983bb3908f8a767cbe00");
    }
    // destination Mixpanel
    Mixpanel.logEvent("Account Trading Config View", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

/**
 * Reset Password View: User views the Reset Password page (in-app).
 * 
 * @see {@link https://www.avo.app/schemas/Zba2v6MXsSx1EdxPIQKm/events/oVvoBVCkLZ}
 */
export function resetPasswordView() {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({id: "WN7yP-IxTA", name: "platform", value: sysPlatform});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "oVvoBVCkLZ", "9d40933249d609e8bb357d12ff8ddd4df0e0d4aa0cf4d491bbc10cb6194dc565", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Reset Password View", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("oVvoBVCkLZ", "Reset Password View", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Reset Password View", eventProperties, "oVvoBVCkLZ", "9d40933249d609e8bb357d12ff8ddd4df0e0d4aa0cf4d491bbc10cb6194dc565");
    }
    // destination Mixpanel
    Mixpanel.logEvent("Reset Password View", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface ConnectExternalAccountViewProperties {
  epUserSubscriptionDuration: number | null | undefined;
  epUserSubscriptionPlan: EpUserSubscriptionPlanValueType;
  epUserSubscriptionIsActive: boolean | null | undefined;
  epUserIsMobileAppUser: boolean | null | undefined;
  epUserIsAdmin: boolean | null | undefined;
  epUserIsTelegramConnected: boolean | null | undefined;
  epUserIsDiscordConnected: boolean | null | undefined;
  epUserFeatureFlags: string[] | null | undefined;
  epUserIsDarkMode: boolean | null | undefined;
  isTelegramMiniApp: boolean | null | undefined;
  onboardingStep: OnboardingStepValueType | null | undefined;
  epUserIsOnboarding: boolean;
}
/**
 * Connect External Account View: Triggered when a user views the screen to connect their Telegram or discord account.
 * 
 * @param properties the properties associatied with this event
 * @param properties.epUserSubscriptionDuration: The current subscription duration for the user, in days. Not sent for users with Expired or Trial subscription plans.
 * @param properties.epUserSubscriptionPlan: The current subscription plan for the user. Users without an active subscription should have the value set to Expired.
 * @param properties.epUserSubscriptionIsActive: Set to True if the user has an active subscription (the last subscription expiration date is smaller than the current date).
 * @param properties.epUserIsMobileAppUser: no description
 * @param properties.epUserIsAdmin: no description
 * @param properties.epUserIsTelegramConnected: no description
 * @param properties.epUserIsDiscordConnected: no description
 * @param properties.epUserFeatureFlags: no description
 * @param properties.epUserIsDarkMode: no description
 * @param properties.isTelegramMiniApp: no description
 * @param properties.onboardingStep: Contain the onboarding step - Email confirmation, Connect exchange, Trading method, Method settings, Overview
 * @param properties.epUserIsOnboarding: Used to track which events happened during onboarding 
 * 
 * @see {@link https://www.avo.app/schemas/Zba2v6MXsSx1EdxPIQKm/events/P_Qeke-CAE}
 */
export function connectExternalAccountView(properties: ConnectExternalAccountViewProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  properties.epUserSubscriptionDuration !== undefined && properties.epUserSubscriptionDuration !== null ?
    eventPropertiesArray.push({id: "BrNPvrBkq", name: "ep_user_subscription_duration", value: properties.epUserSubscriptionDuration}) :
    eventPropertiesArray.push({id: "BrNPvrBkq", name: "ep_user_subscription_duration", value: null});
  eventPropertiesArray.push({id: "Ak0bD3528L", name: "ep_user_subscription_plan", value: properties.epUserSubscriptionPlan});
  properties.epUserSubscriptionIsActive !== undefined && properties.epUserSubscriptionIsActive !== null ?
    eventPropertiesArray.push({id: "P2zcEByfWK", name: "ep_user_subscription_is_active", value: properties.epUserSubscriptionIsActive}) :
    eventPropertiesArray.push({id: "P2zcEByfWK", name: "ep_user_subscription_is_active", value: null});
  properties.epUserIsMobileAppUser !== undefined && properties.epUserIsMobileAppUser !== null ?
    eventPropertiesArray.push({id: "gkaSZCbXw8", name: "ep_user_is_mobile_app_user", value: properties.epUserIsMobileAppUser}) :
    eventPropertiesArray.push({id: "gkaSZCbXw8", name: "ep_user_is_mobile_app_user", value: null});
  properties.epUserIsAdmin !== undefined && properties.epUserIsAdmin !== null ?
    eventPropertiesArray.push({id: "1NHsnnGVd0", name: "ep_user_is_admin", value: properties.epUserIsAdmin}) :
    eventPropertiesArray.push({id: "1NHsnnGVd0", name: "ep_user_is_admin", value: null});
  properties.epUserIsTelegramConnected !== undefined && properties.epUserIsTelegramConnected !== null ?
    eventPropertiesArray.push({id: "QBh1Ik3rEm", name: "ep_user_is_telegram_connected", value: properties.epUserIsTelegramConnected}) :
    eventPropertiesArray.push({id: "QBh1Ik3rEm", name: "ep_user_is_telegram_connected", value: null});
  properties.epUserIsDiscordConnected !== undefined && properties.epUserIsDiscordConnected !== null ?
    eventPropertiesArray.push({id: "Z5anKuo4On", name: "ep_user_is_discord_connected", value: properties.epUserIsDiscordConnected}) :
    eventPropertiesArray.push({id: "Z5anKuo4On", name: "ep_user_is_discord_connected", value: null});
  properties.epUserFeatureFlags !== undefined && properties.epUserFeatureFlags !== null ?
    eventPropertiesArray.push({id: "ZkS2YBJULL", name: "ep_user_feature_flags", value: properties.epUserFeatureFlags}) :
    eventPropertiesArray.push({id: "ZkS2YBJULL", name: "ep_user_feature_flags", value: null});
  properties.epUserIsDarkMode !== undefined && properties.epUserIsDarkMode !== null ?
    eventPropertiesArray.push({id: "pZYzhjQhIW", name: "ep_user_is_dark_mode", value: properties.epUserIsDarkMode}) :
    eventPropertiesArray.push({id: "pZYzhjQhIW", name: "ep_user_is_dark_mode", value: null});
  properties.isTelegramMiniApp !== undefined && properties.isTelegramMiniApp !== null ?
    eventPropertiesArray.push({id: "vh-KiP-5Q", name: "is_telegram_mini_app", value: properties.isTelegramMiniApp}) :
    eventPropertiesArray.push({id: "vh-KiP-5Q", name: "is_telegram_mini_app", value: null});
  properties.onboardingStep !== undefined && properties.onboardingStep !== null ?
    eventPropertiesArray.push({id: "-sPjCGnFt", name: "onboarding_step", value: properties.onboardingStep}) :
    eventPropertiesArray.push({id: "-sPjCGnFt", name: "onboarding_step", value: null});
  eventPropertiesArray.push({id: "01c5raMTE", name: "ep_user_is_onboarding", value: properties.epUserIsOnboarding});
  eventPropertiesArray.push({id: "WN7yP-IxTA", name: "platform", value: sysPlatform});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "P_Qeke-CAE", "2a9f4c549f1c2fb6e5402b084c2de63ace1bceaab179429c62217715c4dd1368", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Connect External Account View", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("P_Qeke-CAE", "Connect External Account View", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Connect External Account View", eventProperties, "P_Qeke-CAE", "2a9f4c549f1c2fb6e5402b084c2de63ace1bceaab179429c62217715c4dd1368");
    }
    // destination Mixpanel
    Mixpanel.logEvent("Connect External Account View", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface ValidateTelegramViewProperties {
  epUserSubscriptionDuration: number | null | undefined;
  epUserSubscriptionPlan: EpUserSubscriptionPlanValueType;
  epUserSubscriptionIsActive: boolean | null | undefined;
  epUserIsMobileAppUser: boolean | null | undefined;
  epUserIsAdmin: boolean | null | undefined;
  epUserIsTelegramConnected: boolean | null | undefined;
  epUserIsDiscordConnected: boolean | null | undefined;
  epUserFeatureFlags: string[] | null | undefined;
  epUserIsDarkMode: boolean | null | undefined;
  isTelegramMiniApp: boolean | null | undefined;
  onboardingStep: OnboardingStepValueType | null | undefined;
  epUserIsOnboarding: boolean;
}
/**
 * Validate Telegram View: Triggered when a user views the screen to validate they are the owners of the Telegram account during Onboarding or later in Accounts&Groups
 * 
 * @param properties the properties associatied with this event
 * @param properties.epUserSubscriptionDuration: The current subscription duration for the user, in days. Not sent for users with Expired or Trial subscription plans.
 * @param properties.epUserSubscriptionPlan: The current subscription plan for the user. Users without an active subscription should have the value set to Expired.
 * @param properties.epUserSubscriptionIsActive: Set to True if the user has an active subscription (the last subscription expiration date is smaller than the current date).
 * @param properties.epUserIsMobileAppUser: no description
 * @param properties.epUserIsAdmin: no description
 * @param properties.epUserIsTelegramConnected: no description
 * @param properties.epUserIsDiscordConnected: no description
 * @param properties.epUserFeatureFlags: no description
 * @param properties.epUserIsDarkMode: no description
 * @param properties.isTelegramMiniApp: no description
 * @param properties.onboardingStep: Contain the onboarding step - Email confirmation, Connect exchange, Trading method, Method settings, Overview
 * @param properties.epUserIsOnboarding: Used to track which events happened during onboarding 
 * 
 * @see {@link https://www.avo.app/schemas/Zba2v6MXsSx1EdxPIQKm/events/LdYKbFQzDz}
 */
export function validateTelegramView(properties: ValidateTelegramViewProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  properties.epUserSubscriptionDuration !== undefined && properties.epUserSubscriptionDuration !== null ?
    eventPropertiesArray.push({id: "BrNPvrBkq", name: "ep_user_subscription_duration", value: properties.epUserSubscriptionDuration}) :
    eventPropertiesArray.push({id: "BrNPvrBkq", name: "ep_user_subscription_duration", value: null});
  eventPropertiesArray.push({id: "Ak0bD3528L", name: "ep_user_subscription_plan", value: properties.epUserSubscriptionPlan});
  properties.epUserSubscriptionIsActive !== undefined && properties.epUserSubscriptionIsActive !== null ?
    eventPropertiesArray.push({id: "P2zcEByfWK", name: "ep_user_subscription_is_active", value: properties.epUserSubscriptionIsActive}) :
    eventPropertiesArray.push({id: "P2zcEByfWK", name: "ep_user_subscription_is_active", value: null});
  properties.epUserIsMobileAppUser !== undefined && properties.epUserIsMobileAppUser !== null ?
    eventPropertiesArray.push({id: "gkaSZCbXw8", name: "ep_user_is_mobile_app_user", value: properties.epUserIsMobileAppUser}) :
    eventPropertiesArray.push({id: "gkaSZCbXw8", name: "ep_user_is_mobile_app_user", value: null});
  properties.epUserIsAdmin !== undefined && properties.epUserIsAdmin !== null ?
    eventPropertiesArray.push({id: "1NHsnnGVd0", name: "ep_user_is_admin", value: properties.epUserIsAdmin}) :
    eventPropertiesArray.push({id: "1NHsnnGVd0", name: "ep_user_is_admin", value: null});
  properties.epUserIsTelegramConnected !== undefined && properties.epUserIsTelegramConnected !== null ?
    eventPropertiesArray.push({id: "QBh1Ik3rEm", name: "ep_user_is_telegram_connected", value: properties.epUserIsTelegramConnected}) :
    eventPropertiesArray.push({id: "QBh1Ik3rEm", name: "ep_user_is_telegram_connected", value: null});
  properties.epUserIsDiscordConnected !== undefined && properties.epUserIsDiscordConnected !== null ?
    eventPropertiesArray.push({id: "Z5anKuo4On", name: "ep_user_is_discord_connected", value: properties.epUserIsDiscordConnected}) :
    eventPropertiesArray.push({id: "Z5anKuo4On", name: "ep_user_is_discord_connected", value: null});
  properties.epUserFeatureFlags !== undefined && properties.epUserFeatureFlags !== null ?
    eventPropertiesArray.push({id: "ZkS2YBJULL", name: "ep_user_feature_flags", value: properties.epUserFeatureFlags}) :
    eventPropertiesArray.push({id: "ZkS2YBJULL", name: "ep_user_feature_flags", value: null});
  properties.epUserIsDarkMode !== undefined && properties.epUserIsDarkMode !== null ?
    eventPropertiesArray.push({id: "pZYzhjQhIW", name: "ep_user_is_dark_mode", value: properties.epUserIsDarkMode}) :
    eventPropertiesArray.push({id: "pZYzhjQhIW", name: "ep_user_is_dark_mode", value: null});
  properties.isTelegramMiniApp !== undefined && properties.isTelegramMiniApp !== null ?
    eventPropertiesArray.push({id: "vh-KiP-5Q", name: "is_telegram_mini_app", value: properties.isTelegramMiniApp}) :
    eventPropertiesArray.push({id: "vh-KiP-5Q", name: "is_telegram_mini_app", value: null});
  properties.onboardingStep !== undefined && properties.onboardingStep !== null ?
    eventPropertiesArray.push({id: "-sPjCGnFt", name: "onboarding_step", value: properties.onboardingStep}) :
    eventPropertiesArray.push({id: "-sPjCGnFt", name: "onboarding_step", value: null});
  eventPropertiesArray.push({id: "01c5raMTE", name: "ep_user_is_onboarding", value: properties.epUserIsOnboarding});
  eventPropertiesArray.push({id: "WN7yP-IxTA", name: "platform", value: sysPlatform});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "LdYKbFQzDz", "4cdaa562537b520beb3f1000c913a20516942bdfbeb1d891d528dd9a199af3b3", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Validate Telegram View", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("LdYKbFQzDz", "Validate Telegram View", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Validate Telegram View", eventProperties, "LdYKbFQzDz", "4cdaa562537b520beb3f1000c913a20516942bdfbeb1d891d528dd9a199af3b3");
    }
    // destination Mixpanel
    Mixpanel.logEvent("Validate Telegram View", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface OnboardingMinusConnectGroupViewProperties {
  epUserSubscriptionDuration: number | null | undefined;
  epUserSubscriptionPlan: EpUserSubscriptionPlanValueType;
  epUserSubscriptionIsActive: boolean | null | undefined;
  epUserIsMobileAppUser: boolean | null | undefined;
  epUserIsAdmin: boolean | null | undefined;
  epUserIsTelegramConnected: boolean | null | undefined;
  epUserIsDiscordConnected: boolean | null | undefined;
  epUserFeatureFlags: string[] | null | undefined;
  epUserIsDarkMode: boolean | null | undefined;
  isTelegramMiniApp: boolean | null | undefined;
  onboardingStep: OnboardingStepValueType;
  epUserIsOnboarding: boolean;
  epUserGroupsCount: number;
}
/**
 * Onboarding - Connect Group View: User views the connect group screen during the onboarding.
 * 
 * @param properties the properties associatied with this event
 * @param properties.epUserSubscriptionDuration: The current subscription duration for the user, in days. Not sent for users with Expired or Trial subscription plans.
 * @param properties.epUserSubscriptionPlan: The current subscription plan for the user. Users without an active subscription should have the value set to Expired.
 * @param properties.epUserSubscriptionIsActive: Set to True if the user has an active subscription (the last subscription expiration date is smaller than the current date).
 * @param properties.epUserIsMobileAppUser: no description
 * @param properties.epUserIsAdmin: no description
 * @param properties.epUserIsTelegramConnected: no description
 * @param properties.epUserIsDiscordConnected: no description
 * @param properties.epUserFeatureFlags: no description
 * @param properties.epUserIsDarkMode: no description
 * @param properties.isTelegramMiniApp: no description
 * @param properties.onboardingStep: Contain the onboarding step - Email confirmation, Connect exchange, Trading method, Method settings, Overview
 * @param properties.epUserIsOnboarding: Used to track which events happened during onboarding 
 * @param properties.epUserGroupsCount: The number of Telegram channels the user is currently a member of.
 * 
 * @see {@link https://www.avo.app/schemas/Zba2v6MXsSx1EdxPIQKm/events/Eeczyze8Hn}
 */
export function onboardingConnectGroupView(properties: OnboardingMinusConnectGroupViewProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  properties.epUserSubscriptionDuration !== undefined && properties.epUserSubscriptionDuration !== null ?
    eventPropertiesArray.push({id: "BrNPvrBkq", name: "ep_user_subscription_duration", value: properties.epUserSubscriptionDuration}) :
    eventPropertiesArray.push({id: "BrNPvrBkq", name: "ep_user_subscription_duration", value: null});
  eventPropertiesArray.push({id: "Ak0bD3528L", name: "ep_user_subscription_plan", value: properties.epUserSubscriptionPlan});
  properties.epUserSubscriptionIsActive !== undefined && properties.epUserSubscriptionIsActive !== null ?
    eventPropertiesArray.push({id: "P2zcEByfWK", name: "ep_user_subscription_is_active", value: properties.epUserSubscriptionIsActive}) :
    eventPropertiesArray.push({id: "P2zcEByfWK", name: "ep_user_subscription_is_active", value: null});
  properties.epUserIsMobileAppUser !== undefined && properties.epUserIsMobileAppUser !== null ?
    eventPropertiesArray.push({id: "gkaSZCbXw8", name: "ep_user_is_mobile_app_user", value: properties.epUserIsMobileAppUser}) :
    eventPropertiesArray.push({id: "gkaSZCbXw8", name: "ep_user_is_mobile_app_user", value: null});
  properties.epUserIsAdmin !== undefined && properties.epUserIsAdmin !== null ?
    eventPropertiesArray.push({id: "1NHsnnGVd0", name: "ep_user_is_admin", value: properties.epUserIsAdmin}) :
    eventPropertiesArray.push({id: "1NHsnnGVd0", name: "ep_user_is_admin", value: null});
  properties.epUserIsTelegramConnected !== undefined && properties.epUserIsTelegramConnected !== null ?
    eventPropertiesArray.push({id: "QBh1Ik3rEm", name: "ep_user_is_telegram_connected", value: properties.epUserIsTelegramConnected}) :
    eventPropertiesArray.push({id: "QBh1Ik3rEm", name: "ep_user_is_telegram_connected", value: null});
  properties.epUserIsDiscordConnected !== undefined && properties.epUserIsDiscordConnected !== null ?
    eventPropertiesArray.push({id: "Z5anKuo4On", name: "ep_user_is_discord_connected", value: properties.epUserIsDiscordConnected}) :
    eventPropertiesArray.push({id: "Z5anKuo4On", name: "ep_user_is_discord_connected", value: null});
  properties.epUserFeatureFlags !== undefined && properties.epUserFeatureFlags !== null ?
    eventPropertiesArray.push({id: "ZkS2YBJULL", name: "ep_user_feature_flags", value: properties.epUserFeatureFlags}) :
    eventPropertiesArray.push({id: "ZkS2YBJULL", name: "ep_user_feature_flags", value: null});
  properties.epUserIsDarkMode !== undefined && properties.epUserIsDarkMode !== null ?
    eventPropertiesArray.push({id: "pZYzhjQhIW", name: "ep_user_is_dark_mode", value: properties.epUserIsDarkMode}) :
    eventPropertiesArray.push({id: "pZYzhjQhIW", name: "ep_user_is_dark_mode", value: null});
  properties.isTelegramMiniApp !== undefined && properties.isTelegramMiniApp !== null ?
    eventPropertiesArray.push({id: "vh-KiP-5Q", name: "is_telegram_mini_app", value: properties.isTelegramMiniApp}) :
    eventPropertiesArray.push({id: "vh-KiP-5Q", name: "is_telegram_mini_app", value: null});
  eventPropertiesArray.push({id: "-sPjCGnFt", name: "onboarding_step", value: properties.onboardingStep});
  eventPropertiesArray.push({id: "01c5raMTE", name: "ep_user_is_onboarding", value: properties.epUserIsOnboarding});
  eventPropertiesArray.push({id: "Daij3OzuMn", name: "ep_user_groups_count", value: properties.epUserGroupsCount});
  eventPropertiesArray.push({id: "WN7yP-IxTA", name: "platform", value: sysPlatform});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "Eeczyze8Hn", "465f606fa21e4070934496fffed1be6246d5de9256b3e9bb20297036dc624974", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Onboarding - Connect Group View", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("Eeczyze8Hn", "Onboarding - Connect Group View", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Onboarding - Connect Group View", eventProperties, "Eeczyze8Hn", "465f606fa21e4070934496fffed1be6246d5de9256b3e9bb20297036dc624974");
    }
    // destination Mixpanel
    Mixpanel.logEvent("Onboarding - Connect Group View", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface OnboardingMinusGroupConfigurationDetailsViewProperties {
  epUserSubscriptionDuration: number | null | undefined;
  epUserSubscriptionPlan: EpUserSubscriptionPlanValueType;
  epUserSubscriptionIsActive: boolean | null | undefined;
  epUserIsMobileAppUser: boolean | null | undefined;
  epUserIsAdmin: boolean | null | undefined;
  epUserIsTelegramConnected: boolean | null | undefined;
  epUserIsDiscordConnected: boolean | null | undefined;
  epUserFeatureFlags: string[] | null | undefined;
  epUserIsDarkMode: boolean | null | undefined;
  isTelegramMiniApp: boolean | null | undefined;
  onboardingStep: OnboardingStepValueType;
  epUserIsOnboarding: boolean;
  tradingMethodCategory: TradingMethodCategoryValueType | null | undefined;
}
/**
 * Onboarding - Group Configuration Details View: User views the trading configuration details modal after clicking one of the channel configurations
 * 
 * @param properties the properties associatied with this event
 * @param properties.epUserSubscriptionDuration: The current subscription duration for the user, in days. Not sent for users with Expired or Trial subscription plans.
 * @param properties.epUserSubscriptionPlan: The current subscription plan for the user. Users without an active subscription should have the value set to Expired.
 * @param properties.epUserSubscriptionIsActive: Set to True if the user has an active subscription (the last subscription expiration date is smaller than the current date).
 * @param properties.epUserIsMobileAppUser: no description
 * @param properties.epUserIsAdmin: no description
 * @param properties.epUserIsTelegramConnected: no description
 * @param properties.epUserIsDiscordConnected: no description
 * @param properties.epUserFeatureFlags: no description
 * @param properties.epUserIsDarkMode: no description
 * @param properties.isTelegramMiniApp: no description
 * @param properties.onboardingStep: Contain the onboarding step - Email confirmation, Connect exchange, Trading method, Method settings, Overview
 * @param properties.epUserIsOnboarding: Used to track which events happened during onboarding 
 * @param properties.tradingMethodCategory: Category of the selected bot in the list of bots in onboarding
 * 
 * @see {@link https://www.avo.app/schemas/Zba2v6MXsSx1EdxPIQKm/events/ELqX_1zMP6}
 */
export function onboardingGroupConfigurationDetailsView(properties: OnboardingMinusGroupConfigurationDetailsViewProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  properties.epUserSubscriptionDuration !== undefined && properties.epUserSubscriptionDuration !== null ?
    eventPropertiesArray.push({id: "BrNPvrBkq", name: "ep_user_subscription_duration", value: properties.epUserSubscriptionDuration}) :
    eventPropertiesArray.push({id: "BrNPvrBkq", name: "ep_user_subscription_duration", value: null});
  eventPropertiesArray.push({id: "Ak0bD3528L", name: "ep_user_subscription_plan", value: properties.epUserSubscriptionPlan});
  properties.epUserSubscriptionIsActive !== undefined && properties.epUserSubscriptionIsActive !== null ?
    eventPropertiesArray.push({id: "P2zcEByfWK", name: "ep_user_subscription_is_active", value: properties.epUserSubscriptionIsActive}) :
    eventPropertiesArray.push({id: "P2zcEByfWK", name: "ep_user_subscription_is_active", value: null});
  properties.epUserIsMobileAppUser !== undefined && properties.epUserIsMobileAppUser !== null ?
    eventPropertiesArray.push({id: "gkaSZCbXw8", name: "ep_user_is_mobile_app_user", value: properties.epUserIsMobileAppUser}) :
    eventPropertiesArray.push({id: "gkaSZCbXw8", name: "ep_user_is_mobile_app_user", value: null});
  properties.epUserIsAdmin !== undefined && properties.epUserIsAdmin !== null ?
    eventPropertiesArray.push({id: "1NHsnnGVd0", name: "ep_user_is_admin", value: properties.epUserIsAdmin}) :
    eventPropertiesArray.push({id: "1NHsnnGVd0", name: "ep_user_is_admin", value: null});
  properties.epUserIsTelegramConnected !== undefined && properties.epUserIsTelegramConnected !== null ?
    eventPropertiesArray.push({id: "QBh1Ik3rEm", name: "ep_user_is_telegram_connected", value: properties.epUserIsTelegramConnected}) :
    eventPropertiesArray.push({id: "QBh1Ik3rEm", name: "ep_user_is_telegram_connected", value: null});
  properties.epUserIsDiscordConnected !== undefined && properties.epUserIsDiscordConnected !== null ?
    eventPropertiesArray.push({id: "Z5anKuo4On", name: "ep_user_is_discord_connected", value: properties.epUserIsDiscordConnected}) :
    eventPropertiesArray.push({id: "Z5anKuo4On", name: "ep_user_is_discord_connected", value: null});
  properties.epUserFeatureFlags !== undefined && properties.epUserFeatureFlags !== null ?
    eventPropertiesArray.push({id: "ZkS2YBJULL", name: "ep_user_feature_flags", value: properties.epUserFeatureFlags}) :
    eventPropertiesArray.push({id: "ZkS2YBJULL", name: "ep_user_feature_flags", value: null});
  properties.epUserIsDarkMode !== undefined && properties.epUserIsDarkMode !== null ?
    eventPropertiesArray.push({id: "pZYzhjQhIW", name: "ep_user_is_dark_mode", value: properties.epUserIsDarkMode}) :
    eventPropertiesArray.push({id: "pZYzhjQhIW", name: "ep_user_is_dark_mode", value: null});
  properties.isTelegramMiniApp !== undefined && properties.isTelegramMiniApp !== null ?
    eventPropertiesArray.push({id: "vh-KiP-5Q", name: "is_telegram_mini_app", value: properties.isTelegramMiniApp}) :
    eventPropertiesArray.push({id: "vh-KiP-5Q", name: "is_telegram_mini_app", value: null});
  eventPropertiesArray.push({id: "-sPjCGnFt", name: "onboarding_step", value: properties.onboardingStep});
  eventPropertiesArray.push({id: "01c5raMTE", name: "ep_user_is_onboarding", value: properties.epUserIsOnboarding});
  properties.tradingMethodCategory !== undefined && properties.tradingMethodCategory !== null ?
    eventPropertiesArray.push({id: "TWj16Ybpf", name: "trading_method_category", value: properties.tradingMethodCategory}) :
    eventPropertiesArray.push({id: "TWj16Ybpf", name: "trading_method_category", value: null});
  eventPropertiesArray.push({id: "WN7yP-IxTA", name: "platform", value: sysPlatform});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "ELqX_1zMP6", "c6e84ed5349d725590791de9ce3183365429e80b5920d6ada5d1c59bf1e0e9a7", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Onboarding - Group Configuration Details View", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("ELqX_1zMP6", "Onboarding - Group Configuration Details View", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Onboarding - Group Configuration Details View", eventProperties, "ELqX_1zMP6", "c6e84ed5349d725590791de9ce3183365429e80b5920d6ada5d1c59bf1e0e9a7");
    }
    // destination Mixpanel
    Mixpanel.logEvent("Onboarding - Group Configuration Details View", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface UserLoggedInProperties {
  epUserSubscriptionDuration: number | null | undefined;
  epUserSubscriptionPlan: EpUserSubscriptionPlanValueType | null | undefined;
  epUserSubscriptionIsActive: boolean | null | undefined;
  epUserIsMobileAppUser: boolean | null | undefined;
  epUserIsAdmin: boolean | null | undefined;
  epUserIsTelegramConnected: boolean | null | undefined;
  epUserIsDiscordConnected: boolean | null | undefined;
  epUserFeatureFlags: string[] | null | undefined;
  epUserIsDarkMode: boolean | null | undefined;
  isTelegramMiniApp: boolean | null | undefined;
  userId_: string;
  userSystemDarkModeOn: boolean;
  isNewUser: boolean | null | undefined;
  sourceButton: string | null | undefined;
  source: string | null | undefined;
}
/**
 * User Logged In: system == os // browser

 * 
 * @param properties the properties associatied with this event
 * @param properties.epUserSubscriptionDuration: The current subscription duration for the user, in days. Not sent for users with Expired or Trial subscription plans.
 * @param properties.epUserSubscriptionPlan: The current subscription plan for the user. Users without an active subscription should have the value set to Expired.
 * @param properties.epUserSubscriptionIsActive: Set to True if the user has an active subscription (the last subscription expiration date is smaller than the current date).
 * @param properties.epUserIsMobileAppUser: no description
 * @param properties.epUserIsAdmin: no description
 * @param properties.epUserIsTelegramConnected: no description
 * @param properties.epUserIsDiscordConnected: no description
 * @param properties.epUserFeatureFlags: no description
 * @param properties.epUserIsDarkMode: no description
 * @param properties.isTelegramMiniApp: no description
 * @param properties.userId_: The value used to identify the user. Make sure it's a unique sequence of characters used to identify the user.
 * @param properties.userSystemDarkModeOn: no description
 * @param properties.isNewUser: no description
 * @param properties.sourceButton: no description
 * @param properties.source: no description
 * 
 * @see {@link https://www.avo.app/schemas/Zba2v6MXsSx1EdxPIQKm/events/GEJYFsDL0b}
 */
export function userLoggedIn(properties: UserLoggedInProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  properties.epUserSubscriptionDuration !== undefined && properties.epUserSubscriptionDuration !== null ?
    eventPropertiesArray.push({id: "BrNPvrBkq", name: "ep_user_subscription_duration", value: properties.epUserSubscriptionDuration}) :
    eventPropertiesArray.push({id: "BrNPvrBkq", name: "ep_user_subscription_duration", value: null});
  properties.epUserSubscriptionPlan !== undefined && properties.epUserSubscriptionPlan !== null ?
    eventPropertiesArray.push({id: "Ak0bD3528L", name: "ep_user_subscription_plan", value: properties.epUserSubscriptionPlan}) :
    eventPropertiesArray.push({id: "Ak0bD3528L", name: "ep_user_subscription_plan", value: null});
  properties.epUserSubscriptionIsActive !== undefined && properties.epUserSubscriptionIsActive !== null ?
    eventPropertiesArray.push({id: "P2zcEByfWK", name: "ep_user_subscription_is_active", value: properties.epUserSubscriptionIsActive}) :
    eventPropertiesArray.push({id: "P2zcEByfWK", name: "ep_user_subscription_is_active", value: null});
  properties.epUserIsMobileAppUser !== undefined && properties.epUserIsMobileAppUser !== null ?
    eventPropertiesArray.push({id: "gkaSZCbXw8", name: "ep_user_is_mobile_app_user", value: properties.epUserIsMobileAppUser}) :
    eventPropertiesArray.push({id: "gkaSZCbXw8", name: "ep_user_is_mobile_app_user", value: null});
  properties.epUserIsAdmin !== undefined && properties.epUserIsAdmin !== null ?
    eventPropertiesArray.push({id: "1NHsnnGVd0", name: "ep_user_is_admin", value: properties.epUserIsAdmin}) :
    eventPropertiesArray.push({id: "1NHsnnGVd0", name: "ep_user_is_admin", value: null});
  properties.epUserIsTelegramConnected !== undefined && properties.epUserIsTelegramConnected !== null ?
    eventPropertiesArray.push({id: "QBh1Ik3rEm", name: "ep_user_is_telegram_connected", value: properties.epUserIsTelegramConnected}) :
    eventPropertiesArray.push({id: "QBh1Ik3rEm", name: "ep_user_is_telegram_connected", value: null});
  properties.epUserIsDiscordConnected !== undefined && properties.epUserIsDiscordConnected !== null ?
    eventPropertiesArray.push({id: "Z5anKuo4On", name: "ep_user_is_discord_connected", value: properties.epUserIsDiscordConnected}) :
    eventPropertiesArray.push({id: "Z5anKuo4On", name: "ep_user_is_discord_connected", value: null});
  properties.epUserFeatureFlags !== undefined && properties.epUserFeatureFlags !== null ?
    eventPropertiesArray.push({id: "ZkS2YBJULL", name: "ep_user_feature_flags", value: properties.epUserFeatureFlags}) :
    eventPropertiesArray.push({id: "ZkS2YBJULL", name: "ep_user_feature_flags", value: null});
  properties.epUserIsDarkMode !== undefined && properties.epUserIsDarkMode !== null ?
    eventPropertiesArray.push({id: "pZYzhjQhIW", name: "ep_user_is_dark_mode", value: properties.epUserIsDarkMode}) :
    eventPropertiesArray.push({id: "pZYzhjQhIW", name: "ep_user_is_dark_mode", value: null});
  properties.isTelegramMiniApp !== undefined && properties.isTelegramMiniApp !== null ?
    eventPropertiesArray.push({id: "vh-KiP-5Q", name: "is_telegram_mini_app", value: properties.isTelegramMiniApp}) :
    eventPropertiesArray.push({id: "vh-KiP-5Q", name: "is_telegram_mini_app", value: null});
  eventPropertiesArray.push({id: "WGqWRXoIQU", name: "user_system_dark_mode_on", value: properties.userSystemDarkModeOn});
  properties.isNewUser !== undefined && properties.isNewUser !== null ?
    eventPropertiesArray.push({id: "bebJXBXPc", name: "is_new_user", value: properties.isNewUser}) :
    eventPropertiesArray.push({id: "bebJXBXPc", name: "is_new_user", value: null});
  properties.sourceButton !== undefined && properties.sourceButton !== null ?
    eventPropertiesArray.push({id: "p7osgNHCB", name: "source_button", value: properties.sourceButton}) :
    eventPropertiesArray.push({id: "p7osgNHCB", name: "source_button", value: null});
  properties.source !== undefined && properties.source !== null ?
    eventPropertiesArray.push({id: "X06iYPhVw", name: "source", value: properties.source}) :
    eventPropertiesArray.push({id: "X06iYPhVw", name: "source", value: null});
  eventPropertiesArray.push({id: "WN7yP-IxTA", name: "platform", value: sysPlatform});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "GEJYFsDL0b", "434ff403df9a35b3b6e3d0ce195916e9a6e7e914e7117921c0bf938bdae4bdc9", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("User Logged In", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("GEJYFsDL0b", "User Logged In", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("User Logged In", eventProperties, "GEJYFsDL0b", "434ff403df9a35b3b6e3d0ce195916e9a6e7e914e7117921c0bf938bdae4bdc9");
    }
    // destination Mixpanel
    Mixpanel.identify(properties.userId_);
    Mixpanel.logEvent("User Logged In", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface UserLoggedOutProperties {
  epUserSubscriptionDuration: number | null | undefined;
  epUserSubscriptionPlan: EpUserSubscriptionPlanValueType | null | undefined;
  epUserSubscriptionIsActive: boolean | null | undefined;
  epUserIsMobileAppUser: boolean | null | undefined;
  epUserIsAdmin: boolean | null | undefined;
  epUserIsTelegramConnected: boolean | null | undefined;
  epUserIsDiscordConnected: boolean | null | undefined;
  epUserFeatureFlags: string[] | null | undefined;
  epUserIsDarkMode: boolean | null | undefined;
  isTelegramMiniApp: boolean | null | undefined;
}
/**
 * User Logged Out: No description
 * 
 * @param properties the properties associatied with this event
 * @param properties.epUserSubscriptionDuration: The current subscription duration for the user, in days. Not sent for users with Expired or Trial subscription plans.
 * @param properties.epUserSubscriptionPlan: The current subscription plan for the user. Users without an active subscription should have the value set to Expired.
 * @param properties.epUserSubscriptionIsActive: Set to True if the user has an active subscription (the last subscription expiration date is smaller than the current date).
 * @param properties.epUserIsMobileAppUser: no description
 * @param properties.epUserIsAdmin: no description
 * @param properties.epUserIsTelegramConnected: no description
 * @param properties.epUserIsDiscordConnected: no description
 * @param properties.epUserFeatureFlags: no description
 * @param properties.epUserIsDarkMode: no description
 * @param properties.isTelegramMiniApp: no description
 * 
 * @see {@link https://www.avo.app/schemas/Zba2v6MXsSx1EdxPIQKm/events/SBZmaL6j-a}
 */
export function userLoggedOut(properties: UserLoggedOutProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  properties.epUserSubscriptionDuration !== undefined && properties.epUserSubscriptionDuration !== null ?
    eventPropertiesArray.push({id: "BrNPvrBkq", name: "ep_user_subscription_duration", value: properties.epUserSubscriptionDuration}) :
    eventPropertiesArray.push({id: "BrNPvrBkq", name: "ep_user_subscription_duration", value: null});
  properties.epUserSubscriptionPlan !== undefined && properties.epUserSubscriptionPlan !== null ?
    eventPropertiesArray.push({id: "Ak0bD3528L", name: "ep_user_subscription_plan", value: properties.epUserSubscriptionPlan}) :
    eventPropertiesArray.push({id: "Ak0bD3528L", name: "ep_user_subscription_plan", value: null});
  properties.epUserSubscriptionIsActive !== undefined && properties.epUserSubscriptionIsActive !== null ?
    eventPropertiesArray.push({id: "P2zcEByfWK", name: "ep_user_subscription_is_active", value: properties.epUserSubscriptionIsActive}) :
    eventPropertiesArray.push({id: "P2zcEByfWK", name: "ep_user_subscription_is_active", value: null});
  properties.epUserIsMobileAppUser !== undefined && properties.epUserIsMobileAppUser !== null ?
    eventPropertiesArray.push({id: "gkaSZCbXw8", name: "ep_user_is_mobile_app_user", value: properties.epUserIsMobileAppUser}) :
    eventPropertiesArray.push({id: "gkaSZCbXw8", name: "ep_user_is_mobile_app_user", value: null});
  properties.epUserIsAdmin !== undefined && properties.epUserIsAdmin !== null ?
    eventPropertiesArray.push({id: "1NHsnnGVd0", name: "ep_user_is_admin", value: properties.epUserIsAdmin}) :
    eventPropertiesArray.push({id: "1NHsnnGVd0", name: "ep_user_is_admin", value: null});
  properties.epUserIsTelegramConnected !== undefined && properties.epUserIsTelegramConnected !== null ?
    eventPropertiesArray.push({id: "QBh1Ik3rEm", name: "ep_user_is_telegram_connected", value: properties.epUserIsTelegramConnected}) :
    eventPropertiesArray.push({id: "QBh1Ik3rEm", name: "ep_user_is_telegram_connected", value: null});
  properties.epUserIsDiscordConnected !== undefined && properties.epUserIsDiscordConnected !== null ?
    eventPropertiesArray.push({id: "Z5anKuo4On", name: "ep_user_is_discord_connected", value: properties.epUserIsDiscordConnected}) :
    eventPropertiesArray.push({id: "Z5anKuo4On", name: "ep_user_is_discord_connected", value: null});
  properties.epUserFeatureFlags !== undefined && properties.epUserFeatureFlags !== null ?
    eventPropertiesArray.push({id: "ZkS2YBJULL", name: "ep_user_feature_flags", value: properties.epUserFeatureFlags}) :
    eventPropertiesArray.push({id: "ZkS2YBJULL", name: "ep_user_feature_flags", value: null});
  properties.epUserIsDarkMode !== undefined && properties.epUserIsDarkMode !== null ?
    eventPropertiesArray.push({id: "pZYzhjQhIW", name: "ep_user_is_dark_mode", value: properties.epUserIsDarkMode}) :
    eventPropertiesArray.push({id: "pZYzhjQhIW", name: "ep_user_is_dark_mode", value: null});
  properties.isTelegramMiniApp !== undefined && properties.isTelegramMiniApp !== null ?
    eventPropertiesArray.push({id: "vh-KiP-5Q", name: "is_telegram_mini_app", value: properties.isTelegramMiniApp}) :
    eventPropertiesArray.push({id: "vh-KiP-5Q", name: "is_telegram_mini_app", value: null});
  eventPropertiesArray.push({id: "WN7yP-IxTA", name: "platform", value: sysPlatform});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "SBZmaL6j-a", "67484c0b063b678e14b5add54eb58ec8d9e81a6553237fc58947791bfdf33840", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("User Logged Out", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("SBZmaL6j-a", "User Logged Out", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("User Logged Out", eventProperties, "SBZmaL6j-a", "67484c0b063b678e14b5add54eb58ec8d9e81a6553237fc58947791bfdf33840");
    }
    // destination Mixpanel
    Mixpanel.logEvent("User Logged Out", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface OnboardingMinusJoinFreeGroupViewProperties {
  epUserSubscriptionDuration: number | null | undefined;
  epUserSubscriptionPlan: EpUserSubscriptionPlanValueType;
  epUserSubscriptionIsActive: boolean | null | undefined;
  epUserIsMobileAppUser: boolean | null | undefined;
  epUserIsAdmin: boolean | null | undefined;
  epUserIsTelegramConnected: boolean | null | undefined;
  epUserIsDiscordConnected: boolean | null | undefined;
  epUserFeatureFlags: string[] | null | undefined;
  epUserIsDarkMode: boolean | null | undefined;
  isTelegramMiniApp: boolean | null | undefined;
}
/**
 * Onboarding - Join Free Group View: No description
 * 
 * @param properties the properties associatied with this event
 * @param properties.epUserSubscriptionDuration: The current subscription duration for the user, in days. Not sent for users with Expired or Trial subscription plans.
 * @param properties.epUserSubscriptionPlan: The current subscription plan for the user. Users without an active subscription should have the value set to Expired.
 * @param properties.epUserSubscriptionIsActive: Set to True if the user has an active subscription (the last subscription expiration date is smaller than the current date).
 * @param properties.epUserIsMobileAppUser: no description
 * @param properties.epUserIsAdmin: no description
 * @param properties.epUserIsTelegramConnected: no description
 * @param properties.epUserIsDiscordConnected: no description
 * @param properties.epUserFeatureFlags: no description
 * @param properties.epUserIsDarkMode: no description
 * @param properties.isTelegramMiniApp: no description
 * 
 * @see {@link https://www.avo.app/schemas/Zba2v6MXsSx1EdxPIQKm/events/uTc5_Q6sTt}
 */
export function onboardingJoinFreeGroupView(properties: OnboardingMinusJoinFreeGroupViewProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  properties.epUserSubscriptionDuration !== undefined && properties.epUserSubscriptionDuration !== null ?
    eventPropertiesArray.push({id: "BrNPvrBkq", name: "ep_user_subscription_duration", value: properties.epUserSubscriptionDuration}) :
    eventPropertiesArray.push({id: "BrNPvrBkq", name: "ep_user_subscription_duration", value: null});
  eventPropertiesArray.push({id: "Ak0bD3528L", name: "ep_user_subscription_plan", value: properties.epUserSubscriptionPlan});
  properties.epUserSubscriptionIsActive !== undefined && properties.epUserSubscriptionIsActive !== null ?
    eventPropertiesArray.push({id: "P2zcEByfWK", name: "ep_user_subscription_is_active", value: properties.epUserSubscriptionIsActive}) :
    eventPropertiesArray.push({id: "P2zcEByfWK", name: "ep_user_subscription_is_active", value: null});
  properties.epUserIsMobileAppUser !== undefined && properties.epUserIsMobileAppUser !== null ?
    eventPropertiesArray.push({id: "gkaSZCbXw8", name: "ep_user_is_mobile_app_user", value: properties.epUserIsMobileAppUser}) :
    eventPropertiesArray.push({id: "gkaSZCbXw8", name: "ep_user_is_mobile_app_user", value: null});
  properties.epUserIsAdmin !== undefined && properties.epUserIsAdmin !== null ?
    eventPropertiesArray.push({id: "1NHsnnGVd0", name: "ep_user_is_admin", value: properties.epUserIsAdmin}) :
    eventPropertiesArray.push({id: "1NHsnnGVd0", name: "ep_user_is_admin", value: null});
  properties.epUserIsTelegramConnected !== undefined && properties.epUserIsTelegramConnected !== null ?
    eventPropertiesArray.push({id: "QBh1Ik3rEm", name: "ep_user_is_telegram_connected", value: properties.epUserIsTelegramConnected}) :
    eventPropertiesArray.push({id: "QBh1Ik3rEm", name: "ep_user_is_telegram_connected", value: null});
  properties.epUserIsDiscordConnected !== undefined && properties.epUserIsDiscordConnected !== null ?
    eventPropertiesArray.push({id: "Z5anKuo4On", name: "ep_user_is_discord_connected", value: properties.epUserIsDiscordConnected}) :
    eventPropertiesArray.push({id: "Z5anKuo4On", name: "ep_user_is_discord_connected", value: null});
  properties.epUserFeatureFlags !== undefined && properties.epUserFeatureFlags !== null ?
    eventPropertiesArray.push({id: "ZkS2YBJULL", name: "ep_user_feature_flags", value: properties.epUserFeatureFlags}) :
    eventPropertiesArray.push({id: "ZkS2YBJULL", name: "ep_user_feature_flags", value: null});
  properties.epUserIsDarkMode !== undefined && properties.epUserIsDarkMode !== null ?
    eventPropertiesArray.push({id: "pZYzhjQhIW", name: "ep_user_is_dark_mode", value: properties.epUserIsDarkMode}) :
    eventPropertiesArray.push({id: "pZYzhjQhIW", name: "ep_user_is_dark_mode", value: null});
  properties.isTelegramMiniApp !== undefined && properties.isTelegramMiniApp !== null ?
    eventPropertiesArray.push({id: "vh-KiP-5Q", name: "is_telegram_mini_app", value: properties.isTelegramMiniApp}) :
    eventPropertiesArray.push({id: "vh-KiP-5Q", name: "is_telegram_mini_app", value: null});
  eventPropertiesArray.push({id: "WN7yP-IxTA", name: "platform", value: sysPlatform});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "uTc5_Q6sTt", "baffc7a39d0e1b7489e0ca4f1a4ca5fd28f0e86d4c2028ec362fb270565d3f45", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Onboarding - Join Free Group View", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("uTc5_Q6sTt", "Onboarding - Join Free Group View", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Onboarding - Join Free Group View", eventProperties, "uTc5_Q6sTt", "baffc7a39d0e1b7489e0ca4f1a4ca5fd28f0e86d4c2028ec362fb270565d3f45");
    }
    // destination Mixpanel
    Mixpanel.logEvent("Onboarding - Join Free Group View", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface WatchlistMarketsViewWebsiteProperties {
  epUserSubscriptionDuration: number | null | undefined;
  epUserSubscriptionPlan: EpUserSubscriptionPlanValueType | null | undefined;
  epUserSubscriptionIsActive: boolean | null | undefined;
  epUserIsMobileAppUser: boolean | null | undefined;
  epUserIsAdmin: boolean | null | undefined;
  epUserIsTelegramConnected: boolean | null | undefined;
  epUserIsDiscordConnected: boolean | null | undefined;
  epUserFeatureFlags: string[] | null | undefined;
  epUserIsDarkMode: boolean | null | undefined;
  isTelegramMiniApp: boolean | null | undefined;
}
/**
 * Watchlist / Markets View (Website): User opened the Watchlist / Markets (Website)
 * 
 * @param properties the properties associatied with this event
 * @param properties.epUserSubscriptionDuration: The current subscription duration for the user, in days. Not sent for users with Expired or Trial subscription plans.
 * @param properties.epUserSubscriptionPlan: The current subscription plan for the user. Users without an active subscription should have the value set to Expired.
 * @param properties.epUserSubscriptionIsActive: Set to True if the user has an active subscription (the last subscription expiration date is smaller than the current date).
 * @param properties.epUserIsMobileAppUser: no description
 * @param properties.epUserIsAdmin: no description
 * @param properties.epUserIsTelegramConnected: no description
 * @param properties.epUserIsDiscordConnected: no description
 * @param properties.epUserFeatureFlags: no description
 * @param properties.epUserIsDarkMode: no description
 * @param properties.isTelegramMiniApp: no description
 * 
 * @see {@link https://www.avo.app/schemas/Zba2v6MXsSx1EdxPIQKm/events/GFuggQQfQP}
 */
export function watchlistMarketsViewWebsite(properties: WatchlistMarketsViewWebsiteProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  properties.epUserSubscriptionDuration !== undefined && properties.epUserSubscriptionDuration !== null ?
    eventPropertiesArray.push({id: "BrNPvrBkq", name: "ep_user_subscription_duration", value: properties.epUserSubscriptionDuration}) :
    eventPropertiesArray.push({id: "BrNPvrBkq", name: "ep_user_subscription_duration", value: null});
  properties.epUserSubscriptionPlan !== undefined && properties.epUserSubscriptionPlan !== null ?
    eventPropertiesArray.push({id: "Ak0bD3528L", name: "ep_user_subscription_plan", value: properties.epUserSubscriptionPlan}) :
    eventPropertiesArray.push({id: "Ak0bD3528L", name: "ep_user_subscription_plan", value: null});
  properties.epUserSubscriptionIsActive !== undefined && properties.epUserSubscriptionIsActive !== null ?
    eventPropertiesArray.push({id: "P2zcEByfWK", name: "ep_user_subscription_is_active", value: properties.epUserSubscriptionIsActive}) :
    eventPropertiesArray.push({id: "P2zcEByfWK", name: "ep_user_subscription_is_active", value: null});
  properties.epUserIsMobileAppUser !== undefined && properties.epUserIsMobileAppUser !== null ?
    eventPropertiesArray.push({id: "gkaSZCbXw8", name: "ep_user_is_mobile_app_user", value: properties.epUserIsMobileAppUser}) :
    eventPropertiesArray.push({id: "gkaSZCbXw8", name: "ep_user_is_mobile_app_user", value: null});
  properties.epUserIsAdmin !== undefined && properties.epUserIsAdmin !== null ?
    eventPropertiesArray.push({id: "1NHsnnGVd0", name: "ep_user_is_admin", value: properties.epUserIsAdmin}) :
    eventPropertiesArray.push({id: "1NHsnnGVd0", name: "ep_user_is_admin", value: null});
  properties.epUserIsTelegramConnected !== undefined && properties.epUserIsTelegramConnected !== null ?
    eventPropertiesArray.push({id: "QBh1Ik3rEm", name: "ep_user_is_telegram_connected", value: properties.epUserIsTelegramConnected}) :
    eventPropertiesArray.push({id: "QBh1Ik3rEm", name: "ep_user_is_telegram_connected", value: null});
  properties.epUserIsDiscordConnected !== undefined && properties.epUserIsDiscordConnected !== null ?
    eventPropertiesArray.push({id: "Z5anKuo4On", name: "ep_user_is_discord_connected", value: properties.epUserIsDiscordConnected}) :
    eventPropertiesArray.push({id: "Z5anKuo4On", name: "ep_user_is_discord_connected", value: null});
  properties.epUserFeatureFlags !== undefined && properties.epUserFeatureFlags !== null ?
    eventPropertiesArray.push({id: "ZkS2YBJULL", name: "ep_user_feature_flags", value: properties.epUserFeatureFlags}) :
    eventPropertiesArray.push({id: "ZkS2YBJULL", name: "ep_user_feature_flags", value: null});
  properties.epUserIsDarkMode !== undefined && properties.epUserIsDarkMode !== null ?
    eventPropertiesArray.push({id: "pZYzhjQhIW", name: "ep_user_is_dark_mode", value: properties.epUserIsDarkMode}) :
    eventPropertiesArray.push({id: "pZYzhjQhIW", name: "ep_user_is_dark_mode", value: null});
  properties.isTelegramMiniApp !== undefined && properties.isTelegramMiniApp !== null ?
    eventPropertiesArray.push({id: "vh-KiP-5Q", name: "is_telegram_mini_app", value: properties.isTelegramMiniApp}) :
    eventPropertiesArray.push({id: "vh-KiP-5Q", name: "is_telegram_mini_app", value: null});
  eventPropertiesArray.push({id: "WN7yP-IxTA", name: "platform", value: sysPlatform});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "GFuggQQfQP", "d1310736170e786b3891ab72ff6932faf8d29138fd2c131b6e168be4144b89d9", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Watchlist / Markets View (Website)", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("GFuggQQfQP", "Watchlist / Markets View (Website)", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Watchlist / Markets View (Website)", eventProperties, "GFuggQQfQP", "d1310736170e786b3891ab72ff6932faf8d29138fd2c131b6e168be4144b89d9");
    }
    // destination Mixpanel
    Mixpanel.logEvent("Watchlist / Markets View (Website)", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface ClosedTradesViewProperties {
  epUserSubscriptionDuration: number | null | undefined;
  epUserSubscriptionPlan: EpUserSubscriptionPlanValueType | null | undefined;
  epUserSubscriptionIsActive: boolean | null | undefined;
  epUserIsMobileAppUser: boolean | null | undefined;
  epUserIsAdmin: boolean | null | undefined;
  epUserIsTelegramConnected: boolean | null | undefined;
  epUserIsDiscordConnected: boolean | null | undefined;
  epUserFeatureFlags: string[] | null | undefined;
  epUserIsDarkMode: boolean | null | undefined;
  isTelegramMiniApp: boolean | null | undefined;
  epUserTotalAutoTradingGroupsCount: number | null | undefined;
  epUserTotalAutoTradingGroupsNames: string[] | null | undefined;
  epUserCurrentAutoTradingGroupsCount: number | null | undefined;
  epUserCurrentAutoTradingGroupsNames: string[] | null | undefined;
  epUserGroupsCount: number | null | undefined;
  epUserGroupsNames: string[] | null | undefined;
}
/**
 * Closed Trades View: User views the closed trades page on the app (filtered on closed), website or bot.
 * 
 * @param properties the properties associatied with this event
 * @param properties.epUserSubscriptionDuration: The current subscription duration for the user, in days. Not sent for users with Expired or Trial subscription plans.
 * @param properties.epUserSubscriptionPlan: The current subscription plan for the user. Users without an active subscription should have the value set to Expired.
 * @param properties.epUserSubscriptionIsActive: Set to True if the user has an active subscription (the last subscription expiration date is smaller than the current date).
 * @param properties.epUserIsMobileAppUser: no description
 * @param properties.epUserIsAdmin: no description
 * @param properties.epUserIsTelegramConnected: no description
 * @param properties.epUserIsDiscordConnected: no description
 * @param properties.epUserFeatureFlags: no description
 * @param properties.epUserIsDarkMode: no description
 * @param properties.isTelegramMiniApp: no description
 * @param properties.epUserTotalAutoTradingGroupsCount: The total number of groups the user has ever had connected with auto-trading to any client.
 * @param properties.epUserTotalAutoTradingGroupsNames: The names of the groups that the user has ever had connected with auto-trading to any client.
 * @param properties.epUserCurrentAutoTradingGroupsCount: The number of groups the user currently has connected with auto-trading to an active client. This number represents the number of groups the user is actively following and trading based on. This does not include groups that are connected to clients that have auto-trading disabled.
 * @param properties.epUserCurrentAutoTradingGroupsNames: The names list of the groups the user currently has connected with auto-trading to an active client. This list represents the names of groups the user is actively following and trading based on. This does not include groups that are connected to clients that have auto-trading disabled.
 * @param properties.epUserGroupsCount: The number of Telegram channels the user is currently a member of.
 * @param properties.epUserGroupsNames: The names list of Telegram channels the user is currently a member of.
 * 
 * @see {@link https://www.avo.app/schemas/Zba2v6MXsSx1EdxPIQKm/events/Fhjav1dXn6}
 */
export function closedTradesView(properties: ClosedTradesViewProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  properties.epUserSubscriptionDuration !== undefined && properties.epUserSubscriptionDuration !== null ?
    eventPropertiesArray.push({id: "BrNPvrBkq", name: "ep_user_subscription_duration", value: properties.epUserSubscriptionDuration}) :
    eventPropertiesArray.push({id: "BrNPvrBkq", name: "ep_user_subscription_duration", value: null});
  properties.epUserSubscriptionPlan !== undefined && properties.epUserSubscriptionPlan !== null ?
    eventPropertiesArray.push({id: "Ak0bD3528L", name: "ep_user_subscription_plan", value: properties.epUserSubscriptionPlan}) :
    eventPropertiesArray.push({id: "Ak0bD3528L", name: "ep_user_subscription_plan", value: null});
  properties.epUserSubscriptionIsActive !== undefined && properties.epUserSubscriptionIsActive !== null ?
    eventPropertiesArray.push({id: "P2zcEByfWK", name: "ep_user_subscription_is_active", value: properties.epUserSubscriptionIsActive}) :
    eventPropertiesArray.push({id: "P2zcEByfWK", name: "ep_user_subscription_is_active", value: null});
  properties.epUserIsMobileAppUser !== undefined && properties.epUserIsMobileAppUser !== null ?
    eventPropertiesArray.push({id: "gkaSZCbXw8", name: "ep_user_is_mobile_app_user", value: properties.epUserIsMobileAppUser}) :
    eventPropertiesArray.push({id: "gkaSZCbXw8", name: "ep_user_is_mobile_app_user", value: null});
  properties.epUserIsAdmin !== undefined && properties.epUserIsAdmin !== null ?
    eventPropertiesArray.push({id: "1NHsnnGVd0", name: "ep_user_is_admin", value: properties.epUserIsAdmin}) :
    eventPropertiesArray.push({id: "1NHsnnGVd0", name: "ep_user_is_admin", value: null});
  properties.epUserIsTelegramConnected !== undefined && properties.epUserIsTelegramConnected !== null ?
    eventPropertiesArray.push({id: "QBh1Ik3rEm", name: "ep_user_is_telegram_connected", value: properties.epUserIsTelegramConnected}) :
    eventPropertiesArray.push({id: "QBh1Ik3rEm", name: "ep_user_is_telegram_connected", value: null});
  properties.epUserIsDiscordConnected !== undefined && properties.epUserIsDiscordConnected !== null ?
    eventPropertiesArray.push({id: "Z5anKuo4On", name: "ep_user_is_discord_connected", value: properties.epUserIsDiscordConnected}) :
    eventPropertiesArray.push({id: "Z5anKuo4On", name: "ep_user_is_discord_connected", value: null});
  properties.epUserFeatureFlags !== undefined && properties.epUserFeatureFlags !== null ?
    eventPropertiesArray.push({id: "ZkS2YBJULL", name: "ep_user_feature_flags", value: properties.epUserFeatureFlags}) :
    eventPropertiesArray.push({id: "ZkS2YBJULL", name: "ep_user_feature_flags", value: null});
  properties.epUserIsDarkMode !== undefined && properties.epUserIsDarkMode !== null ?
    eventPropertiesArray.push({id: "pZYzhjQhIW", name: "ep_user_is_dark_mode", value: properties.epUserIsDarkMode}) :
    eventPropertiesArray.push({id: "pZYzhjQhIW", name: "ep_user_is_dark_mode", value: null});
  properties.isTelegramMiniApp !== undefined && properties.isTelegramMiniApp !== null ?
    eventPropertiesArray.push({id: "vh-KiP-5Q", name: "is_telegram_mini_app", value: properties.isTelegramMiniApp}) :
    eventPropertiesArray.push({id: "vh-KiP-5Q", name: "is_telegram_mini_app", value: null});
  properties.epUserTotalAutoTradingGroupsCount !== undefined && properties.epUserTotalAutoTradingGroupsCount !== null ?
    eventPropertiesArray.push({id: "F33-9bIqF0", name: "ep_user_total_auto_trading_groups_count", value: properties.epUserTotalAutoTradingGroupsCount}) :
    eventPropertiesArray.push({id: "F33-9bIqF0", name: "ep_user_total_auto_trading_groups_count", value: null});
  properties.epUserTotalAutoTradingGroupsNames !== undefined && properties.epUserTotalAutoTradingGroupsNames !== null ?
    eventPropertiesArray.push({id: "VxrddG5osk", name: "ep_user_total_auto_trading_groups_names", value: properties.epUserTotalAutoTradingGroupsNames}) :
    eventPropertiesArray.push({id: "VxrddG5osk", name: "ep_user_total_auto_trading_groups_names", value: null});
  properties.epUserCurrentAutoTradingGroupsCount !== undefined && properties.epUserCurrentAutoTradingGroupsCount !== null ?
    eventPropertiesArray.push({id: "PrQVf8bCQZ", name: "ep_user_current_auto_trading_groups_count", value: properties.epUserCurrentAutoTradingGroupsCount}) :
    eventPropertiesArray.push({id: "PrQVf8bCQZ", name: "ep_user_current_auto_trading_groups_count", value: null});
  properties.epUserCurrentAutoTradingGroupsNames !== undefined && properties.epUserCurrentAutoTradingGroupsNames !== null ?
    eventPropertiesArray.push({id: "S44gtOE_4c", name: "ep_user_current_auto_trading_groups_names", value: properties.epUserCurrentAutoTradingGroupsNames}) :
    eventPropertiesArray.push({id: "S44gtOE_4c", name: "ep_user_current_auto_trading_groups_names", value: null});
  properties.epUserGroupsCount !== undefined && properties.epUserGroupsCount !== null ?
    eventPropertiesArray.push({id: "Daij3OzuMn", name: "ep_user_groups_count", value: properties.epUserGroupsCount}) :
    eventPropertiesArray.push({id: "Daij3OzuMn", name: "ep_user_groups_count", value: null});
  properties.epUserGroupsNames !== undefined && properties.epUserGroupsNames !== null ?
    eventPropertiesArray.push({id: "skk1UTP7Cq", name: "ep_user_groups_names", value: properties.epUserGroupsNames}) :
    eventPropertiesArray.push({id: "skk1UTP7Cq", name: "ep_user_groups_names", value: null});
  eventPropertiesArray.push({id: "WN7yP-IxTA", name: "platform", value: sysPlatform});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "Fhjav1dXn6", "71e1b841da032343d1fddc0367652053af0872e01c640c2bbd25d2f369c7eba4", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Closed Trades View", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("Fhjav1dXn6", "Closed Trades View", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Closed Trades View", eventProperties, "Fhjav1dXn6", "71e1b841da032343d1fddc0367652053af0872e01c640c2bbd25d2f369c7eba4");
    }
    // destination Mixpanel
    Mixpanel.logEvent("Closed Trades View", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface PortfolioCoinsViewProperties {
  epUserSubscriptionDuration: number | null | undefined;
  epUserSubscriptionPlan: EpUserSubscriptionPlanValueType | null | undefined;
  epUserSubscriptionIsActive: boolean | null | undefined;
  epUserIsMobileAppUser: boolean | null | undefined;
  epUserIsAdmin: boolean | null | undefined;
  epUserIsTelegramConnected: boolean | null | undefined;
  epUserIsDiscordConnected: boolean | null | undefined;
  epUserFeatureFlags: string[] | null | undefined;
  epUserIsDarkMode: boolean | null | undefined;
  isTelegramMiniApp: boolean | null | undefined;
}
/**
 * Portfolio Coins View: The user opens the Portfolio 'Coins' View on the app and on the Website (Currently no such view for the bot) 291221
 * 
 * @param properties the properties associatied with this event
 * @param properties.epUserSubscriptionDuration: The current subscription duration for the user, in days. Not sent for users with Expired or Trial subscription plans.
 * @param properties.epUserSubscriptionPlan: The current subscription plan for the user. Users without an active subscription should have the value set to Expired.
 * @param properties.epUserSubscriptionIsActive: Set to True if the user has an active subscription (the last subscription expiration date is smaller than the current date).
 * @param properties.epUserIsMobileAppUser: no description
 * @param properties.epUserIsAdmin: no description
 * @param properties.epUserIsTelegramConnected: no description
 * @param properties.epUserIsDiscordConnected: no description
 * @param properties.epUserFeatureFlags: no description
 * @param properties.epUserIsDarkMode: no description
 * @param properties.isTelegramMiniApp: no description
 * 
 * @see {@link https://www.avo.app/schemas/Zba2v6MXsSx1EdxPIQKm/events/uDcooYTd4b}
 */
export function portfolioCoinsView(properties: PortfolioCoinsViewProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  properties.epUserSubscriptionDuration !== undefined && properties.epUserSubscriptionDuration !== null ?
    eventPropertiesArray.push({id: "BrNPvrBkq", name: "ep_user_subscription_duration", value: properties.epUserSubscriptionDuration}) :
    eventPropertiesArray.push({id: "BrNPvrBkq", name: "ep_user_subscription_duration", value: null});
  properties.epUserSubscriptionPlan !== undefined && properties.epUserSubscriptionPlan !== null ?
    eventPropertiesArray.push({id: "Ak0bD3528L", name: "ep_user_subscription_plan", value: properties.epUserSubscriptionPlan}) :
    eventPropertiesArray.push({id: "Ak0bD3528L", name: "ep_user_subscription_plan", value: null});
  properties.epUserSubscriptionIsActive !== undefined && properties.epUserSubscriptionIsActive !== null ?
    eventPropertiesArray.push({id: "P2zcEByfWK", name: "ep_user_subscription_is_active", value: properties.epUserSubscriptionIsActive}) :
    eventPropertiesArray.push({id: "P2zcEByfWK", name: "ep_user_subscription_is_active", value: null});
  properties.epUserIsMobileAppUser !== undefined && properties.epUserIsMobileAppUser !== null ?
    eventPropertiesArray.push({id: "gkaSZCbXw8", name: "ep_user_is_mobile_app_user", value: properties.epUserIsMobileAppUser}) :
    eventPropertiesArray.push({id: "gkaSZCbXw8", name: "ep_user_is_mobile_app_user", value: null});
  properties.epUserIsAdmin !== undefined && properties.epUserIsAdmin !== null ?
    eventPropertiesArray.push({id: "1NHsnnGVd0", name: "ep_user_is_admin", value: properties.epUserIsAdmin}) :
    eventPropertiesArray.push({id: "1NHsnnGVd0", name: "ep_user_is_admin", value: null});
  properties.epUserIsTelegramConnected !== undefined && properties.epUserIsTelegramConnected !== null ?
    eventPropertiesArray.push({id: "QBh1Ik3rEm", name: "ep_user_is_telegram_connected", value: properties.epUserIsTelegramConnected}) :
    eventPropertiesArray.push({id: "QBh1Ik3rEm", name: "ep_user_is_telegram_connected", value: null});
  properties.epUserIsDiscordConnected !== undefined && properties.epUserIsDiscordConnected !== null ?
    eventPropertiesArray.push({id: "Z5anKuo4On", name: "ep_user_is_discord_connected", value: properties.epUserIsDiscordConnected}) :
    eventPropertiesArray.push({id: "Z5anKuo4On", name: "ep_user_is_discord_connected", value: null});
  properties.epUserFeatureFlags !== undefined && properties.epUserFeatureFlags !== null ?
    eventPropertiesArray.push({id: "ZkS2YBJULL", name: "ep_user_feature_flags", value: properties.epUserFeatureFlags}) :
    eventPropertiesArray.push({id: "ZkS2YBJULL", name: "ep_user_feature_flags", value: null});
  properties.epUserIsDarkMode !== undefined && properties.epUserIsDarkMode !== null ?
    eventPropertiesArray.push({id: "pZYzhjQhIW", name: "ep_user_is_dark_mode", value: properties.epUserIsDarkMode}) :
    eventPropertiesArray.push({id: "pZYzhjQhIW", name: "ep_user_is_dark_mode", value: null});
  properties.isTelegramMiniApp !== undefined && properties.isTelegramMiniApp !== null ?
    eventPropertiesArray.push({id: "vh-KiP-5Q", name: "is_telegram_mini_app", value: properties.isTelegramMiniApp}) :
    eventPropertiesArray.push({id: "vh-KiP-5Q", name: "is_telegram_mini_app", value: null});
  eventPropertiesArray.push({id: "WN7yP-IxTA", name: "platform", value: sysPlatform});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "uDcooYTd4b", "606d18774587121b453ced68b902a3d7377b9a0cf2b21be30c0e3601f445d7df", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Portfolio Coins View", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("uDcooYTd4b", "Portfolio Coins View", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Portfolio Coins View", eventProperties, "uDcooYTd4b", "606d18774587121b453ced68b902a3d7377b9a0cf2b21be30c0e3601f445d7df");
    }
    // destination Mixpanel
    Mixpanel.logEvent("Portfolio Coins View", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface SignalChannelsViewProperties {
  websiteOriginTimeOfAction: WebsiteOriginTimeOfActionValueType;
}
/**
 * Signal Channels View: User who view the Signals Page (Channels View) before selecting a specific channel. 
 * 
 * @param properties the properties associatied with this event
 * @param properties.websiteOriginTimeOfAction: no description
 * 
 * @see {@link https://www.avo.app/schemas/Zba2v6MXsSx1EdxPIQKm/events/KwMtBaWt9}
 */
export function signalChannelsView(properties: SignalChannelsViewProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({id: "h_JM3gZSVo", name: "website_origin_time_of_action", value: properties.websiteOriginTimeOfAction});
  eventPropertiesArray.push({id: "WN7yP-IxTA", name: "platform", value: sysPlatform});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "KwMtBaWt9", "c14bdd85d91056d9ff908b153fd93bae33d5a73f45cfbdd2f728935b36ba1009", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Signal Channels View", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("KwMtBaWt9", "Signal Channels View", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Signal Channels View", eventProperties, "KwMtBaWt9", "c14bdd85d91056d9ff908b153fd93bae33d5a73f45cfbdd2f728935b36ba1009");
    }
    // destination Mixpanel
    Mixpanel.logEvent("Signal Channels View", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface OpenSignalsViewProperties {
  epUserSubscriptionDuration: number | null | undefined;
  epUserSubscriptionPlan: EpUserSubscriptionPlanValueType;
  epUserSubscriptionIsActive: boolean | null | undefined;
  epUserIsMobileAppUser: boolean | null | undefined;
  epUserIsAdmin: boolean | null | undefined;
  epUserIsTelegramConnected: boolean | null | undefined;
  epUserIsDiscordConnected: boolean | null | undefined;
  epUserFeatureFlags: string[] | null | undefined;
  epUserIsDarkMode: boolean | null | undefined;
  isTelegramMiniApp: boolean | null | undefined;
  groupChannelId: number;
}
/**
 * Open Signals View: User views the Open Signals View (typically after selecting a channel in the Signals Channel View)
 * 
 * @param properties the properties associatied with this event
 * @param properties.epUserSubscriptionDuration: The current subscription duration for the user, in days. Not sent for users with Expired or Trial subscription plans.
 * @param properties.epUserSubscriptionPlan: The current subscription plan for the user. Users without an active subscription should have the value set to Expired.
 * @param properties.epUserSubscriptionIsActive: Set to True if the user has an active subscription (the last subscription expiration date is smaller than the current date).
 * @param properties.epUserIsMobileAppUser: no description
 * @param properties.epUserIsAdmin: no description
 * @param properties.epUserIsTelegramConnected: no description
 * @param properties.epUserIsDiscordConnected: no description
 * @param properties.epUserFeatureFlags: no description
 * @param properties.epUserIsDarkMode: no description
 * @param properties.isTelegramMiniApp: no description
 * @param properties.groupChannelId: The current channel/group id that was recorded as part of the event
 * 
 * @see {@link https://www.avo.app/schemas/Zba2v6MXsSx1EdxPIQKm/events/I25HxvF1Vy}
 */
export function openSignalsView(properties: OpenSignalsViewProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  properties.epUserSubscriptionDuration !== undefined && properties.epUserSubscriptionDuration !== null ?
    eventPropertiesArray.push({id: "BrNPvrBkq", name: "ep_user_subscription_duration", value: properties.epUserSubscriptionDuration}) :
    eventPropertiesArray.push({id: "BrNPvrBkq", name: "ep_user_subscription_duration", value: null});
  eventPropertiesArray.push({id: "Ak0bD3528L", name: "ep_user_subscription_plan", value: properties.epUserSubscriptionPlan});
  properties.epUserSubscriptionIsActive !== undefined && properties.epUserSubscriptionIsActive !== null ?
    eventPropertiesArray.push({id: "P2zcEByfWK", name: "ep_user_subscription_is_active", value: properties.epUserSubscriptionIsActive}) :
    eventPropertiesArray.push({id: "P2zcEByfWK", name: "ep_user_subscription_is_active", value: null});
  properties.epUserIsMobileAppUser !== undefined && properties.epUserIsMobileAppUser !== null ?
    eventPropertiesArray.push({id: "gkaSZCbXw8", name: "ep_user_is_mobile_app_user", value: properties.epUserIsMobileAppUser}) :
    eventPropertiesArray.push({id: "gkaSZCbXw8", name: "ep_user_is_mobile_app_user", value: null});
  properties.epUserIsAdmin !== undefined && properties.epUserIsAdmin !== null ?
    eventPropertiesArray.push({id: "1NHsnnGVd0", name: "ep_user_is_admin", value: properties.epUserIsAdmin}) :
    eventPropertiesArray.push({id: "1NHsnnGVd0", name: "ep_user_is_admin", value: null});
  properties.epUserIsTelegramConnected !== undefined && properties.epUserIsTelegramConnected !== null ?
    eventPropertiesArray.push({id: "QBh1Ik3rEm", name: "ep_user_is_telegram_connected", value: properties.epUserIsTelegramConnected}) :
    eventPropertiesArray.push({id: "QBh1Ik3rEm", name: "ep_user_is_telegram_connected", value: null});
  properties.epUserIsDiscordConnected !== undefined && properties.epUserIsDiscordConnected !== null ?
    eventPropertiesArray.push({id: "Z5anKuo4On", name: "ep_user_is_discord_connected", value: properties.epUserIsDiscordConnected}) :
    eventPropertiesArray.push({id: "Z5anKuo4On", name: "ep_user_is_discord_connected", value: null});
  properties.epUserFeatureFlags !== undefined && properties.epUserFeatureFlags !== null ?
    eventPropertiesArray.push({id: "ZkS2YBJULL", name: "ep_user_feature_flags", value: properties.epUserFeatureFlags}) :
    eventPropertiesArray.push({id: "ZkS2YBJULL", name: "ep_user_feature_flags", value: null});
  properties.epUserIsDarkMode !== undefined && properties.epUserIsDarkMode !== null ?
    eventPropertiesArray.push({id: "pZYzhjQhIW", name: "ep_user_is_dark_mode", value: properties.epUserIsDarkMode}) :
    eventPropertiesArray.push({id: "pZYzhjQhIW", name: "ep_user_is_dark_mode", value: null});
  properties.isTelegramMiniApp !== undefined && properties.isTelegramMiniApp !== null ?
    eventPropertiesArray.push({id: "vh-KiP-5Q", name: "is_telegram_mini_app", value: properties.isTelegramMiniApp}) :
    eventPropertiesArray.push({id: "vh-KiP-5Q", name: "is_telegram_mini_app", value: null});
  eventPropertiesArray.push({id: "dcXTMVDlJn", name: "group_channel_id", value: properties.groupChannelId});
  eventPropertiesArray.push({id: "WN7yP-IxTA", name: "platform", value: sysPlatform});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "I25HxvF1Vy", "8727e6b47502dbcccc18ed4c9aaf4424f6a70c28a6ea7b8220f813ec5c947fb4", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Open Signals View", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("I25HxvF1Vy", "Open Signals View", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Open Signals View", eventProperties, "I25HxvF1Vy", "8727e6b47502dbcccc18ed4c9aaf4424f6a70c28a6ea7b8220f813ec5c947fb4");
    }
    // destination Mixpanel
    Mixpanel.logEvent("Open Signals View", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface ClosedSignalsViewProperties {
  epUserSubscriptionDuration: number | null | undefined;
  epUserSubscriptionPlan: EpUserSubscriptionPlanValueType;
  epUserSubscriptionIsActive: boolean | null | undefined;
  epUserIsMobileAppUser: boolean | null | undefined;
  epUserIsAdmin: boolean | null | undefined;
  epUserIsTelegramConnected: boolean | null | undefined;
  epUserIsDiscordConnected: boolean | null | undefined;
  epUserFeatureFlags: string[] | null | undefined;
  epUserIsDarkMode: boolean | null | undefined;
  isTelegramMiniApp: boolean | null | undefined;
  groupChannelId: number;
}
/**
 * Closed Signals View: User views the Closed signals view (for a specific channel)
 * 
 * @param properties the properties associatied with this event
 * @param properties.epUserSubscriptionDuration: The current subscription duration for the user, in days. Not sent for users with Expired or Trial subscription plans.
 * @param properties.epUserSubscriptionPlan: The current subscription plan for the user. Users without an active subscription should have the value set to Expired.
 * @param properties.epUserSubscriptionIsActive: Set to True if the user has an active subscription (the last subscription expiration date is smaller than the current date).
 * @param properties.epUserIsMobileAppUser: no description
 * @param properties.epUserIsAdmin: no description
 * @param properties.epUserIsTelegramConnected: no description
 * @param properties.epUserIsDiscordConnected: no description
 * @param properties.epUserFeatureFlags: no description
 * @param properties.epUserIsDarkMode: no description
 * @param properties.isTelegramMiniApp: no description
 * @param properties.groupChannelId: The current channel/group id that was recorded as part of the event
 * 
 * @see {@link https://www.avo.app/schemas/Zba2v6MXsSx1EdxPIQKm/events/vXJ-eaQqL}
 */
export function closedSignalsView(properties: ClosedSignalsViewProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  properties.epUserSubscriptionDuration !== undefined && properties.epUserSubscriptionDuration !== null ?
    eventPropertiesArray.push({id: "BrNPvrBkq", name: "ep_user_subscription_duration", value: properties.epUserSubscriptionDuration}) :
    eventPropertiesArray.push({id: "BrNPvrBkq", name: "ep_user_subscription_duration", value: null});
  eventPropertiesArray.push({id: "Ak0bD3528L", name: "ep_user_subscription_plan", value: properties.epUserSubscriptionPlan});
  properties.epUserSubscriptionIsActive !== undefined && properties.epUserSubscriptionIsActive !== null ?
    eventPropertiesArray.push({id: "P2zcEByfWK", name: "ep_user_subscription_is_active", value: properties.epUserSubscriptionIsActive}) :
    eventPropertiesArray.push({id: "P2zcEByfWK", name: "ep_user_subscription_is_active", value: null});
  properties.epUserIsMobileAppUser !== undefined && properties.epUserIsMobileAppUser !== null ?
    eventPropertiesArray.push({id: "gkaSZCbXw8", name: "ep_user_is_mobile_app_user", value: properties.epUserIsMobileAppUser}) :
    eventPropertiesArray.push({id: "gkaSZCbXw8", name: "ep_user_is_mobile_app_user", value: null});
  properties.epUserIsAdmin !== undefined && properties.epUserIsAdmin !== null ?
    eventPropertiesArray.push({id: "1NHsnnGVd0", name: "ep_user_is_admin", value: properties.epUserIsAdmin}) :
    eventPropertiesArray.push({id: "1NHsnnGVd0", name: "ep_user_is_admin", value: null});
  properties.epUserIsTelegramConnected !== undefined && properties.epUserIsTelegramConnected !== null ?
    eventPropertiesArray.push({id: "QBh1Ik3rEm", name: "ep_user_is_telegram_connected", value: properties.epUserIsTelegramConnected}) :
    eventPropertiesArray.push({id: "QBh1Ik3rEm", name: "ep_user_is_telegram_connected", value: null});
  properties.epUserIsDiscordConnected !== undefined && properties.epUserIsDiscordConnected !== null ?
    eventPropertiesArray.push({id: "Z5anKuo4On", name: "ep_user_is_discord_connected", value: properties.epUserIsDiscordConnected}) :
    eventPropertiesArray.push({id: "Z5anKuo4On", name: "ep_user_is_discord_connected", value: null});
  properties.epUserFeatureFlags !== undefined && properties.epUserFeatureFlags !== null ?
    eventPropertiesArray.push({id: "ZkS2YBJULL", name: "ep_user_feature_flags", value: properties.epUserFeatureFlags}) :
    eventPropertiesArray.push({id: "ZkS2YBJULL", name: "ep_user_feature_flags", value: null});
  properties.epUserIsDarkMode !== undefined && properties.epUserIsDarkMode !== null ?
    eventPropertiesArray.push({id: "pZYzhjQhIW", name: "ep_user_is_dark_mode", value: properties.epUserIsDarkMode}) :
    eventPropertiesArray.push({id: "pZYzhjQhIW", name: "ep_user_is_dark_mode", value: null});
  properties.isTelegramMiniApp !== undefined && properties.isTelegramMiniApp !== null ?
    eventPropertiesArray.push({id: "vh-KiP-5Q", name: "is_telegram_mini_app", value: properties.isTelegramMiniApp}) :
    eventPropertiesArray.push({id: "vh-KiP-5Q", name: "is_telegram_mini_app", value: null});
  eventPropertiesArray.push({id: "dcXTMVDlJn", name: "group_channel_id", value: properties.groupChannelId});
  eventPropertiesArray.push({id: "WN7yP-IxTA", name: "platform", value: sysPlatform});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "vXJ-eaQqL", "192031028312d30bf875bf1f3b27402a39ea1fadbbb1c1f9d0d408d5cec65421", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Closed Signals View", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("vXJ-eaQqL", "Closed Signals View", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Closed Signals View", eventProperties, "vXJ-eaQqL", "192031028312d30bf875bf1f3b27402a39ea1fadbbb1c1f9d0d408d5cec65421");
    }
    // destination Mixpanel
    Mixpanel.logEvent("Closed Signals View", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface OneClickFollowSignalClickedProperties {
  epUserSubscriptionDuration: number | null | undefined;
  epUserSubscriptionPlan: EpUserSubscriptionPlanValueType;
  epUserSubscriptionIsActive: boolean | null | undefined;
  epUserIsMobileAppUser: boolean | null | undefined;
  epUserIsAdmin: boolean | null | undefined;
  epUserIsTelegramConnected: boolean | null | undefined;
  epUserIsDiscordConnected: boolean | null | undefined;
  epUserFeatureFlags: string[] | null | undefined;
  epUserIsDarkMode: boolean | null | undefined;
  isTelegramMiniApp: boolean | null | undefined;
  groupSignalId: number;
  groupChannelId: number;
}
/**
 * One Click Follow Signal Clicked: User clicks the '1 click follow' action on a specific Signal 
 * 
 * @param properties the properties associatied with this event
 * @param properties.epUserSubscriptionDuration: The current subscription duration for the user, in days. Not sent for users with Expired or Trial subscription plans.
 * @param properties.epUserSubscriptionPlan: The current subscription plan for the user. Users without an active subscription should have the value set to Expired.
 * @param properties.epUserSubscriptionIsActive: Set to True if the user has an active subscription (the last subscription expiration date is smaller than the current date).
 * @param properties.epUserIsMobileAppUser: no description
 * @param properties.epUserIsAdmin: no description
 * @param properties.epUserIsTelegramConnected: no description
 * @param properties.epUserIsDiscordConnected: no description
 * @param properties.epUserFeatureFlags: no description
 * @param properties.epUserIsDarkMode: no description
 * @param properties.isTelegramMiniApp: no description
 * @param properties.groupSignalId: the Signal ID that was followed.
 * @param properties.groupChannelId: The current channel/group id that was recorded as part of the event
 * 
 * @see {@link https://www.avo.app/schemas/Zba2v6MXsSx1EdxPIQKm/events/Qm4BZKjsR}
 */
export function oneClickFollowSignalClicked(properties: OneClickFollowSignalClickedProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  properties.epUserSubscriptionDuration !== undefined && properties.epUserSubscriptionDuration !== null ?
    eventPropertiesArray.push({id: "BrNPvrBkq", name: "ep_user_subscription_duration", value: properties.epUserSubscriptionDuration}) :
    eventPropertiesArray.push({id: "BrNPvrBkq", name: "ep_user_subscription_duration", value: null});
  eventPropertiesArray.push({id: "Ak0bD3528L", name: "ep_user_subscription_plan", value: properties.epUserSubscriptionPlan});
  properties.epUserSubscriptionIsActive !== undefined && properties.epUserSubscriptionIsActive !== null ?
    eventPropertiesArray.push({id: "P2zcEByfWK", name: "ep_user_subscription_is_active", value: properties.epUserSubscriptionIsActive}) :
    eventPropertiesArray.push({id: "P2zcEByfWK", name: "ep_user_subscription_is_active", value: null});
  properties.epUserIsMobileAppUser !== undefined && properties.epUserIsMobileAppUser !== null ?
    eventPropertiesArray.push({id: "gkaSZCbXw8", name: "ep_user_is_mobile_app_user", value: properties.epUserIsMobileAppUser}) :
    eventPropertiesArray.push({id: "gkaSZCbXw8", name: "ep_user_is_mobile_app_user", value: null});
  properties.epUserIsAdmin !== undefined && properties.epUserIsAdmin !== null ?
    eventPropertiesArray.push({id: "1NHsnnGVd0", name: "ep_user_is_admin", value: properties.epUserIsAdmin}) :
    eventPropertiesArray.push({id: "1NHsnnGVd0", name: "ep_user_is_admin", value: null});
  properties.epUserIsTelegramConnected !== undefined && properties.epUserIsTelegramConnected !== null ?
    eventPropertiesArray.push({id: "QBh1Ik3rEm", name: "ep_user_is_telegram_connected", value: properties.epUserIsTelegramConnected}) :
    eventPropertiesArray.push({id: "QBh1Ik3rEm", name: "ep_user_is_telegram_connected", value: null});
  properties.epUserIsDiscordConnected !== undefined && properties.epUserIsDiscordConnected !== null ?
    eventPropertiesArray.push({id: "Z5anKuo4On", name: "ep_user_is_discord_connected", value: properties.epUserIsDiscordConnected}) :
    eventPropertiesArray.push({id: "Z5anKuo4On", name: "ep_user_is_discord_connected", value: null});
  properties.epUserFeatureFlags !== undefined && properties.epUserFeatureFlags !== null ?
    eventPropertiesArray.push({id: "ZkS2YBJULL", name: "ep_user_feature_flags", value: properties.epUserFeatureFlags}) :
    eventPropertiesArray.push({id: "ZkS2YBJULL", name: "ep_user_feature_flags", value: null});
  properties.epUserIsDarkMode !== undefined && properties.epUserIsDarkMode !== null ?
    eventPropertiesArray.push({id: "pZYzhjQhIW", name: "ep_user_is_dark_mode", value: properties.epUserIsDarkMode}) :
    eventPropertiesArray.push({id: "pZYzhjQhIW", name: "ep_user_is_dark_mode", value: null});
  properties.isTelegramMiniApp !== undefined && properties.isTelegramMiniApp !== null ?
    eventPropertiesArray.push({id: "vh-KiP-5Q", name: "is_telegram_mini_app", value: properties.isTelegramMiniApp}) :
    eventPropertiesArray.push({id: "vh-KiP-5Q", name: "is_telegram_mini_app", value: null});
  eventPropertiesArray.push({id: "7IRi9I3Eta", name: "group_signal_id", value: properties.groupSignalId});
  eventPropertiesArray.push({id: "dcXTMVDlJn", name: "group_channel_id", value: properties.groupChannelId});
  eventPropertiesArray.push({id: "WN7yP-IxTA", name: "platform", value: sysPlatform});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "Qm4BZKjsR", "8ea898575d65480538130ed425151f3044774f50958fe6a5601ff0f3834be144", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("One Click Follow Signal Clicked", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("Qm4BZKjsR", "One Click Follow Signal Clicked", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("One Click Follow Signal Clicked", eventProperties, "Qm4BZKjsR", "8ea898575d65480538130ed425151f3044774f50958fe6a5601ff0f3834be144");
    }
    // destination Mixpanel
    Mixpanel.logEvent("One Click Follow Signal Clicked", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface UpdateTradeBasedOnSignalClickedProperties {
  epUserSubscriptionDuration: number | null | undefined;
  epUserSubscriptionPlan: EpUserSubscriptionPlanValueType;
  epUserSubscriptionIsActive: boolean | null | undefined;
  epUserIsMobileAppUser: boolean | null | undefined;
  epUserIsAdmin: boolean | null | undefined;
  epUserIsTelegramConnected: boolean | null | undefined;
  epUserIsDiscordConnected: boolean | null | undefined;
  epUserFeatureFlags: string[] | null | undefined;
  epUserIsDarkMode: boolean | null | undefined;
  isTelegramMiniApp: boolean | null | undefined;
  groupSignalId: number;
  groupChannelId: number;
}
/**
 * Update Trade Based on Signal Clicked: User clicks the 'update' action on a specific Signal 
 * 
 * @param properties the properties associatied with this event
 * @param properties.epUserSubscriptionDuration: The current subscription duration for the user, in days. Not sent for users with Expired or Trial subscription plans.
 * @param properties.epUserSubscriptionPlan: The current subscription plan for the user. Users without an active subscription should have the value set to Expired.
 * @param properties.epUserSubscriptionIsActive: Set to True if the user has an active subscription (the last subscription expiration date is smaller than the current date).
 * @param properties.epUserIsMobileAppUser: no description
 * @param properties.epUserIsAdmin: no description
 * @param properties.epUserIsTelegramConnected: no description
 * @param properties.epUserIsDiscordConnected: no description
 * @param properties.epUserFeatureFlags: no description
 * @param properties.epUserIsDarkMode: no description
 * @param properties.isTelegramMiniApp: no description
 * @param properties.groupSignalId: the Signal ID that was followed.
 * @param properties.groupChannelId: The current channel/group id that was recorded as part of the event
 * 
 * @see {@link https://www.avo.app/schemas/Zba2v6MXsSx1EdxPIQKm/events/6w26o3h2Xv}
 */
export function updateTradeBasedOnSignalClicked(properties: UpdateTradeBasedOnSignalClickedProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  properties.epUserSubscriptionDuration !== undefined && properties.epUserSubscriptionDuration !== null ?
    eventPropertiesArray.push({id: "BrNPvrBkq", name: "ep_user_subscription_duration", value: properties.epUserSubscriptionDuration}) :
    eventPropertiesArray.push({id: "BrNPvrBkq", name: "ep_user_subscription_duration", value: null});
  eventPropertiesArray.push({id: "Ak0bD3528L", name: "ep_user_subscription_plan", value: properties.epUserSubscriptionPlan});
  properties.epUserSubscriptionIsActive !== undefined && properties.epUserSubscriptionIsActive !== null ?
    eventPropertiesArray.push({id: "P2zcEByfWK", name: "ep_user_subscription_is_active", value: properties.epUserSubscriptionIsActive}) :
    eventPropertiesArray.push({id: "P2zcEByfWK", name: "ep_user_subscription_is_active", value: null});
  properties.epUserIsMobileAppUser !== undefined && properties.epUserIsMobileAppUser !== null ?
    eventPropertiesArray.push({id: "gkaSZCbXw8", name: "ep_user_is_mobile_app_user", value: properties.epUserIsMobileAppUser}) :
    eventPropertiesArray.push({id: "gkaSZCbXw8", name: "ep_user_is_mobile_app_user", value: null});
  properties.epUserIsAdmin !== undefined && properties.epUserIsAdmin !== null ?
    eventPropertiesArray.push({id: "1NHsnnGVd0", name: "ep_user_is_admin", value: properties.epUserIsAdmin}) :
    eventPropertiesArray.push({id: "1NHsnnGVd0", name: "ep_user_is_admin", value: null});
  properties.epUserIsTelegramConnected !== undefined && properties.epUserIsTelegramConnected !== null ?
    eventPropertiesArray.push({id: "QBh1Ik3rEm", name: "ep_user_is_telegram_connected", value: properties.epUserIsTelegramConnected}) :
    eventPropertiesArray.push({id: "QBh1Ik3rEm", name: "ep_user_is_telegram_connected", value: null});
  properties.epUserIsDiscordConnected !== undefined && properties.epUserIsDiscordConnected !== null ?
    eventPropertiesArray.push({id: "Z5anKuo4On", name: "ep_user_is_discord_connected", value: properties.epUserIsDiscordConnected}) :
    eventPropertiesArray.push({id: "Z5anKuo4On", name: "ep_user_is_discord_connected", value: null});
  properties.epUserFeatureFlags !== undefined && properties.epUserFeatureFlags !== null ?
    eventPropertiesArray.push({id: "ZkS2YBJULL", name: "ep_user_feature_flags", value: properties.epUserFeatureFlags}) :
    eventPropertiesArray.push({id: "ZkS2YBJULL", name: "ep_user_feature_flags", value: null});
  properties.epUserIsDarkMode !== undefined && properties.epUserIsDarkMode !== null ?
    eventPropertiesArray.push({id: "pZYzhjQhIW", name: "ep_user_is_dark_mode", value: properties.epUserIsDarkMode}) :
    eventPropertiesArray.push({id: "pZYzhjQhIW", name: "ep_user_is_dark_mode", value: null});
  properties.isTelegramMiniApp !== undefined && properties.isTelegramMiniApp !== null ?
    eventPropertiesArray.push({id: "vh-KiP-5Q", name: "is_telegram_mini_app", value: properties.isTelegramMiniApp}) :
    eventPropertiesArray.push({id: "vh-KiP-5Q", name: "is_telegram_mini_app", value: null});
  eventPropertiesArray.push({id: "7IRi9I3Eta", name: "group_signal_id", value: properties.groupSignalId});
  eventPropertiesArray.push({id: "dcXTMVDlJn", name: "group_channel_id", value: properties.groupChannelId});
  eventPropertiesArray.push({id: "WN7yP-IxTA", name: "platform", value: sysPlatform});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "6w26o3h2Xv", "dbfbaa69b10db609cba7b063dbb5db93b0c9ddbb402b6c9e4904493a4dff9f27", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Update Trade Based on Signal Clicked", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("6w26o3h2Xv", "Update Trade Based on Signal Clicked", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Update Trade Based on Signal Clicked", eventProperties, "6w26o3h2Xv", "dbfbaa69b10db609cba7b063dbb5db93b0c9ddbb402b6c9e4904493a4dff9f27");
    }
    // destination Mixpanel
    Mixpanel.logEvent("Update Trade Based on Signal Clicked", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface CloseTradeBasedOnSignalClickedProperties {
  epUserSubscriptionDuration: number | null | undefined;
  epUserSubscriptionPlan: EpUserSubscriptionPlanValueType;
  epUserSubscriptionIsActive: boolean | null | undefined;
  epUserIsMobileAppUser: boolean | null | undefined;
  epUserIsAdmin: boolean | null | undefined;
  epUserIsTelegramConnected: boolean | null | undefined;
  epUserIsDiscordConnected: boolean | null | undefined;
  epUserFeatureFlags: string[] | null | undefined;
  epUserIsDarkMode: boolean | null | undefined;
  isTelegramMiniApp: boolean | null | undefined;
  groupSignalId: number;
  groupChannelId: number;
}
/**
 * Close Trade Based on Signal Clicked: User clicks the 'Close' action on a specific Signal (and closes an open traded that is currently following this signal)
 * 
 * @param properties the properties associatied with this event
 * @param properties.epUserSubscriptionDuration: The current subscription duration for the user, in days. Not sent for users with Expired or Trial subscription plans.
 * @param properties.epUserSubscriptionPlan: The current subscription plan for the user. Users without an active subscription should have the value set to Expired.
 * @param properties.epUserSubscriptionIsActive: Set to True if the user has an active subscription (the last subscription expiration date is smaller than the current date).
 * @param properties.epUserIsMobileAppUser: no description
 * @param properties.epUserIsAdmin: no description
 * @param properties.epUserIsTelegramConnected: no description
 * @param properties.epUserIsDiscordConnected: no description
 * @param properties.epUserFeatureFlags: no description
 * @param properties.epUserIsDarkMode: no description
 * @param properties.isTelegramMiniApp: no description
 * @param properties.groupSignalId: the Signal ID that was followed.
 * @param properties.groupChannelId: The current channel/group id that was recorded as part of the event
 * 
 * @see {@link https://www.avo.app/schemas/Zba2v6MXsSx1EdxPIQKm/events/oidL0MPbc_}
 */
export function closeTradeBasedOnSignalClicked(properties: CloseTradeBasedOnSignalClickedProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  properties.epUserSubscriptionDuration !== undefined && properties.epUserSubscriptionDuration !== null ?
    eventPropertiesArray.push({id: "BrNPvrBkq", name: "ep_user_subscription_duration", value: properties.epUserSubscriptionDuration}) :
    eventPropertiesArray.push({id: "BrNPvrBkq", name: "ep_user_subscription_duration", value: null});
  eventPropertiesArray.push({id: "Ak0bD3528L", name: "ep_user_subscription_plan", value: properties.epUserSubscriptionPlan});
  properties.epUserSubscriptionIsActive !== undefined && properties.epUserSubscriptionIsActive !== null ?
    eventPropertiesArray.push({id: "P2zcEByfWK", name: "ep_user_subscription_is_active", value: properties.epUserSubscriptionIsActive}) :
    eventPropertiesArray.push({id: "P2zcEByfWK", name: "ep_user_subscription_is_active", value: null});
  properties.epUserIsMobileAppUser !== undefined && properties.epUserIsMobileAppUser !== null ?
    eventPropertiesArray.push({id: "gkaSZCbXw8", name: "ep_user_is_mobile_app_user", value: properties.epUserIsMobileAppUser}) :
    eventPropertiesArray.push({id: "gkaSZCbXw8", name: "ep_user_is_mobile_app_user", value: null});
  properties.epUserIsAdmin !== undefined && properties.epUserIsAdmin !== null ?
    eventPropertiesArray.push({id: "1NHsnnGVd0", name: "ep_user_is_admin", value: properties.epUserIsAdmin}) :
    eventPropertiesArray.push({id: "1NHsnnGVd0", name: "ep_user_is_admin", value: null});
  properties.epUserIsTelegramConnected !== undefined && properties.epUserIsTelegramConnected !== null ?
    eventPropertiesArray.push({id: "QBh1Ik3rEm", name: "ep_user_is_telegram_connected", value: properties.epUserIsTelegramConnected}) :
    eventPropertiesArray.push({id: "QBh1Ik3rEm", name: "ep_user_is_telegram_connected", value: null});
  properties.epUserIsDiscordConnected !== undefined && properties.epUserIsDiscordConnected !== null ?
    eventPropertiesArray.push({id: "Z5anKuo4On", name: "ep_user_is_discord_connected", value: properties.epUserIsDiscordConnected}) :
    eventPropertiesArray.push({id: "Z5anKuo4On", name: "ep_user_is_discord_connected", value: null});
  properties.epUserFeatureFlags !== undefined && properties.epUserFeatureFlags !== null ?
    eventPropertiesArray.push({id: "ZkS2YBJULL", name: "ep_user_feature_flags", value: properties.epUserFeatureFlags}) :
    eventPropertiesArray.push({id: "ZkS2YBJULL", name: "ep_user_feature_flags", value: null});
  properties.epUserIsDarkMode !== undefined && properties.epUserIsDarkMode !== null ?
    eventPropertiesArray.push({id: "pZYzhjQhIW", name: "ep_user_is_dark_mode", value: properties.epUserIsDarkMode}) :
    eventPropertiesArray.push({id: "pZYzhjQhIW", name: "ep_user_is_dark_mode", value: null});
  properties.isTelegramMiniApp !== undefined && properties.isTelegramMiniApp !== null ?
    eventPropertiesArray.push({id: "vh-KiP-5Q", name: "is_telegram_mini_app", value: properties.isTelegramMiniApp}) :
    eventPropertiesArray.push({id: "vh-KiP-5Q", name: "is_telegram_mini_app", value: null});
  eventPropertiesArray.push({id: "7IRi9I3Eta", name: "group_signal_id", value: properties.groupSignalId});
  eventPropertiesArray.push({id: "dcXTMVDlJn", name: "group_channel_id", value: properties.groupChannelId});
  eventPropertiesArray.push({id: "WN7yP-IxTA", name: "platform", value: sysPlatform});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "oidL0MPbc_", "36e923fa725be1608c81a232f1a8e7d0665954d1432edbadca5d2e3ea54818e7", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Close Trade Based on Signal Clicked", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("oidL0MPbc_", "Close Trade Based on Signal Clicked", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Close Trade Based on Signal Clicked", eventProperties, "oidL0MPbc_", "36e923fa725be1608c81a232f1a8e7d0665954d1432edbadca5d2e3ea54818e7");
    }
    // destination Mixpanel
    Mixpanel.logEvent("Close Trade Based on Signal Clicked", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface SignalFollowUpdateCloseModalSubmitActionProperties {
  epUserSubscriptionDuration: number | null | undefined;
  epUserSubscriptionPlan: EpUserSubscriptionPlanValueType;
  epUserSubscriptionIsActive: boolean | null | undefined;
  epUserIsMobileAppUser: boolean | null | undefined;
  epUserIsAdmin: boolean | null | undefined;
  epUserIsTelegramConnected: boolean | null | undefined;
  epUserIsDiscordConnected: boolean | null | undefined;
  epUserFeatureFlags: string[] | null | undefined;
  epUserIsDarkMode: boolean | null | undefined;
  isTelegramMiniApp: boolean | null | undefined;
  groupSignalId: number;
  followSignalModalType: FollowSignalModalTypeValueType;
  groupChannelId: number;
}
/**
 * Signal Follow/Update/Close Modal Submit Action: The user submits and finalizes the action
 * 
 * @param properties the properties associatied with this event
 * @param properties.epUserSubscriptionDuration: The current subscription duration for the user, in days. Not sent for users with Expired or Trial subscription plans.
 * @param properties.epUserSubscriptionPlan: The current subscription plan for the user. Users without an active subscription should have the value set to Expired.
 * @param properties.epUserSubscriptionIsActive: Set to True if the user has an active subscription (the last subscription expiration date is smaller than the current date).
 * @param properties.epUserIsMobileAppUser: no description
 * @param properties.epUserIsAdmin: no description
 * @param properties.epUserIsTelegramConnected: no description
 * @param properties.epUserIsDiscordConnected: no description
 * @param properties.epUserFeatureFlags: no description
 * @param properties.epUserIsDarkMode: no description
 * @param properties.isTelegramMiniApp: no description
 * @param properties.groupSignalId: the Signal ID that was followed.
 * @param properties.followSignalModalType: no description
 * @param properties.groupChannelId: The current channel/group id that was recorded as part of the event
 * 
 * @see {@link https://www.avo.app/schemas/Zba2v6MXsSx1EdxPIQKm/events/wjZn_TxqUT}
 */
export function signalFollowupdatecloseModalSubmitAction(properties: SignalFollowUpdateCloseModalSubmitActionProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  properties.epUserSubscriptionDuration !== undefined && properties.epUserSubscriptionDuration !== null ?
    eventPropertiesArray.push({id: "BrNPvrBkq", name: "ep_user_subscription_duration", value: properties.epUserSubscriptionDuration}) :
    eventPropertiesArray.push({id: "BrNPvrBkq", name: "ep_user_subscription_duration", value: null});
  eventPropertiesArray.push({id: "Ak0bD3528L", name: "ep_user_subscription_plan", value: properties.epUserSubscriptionPlan});
  properties.epUserSubscriptionIsActive !== undefined && properties.epUserSubscriptionIsActive !== null ?
    eventPropertiesArray.push({id: "P2zcEByfWK", name: "ep_user_subscription_is_active", value: properties.epUserSubscriptionIsActive}) :
    eventPropertiesArray.push({id: "P2zcEByfWK", name: "ep_user_subscription_is_active", value: null});
  properties.epUserIsMobileAppUser !== undefined && properties.epUserIsMobileAppUser !== null ?
    eventPropertiesArray.push({id: "gkaSZCbXw8", name: "ep_user_is_mobile_app_user", value: properties.epUserIsMobileAppUser}) :
    eventPropertiesArray.push({id: "gkaSZCbXw8", name: "ep_user_is_mobile_app_user", value: null});
  properties.epUserIsAdmin !== undefined && properties.epUserIsAdmin !== null ?
    eventPropertiesArray.push({id: "1NHsnnGVd0", name: "ep_user_is_admin", value: properties.epUserIsAdmin}) :
    eventPropertiesArray.push({id: "1NHsnnGVd0", name: "ep_user_is_admin", value: null});
  properties.epUserIsTelegramConnected !== undefined && properties.epUserIsTelegramConnected !== null ?
    eventPropertiesArray.push({id: "QBh1Ik3rEm", name: "ep_user_is_telegram_connected", value: properties.epUserIsTelegramConnected}) :
    eventPropertiesArray.push({id: "QBh1Ik3rEm", name: "ep_user_is_telegram_connected", value: null});
  properties.epUserIsDiscordConnected !== undefined && properties.epUserIsDiscordConnected !== null ?
    eventPropertiesArray.push({id: "Z5anKuo4On", name: "ep_user_is_discord_connected", value: properties.epUserIsDiscordConnected}) :
    eventPropertiesArray.push({id: "Z5anKuo4On", name: "ep_user_is_discord_connected", value: null});
  properties.epUserFeatureFlags !== undefined && properties.epUserFeatureFlags !== null ?
    eventPropertiesArray.push({id: "ZkS2YBJULL", name: "ep_user_feature_flags", value: properties.epUserFeatureFlags}) :
    eventPropertiesArray.push({id: "ZkS2YBJULL", name: "ep_user_feature_flags", value: null});
  properties.epUserIsDarkMode !== undefined && properties.epUserIsDarkMode !== null ?
    eventPropertiesArray.push({id: "pZYzhjQhIW", name: "ep_user_is_dark_mode", value: properties.epUserIsDarkMode}) :
    eventPropertiesArray.push({id: "pZYzhjQhIW", name: "ep_user_is_dark_mode", value: null});
  properties.isTelegramMiniApp !== undefined && properties.isTelegramMiniApp !== null ?
    eventPropertiesArray.push({id: "vh-KiP-5Q", name: "is_telegram_mini_app", value: properties.isTelegramMiniApp}) :
    eventPropertiesArray.push({id: "vh-KiP-5Q", name: "is_telegram_mini_app", value: null});
  eventPropertiesArray.push({id: "7IRi9I3Eta", name: "group_signal_id", value: properties.groupSignalId});
  eventPropertiesArray.push({id: "otdsBCiGW8", name: "follow_signal_modal_type", value: properties.followSignalModalType});
  eventPropertiesArray.push({id: "dcXTMVDlJn", name: "group_channel_id", value: properties.groupChannelId});
  eventPropertiesArray.push({id: "WN7yP-IxTA", name: "platform", value: sysPlatform});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "wjZn_TxqUT", "4c97f412130458438e10d58787cefe6f4bb5cc6d675f5b551153b6cf0c7a09bc", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Signal Follow/Update/Close Modal Submit Action", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("wjZn_TxqUT", "Signal Follow/Update/Close Modal Submit Action", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Signal Follow/Update/Close Modal Submit Action", eventProperties, "wjZn_TxqUT", "4c97f412130458438e10d58787cefe6f4bb5cc6d675f5b551153b6cf0c7a09bc");
    }
    // destination Mixpanel
    Mixpanel.logEvent("Signal Follow/Update/Close Modal Submit Action", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface SignalDetailsViewClickedProperties {
  epUserSubscriptionDuration: number | null | undefined;
  epUserSubscriptionPlan: EpUserSubscriptionPlanValueType;
  epUserSubscriptionIsActive: boolean | null | undefined;
  epUserIsMobileAppUser: boolean | null | undefined;
  epUserIsAdmin: boolean | null | undefined;
  epUserIsTelegramConnected: boolean | null | undefined;
  epUserIsDiscordConnected: boolean | null | undefined;
  epUserFeatureFlags: string[] | null | undefined;
  epUserIsDarkMode: boolean | null | undefined;
  isTelegramMiniApp: boolean | null | undefined;
  groupSignalId: number;
  groupChannelId: number;
  websiteOriginTimeOfAction: WebsiteOriginTimeOfActionValueType;
}
/**
 * Signal Details View Clicked: The user clicked a specific signal and opened the signal drawer
 * 
 * @param properties the properties associatied with this event
 * @param properties.epUserSubscriptionDuration: The current subscription duration for the user, in days. Not sent for users with Expired or Trial subscription plans.
 * @param properties.epUserSubscriptionPlan: The current subscription plan for the user. Users without an active subscription should have the value set to Expired.
 * @param properties.epUserSubscriptionIsActive: Set to True if the user has an active subscription (the last subscription expiration date is smaller than the current date).
 * @param properties.epUserIsMobileAppUser: no description
 * @param properties.epUserIsAdmin: no description
 * @param properties.epUserIsTelegramConnected: no description
 * @param properties.epUserIsDiscordConnected: no description
 * @param properties.epUserFeatureFlags: no description
 * @param properties.epUserIsDarkMode: no description
 * @param properties.isTelegramMiniApp: no description
 * @param properties.groupSignalId: the Signal ID that was followed.
 * @param properties.groupChannelId: The current channel/group id that was recorded as part of the event
 * @param properties.websiteOriginTimeOfAction: no description
 * 
 * @see {@link https://www.avo.app/schemas/Zba2v6MXsSx1EdxPIQKm/events/iBYdnnbmbr}
 */
export function signalDetailsViewClicked(properties: SignalDetailsViewClickedProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  properties.epUserSubscriptionDuration !== undefined && properties.epUserSubscriptionDuration !== null ?
    eventPropertiesArray.push({id: "BrNPvrBkq", name: "ep_user_subscription_duration", value: properties.epUserSubscriptionDuration}) :
    eventPropertiesArray.push({id: "BrNPvrBkq", name: "ep_user_subscription_duration", value: null});
  eventPropertiesArray.push({id: "Ak0bD3528L", name: "ep_user_subscription_plan", value: properties.epUserSubscriptionPlan});
  properties.epUserSubscriptionIsActive !== undefined && properties.epUserSubscriptionIsActive !== null ?
    eventPropertiesArray.push({id: "P2zcEByfWK", name: "ep_user_subscription_is_active", value: properties.epUserSubscriptionIsActive}) :
    eventPropertiesArray.push({id: "P2zcEByfWK", name: "ep_user_subscription_is_active", value: null});
  properties.epUserIsMobileAppUser !== undefined && properties.epUserIsMobileAppUser !== null ?
    eventPropertiesArray.push({id: "gkaSZCbXw8", name: "ep_user_is_mobile_app_user", value: properties.epUserIsMobileAppUser}) :
    eventPropertiesArray.push({id: "gkaSZCbXw8", name: "ep_user_is_mobile_app_user", value: null});
  properties.epUserIsAdmin !== undefined && properties.epUserIsAdmin !== null ?
    eventPropertiesArray.push({id: "1NHsnnGVd0", name: "ep_user_is_admin", value: properties.epUserIsAdmin}) :
    eventPropertiesArray.push({id: "1NHsnnGVd0", name: "ep_user_is_admin", value: null});
  properties.epUserIsTelegramConnected !== undefined && properties.epUserIsTelegramConnected !== null ?
    eventPropertiesArray.push({id: "QBh1Ik3rEm", name: "ep_user_is_telegram_connected", value: properties.epUserIsTelegramConnected}) :
    eventPropertiesArray.push({id: "QBh1Ik3rEm", name: "ep_user_is_telegram_connected", value: null});
  properties.epUserIsDiscordConnected !== undefined && properties.epUserIsDiscordConnected !== null ?
    eventPropertiesArray.push({id: "Z5anKuo4On", name: "ep_user_is_discord_connected", value: properties.epUserIsDiscordConnected}) :
    eventPropertiesArray.push({id: "Z5anKuo4On", name: "ep_user_is_discord_connected", value: null});
  properties.epUserFeatureFlags !== undefined && properties.epUserFeatureFlags !== null ?
    eventPropertiesArray.push({id: "ZkS2YBJULL", name: "ep_user_feature_flags", value: properties.epUserFeatureFlags}) :
    eventPropertiesArray.push({id: "ZkS2YBJULL", name: "ep_user_feature_flags", value: null});
  properties.epUserIsDarkMode !== undefined && properties.epUserIsDarkMode !== null ?
    eventPropertiesArray.push({id: "pZYzhjQhIW", name: "ep_user_is_dark_mode", value: properties.epUserIsDarkMode}) :
    eventPropertiesArray.push({id: "pZYzhjQhIW", name: "ep_user_is_dark_mode", value: null});
  properties.isTelegramMiniApp !== undefined && properties.isTelegramMiniApp !== null ?
    eventPropertiesArray.push({id: "vh-KiP-5Q", name: "is_telegram_mini_app", value: properties.isTelegramMiniApp}) :
    eventPropertiesArray.push({id: "vh-KiP-5Q", name: "is_telegram_mini_app", value: null});
  eventPropertiesArray.push({id: "7IRi9I3Eta", name: "group_signal_id", value: properties.groupSignalId});
  eventPropertiesArray.push({id: "dcXTMVDlJn", name: "group_channel_id", value: properties.groupChannelId});
  eventPropertiesArray.push({id: "h_JM3gZSVo", name: "website_origin_time_of_action", value: properties.websiteOriginTimeOfAction});
  eventPropertiesArray.push({id: "WN7yP-IxTA", name: "platform", value: sysPlatform});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "iBYdnnbmbr", "31d112570e9089bc08298cee531d5a87e9c66e1b06f132bacd05e9c012e4e165", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Signal Details View Clicked", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("iBYdnnbmbr", "Signal Details View Clicked", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Signal Details View Clicked", eventProperties, "iBYdnnbmbr", "31d112570e9089bc08298cee531d5a87e9c66e1b06f132bacd05e9c012e4e165");
    }
    // destination Mixpanel
    Mixpanel.logEvent("Signal Details View Clicked", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface MiscMinusMessagingPlatformConnectedProperties {
  botSource: BotSourceValueType | null | undefined;
}
/**
 * Misc - Messaging Platform Connected: Send this event after the user connected the messaging platform either from the Onboarding process or from the settings menu.
 * 
 * @param properties the properties associatied with this event
 * @param properties.botSource: Whether the user started the onboarding from the telegram or discord bot.
 * 
 * @see {@link https://www.avo.app/schemas/Zba2v6MXsSx1EdxPIQKm/events/t8MGXYCTHb}
 */
export function miscMessagingPlatformConnected(properties: MiscMinusMessagingPlatformConnectedProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  properties.botSource !== undefined && properties.botSource !== null ?
    eventPropertiesArray.push({id: "77pb0xYM-Q", name: "bot_source", value: properties.botSource}) :
    eventPropertiesArray.push({id: "77pb0xYM-Q", name: "bot_source", value: null});
  eventPropertiesArray.push({id: "WN7yP-IxTA", name: "platform", value: sysPlatform});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "t8MGXYCTHb", "2f96d0733a7162c4bed44e38b22d2fc317c093674e147bae1de969890579ec46", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Misc - Messaging Platform Connected", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("t8MGXYCTHb", "Misc - Messaging Platform Connected", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Misc - Messaging Platform Connected", eventProperties, "t8MGXYCTHb", "2f96d0733a7162c4bed44e38b22d2fc317c093674e147bae1de969890579ec46");
    }
    // destination Mixpanel
    Mixpanel.logEvent("Misc - Messaging Platform Connected", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface InfoTooltipReviewedProperties {
  epUserSubscriptionDuration: number | null | undefined;
  epUserSubscriptionPlan: EpUserSubscriptionPlanValueType;
  epUserSubscriptionIsActive: boolean | null | undefined;
  epUserIsMobileAppUser: boolean | null | undefined;
  epUserIsAdmin: boolean | null | undefined;
  epUserIsTelegramConnected: boolean | null | undefined;
  epUserIsDiscordConnected: boolean | null | undefined;
  epUserFeatureFlags: string[] | null | undefined;
  epUserIsDarkMode: boolean | null | undefined;
  isTelegramMiniApp: boolean | null | undefined;
  infoTooltipNameAndLocation: string;
  infoTooltipReviewTime: number;
}
/**
 * Info Tooltip Reviewed: The event is recorded if the user reviewed the info tooltip for more than 2 seconds. The time of the review/interaction and the name of the tooltip component (where it is displayed) are the two properties of interest
 * 
 * @param properties the properties associatied with this event
 * @param properties.epUserSubscriptionDuration: The current subscription duration for the user, in days. Not sent for users with Expired or Trial subscription plans.
 * @param properties.epUserSubscriptionPlan: The current subscription plan for the user. Users without an active subscription should have the value set to Expired.
 * @param properties.epUserSubscriptionIsActive: Set to True if the user has an active subscription (the last subscription expiration date is smaller than the current date).
 * @param properties.epUserIsMobileAppUser: no description
 * @param properties.epUserIsAdmin: no description
 * @param properties.epUserIsTelegramConnected: no description
 * @param properties.epUserIsDiscordConnected: no description
 * @param properties.epUserFeatureFlags: no description
 * @param properties.epUserIsDarkMode: no description
 * @param properties.isTelegramMiniApp: no description
 * @param properties.infoTooltipNameAndLocation: no description
 * @param properties.infoTooltipReviewTime: no description
 * 
 * @see {@link https://www.avo.app/schemas/Zba2v6MXsSx1EdxPIQKm/events/n9Nu1lJmLV}
 */
export function infoTooltipReviewed(properties: InfoTooltipReviewedProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  properties.epUserSubscriptionDuration !== undefined && properties.epUserSubscriptionDuration !== null ?
    eventPropertiesArray.push({id: "BrNPvrBkq", name: "ep_user_subscription_duration", value: properties.epUserSubscriptionDuration}) :
    eventPropertiesArray.push({id: "BrNPvrBkq", name: "ep_user_subscription_duration", value: null});
  eventPropertiesArray.push({id: "Ak0bD3528L", name: "ep_user_subscription_plan", value: properties.epUserSubscriptionPlan});
  properties.epUserSubscriptionIsActive !== undefined && properties.epUserSubscriptionIsActive !== null ?
    eventPropertiesArray.push({id: "P2zcEByfWK", name: "ep_user_subscription_is_active", value: properties.epUserSubscriptionIsActive}) :
    eventPropertiesArray.push({id: "P2zcEByfWK", name: "ep_user_subscription_is_active", value: null});
  properties.epUserIsMobileAppUser !== undefined && properties.epUserIsMobileAppUser !== null ?
    eventPropertiesArray.push({id: "gkaSZCbXw8", name: "ep_user_is_mobile_app_user", value: properties.epUserIsMobileAppUser}) :
    eventPropertiesArray.push({id: "gkaSZCbXw8", name: "ep_user_is_mobile_app_user", value: null});
  properties.epUserIsAdmin !== undefined && properties.epUserIsAdmin !== null ?
    eventPropertiesArray.push({id: "1NHsnnGVd0", name: "ep_user_is_admin", value: properties.epUserIsAdmin}) :
    eventPropertiesArray.push({id: "1NHsnnGVd0", name: "ep_user_is_admin", value: null});
  properties.epUserIsTelegramConnected !== undefined && properties.epUserIsTelegramConnected !== null ?
    eventPropertiesArray.push({id: "QBh1Ik3rEm", name: "ep_user_is_telegram_connected", value: properties.epUserIsTelegramConnected}) :
    eventPropertiesArray.push({id: "QBh1Ik3rEm", name: "ep_user_is_telegram_connected", value: null});
  properties.epUserIsDiscordConnected !== undefined && properties.epUserIsDiscordConnected !== null ?
    eventPropertiesArray.push({id: "Z5anKuo4On", name: "ep_user_is_discord_connected", value: properties.epUserIsDiscordConnected}) :
    eventPropertiesArray.push({id: "Z5anKuo4On", name: "ep_user_is_discord_connected", value: null});
  properties.epUserFeatureFlags !== undefined && properties.epUserFeatureFlags !== null ?
    eventPropertiesArray.push({id: "ZkS2YBJULL", name: "ep_user_feature_flags", value: properties.epUserFeatureFlags}) :
    eventPropertiesArray.push({id: "ZkS2YBJULL", name: "ep_user_feature_flags", value: null});
  properties.epUserIsDarkMode !== undefined && properties.epUserIsDarkMode !== null ?
    eventPropertiesArray.push({id: "pZYzhjQhIW", name: "ep_user_is_dark_mode", value: properties.epUserIsDarkMode}) :
    eventPropertiesArray.push({id: "pZYzhjQhIW", name: "ep_user_is_dark_mode", value: null});
  properties.isTelegramMiniApp !== undefined && properties.isTelegramMiniApp !== null ?
    eventPropertiesArray.push({id: "vh-KiP-5Q", name: "is_telegram_mini_app", value: properties.isTelegramMiniApp}) :
    eventPropertiesArray.push({id: "vh-KiP-5Q", name: "is_telegram_mini_app", value: null});
  eventPropertiesArray.push({id: "cagrxvMk_m", name: "info_tooltip_name_and_location", value: properties.infoTooltipNameAndLocation});
  eventPropertiesArray.push({id: "koA1wbFd5A", name: "info_tooltip_review_time", value: properties.infoTooltipReviewTime});
  eventPropertiesArray.push({id: "WN7yP-IxTA", name: "platform", value: sysPlatform});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "n9Nu1lJmLV", "ba81a76cecaabc17c6655bd8166724399708ee10b6c2167820e046484cac9df4", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Info Tooltip Reviewed", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("n9Nu1lJmLV", "Info Tooltip Reviewed", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Info Tooltip Reviewed", eventProperties, "n9Nu1lJmLV", "ba81a76cecaabc17c6655bd8166724399708ee10b6c2167820e046484cac9df4");
    }
    // destination Mixpanel
    Mixpanel.logEvent("Info Tooltip Reviewed", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

/**
 * TradingView Scripts View (Web): User clicks the TradingView Script Tab
 * 
 * @see {@link https://www.avo.app/schemas/Zba2v6MXsSx1EdxPIQKm/events/9MGreNfLDq}
 */
export function tradingviewScriptsViewWeb() {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({id: "WN7yP-IxTA", name: "platform", value: sysPlatform});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "9MGreNfLDq", "9f1be09f1d4874ca1eaa34ca574cfad34faff49dd4773924734dcaaaf1af566c", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("TradingView Scripts View (Web)", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("9MGreNfLDq", "TradingView Scripts View (Web)", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("TradingView Scripts View (Web)", eventProperties, "9MGreNfLDq", "9f1be09f1d4874ca1eaa34ca574cfad34faff49dd4773924734dcaaaf1af566c");
    }
    // destination Mixpanel
    Mixpanel.logEvent("TradingView Scripts View (Web)", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface BotMinusCreateSaveChangesClickedProperties {
  epUserSubscriptionDuration: number | null | undefined;
  epUserSubscriptionPlan: EpUserSubscriptionPlanValueType;
  epUserSubscriptionIsActive: boolean | null | undefined;
  epUserIsMobileAppUser: boolean | null | undefined;
  epUserIsAdmin: boolean | null | undefined;
  epUserIsTelegramConnected: boolean | null | undefined;
  epUserIsDiscordConnected: boolean | null | undefined;
  epUserFeatureFlags: string[] | null | undefined;
  epUserIsDarkMode: boolean | null | undefined;
  isTelegramMiniApp: boolean | null | undefined;
  dcaBotCreateeditOrigin: DcaBotCreateeditOriginValueType;
  botType: BotTypeValueType;
}
/**
 * Bot - Create / Save Changes Clicked: No description
 * 
 * @param properties the properties associatied with this event
 * @param properties.epUserSubscriptionDuration: The current subscription duration for the user, in days. Not sent for users with Expired or Trial subscription plans.
 * @param properties.epUserSubscriptionPlan: The current subscription plan for the user. Users without an active subscription should have the value set to Expired.
 * @param properties.epUserSubscriptionIsActive: Set to True if the user has an active subscription (the last subscription expiration date is smaller than the current date).
 * @param properties.epUserIsMobileAppUser: no description
 * @param properties.epUserIsAdmin: no description
 * @param properties.epUserIsTelegramConnected: no description
 * @param properties.epUserIsDiscordConnected: no description
 * @param properties.epUserFeatureFlags: no description
 * @param properties.epUserIsDarkMode: no description
 * @param properties.isTelegramMiniApp: no description
 * @param properties.dcaBotCreateeditOrigin: no description
 * @param properties.botType: The bot type for the 'Bot' events (DCA, TradingView and Signals)
 * 
 * @see {@link https://www.avo.app/schemas/Zba2v6MXsSx1EdxPIQKm/events/tNbZmCC-DS}
 */
export function botCreateSaveChangesClicked(properties: BotMinusCreateSaveChangesClickedProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  properties.epUserSubscriptionDuration !== undefined && properties.epUserSubscriptionDuration !== null ?
    eventPropertiesArray.push({id: "BrNPvrBkq", name: "ep_user_subscription_duration", value: properties.epUserSubscriptionDuration}) :
    eventPropertiesArray.push({id: "BrNPvrBkq", name: "ep_user_subscription_duration", value: null});
  eventPropertiesArray.push({id: "Ak0bD3528L", name: "ep_user_subscription_plan", value: properties.epUserSubscriptionPlan});
  properties.epUserSubscriptionIsActive !== undefined && properties.epUserSubscriptionIsActive !== null ?
    eventPropertiesArray.push({id: "P2zcEByfWK", name: "ep_user_subscription_is_active", value: properties.epUserSubscriptionIsActive}) :
    eventPropertiesArray.push({id: "P2zcEByfWK", name: "ep_user_subscription_is_active", value: null});
  properties.epUserIsMobileAppUser !== undefined && properties.epUserIsMobileAppUser !== null ?
    eventPropertiesArray.push({id: "gkaSZCbXw8", name: "ep_user_is_mobile_app_user", value: properties.epUserIsMobileAppUser}) :
    eventPropertiesArray.push({id: "gkaSZCbXw8", name: "ep_user_is_mobile_app_user", value: null});
  properties.epUserIsAdmin !== undefined && properties.epUserIsAdmin !== null ?
    eventPropertiesArray.push({id: "1NHsnnGVd0", name: "ep_user_is_admin", value: properties.epUserIsAdmin}) :
    eventPropertiesArray.push({id: "1NHsnnGVd0", name: "ep_user_is_admin", value: null});
  properties.epUserIsTelegramConnected !== undefined && properties.epUserIsTelegramConnected !== null ?
    eventPropertiesArray.push({id: "QBh1Ik3rEm", name: "ep_user_is_telegram_connected", value: properties.epUserIsTelegramConnected}) :
    eventPropertiesArray.push({id: "QBh1Ik3rEm", name: "ep_user_is_telegram_connected", value: null});
  properties.epUserIsDiscordConnected !== undefined && properties.epUserIsDiscordConnected !== null ?
    eventPropertiesArray.push({id: "Z5anKuo4On", name: "ep_user_is_discord_connected", value: properties.epUserIsDiscordConnected}) :
    eventPropertiesArray.push({id: "Z5anKuo4On", name: "ep_user_is_discord_connected", value: null});
  properties.epUserFeatureFlags !== undefined && properties.epUserFeatureFlags !== null ?
    eventPropertiesArray.push({id: "ZkS2YBJULL", name: "ep_user_feature_flags", value: properties.epUserFeatureFlags}) :
    eventPropertiesArray.push({id: "ZkS2YBJULL", name: "ep_user_feature_flags", value: null});
  properties.epUserIsDarkMode !== undefined && properties.epUserIsDarkMode !== null ?
    eventPropertiesArray.push({id: "pZYzhjQhIW", name: "ep_user_is_dark_mode", value: properties.epUserIsDarkMode}) :
    eventPropertiesArray.push({id: "pZYzhjQhIW", name: "ep_user_is_dark_mode", value: null});
  properties.isTelegramMiniApp !== undefined && properties.isTelegramMiniApp !== null ?
    eventPropertiesArray.push({id: "vh-KiP-5Q", name: "is_telegram_mini_app", value: properties.isTelegramMiniApp}) :
    eventPropertiesArray.push({id: "vh-KiP-5Q", name: "is_telegram_mini_app", value: null});
  eventPropertiesArray.push({id: "HPFtxbqHeQ", name: "dca_bot_create/edit_origin", value: properties.dcaBotCreateeditOrigin});
  eventPropertiesArray.push({id: "4WjfkyHvj0", name: "bot_type", value: properties.botType});
  eventPropertiesArray.push({id: "WN7yP-IxTA", name: "platform", value: sysPlatform});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "tNbZmCC-DS", "f71c0be29894f7142091d396d3578b45e9894c92f01e260219611d39c8446eff", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Bot - Create / Save Changes Clicked", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("tNbZmCC-DS", "Bot - Create / Save Changes Clicked", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Bot - Create / Save Changes Clicked", eventProperties, "tNbZmCC-DS", "f71c0be29894f7142091d396d3578b45e9894c92f01e260219611d39c8446eff");
    }
    // destination Mixpanel
    Mixpanel.logEvent("Bot - Create / Save Changes Clicked", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface BotMinusMyBotsViewWebProperties {
  epUserSubscriptionDuration: number | null | undefined;
  epUserSubscriptionPlan: EpUserSubscriptionPlanValueType;
  epUserSubscriptionIsActive: boolean | null | undefined;
  epUserIsMobileAppUser: boolean | null | undefined;
  epUserIsAdmin: boolean | null | undefined;
  epUserIsTelegramConnected: boolean | null | undefined;
  epUserIsDiscordConnected: boolean | null | undefined;
  epUserFeatureFlags: string[] | null | undefined;
  epUserIsDarkMode: boolean | null | undefined;
  isTelegramMiniApp: boolean | null | undefined;
  botType: BotTypeValueType;
}
/**
 * Bot - My Bots View (Web): No description
 * 
 * @param properties the properties associatied with this event
 * @param properties.epUserSubscriptionDuration: The current subscription duration for the user, in days. Not sent for users with Expired or Trial subscription plans.
 * @param properties.epUserSubscriptionPlan: The current subscription plan for the user. Users without an active subscription should have the value set to Expired.
 * @param properties.epUserSubscriptionIsActive: Set to True if the user has an active subscription (the last subscription expiration date is smaller than the current date).
 * @param properties.epUserIsMobileAppUser: no description
 * @param properties.epUserIsAdmin: no description
 * @param properties.epUserIsTelegramConnected: no description
 * @param properties.epUserIsDiscordConnected: no description
 * @param properties.epUserFeatureFlags: no description
 * @param properties.epUserIsDarkMode: no description
 * @param properties.isTelegramMiniApp: no description
 * @param properties.botType: The bot type for the 'Bot' events (DCA, TradingView and Signals)
 * 
 * @see {@link https://www.avo.app/schemas/Zba2v6MXsSx1EdxPIQKm/events/6FA0VaE7BV}
 */
export function botMyBotsViewWeb(properties: BotMinusMyBotsViewWebProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  properties.epUserSubscriptionDuration !== undefined && properties.epUserSubscriptionDuration !== null ?
    eventPropertiesArray.push({id: "BrNPvrBkq", name: "ep_user_subscription_duration", value: properties.epUserSubscriptionDuration}) :
    eventPropertiesArray.push({id: "BrNPvrBkq", name: "ep_user_subscription_duration", value: null});
  eventPropertiesArray.push({id: "Ak0bD3528L", name: "ep_user_subscription_plan", value: properties.epUserSubscriptionPlan});
  properties.epUserSubscriptionIsActive !== undefined && properties.epUserSubscriptionIsActive !== null ?
    eventPropertiesArray.push({id: "P2zcEByfWK", name: "ep_user_subscription_is_active", value: properties.epUserSubscriptionIsActive}) :
    eventPropertiesArray.push({id: "P2zcEByfWK", name: "ep_user_subscription_is_active", value: null});
  properties.epUserIsMobileAppUser !== undefined && properties.epUserIsMobileAppUser !== null ?
    eventPropertiesArray.push({id: "gkaSZCbXw8", name: "ep_user_is_mobile_app_user", value: properties.epUserIsMobileAppUser}) :
    eventPropertiesArray.push({id: "gkaSZCbXw8", name: "ep_user_is_mobile_app_user", value: null});
  properties.epUserIsAdmin !== undefined && properties.epUserIsAdmin !== null ?
    eventPropertiesArray.push({id: "1NHsnnGVd0", name: "ep_user_is_admin", value: properties.epUserIsAdmin}) :
    eventPropertiesArray.push({id: "1NHsnnGVd0", name: "ep_user_is_admin", value: null});
  properties.epUserIsTelegramConnected !== undefined && properties.epUserIsTelegramConnected !== null ?
    eventPropertiesArray.push({id: "QBh1Ik3rEm", name: "ep_user_is_telegram_connected", value: properties.epUserIsTelegramConnected}) :
    eventPropertiesArray.push({id: "QBh1Ik3rEm", name: "ep_user_is_telegram_connected", value: null});
  properties.epUserIsDiscordConnected !== undefined && properties.epUserIsDiscordConnected !== null ?
    eventPropertiesArray.push({id: "Z5anKuo4On", name: "ep_user_is_discord_connected", value: properties.epUserIsDiscordConnected}) :
    eventPropertiesArray.push({id: "Z5anKuo4On", name: "ep_user_is_discord_connected", value: null});
  properties.epUserFeatureFlags !== undefined && properties.epUserFeatureFlags !== null ?
    eventPropertiesArray.push({id: "ZkS2YBJULL", name: "ep_user_feature_flags", value: properties.epUserFeatureFlags}) :
    eventPropertiesArray.push({id: "ZkS2YBJULL", name: "ep_user_feature_flags", value: null});
  properties.epUserIsDarkMode !== undefined && properties.epUserIsDarkMode !== null ?
    eventPropertiesArray.push({id: "pZYzhjQhIW", name: "ep_user_is_dark_mode", value: properties.epUserIsDarkMode}) :
    eventPropertiesArray.push({id: "pZYzhjQhIW", name: "ep_user_is_dark_mode", value: null});
  properties.isTelegramMiniApp !== undefined && properties.isTelegramMiniApp !== null ?
    eventPropertiesArray.push({id: "vh-KiP-5Q", name: "is_telegram_mini_app", value: properties.isTelegramMiniApp}) :
    eventPropertiesArray.push({id: "vh-KiP-5Q", name: "is_telegram_mini_app", value: null});
  eventPropertiesArray.push({id: "4WjfkyHvj0", name: "bot_type", value: properties.botType});
  eventPropertiesArray.push({id: "WN7yP-IxTA", name: "platform", value: sysPlatform});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "6FA0VaE7BV", "c451ebca838cfa852e0442335a7c8d1aabe709fefffe6ce3fdfb3f1250192c5b", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Bot - My Bots View (Web)", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("6FA0VaE7BV", "Bot - My Bots View (Web)", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Bot - My Bots View (Web)", eventProperties, "6FA0VaE7BV", "c451ebca838cfa852e0442335a7c8d1aabe709fefffe6ce3fdfb3f1250192c5b");
    }
    // destination Mixpanel
    Mixpanel.logEvent("Bot - My Bots View (Web)", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface DCABotMinusExplorePublicBotsViewWebProperties {
  epUserSubscriptionDuration: number | null | undefined;
  epUserSubscriptionPlan: EpUserSubscriptionPlanValueType;
  epUserSubscriptionIsActive: boolean | null | undefined;
  epUserIsMobileAppUser: boolean | null | undefined;
  epUserIsAdmin: boolean | null | undefined;
  epUserIsTelegramConnected: boolean | null | undefined;
  epUserIsDiscordConnected: boolean | null | undefined;
  epUserFeatureFlags: string[] | null | undefined;
  epUserIsDarkMode: boolean | null | undefined;
  isTelegramMiniApp: boolean | null | undefined;
}
/**
 * DCA Bot - Explore Public Bots View (Web): No description
 * 
 * @param properties the properties associatied with this event
 * @param properties.epUserSubscriptionDuration: The current subscription duration for the user, in days. Not sent for users with Expired or Trial subscription plans.
 * @param properties.epUserSubscriptionPlan: The current subscription plan for the user. Users without an active subscription should have the value set to Expired.
 * @param properties.epUserSubscriptionIsActive: Set to True if the user has an active subscription (the last subscription expiration date is smaller than the current date).
 * @param properties.epUserIsMobileAppUser: no description
 * @param properties.epUserIsAdmin: no description
 * @param properties.epUserIsTelegramConnected: no description
 * @param properties.epUserIsDiscordConnected: no description
 * @param properties.epUserFeatureFlags: no description
 * @param properties.epUserIsDarkMode: no description
 * @param properties.isTelegramMiniApp: no description
 * 
 * @see {@link https://www.avo.app/schemas/Zba2v6MXsSx1EdxPIQKm/events/-eS0ATI6OZ}
 */
export function dcaBotExplorePublicBotsViewWeb(properties: DCABotMinusExplorePublicBotsViewWebProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  properties.epUserSubscriptionDuration !== undefined && properties.epUserSubscriptionDuration !== null ?
    eventPropertiesArray.push({id: "BrNPvrBkq", name: "ep_user_subscription_duration", value: properties.epUserSubscriptionDuration}) :
    eventPropertiesArray.push({id: "BrNPvrBkq", name: "ep_user_subscription_duration", value: null});
  eventPropertiesArray.push({id: "Ak0bD3528L", name: "ep_user_subscription_plan", value: properties.epUserSubscriptionPlan});
  properties.epUserSubscriptionIsActive !== undefined && properties.epUserSubscriptionIsActive !== null ?
    eventPropertiesArray.push({id: "P2zcEByfWK", name: "ep_user_subscription_is_active", value: properties.epUserSubscriptionIsActive}) :
    eventPropertiesArray.push({id: "P2zcEByfWK", name: "ep_user_subscription_is_active", value: null});
  properties.epUserIsMobileAppUser !== undefined && properties.epUserIsMobileAppUser !== null ?
    eventPropertiesArray.push({id: "gkaSZCbXw8", name: "ep_user_is_mobile_app_user", value: properties.epUserIsMobileAppUser}) :
    eventPropertiesArray.push({id: "gkaSZCbXw8", name: "ep_user_is_mobile_app_user", value: null});
  properties.epUserIsAdmin !== undefined && properties.epUserIsAdmin !== null ?
    eventPropertiesArray.push({id: "1NHsnnGVd0", name: "ep_user_is_admin", value: properties.epUserIsAdmin}) :
    eventPropertiesArray.push({id: "1NHsnnGVd0", name: "ep_user_is_admin", value: null});
  properties.epUserIsTelegramConnected !== undefined && properties.epUserIsTelegramConnected !== null ?
    eventPropertiesArray.push({id: "QBh1Ik3rEm", name: "ep_user_is_telegram_connected", value: properties.epUserIsTelegramConnected}) :
    eventPropertiesArray.push({id: "QBh1Ik3rEm", name: "ep_user_is_telegram_connected", value: null});
  properties.epUserIsDiscordConnected !== undefined && properties.epUserIsDiscordConnected !== null ?
    eventPropertiesArray.push({id: "Z5anKuo4On", name: "ep_user_is_discord_connected", value: properties.epUserIsDiscordConnected}) :
    eventPropertiesArray.push({id: "Z5anKuo4On", name: "ep_user_is_discord_connected", value: null});
  properties.epUserFeatureFlags !== undefined && properties.epUserFeatureFlags !== null ?
    eventPropertiesArray.push({id: "ZkS2YBJULL", name: "ep_user_feature_flags", value: properties.epUserFeatureFlags}) :
    eventPropertiesArray.push({id: "ZkS2YBJULL", name: "ep_user_feature_flags", value: null});
  properties.epUserIsDarkMode !== undefined && properties.epUserIsDarkMode !== null ?
    eventPropertiesArray.push({id: "pZYzhjQhIW", name: "ep_user_is_dark_mode", value: properties.epUserIsDarkMode}) :
    eventPropertiesArray.push({id: "pZYzhjQhIW", name: "ep_user_is_dark_mode", value: null});
  properties.isTelegramMiniApp !== undefined && properties.isTelegramMiniApp !== null ?
    eventPropertiesArray.push({id: "vh-KiP-5Q", name: "is_telegram_mini_app", value: properties.isTelegramMiniApp}) :
    eventPropertiesArray.push({id: "vh-KiP-5Q", name: "is_telegram_mini_app", value: null});
  eventPropertiesArray.push({id: "WN7yP-IxTA", name: "platform", value: sysPlatform});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "-eS0ATI6OZ", "c5fc55ad0a93958325890bb6f06387658f483b6ff53b9feb2ce3cb4b76acfa98", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("DCA Bot - Explore Public Bots View (Web)", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("-eS0ATI6OZ", "DCA Bot - Explore Public Bots View (Web)", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("DCA Bot - Explore Public Bots View (Web)", eventProperties, "-eS0ATI6OZ", "c5fc55ad0a93958325890bb6f06387658f483b6ff53b9feb2ce3cb4b76acfa98");
    }
    // destination Mixpanel
    Mixpanel.logEvent("DCA Bot - Explore Public Bots View (Web)", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface DCABotMinusPublicBotCopyViewWebProperties {
  epUserSubscriptionDuration: number | null | undefined;
  epUserSubscriptionPlan: EpUserSubscriptionPlanValueType;
  epUserSubscriptionIsActive: boolean | null | undefined;
  epUserIsMobileAppUser: boolean | null | undefined;
  epUserIsAdmin: boolean | null | undefined;
  epUserIsTelegramConnected: boolean | null | undefined;
  epUserIsDiscordConnected: boolean | null | undefined;
  epUserFeatureFlags: string[] | null | undefined;
  epUserIsDarkMode: boolean | null | undefined;
  isTelegramMiniApp: boolean | null | undefined;
  botRank: number | null | undefined;
}
/**
 * DCA Bot - Public Bot Copy View (Web): No description
 * 
 * @param properties the properties associatied with this event
 * @param properties.epUserSubscriptionDuration: The current subscription duration for the user, in days. Not sent for users with Expired or Trial subscription plans.
 * @param properties.epUserSubscriptionPlan: The current subscription plan for the user. Users without an active subscription should have the value set to Expired.
 * @param properties.epUserSubscriptionIsActive: Set to True if the user has an active subscription (the last subscription expiration date is smaller than the current date).
 * @param properties.epUserIsMobileAppUser: no description
 * @param properties.epUserIsAdmin: no description
 * @param properties.epUserIsTelegramConnected: no description
 * @param properties.epUserIsDiscordConnected: no description
 * @param properties.epUserFeatureFlags: no description
 * @param properties.epUserIsDarkMode: no description
 * @param properties.isTelegramMiniApp: no description
 * @param properties.botRank: Rank of selected bot in list of bots in onboarding
 * 
 * @see {@link https://www.avo.app/schemas/Zba2v6MXsSx1EdxPIQKm/events/W-frnBaedF}
 */
export function dcaBotPublicBotCopyViewWeb(properties: DCABotMinusPublicBotCopyViewWebProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  properties.epUserSubscriptionDuration !== undefined && properties.epUserSubscriptionDuration !== null ?
    eventPropertiesArray.push({id: "BrNPvrBkq", name: "ep_user_subscription_duration", value: properties.epUserSubscriptionDuration}) :
    eventPropertiesArray.push({id: "BrNPvrBkq", name: "ep_user_subscription_duration", value: null});
  eventPropertiesArray.push({id: "Ak0bD3528L", name: "ep_user_subscription_plan", value: properties.epUserSubscriptionPlan});
  properties.epUserSubscriptionIsActive !== undefined && properties.epUserSubscriptionIsActive !== null ?
    eventPropertiesArray.push({id: "P2zcEByfWK", name: "ep_user_subscription_is_active", value: properties.epUserSubscriptionIsActive}) :
    eventPropertiesArray.push({id: "P2zcEByfWK", name: "ep_user_subscription_is_active", value: null});
  properties.epUserIsMobileAppUser !== undefined && properties.epUserIsMobileAppUser !== null ?
    eventPropertiesArray.push({id: "gkaSZCbXw8", name: "ep_user_is_mobile_app_user", value: properties.epUserIsMobileAppUser}) :
    eventPropertiesArray.push({id: "gkaSZCbXw8", name: "ep_user_is_mobile_app_user", value: null});
  properties.epUserIsAdmin !== undefined && properties.epUserIsAdmin !== null ?
    eventPropertiesArray.push({id: "1NHsnnGVd0", name: "ep_user_is_admin", value: properties.epUserIsAdmin}) :
    eventPropertiesArray.push({id: "1NHsnnGVd0", name: "ep_user_is_admin", value: null});
  properties.epUserIsTelegramConnected !== undefined && properties.epUserIsTelegramConnected !== null ?
    eventPropertiesArray.push({id: "QBh1Ik3rEm", name: "ep_user_is_telegram_connected", value: properties.epUserIsTelegramConnected}) :
    eventPropertiesArray.push({id: "QBh1Ik3rEm", name: "ep_user_is_telegram_connected", value: null});
  properties.epUserIsDiscordConnected !== undefined && properties.epUserIsDiscordConnected !== null ?
    eventPropertiesArray.push({id: "Z5anKuo4On", name: "ep_user_is_discord_connected", value: properties.epUserIsDiscordConnected}) :
    eventPropertiesArray.push({id: "Z5anKuo4On", name: "ep_user_is_discord_connected", value: null});
  properties.epUserFeatureFlags !== undefined && properties.epUserFeatureFlags !== null ?
    eventPropertiesArray.push({id: "ZkS2YBJULL", name: "ep_user_feature_flags", value: properties.epUserFeatureFlags}) :
    eventPropertiesArray.push({id: "ZkS2YBJULL", name: "ep_user_feature_flags", value: null});
  properties.epUserIsDarkMode !== undefined && properties.epUserIsDarkMode !== null ?
    eventPropertiesArray.push({id: "pZYzhjQhIW", name: "ep_user_is_dark_mode", value: properties.epUserIsDarkMode}) :
    eventPropertiesArray.push({id: "pZYzhjQhIW", name: "ep_user_is_dark_mode", value: null});
  properties.isTelegramMiniApp !== undefined && properties.isTelegramMiniApp !== null ?
    eventPropertiesArray.push({id: "vh-KiP-5Q", name: "is_telegram_mini_app", value: properties.isTelegramMiniApp}) :
    eventPropertiesArray.push({id: "vh-KiP-5Q", name: "is_telegram_mini_app", value: null});
  properties.botRank !== undefined && properties.botRank !== null ?
    eventPropertiesArray.push({id: "grtY72q2w", name: "bot_rank", value: properties.botRank}) :
    eventPropertiesArray.push({id: "grtY72q2w", name: "bot_rank", value: null});
  eventPropertiesArray.push({id: "WN7yP-IxTA", name: "platform", value: sysPlatform});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "W-frnBaedF", "1eebe5c788da384e4335cf00cfd54930e70673506e3f3d871ca379ec7b06ffb7", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("DCA Bot - Public Bot Copy View (Web)", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("W-frnBaedF", "DCA Bot - Public Bot Copy View (Web)", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("DCA Bot - Public Bot Copy View (Web)", eventProperties, "W-frnBaedF", "1eebe5c788da384e4335cf00cfd54930e70673506e3f3d871ca379ec7b06ffb7");
    }
    // destination Mixpanel
    Mixpanel.logEvent("DCA Bot - Public Bot Copy View (Web)", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface DCABotMinusCopyBotConfigurationViewClickedProperties {
  epUserSubscriptionDuration: number | null | undefined;
  epUserSubscriptionPlan: EpUserSubscriptionPlanValueType;
  epUserSubscriptionIsActive: boolean | null | undefined;
  epUserIsMobileAppUser: boolean | null | undefined;
  epUserIsAdmin: boolean | null | undefined;
  epUserIsTelegramConnected: boolean | null | undefined;
  epUserIsDiscordConnected: boolean | null | undefined;
  epUserFeatureFlags: string[] | null | undefined;
  epUserIsDarkMode: boolean | null | undefined;
  isTelegramMiniApp: boolean | null | undefined;
}
/**
 * DCA Bot - Copy Bot Configuration View Clicked: When the user clicks the 'Show bot configuration' button on the copy bot page
 * 
 * @param properties the properties associatied with this event
 * @param properties.epUserSubscriptionDuration: The current subscription duration for the user, in days. Not sent for users with Expired or Trial subscription plans.
 * @param properties.epUserSubscriptionPlan: The current subscription plan for the user. Users without an active subscription should have the value set to Expired.
 * @param properties.epUserSubscriptionIsActive: Set to True if the user has an active subscription (the last subscription expiration date is smaller than the current date).
 * @param properties.epUserIsMobileAppUser: no description
 * @param properties.epUserIsAdmin: no description
 * @param properties.epUserIsTelegramConnected: no description
 * @param properties.epUserIsDiscordConnected: no description
 * @param properties.epUserFeatureFlags: no description
 * @param properties.epUserIsDarkMode: no description
 * @param properties.isTelegramMiniApp: no description
 * 
 * @see {@link https://www.avo.app/schemas/Zba2v6MXsSx1EdxPIQKm/events/3HJILNsbsf}
 */
export function dcaBotCopyBotConfigurationViewClicked(properties: DCABotMinusCopyBotConfigurationViewClickedProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  properties.epUserSubscriptionDuration !== undefined && properties.epUserSubscriptionDuration !== null ?
    eventPropertiesArray.push({id: "BrNPvrBkq", name: "ep_user_subscription_duration", value: properties.epUserSubscriptionDuration}) :
    eventPropertiesArray.push({id: "BrNPvrBkq", name: "ep_user_subscription_duration", value: null});
  eventPropertiesArray.push({id: "Ak0bD3528L", name: "ep_user_subscription_plan", value: properties.epUserSubscriptionPlan});
  properties.epUserSubscriptionIsActive !== undefined && properties.epUserSubscriptionIsActive !== null ?
    eventPropertiesArray.push({id: "P2zcEByfWK", name: "ep_user_subscription_is_active", value: properties.epUserSubscriptionIsActive}) :
    eventPropertiesArray.push({id: "P2zcEByfWK", name: "ep_user_subscription_is_active", value: null});
  properties.epUserIsMobileAppUser !== undefined && properties.epUserIsMobileAppUser !== null ?
    eventPropertiesArray.push({id: "gkaSZCbXw8", name: "ep_user_is_mobile_app_user", value: properties.epUserIsMobileAppUser}) :
    eventPropertiesArray.push({id: "gkaSZCbXw8", name: "ep_user_is_mobile_app_user", value: null});
  properties.epUserIsAdmin !== undefined && properties.epUserIsAdmin !== null ?
    eventPropertiesArray.push({id: "1NHsnnGVd0", name: "ep_user_is_admin", value: properties.epUserIsAdmin}) :
    eventPropertiesArray.push({id: "1NHsnnGVd0", name: "ep_user_is_admin", value: null});
  properties.epUserIsTelegramConnected !== undefined && properties.epUserIsTelegramConnected !== null ?
    eventPropertiesArray.push({id: "QBh1Ik3rEm", name: "ep_user_is_telegram_connected", value: properties.epUserIsTelegramConnected}) :
    eventPropertiesArray.push({id: "QBh1Ik3rEm", name: "ep_user_is_telegram_connected", value: null});
  properties.epUserIsDiscordConnected !== undefined && properties.epUserIsDiscordConnected !== null ?
    eventPropertiesArray.push({id: "Z5anKuo4On", name: "ep_user_is_discord_connected", value: properties.epUserIsDiscordConnected}) :
    eventPropertiesArray.push({id: "Z5anKuo4On", name: "ep_user_is_discord_connected", value: null});
  properties.epUserFeatureFlags !== undefined && properties.epUserFeatureFlags !== null ?
    eventPropertiesArray.push({id: "ZkS2YBJULL", name: "ep_user_feature_flags", value: properties.epUserFeatureFlags}) :
    eventPropertiesArray.push({id: "ZkS2YBJULL", name: "ep_user_feature_flags", value: null});
  properties.epUserIsDarkMode !== undefined && properties.epUserIsDarkMode !== null ?
    eventPropertiesArray.push({id: "pZYzhjQhIW", name: "ep_user_is_dark_mode", value: properties.epUserIsDarkMode}) :
    eventPropertiesArray.push({id: "pZYzhjQhIW", name: "ep_user_is_dark_mode", value: null});
  properties.isTelegramMiniApp !== undefined && properties.isTelegramMiniApp !== null ?
    eventPropertiesArray.push({id: "vh-KiP-5Q", name: "is_telegram_mini_app", value: properties.isTelegramMiniApp}) :
    eventPropertiesArray.push({id: "vh-KiP-5Q", name: "is_telegram_mini_app", value: null});
  eventPropertiesArray.push({id: "WN7yP-IxTA", name: "platform", value: sysPlatform});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "3HJILNsbsf", "9a5f216e89a6dce8f1d661e8876270b07b631d092d2b48622f7b2d2c44eec5ff", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("DCA Bot - Copy Bot Configuration View Clicked", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("3HJILNsbsf", "DCA Bot - Copy Bot Configuration View Clicked", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("DCA Bot - Copy Bot Configuration View Clicked", eventProperties, "3HJILNsbsf", "9a5f216e89a6dce8f1d661e8876270b07b631d092d2b48622f7b2d2c44eec5ff");
    }
    // destination Mixpanel
    Mixpanel.logEvent("DCA Bot - Copy Bot Configuration View Clicked", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface DCABotMinusEditBeforeCopyClickedProperties {
  epUserSubscriptionDuration: number | null | undefined;
  epUserSubscriptionPlan: EpUserSubscriptionPlanValueType;
  epUserSubscriptionIsActive: boolean | null | undefined;
  epUserIsMobileAppUser: boolean | null | undefined;
  epUserIsAdmin: boolean | null | undefined;
  epUserIsTelegramConnected: boolean | null | undefined;
  epUserIsDiscordConnected: boolean | null | undefined;
  epUserFeatureFlags: string[] | null | undefined;
  epUserIsDarkMode: boolean | null | undefined;
  isTelegramMiniApp: boolean | null | undefined;
}
/**
 * DCA Bot - Edit Before Copy Clicked: No description
 * 
 * @param properties the properties associatied with this event
 * @param properties.epUserSubscriptionDuration: The current subscription duration for the user, in days. Not sent for users with Expired or Trial subscription plans.
 * @param properties.epUserSubscriptionPlan: The current subscription plan for the user. Users without an active subscription should have the value set to Expired.
 * @param properties.epUserSubscriptionIsActive: Set to True if the user has an active subscription (the last subscription expiration date is smaller than the current date).
 * @param properties.epUserIsMobileAppUser: no description
 * @param properties.epUserIsAdmin: no description
 * @param properties.epUserIsTelegramConnected: no description
 * @param properties.epUserIsDiscordConnected: no description
 * @param properties.epUserFeatureFlags: no description
 * @param properties.epUserIsDarkMode: no description
 * @param properties.isTelegramMiniApp: no description
 * 
 * @see {@link https://www.avo.app/schemas/Zba2v6MXsSx1EdxPIQKm/events/QtOl5WL-iz}
 */
export function dcaBotEditBeforeCopyClicked(properties: DCABotMinusEditBeforeCopyClickedProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  properties.epUserSubscriptionDuration !== undefined && properties.epUserSubscriptionDuration !== null ?
    eventPropertiesArray.push({id: "BrNPvrBkq", name: "ep_user_subscription_duration", value: properties.epUserSubscriptionDuration}) :
    eventPropertiesArray.push({id: "BrNPvrBkq", name: "ep_user_subscription_duration", value: null});
  eventPropertiesArray.push({id: "Ak0bD3528L", name: "ep_user_subscription_plan", value: properties.epUserSubscriptionPlan});
  properties.epUserSubscriptionIsActive !== undefined && properties.epUserSubscriptionIsActive !== null ?
    eventPropertiesArray.push({id: "P2zcEByfWK", name: "ep_user_subscription_is_active", value: properties.epUserSubscriptionIsActive}) :
    eventPropertiesArray.push({id: "P2zcEByfWK", name: "ep_user_subscription_is_active", value: null});
  properties.epUserIsMobileAppUser !== undefined && properties.epUserIsMobileAppUser !== null ?
    eventPropertiesArray.push({id: "gkaSZCbXw8", name: "ep_user_is_mobile_app_user", value: properties.epUserIsMobileAppUser}) :
    eventPropertiesArray.push({id: "gkaSZCbXw8", name: "ep_user_is_mobile_app_user", value: null});
  properties.epUserIsAdmin !== undefined && properties.epUserIsAdmin !== null ?
    eventPropertiesArray.push({id: "1NHsnnGVd0", name: "ep_user_is_admin", value: properties.epUserIsAdmin}) :
    eventPropertiesArray.push({id: "1NHsnnGVd0", name: "ep_user_is_admin", value: null});
  properties.epUserIsTelegramConnected !== undefined && properties.epUserIsTelegramConnected !== null ?
    eventPropertiesArray.push({id: "QBh1Ik3rEm", name: "ep_user_is_telegram_connected", value: properties.epUserIsTelegramConnected}) :
    eventPropertiesArray.push({id: "QBh1Ik3rEm", name: "ep_user_is_telegram_connected", value: null});
  properties.epUserIsDiscordConnected !== undefined && properties.epUserIsDiscordConnected !== null ?
    eventPropertiesArray.push({id: "Z5anKuo4On", name: "ep_user_is_discord_connected", value: properties.epUserIsDiscordConnected}) :
    eventPropertiesArray.push({id: "Z5anKuo4On", name: "ep_user_is_discord_connected", value: null});
  properties.epUserFeatureFlags !== undefined && properties.epUserFeatureFlags !== null ?
    eventPropertiesArray.push({id: "ZkS2YBJULL", name: "ep_user_feature_flags", value: properties.epUserFeatureFlags}) :
    eventPropertiesArray.push({id: "ZkS2YBJULL", name: "ep_user_feature_flags", value: null});
  properties.epUserIsDarkMode !== undefined && properties.epUserIsDarkMode !== null ?
    eventPropertiesArray.push({id: "pZYzhjQhIW", name: "ep_user_is_dark_mode", value: properties.epUserIsDarkMode}) :
    eventPropertiesArray.push({id: "pZYzhjQhIW", name: "ep_user_is_dark_mode", value: null});
  properties.isTelegramMiniApp !== undefined && properties.isTelegramMiniApp !== null ?
    eventPropertiesArray.push({id: "vh-KiP-5Q", name: "is_telegram_mini_app", value: properties.isTelegramMiniApp}) :
    eventPropertiesArray.push({id: "vh-KiP-5Q", name: "is_telegram_mini_app", value: null});
  eventPropertiesArray.push({id: "WN7yP-IxTA", name: "platform", value: sysPlatform});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "QtOl5WL-iz", "8d0af0d2f563741d02c47063ade4895983e43ca16470c692164594c0ac153f78", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("DCA Bot - Edit Before Copy Clicked", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("QtOl5WL-iz", "DCA Bot - Edit Before Copy Clicked", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("DCA Bot - Edit Before Copy Clicked", eventProperties, "QtOl5WL-iz", "8d0af0d2f563741d02c47063ade4895983e43ca16470c692164594c0ac153f78");
    }
    // destination Mixpanel
    Mixpanel.logEvent("DCA Bot - Edit Before Copy Clicked", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface BotMinusBotFormViewWebProperties {
  epUserSubscriptionDuration: number | null | undefined;
  epUserSubscriptionPlan: EpUserSubscriptionPlanValueType;
  epUserSubscriptionIsActive: boolean | null | undefined;
  epUserIsMobileAppUser: boolean | null | undefined;
  epUserIsAdmin: boolean | null | undefined;
  epUserIsTelegramConnected: boolean | null | undefined;
  epUserIsDiscordConnected: boolean | null | undefined;
  epUserFeatureFlags: string[] | null | undefined;
  epUserIsDarkMode: boolean | null | undefined;
  isTelegramMiniApp: boolean | null | undefined;
  dcaBotCreateeditOrigin: DcaBotCreateeditOriginValueType;
  botType: BotTypeValueType;
}
/**
 * Bot - Bot Form View (Web): No description
 * 
 * @param properties the properties associatied with this event
 * @param properties.epUserSubscriptionDuration: The current subscription duration for the user, in days. Not sent for users with Expired or Trial subscription plans.
 * @param properties.epUserSubscriptionPlan: The current subscription plan for the user. Users without an active subscription should have the value set to Expired.
 * @param properties.epUserSubscriptionIsActive: Set to True if the user has an active subscription (the last subscription expiration date is smaller than the current date).
 * @param properties.epUserIsMobileAppUser: no description
 * @param properties.epUserIsAdmin: no description
 * @param properties.epUserIsTelegramConnected: no description
 * @param properties.epUserIsDiscordConnected: no description
 * @param properties.epUserFeatureFlags: no description
 * @param properties.epUserIsDarkMode: no description
 * @param properties.isTelegramMiniApp: no description
 * @param properties.dcaBotCreateeditOrigin: no description
 * @param properties.botType: The bot type for the 'Bot' events (DCA, TradingView and Signals)
 * 
 * @see {@link https://www.avo.app/schemas/Zba2v6MXsSx1EdxPIQKm/events/bCjME3k5-7}
 */
export function botBotFormViewWeb(properties: BotMinusBotFormViewWebProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  properties.epUserSubscriptionDuration !== undefined && properties.epUserSubscriptionDuration !== null ?
    eventPropertiesArray.push({id: "BrNPvrBkq", name: "ep_user_subscription_duration", value: properties.epUserSubscriptionDuration}) :
    eventPropertiesArray.push({id: "BrNPvrBkq", name: "ep_user_subscription_duration", value: null});
  eventPropertiesArray.push({id: "Ak0bD3528L", name: "ep_user_subscription_plan", value: properties.epUserSubscriptionPlan});
  properties.epUserSubscriptionIsActive !== undefined && properties.epUserSubscriptionIsActive !== null ?
    eventPropertiesArray.push({id: "P2zcEByfWK", name: "ep_user_subscription_is_active", value: properties.epUserSubscriptionIsActive}) :
    eventPropertiesArray.push({id: "P2zcEByfWK", name: "ep_user_subscription_is_active", value: null});
  properties.epUserIsMobileAppUser !== undefined && properties.epUserIsMobileAppUser !== null ?
    eventPropertiesArray.push({id: "gkaSZCbXw8", name: "ep_user_is_mobile_app_user", value: properties.epUserIsMobileAppUser}) :
    eventPropertiesArray.push({id: "gkaSZCbXw8", name: "ep_user_is_mobile_app_user", value: null});
  properties.epUserIsAdmin !== undefined && properties.epUserIsAdmin !== null ?
    eventPropertiesArray.push({id: "1NHsnnGVd0", name: "ep_user_is_admin", value: properties.epUserIsAdmin}) :
    eventPropertiesArray.push({id: "1NHsnnGVd0", name: "ep_user_is_admin", value: null});
  properties.epUserIsTelegramConnected !== undefined && properties.epUserIsTelegramConnected !== null ?
    eventPropertiesArray.push({id: "QBh1Ik3rEm", name: "ep_user_is_telegram_connected", value: properties.epUserIsTelegramConnected}) :
    eventPropertiesArray.push({id: "QBh1Ik3rEm", name: "ep_user_is_telegram_connected", value: null});
  properties.epUserIsDiscordConnected !== undefined && properties.epUserIsDiscordConnected !== null ?
    eventPropertiesArray.push({id: "Z5anKuo4On", name: "ep_user_is_discord_connected", value: properties.epUserIsDiscordConnected}) :
    eventPropertiesArray.push({id: "Z5anKuo4On", name: "ep_user_is_discord_connected", value: null});
  properties.epUserFeatureFlags !== undefined && properties.epUserFeatureFlags !== null ?
    eventPropertiesArray.push({id: "ZkS2YBJULL", name: "ep_user_feature_flags", value: properties.epUserFeatureFlags}) :
    eventPropertiesArray.push({id: "ZkS2YBJULL", name: "ep_user_feature_flags", value: null});
  properties.epUserIsDarkMode !== undefined && properties.epUserIsDarkMode !== null ?
    eventPropertiesArray.push({id: "pZYzhjQhIW", name: "ep_user_is_dark_mode", value: properties.epUserIsDarkMode}) :
    eventPropertiesArray.push({id: "pZYzhjQhIW", name: "ep_user_is_dark_mode", value: null});
  properties.isTelegramMiniApp !== undefined && properties.isTelegramMiniApp !== null ?
    eventPropertiesArray.push({id: "vh-KiP-5Q", name: "is_telegram_mini_app", value: properties.isTelegramMiniApp}) :
    eventPropertiesArray.push({id: "vh-KiP-5Q", name: "is_telegram_mini_app", value: null});
  eventPropertiesArray.push({id: "HPFtxbqHeQ", name: "dca_bot_create/edit_origin", value: properties.dcaBotCreateeditOrigin});
  eventPropertiesArray.push({id: "4WjfkyHvj0", name: "bot_type", value: properties.botType});
  eventPropertiesArray.push({id: "WN7yP-IxTA", name: "platform", value: sysPlatform});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "bCjME3k5-7", "97b9689ef0562df3c7cb7478ad643b85ee6a0bb01f2851e198c68cc42e3e0259", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Bot - Bot Form View (Web)", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("bCjME3k5-7", "Bot - Bot Form View (Web)", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Bot - Bot Form View (Web)", eventProperties, "bCjME3k5-7", "97b9689ef0562df3c7cb7478ad643b85ee6a0bb01f2851e198c68cc42e3e0259");
    }
    // destination Mixpanel
    Mixpanel.logEvent("Bot - Bot Form View (Web)", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

/**
 * Show Notifications Clicked: User clicked on the bell icon to open the notifications
 * 
 * @see {@link https://www.avo.app/schemas/Zba2v6MXsSx1EdxPIQKm/events/alDDvdiQyQ}
 */
export function showNotificationsClicked() {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({id: "WN7yP-IxTA", name: "platform", value: sysPlatform});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "alDDvdiQyQ", "9fcd6ab79b0d9b58e17ce7b4c7f9cafe8ccfaf5505db3f999a69acecee675e75", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Show Notifications Clicked", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("alDDvdiQyQ", "Show Notifications Clicked", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Show Notifications Clicked", eventProperties, "alDDvdiQyQ", "9fcd6ab79b0d9b58e17ce7b4c7f9cafe8ccfaf5505db3f999a69acecee675e75");
    }
    // destination Mixpanel
    Mixpanel.logEvent("Show Notifications Clicked", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface CloseNotificationsClickedProperties {
  notificationsReviewTime: number;
}
/**
 * Close Notifications Clicked: User clicked anywhere while notifications are open to close the notifications view
 * 
 * @param properties the properties associatied with this event
 * @param properties.notificationsReviewTime: duration in seconds
 * 
 * @see {@link https://www.avo.app/schemas/Zba2v6MXsSx1EdxPIQKm/events/HAYjvhQjba}
 */
export function closeNotificationsClicked(properties: CloseNotificationsClickedProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({id: "h2bNjke5a5", name: "notifications_review_time", value: properties.notificationsReviewTime});
  eventPropertiesArray.push({id: "WN7yP-IxTA", name: "platform", value: sysPlatform});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "HAYjvhQjba", "98e6dcb7bb431ceda553cfa89956c68efa7213ffc53d3287f255b512b368cd61", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Close Notifications Clicked", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("HAYjvhQjba", "Close Notifications Clicked", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Close Notifications Clicked", eventProperties, "HAYjvhQjba", "98e6dcb7bb431ceda553cfa89956c68efa7213ffc53d3287f255b512b368cd61");
    }
    // destination Mixpanel
    Mixpanel.logEvent("Close Notifications Clicked", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface NotificationMarkAllAsReadProperties {
  numberOfUnreadNotifications: number;
}
/**
 * Notification Mark All as Read: User marked all unread notifications as read
 * 
 * @param properties the properties associatied with this event
 * @param properties.numberOfUnreadNotifications: no description
 * 
 * @see {@link https://www.avo.app/schemas/Zba2v6MXsSx1EdxPIQKm/events/liVZ2XqAdr}
 */
export function notificationMarkAllAsRead(properties: NotificationMarkAllAsReadProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({id: "hqvn15D9il", name: "number of unread notifications", value: properties.numberOfUnreadNotifications});
  eventPropertiesArray.push({id: "WN7yP-IxTA", name: "platform", value: sysPlatform});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "liVZ2XqAdr", "46afe19b6524831867fc2a2d4b2ff7c9bb744926c72d170c154c79f05908b210", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Notification Mark All as Read", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("liVZ2XqAdr", "Notification Mark All as Read", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Notification Mark All as Read", eventProperties, "liVZ2XqAdr", "46afe19b6524831867fc2a2d4b2ff7c9bb744926c72d170c154c79f05908b210");
    }
    // destination Mixpanel
    Mixpanel.logEvent("Notification Mark All as Read", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface SingleNotificationClickedProperties {
  epUserSubscriptionDuration: number | null | undefined;
  epUserSubscriptionPlan: EpUserSubscriptionPlanValueType;
  epUserSubscriptionIsActive: boolean | null | undefined;
  epUserIsMobileAppUser: boolean | null | undefined;
  epUserIsAdmin: boolean | null | undefined;
  epUserIsTelegramConnected: boolean | null | undefined;
  epUserIsDiscordConnected: boolean | null | undefined;
  epUserFeatureFlags: string[] | null | undefined;
  epUserIsDarkMode: boolean | null | undefined;
  isTelegramMiniApp: boolean | null | undefined;
  notificationType: string;
  notificationPartClicked: NotificationPartClickedValueType | null | undefined;
}
/**
 * Single Notification Clicked: User clicked on a single notification in the notifications modal
 * 
 * @param properties the properties associatied with this event
 * @param properties.epUserSubscriptionDuration: The current subscription duration for the user, in days. Not sent for users with Expired or Trial subscription plans.
 * @param properties.epUserSubscriptionPlan: The current subscription plan for the user. Users without an active subscription should have the value set to Expired.
 * @param properties.epUserSubscriptionIsActive: Set to True if the user has an active subscription (the last subscription expiration date is smaller than the current date).
 * @param properties.epUserIsMobileAppUser: no description
 * @param properties.epUserIsAdmin: no description
 * @param properties.epUserIsTelegramConnected: no description
 * @param properties.epUserIsDiscordConnected: no description
 * @param properties.epUserFeatureFlags: no description
 * @param properties.epUserIsDarkMode: no description
 * @param properties.isTelegramMiniApp: no description
 * @param properties.notificationType: will show if this notification is for an order, trade or other types.
 * @param properties.notificationPartClicked: no description
 * 
 * @see {@link https://www.avo.app/schemas/Zba2v6MXsSx1EdxPIQKm/events/ijrOdwQoiN}
 */
export function singleNotificationClicked(properties: SingleNotificationClickedProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  properties.epUserSubscriptionDuration !== undefined && properties.epUserSubscriptionDuration !== null ?
    eventPropertiesArray.push({id: "BrNPvrBkq", name: "ep_user_subscription_duration", value: properties.epUserSubscriptionDuration}) :
    eventPropertiesArray.push({id: "BrNPvrBkq", name: "ep_user_subscription_duration", value: null});
  eventPropertiesArray.push({id: "Ak0bD3528L", name: "ep_user_subscription_plan", value: properties.epUserSubscriptionPlan});
  properties.epUserSubscriptionIsActive !== undefined && properties.epUserSubscriptionIsActive !== null ?
    eventPropertiesArray.push({id: "P2zcEByfWK", name: "ep_user_subscription_is_active", value: properties.epUserSubscriptionIsActive}) :
    eventPropertiesArray.push({id: "P2zcEByfWK", name: "ep_user_subscription_is_active", value: null});
  properties.epUserIsMobileAppUser !== undefined && properties.epUserIsMobileAppUser !== null ?
    eventPropertiesArray.push({id: "gkaSZCbXw8", name: "ep_user_is_mobile_app_user", value: properties.epUserIsMobileAppUser}) :
    eventPropertiesArray.push({id: "gkaSZCbXw8", name: "ep_user_is_mobile_app_user", value: null});
  properties.epUserIsAdmin !== undefined && properties.epUserIsAdmin !== null ?
    eventPropertiesArray.push({id: "1NHsnnGVd0", name: "ep_user_is_admin", value: properties.epUserIsAdmin}) :
    eventPropertiesArray.push({id: "1NHsnnGVd0", name: "ep_user_is_admin", value: null});
  properties.epUserIsTelegramConnected !== undefined && properties.epUserIsTelegramConnected !== null ?
    eventPropertiesArray.push({id: "QBh1Ik3rEm", name: "ep_user_is_telegram_connected", value: properties.epUserIsTelegramConnected}) :
    eventPropertiesArray.push({id: "QBh1Ik3rEm", name: "ep_user_is_telegram_connected", value: null});
  properties.epUserIsDiscordConnected !== undefined && properties.epUserIsDiscordConnected !== null ?
    eventPropertiesArray.push({id: "Z5anKuo4On", name: "ep_user_is_discord_connected", value: properties.epUserIsDiscordConnected}) :
    eventPropertiesArray.push({id: "Z5anKuo4On", name: "ep_user_is_discord_connected", value: null});
  properties.epUserFeatureFlags !== undefined && properties.epUserFeatureFlags !== null ?
    eventPropertiesArray.push({id: "ZkS2YBJULL", name: "ep_user_feature_flags", value: properties.epUserFeatureFlags}) :
    eventPropertiesArray.push({id: "ZkS2YBJULL", name: "ep_user_feature_flags", value: null});
  properties.epUserIsDarkMode !== undefined && properties.epUserIsDarkMode !== null ?
    eventPropertiesArray.push({id: "pZYzhjQhIW", name: "ep_user_is_dark_mode", value: properties.epUserIsDarkMode}) :
    eventPropertiesArray.push({id: "pZYzhjQhIW", name: "ep_user_is_dark_mode", value: null});
  properties.isTelegramMiniApp !== undefined && properties.isTelegramMiniApp !== null ?
    eventPropertiesArray.push({id: "vh-KiP-5Q", name: "is_telegram_mini_app", value: properties.isTelegramMiniApp}) :
    eventPropertiesArray.push({id: "vh-KiP-5Q", name: "is_telegram_mini_app", value: null});
  eventPropertiesArray.push({id: "LYsRIVxHuH", name: "notification_type", value: properties.notificationType});
  properties.notificationPartClicked !== undefined && properties.notificationPartClicked !== null ?
    eventPropertiesArray.push({id: "IrjO7UqRCi", name: "notification_part_clicked", value: properties.notificationPartClicked}) :
    eventPropertiesArray.push({id: "IrjO7UqRCi", name: "notification_part_clicked", value: null});
  eventPropertiesArray.push({id: "WN7yP-IxTA", name: "platform", value: sysPlatform});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "ijrOdwQoiN", "ce8dcfaac52ac711d67aa74214967f54900c2c8d00ca3e06072fac539c7d2880", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Single Notification Clicked", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("ijrOdwQoiN", "Single Notification Clicked", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Single Notification Clicked", eventProperties, "ijrOdwQoiN", "ce8dcfaac52ac711d67aa74214967f54900c2c8d00ca3e06072fac539c7d2880");
    }
    // destination Mixpanel
    Mixpanel.logEvent("Single Notification Clicked", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface DashboardMinusMarketsTableViewChangedProperties {
  epUserSubscriptionDuration: number | null | undefined;
  epUserSubscriptionPlan: EpUserSubscriptionPlanValueType;
  epUserSubscriptionIsActive: boolean | null | undefined;
  epUserIsMobileAppUser: boolean | null | undefined;
  epUserIsAdmin: boolean | null | undefined;
  epUserIsTelegramConnected: boolean | null | undefined;
  epUserIsDiscordConnected: boolean | null | undefined;
  epUserFeatureFlags: string[] | null | undefined;
  epUserIsDarkMode: boolean | null | undefined;
  isTelegramMiniApp: boolean | null | undefined;
  marketsTableView: MarketsTableViewValueType;
}
/**
 * Dashboard - Markets Table View Changed: No description
 * 
 * @param properties the properties associatied with this event
 * @param properties.epUserSubscriptionDuration: The current subscription duration for the user, in days. Not sent for users with Expired or Trial subscription plans.
 * @param properties.epUserSubscriptionPlan: The current subscription plan for the user. Users without an active subscription should have the value set to Expired.
 * @param properties.epUserSubscriptionIsActive: Set to True if the user has an active subscription (the last subscription expiration date is smaller than the current date).
 * @param properties.epUserIsMobileAppUser: no description
 * @param properties.epUserIsAdmin: no description
 * @param properties.epUserIsTelegramConnected: no description
 * @param properties.epUserIsDiscordConnected: no description
 * @param properties.epUserFeatureFlags: no description
 * @param properties.epUserIsDarkMode: no description
 * @param properties.isTelegramMiniApp: no description
 * @param properties.marketsTableView: no description
 * 
 * @see {@link https://www.avo.app/schemas/Zba2v6MXsSx1EdxPIQKm/events/ZL1hToErxJ}
 */
export function dashboardMarketsTableViewChanged(properties: DashboardMinusMarketsTableViewChangedProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  properties.epUserSubscriptionDuration !== undefined && properties.epUserSubscriptionDuration !== null ?
    eventPropertiesArray.push({id: "BrNPvrBkq", name: "ep_user_subscription_duration", value: properties.epUserSubscriptionDuration}) :
    eventPropertiesArray.push({id: "BrNPvrBkq", name: "ep_user_subscription_duration", value: null});
  eventPropertiesArray.push({id: "Ak0bD3528L", name: "ep_user_subscription_plan", value: properties.epUserSubscriptionPlan});
  properties.epUserSubscriptionIsActive !== undefined && properties.epUserSubscriptionIsActive !== null ?
    eventPropertiesArray.push({id: "P2zcEByfWK", name: "ep_user_subscription_is_active", value: properties.epUserSubscriptionIsActive}) :
    eventPropertiesArray.push({id: "P2zcEByfWK", name: "ep_user_subscription_is_active", value: null});
  properties.epUserIsMobileAppUser !== undefined && properties.epUserIsMobileAppUser !== null ?
    eventPropertiesArray.push({id: "gkaSZCbXw8", name: "ep_user_is_mobile_app_user", value: properties.epUserIsMobileAppUser}) :
    eventPropertiesArray.push({id: "gkaSZCbXw8", name: "ep_user_is_mobile_app_user", value: null});
  properties.epUserIsAdmin !== undefined && properties.epUserIsAdmin !== null ?
    eventPropertiesArray.push({id: "1NHsnnGVd0", name: "ep_user_is_admin", value: properties.epUserIsAdmin}) :
    eventPropertiesArray.push({id: "1NHsnnGVd0", name: "ep_user_is_admin", value: null});
  properties.epUserIsTelegramConnected !== undefined && properties.epUserIsTelegramConnected !== null ?
    eventPropertiesArray.push({id: "QBh1Ik3rEm", name: "ep_user_is_telegram_connected", value: properties.epUserIsTelegramConnected}) :
    eventPropertiesArray.push({id: "QBh1Ik3rEm", name: "ep_user_is_telegram_connected", value: null});
  properties.epUserIsDiscordConnected !== undefined && properties.epUserIsDiscordConnected !== null ?
    eventPropertiesArray.push({id: "Z5anKuo4On", name: "ep_user_is_discord_connected", value: properties.epUserIsDiscordConnected}) :
    eventPropertiesArray.push({id: "Z5anKuo4On", name: "ep_user_is_discord_connected", value: null});
  properties.epUserFeatureFlags !== undefined && properties.epUserFeatureFlags !== null ?
    eventPropertiesArray.push({id: "ZkS2YBJULL", name: "ep_user_feature_flags", value: properties.epUserFeatureFlags}) :
    eventPropertiesArray.push({id: "ZkS2YBJULL", name: "ep_user_feature_flags", value: null});
  properties.epUserIsDarkMode !== undefined && properties.epUserIsDarkMode !== null ?
    eventPropertiesArray.push({id: "pZYzhjQhIW", name: "ep_user_is_dark_mode", value: properties.epUserIsDarkMode}) :
    eventPropertiesArray.push({id: "pZYzhjQhIW", name: "ep_user_is_dark_mode", value: null});
  properties.isTelegramMiniApp !== undefined && properties.isTelegramMiniApp !== null ?
    eventPropertiesArray.push({id: "vh-KiP-5Q", name: "is_telegram_mini_app", value: properties.isTelegramMiniApp}) :
    eventPropertiesArray.push({id: "vh-KiP-5Q", name: "is_telegram_mini_app", value: null});
  eventPropertiesArray.push({id: "iOt9BSeIV_", name: "markets_table_view", value: properties.marketsTableView});
  eventPropertiesArray.push({id: "WN7yP-IxTA", name: "platform", value: sysPlatform});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "ZL1hToErxJ", "66ad026074feb2bff64a2e4577779a9163d24fd86a40817e05913d070f7a065b", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Dashboard - Markets Table View Changed", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("ZL1hToErxJ", "Dashboard - Markets Table View Changed", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Dashboard - Markets Table View Changed", eventProperties, "ZL1hToErxJ", "66ad026074feb2bff64a2e4577779a9163d24fd86a40817e05913d070f7a065b");
    }
    // destination Mixpanel
    Mixpanel.logEvent("Dashboard - Markets Table View Changed", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface PurchasePlanMinusChoosePlanPageViewProperties {
  epUserSubscriptionDuration: number | null | undefined;
  epUserSubscriptionPlan: EpUserSubscriptionPlanValueType;
  epUserSubscriptionIsActive: boolean | null | undefined;
  epUserIsMobileAppUser: boolean | null | undefined;
  epUserIsAdmin: boolean | null | undefined;
  epUserIsTelegramConnected: boolean | null | undefined;
  epUserIsDiscordConnected: boolean | null | undefined;
  epUserFeatureFlags: string[] | null | undefined;
  epUserIsDarkMode: boolean | null | undefined;
  isTelegramMiniApp: boolean | null | undefined;
  subscriptionInvoiceType: SubscriptionInvoiceTypeValueType;
}
/**
 * Purchase Plan - Choose Plan Page View: user visited cornix.io/settings/billing/purchase (step=plan)
 * 
 * @param properties the properties associatied with this event
 * @param properties.epUserSubscriptionDuration: The current subscription duration for the user, in days. Not sent for users with Expired or Trial subscription plans.
 * @param properties.epUserSubscriptionPlan: The current subscription plan for the user. Users without an active subscription should have the value set to Expired.
 * @param properties.epUserSubscriptionIsActive: Set to True if the user has an active subscription (the last subscription expiration date is smaller than the current date).
 * @param properties.epUserIsMobileAppUser: no description
 * @param properties.epUserIsAdmin: no description
 * @param properties.epUserIsTelegramConnected: no description
 * @param properties.epUserIsDiscordConnected: no description
 * @param properties.epUserFeatureFlags: no description
 * @param properties.epUserIsDarkMode: no description
 * @param properties.isTelegramMiniApp: no description
 * @param properties.subscriptionInvoiceType: The type of the subscription invoice, between Extension, Upgrade and License.
 * 
 * @see {@link https://www.avo.app/schemas/Zba2v6MXsSx1EdxPIQKm/events/KaZmFJAHEG}
 */
export function purchasePlanChoosePlanPageView(properties: PurchasePlanMinusChoosePlanPageViewProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  properties.epUserSubscriptionDuration !== undefined && properties.epUserSubscriptionDuration !== null ?
    eventPropertiesArray.push({id: "BrNPvrBkq", name: "ep_user_subscription_duration", value: properties.epUserSubscriptionDuration}) :
    eventPropertiesArray.push({id: "BrNPvrBkq", name: "ep_user_subscription_duration", value: null});
  eventPropertiesArray.push({id: "Ak0bD3528L", name: "ep_user_subscription_plan", value: properties.epUserSubscriptionPlan});
  properties.epUserSubscriptionIsActive !== undefined && properties.epUserSubscriptionIsActive !== null ?
    eventPropertiesArray.push({id: "P2zcEByfWK", name: "ep_user_subscription_is_active", value: properties.epUserSubscriptionIsActive}) :
    eventPropertiesArray.push({id: "P2zcEByfWK", name: "ep_user_subscription_is_active", value: null});
  properties.epUserIsMobileAppUser !== undefined && properties.epUserIsMobileAppUser !== null ?
    eventPropertiesArray.push({id: "gkaSZCbXw8", name: "ep_user_is_mobile_app_user", value: properties.epUserIsMobileAppUser}) :
    eventPropertiesArray.push({id: "gkaSZCbXw8", name: "ep_user_is_mobile_app_user", value: null});
  properties.epUserIsAdmin !== undefined && properties.epUserIsAdmin !== null ?
    eventPropertiesArray.push({id: "1NHsnnGVd0", name: "ep_user_is_admin", value: properties.epUserIsAdmin}) :
    eventPropertiesArray.push({id: "1NHsnnGVd0", name: "ep_user_is_admin", value: null});
  properties.epUserIsTelegramConnected !== undefined && properties.epUserIsTelegramConnected !== null ?
    eventPropertiesArray.push({id: "QBh1Ik3rEm", name: "ep_user_is_telegram_connected", value: properties.epUserIsTelegramConnected}) :
    eventPropertiesArray.push({id: "QBh1Ik3rEm", name: "ep_user_is_telegram_connected", value: null});
  properties.epUserIsDiscordConnected !== undefined && properties.epUserIsDiscordConnected !== null ?
    eventPropertiesArray.push({id: "Z5anKuo4On", name: "ep_user_is_discord_connected", value: properties.epUserIsDiscordConnected}) :
    eventPropertiesArray.push({id: "Z5anKuo4On", name: "ep_user_is_discord_connected", value: null});
  properties.epUserFeatureFlags !== undefined && properties.epUserFeatureFlags !== null ?
    eventPropertiesArray.push({id: "ZkS2YBJULL", name: "ep_user_feature_flags", value: properties.epUserFeatureFlags}) :
    eventPropertiesArray.push({id: "ZkS2YBJULL", name: "ep_user_feature_flags", value: null});
  properties.epUserIsDarkMode !== undefined && properties.epUserIsDarkMode !== null ?
    eventPropertiesArray.push({id: "pZYzhjQhIW", name: "ep_user_is_dark_mode", value: properties.epUserIsDarkMode}) :
    eventPropertiesArray.push({id: "pZYzhjQhIW", name: "ep_user_is_dark_mode", value: null});
  properties.isTelegramMiniApp !== undefined && properties.isTelegramMiniApp !== null ?
    eventPropertiesArray.push({id: "vh-KiP-5Q", name: "is_telegram_mini_app", value: properties.isTelegramMiniApp}) :
    eventPropertiesArray.push({id: "vh-KiP-5Q", name: "is_telegram_mini_app", value: null});
  eventPropertiesArray.push({id: "H1YgxGowRc", name: "subscription_invoice_type", value: properties.subscriptionInvoiceType});
  eventPropertiesArray.push({id: "WN7yP-IxTA", name: "platform", value: sysPlatform});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "KaZmFJAHEG", "3c86e0be3ea664e88d8e5a7a172bec7b7bfe08e70e2e02545a5aefb9dfbee135", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Purchase Plan - Choose Plan Page View", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("KaZmFJAHEG", "Purchase Plan - Choose Plan Page View", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Purchase Plan - Choose Plan Page View", eventProperties, "KaZmFJAHEG", "3c86e0be3ea664e88d8e5a7a172bec7b7bfe08e70e2e02545a5aefb9dfbee135");
    }
    // destination Mixpanel
    Mixpanel.logEvent("Purchase Plan - Choose Plan Page View", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface PurchasePlanMinusPaymentPageViewProperties {
  epUserSubscriptionDuration: number | null | undefined;
  epUserSubscriptionPlan: EpUserSubscriptionPlanValueType;
  epUserSubscriptionIsActive: boolean | null | undefined;
  epUserIsMobileAppUser: boolean | null | undefined;
  epUserIsAdmin: boolean | null | undefined;
  epUserIsTelegramConnected: boolean | null | undefined;
  epUserIsDiscordConnected: boolean | null | undefined;
  epUserFeatureFlags: string[] | null | undefined;
  epUserIsDarkMode: boolean | null | undefined;
  isTelegramMiniApp: boolean | null | undefined;
  subscriptionInvoiceType: SubscriptionInvoiceTypeValueType;
  subscriptionInvoicePlan: SubscriptionInvoicePlanValueType | null | undefined;
  subscriptionInvoiceDuration: number;
}
/**
 * Purchase Plan - Payment Page View: The user clicked 'buy now' on the step=purchase page (choose your plan page)
 * 
 * @param properties the properties associatied with this event
 * @param properties.epUserSubscriptionDuration: The current subscription duration for the user, in days. Not sent for users with Expired or Trial subscription plans.
 * @param properties.epUserSubscriptionPlan: The current subscription plan for the user. Users without an active subscription should have the value set to Expired.
 * @param properties.epUserSubscriptionIsActive: Set to True if the user has an active subscription (the last subscription expiration date is smaller than the current date).
 * @param properties.epUserIsMobileAppUser: no description
 * @param properties.epUserIsAdmin: no description
 * @param properties.epUserIsTelegramConnected: no description
 * @param properties.epUserIsDiscordConnected: no description
 * @param properties.epUserFeatureFlags: no description
 * @param properties.epUserIsDarkMode: no description
 * @param properties.isTelegramMiniApp: no description
 * @param properties.subscriptionInvoiceType: The type of the subscription invoice, between Extension, Upgrade and License.
 * @param properties.subscriptionInvoicePlan: no description
 * @param properties.subscriptionInvoiceDuration: no description
 * 
 * @see {@link https://www.avo.app/schemas/Zba2v6MXsSx1EdxPIQKm/events/Nz9e7s81Gb}
 */
export function purchasePlanPaymentPageView(properties: PurchasePlanMinusPaymentPageViewProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  properties.epUserSubscriptionDuration !== undefined && properties.epUserSubscriptionDuration !== null ?
    eventPropertiesArray.push({id: "BrNPvrBkq", name: "ep_user_subscription_duration", value: properties.epUserSubscriptionDuration}) :
    eventPropertiesArray.push({id: "BrNPvrBkq", name: "ep_user_subscription_duration", value: null});
  eventPropertiesArray.push({id: "Ak0bD3528L", name: "ep_user_subscription_plan", value: properties.epUserSubscriptionPlan});
  properties.epUserSubscriptionIsActive !== undefined && properties.epUserSubscriptionIsActive !== null ?
    eventPropertiesArray.push({id: "P2zcEByfWK", name: "ep_user_subscription_is_active", value: properties.epUserSubscriptionIsActive}) :
    eventPropertiesArray.push({id: "P2zcEByfWK", name: "ep_user_subscription_is_active", value: null});
  properties.epUserIsMobileAppUser !== undefined && properties.epUserIsMobileAppUser !== null ?
    eventPropertiesArray.push({id: "gkaSZCbXw8", name: "ep_user_is_mobile_app_user", value: properties.epUserIsMobileAppUser}) :
    eventPropertiesArray.push({id: "gkaSZCbXw8", name: "ep_user_is_mobile_app_user", value: null});
  properties.epUserIsAdmin !== undefined && properties.epUserIsAdmin !== null ?
    eventPropertiesArray.push({id: "1NHsnnGVd0", name: "ep_user_is_admin", value: properties.epUserIsAdmin}) :
    eventPropertiesArray.push({id: "1NHsnnGVd0", name: "ep_user_is_admin", value: null});
  properties.epUserIsTelegramConnected !== undefined && properties.epUserIsTelegramConnected !== null ?
    eventPropertiesArray.push({id: "QBh1Ik3rEm", name: "ep_user_is_telegram_connected", value: properties.epUserIsTelegramConnected}) :
    eventPropertiesArray.push({id: "QBh1Ik3rEm", name: "ep_user_is_telegram_connected", value: null});
  properties.epUserIsDiscordConnected !== undefined && properties.epUserIsDiscordConnected !== null ?
    eventPropertiesArray.push({id: "Z5anKuo4On", name: "ep_user_is_discord_connected", value: properties.epUserIsDiscordConnected}) :
    eventPropertiesArray.push({id: "Z5anKuo4On", name: "ep_user_is_discord_connected", value: null});
  properties.epUserFeatureFlags !== undefined && properties.epUserFeatureFlags !== null ?
    eventPropertiesArray.push({id: "ZkS2YBJULL", name: "ep_user_feature_flags", value: properties.epUserFeatureFlags}) :
    eventPropertiesArray.push({id: "ZkS2YBJULL", name: "ep_user_feature_flags", value: null});
  properties.epUserIsDarkMode !== undefined && properties.epUserIsDarkMode !== null ?
    eventPropertiesArray.push({id: "pZYzhjQhIW", name: "ep_user_is_dark_mode", value: properties.epUserIsDarkMode}) :
    eventPropertiesArray.push({id: "pZYzhjQhIW", name: "ep_user_is_dark_mode", value: null});
  properties.isTelegramMiniApp !== undefined && properties.isTelegramMiniApp !== null ?
    eventPropertiesArray.push({id: "vh-KiP-5Q", name: "is_telegram_mini_app", value: properties.isTelegramMiniApp}) :
    eventPropertiesArray.push({id: "vh-KiP-5Q", name: "is_telegram_mini_app", value: null});
  eventPropertiesArray.push({id: "H1YgxGowRc", name: "subscription_invoice_type", value: properties.subscriptionInvoiceType});
  properties.subscriptionInvoicePlan !== undefined && properties.subscriptionInvoicePlan !== null ?
    eventPropertiesArray.push({id: "l6Fv17-9l_", name: "subscription_invoice_plan", value: properties.subscriptionInvoicePlan}) :
    eventPropertiesArray.push({id: "l6Fv17-9l_", name: "subscription_invoice_plan", value: null});
  eventPropertiesArray.push({id: "ngPxlAZr7D", name: "subscription_invoice_duration", value: properties.subscriptionInvoiceDuration});
  eventPropertiesArray.push({id: "WN7yP-IxTA", name: "platform", value: sysPlatform});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "Nz9e7s81Gb", "cc0b66bce66e05f621b77a7ce554ecac08beeabcc97b8686abaf2de590a9f56a", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Purchase Plan - Payment Page View", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("Nz9e7s81Gb", "Purchase Plan - Payment Page View", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Purchase Plan - Payment Page View", eventProperties, "Nz9e7s81Gb", "cc0b66bce66e05f621b77a7ce554ecac08beeabcc97b8686abaf2de590a9f56a");
    }
    // destination Mixpanel
    Mixpanel.logEvent("Purchase Plan - Payment Page View", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface PurchasePlanMinusPayButtonClickedProperties {
  epUserSubscriptionDuration: number | null | undefined;
  epUserSubscriptionPlan: EpUserSubscriptionPlanValueType;
  epUserSubscriptionIsActive: boolean | null | undefined;
  epUserIsMobileAppUser: boolean | null | undefined;
  epUserIsAdmin: boolean | null | undefined;
  epUserIsTelegramConnected: boolean | null | undefined;
  epUserIsDiscordConnected: boolean | null | undefined;
  epUserFeatureFlags: string[] | null | undefined;
  epUserIsDarkMode: boolean | null | undefined;
  isTelegramMiniApp: boolean | null | undefined;
  subscriptionInvoicePaymentMethod: SubscriptionInvoicePaymentMethodValueType;
  subscriptionInvoiceType: SubscriptionInvoiceTypeValueType;
  subscriptionInvoicePlan: SubscriptionInvoicePlanValueType | null | undefined;
  subscriptionInvoiceDuration: number;
  subscriptionInvoicePrice: number;
}
/**
 * Purchase Plan - Pay button Clicked: User clicked 'pay with..' on the payment step
 * 
 * @param properties the properties associatied with this event
 * @param properties.epUserSubscriptionDuration: The current subscription duration for the user, in days. Not sent for users with Expired or Trial subscription plans.
 * @param properties.epUserSubscriptionPlan: The current subscription plan for the user. Users without an active subscription should have the value set to Expired.
 * @param properties.epUserSubscriptionIsActive: Set to True if the user has an active subscription (the last subscription expiration date is smaller than the current date).
 * @param properties.epUserIsMobileAppUser: no description
 * @param properties.epUserIsAdmin: no description
 * @param properties.epUserIsTelegramConnected: no description
 * @param properties.epUserIsDiscordConnected: no description
 * @param properties.epUserFeatureFlags: no description
 * @param properties.epUserIsDarkMode: no description
 * @param properties.isTelegramMiniApp: no description
 * @param properties.subscriptionInvoicePaymentMethod: no description
 * @param properties.subscriptionInvoiceType: The type of the subscription invoice, between Extension, Upgrade and License.
 * @param properties.subscriptionInvoicePlan: no description
 * @param properties.subscriptionInvoiceDuration: no description
 * @param properties.subscriptionInvoicePrice: no description
 * 
 * @see {@link https://www.avo.app/schemas/Zba2v6MXsSx1EdxPIQKm/events/pUnfEi9ML1}
 */
export function purchasePlanPayButtonClicked(properties: PurchasePlanMinusPayButtonClickedProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  properties.epUserSubscriptionDuration !== undefined && properties.epUserSubscriptionDuration !== null ?
    eventPropertiesArray.push({id: "BrNPvrBkq", name: "ep_user_subscription_duration", value: properties.epUserSubscriptionDuration}) :
    eventPropertiesArray.push({id: "BrNPvrBkq", name: "ep_user_subscription_duration", value: null});
  eventPropertiesArray.push({id: "Ak0bD3528L", name: "ep_user_subscription_plan", value: properties.epUserSubscriptionPlan});
  properties.epUserSubscriptionIsActive !== undefined && properties.epUserSubscriptionIsActive !== null ?
    eventPropertiesArray.push({id: "P2zcEByfWK", name: "ep_user_subscription_is_active", value: properties.epUserSubscriptionIsActive}) :
    eventPropertiesArray.push({id: "P2zcEByfWK", name: "ep_user_subscription_is_active", value: null});
  properties.epUserIsMobileAppUser !== undefined && properties.epUserIsMobileAppUser !== null ?
    eventPropertiesArray.push({id: "gkaSZCbXw8", name: "ep_user_is_mobile_app_user", value: properties.epUserIsMobileAppUser}) :
    eventPropertiesArray.push({id: "gkaSZCbXw8", name: "ep_user_is_mobile_app_user", value: null});
  properties.epUserIsAdmin !== undefined && properties.epUserIsAdmin !== null ?
    eventPropertiesArray.push({id: "1NHsnnGVd0", name: "ep_user_is_admin", value: properties.epUserIsAdmin}) :
    eventPropertiesArray.push({id: "1NHsnnGVd0", name: "ep_user_is_admin", value: null});
  properties.epUserIsTelegramConnected !== undefined && properties.epUserIsTelegramConnected !== null ?
    eventPropertiesArray.push({id: "QBh1Ik3rEm", name: "ep_user_is_telegram_connected", value: properties.epUserIsTelegramConnected}) :
    eventPropertiesArray.push({id: "QBh1Ik3rEm", name: "ep_user_is_telegram_connected", value: null});
  properties.epUserIsDiscordConnected !== undefined && properties.epUserIsDiscordConnected !== null ?
    eventPropertiesArray.push({id: "Z5anKuo4On", name: "ep_user_is_discord_connected", value: properties.epUserIsDiscordConnected}) :
    eventPropertiesArray.push({id: "Z5anKuo4On", name: "ep_user_is_discord_connected", value: null});
  properties.epUserFeatureFlags !== undefined && properties.epUserFeatureFlags !== null ?
    eventPropertiesArray.push({id: "ZkS2YBJULL", name: "ep_user_feature_flags", value: properties.epUserFeatureFlags}) :
    eventPropertiesArray.push({id: "ZkS2YBJULL", name: "ep_user_feature_flags", value: null});
  properties.epUserIsDarkMode !== undefined && properties.epUserIsDarkMode !== null ?
    eventPropertiesArray.push({id: "pZYzhjQhIW", name: "ep_user_is_dark_mode", value: properties.epUserIsDarkMode}) :
    eventPropertiesArray.push({id: "pZYzhjQhIW", name: "ep_user_is_dark_mode", value: null});
  properties.isTelegramMiniApp !== undefined && properties.isTelegramMiniApp !== null ?
    eventPropertiesArray.push({id: "vh-KiP-5Q", name: "is_telegram_mini_app", value: properties.isTelegramMiniApp}) :
    eventPropertiesArray.push({id: "vh-KiP-5Q", name: "is_telegram_mini_app", value: null});
  eventPropertiesArray.push({id: "Ywaqw5B_3V", name: "subscription_invoice_payment_method", value: properties.subscriptionInvoicePaymentMethod});
  eventPropertiesArray.push({id: "H1YgxGowRc", name: "subscription_invoice_type", value: properties.subscriptionInvoiceType});
  properties.subscriptionInvoicePlan !== undefined && properties.subscriptionInvoicePlan !== null ?
    eventPropertiesArray.push({id: "l6Fv17-9l_", name: "subscription_invoice_plan", value: properties.subscriptionInvoicePlan}) :
    eventPropertiesArray.push({id: "l6Fv17-9l_", name: "subscription_invoice_plan", value: null});
  eventPropertiesArray.push({id: "ngPxlAZr7D", name: "subscription_invoice_duration", value: properties.subscriptionInvoiceDuration});
  eventPropertiesArray.push({id: "M7SbmukFWb", name: "subscription_invoice_price", value: properties.subscriptionInvoicePrice});
  eventPropertiesArray.push({id: "WN7yP-IxTA", name: "platform", value: sysPlatform});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "pUnfEi9ML1", "6223b4fd67f7cdaea7dc4e466f4a23024ef6a4c1d8e6682b7e15263f6f828e69", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Purchase Plan - Pay button Clicked", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("pUnfEi9ML1", "Purchase Plan - Pay button Clicked", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Purchase Plan - Pay button Clicked", eventProperties, "pUnfEi9ML1", "6223b4fd67f7cdaea7dc4e466f4a23024ef6a4c1d8e6682b7e15263f6f828e69");
    }
    // destination Mixpanel
    Mixpanel.logEvent("Purchase Plan - Pay button Clicked", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface PurchasePlanMinusDurationPageViewProperties {
  epUserSubscriptionDuration: number | null | undefined;
  epUserSubscriptionPlan: EpUserSubscriptionPlanValueType;
  epUserSubscriptionIsActive: boolean | null | undefined;
  epUserIsMobileAppUser: boolean | null | undefined;
  epUserIsAdmin: boolean | null | undefined;
  epUserIsTelegramConnected: boolean | null | undefined;
  epUserIsDiscordConnected: boolean | null | undefined;
  epUserFeatureFlags: string[] | null | undefined;
  epUserIsDarkMode: boolean | null | undefined;
  isTelegramMiniApp: boolean | null | undefined;
  subscriptionInvoiceType: SubscriptionInvoiceTypeValueType;
  subscriptionInvoicePlan: SubscriptionInvoicePlanValueType | null | undefined;
}
/**
 * Purchase Plan - Duration Page View: No description
 * 
 * @param properties the properties associatied with this event
 * @param properties.epUserSubscriptionDuration: The current subscription duration for the user, in days. Not sent for users with Expired or Trial subscription plans.
 * @param properties.epUserSubscriptionPlan: The current subscription plan for the user. Users without an active subscription should have the value set to Expired.
 * @param properties.epUserSubscriptionIsActive: Set to True if the user has an active subscription (the last subscription expiration date is smaller than the current date).
 * @param properties.epUserIsMobileAppUser: no description
 * @param properties.epUserIsAdmin: no description
 * @param properties.epUserIsTelegramConnected: no description
 * @param properties.epUserIsDiscordConnected: no description
 * @param properties.epUserFeatureFlags: no description
 * @param properties.epUserIsDarkMode: no description
 * @param properties.isTelegramMiniApp: no description
 * @param properties.subscriptionInvoiceType: The type of the subscription invoice, between Extension, Upgrade and License.
 * @param properties.subscriptionInvoicePlan: no description
 * 
 * @see {@link https://www.avo.app/schemas/Zba2v6MXsSx1EdxPIQKm/events/pU5SQFg8Mr}
 */
export function purchasePlanDurationPageView(properties: PurchasePlanMinusDurationPageViewProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  properties.epUserSubscriptionDuration !== undefined && properties.epUserSubscriptionDuration !== null ?
    eventPropertiesArray.push({id: "BrNPvrBkq", name: "ep_user_subscription_duration", value: properties.epUserSubscriptionDuration}) :
    eventPropertiesArray.push({id: "BrNPvrBkq", name: "ep_user_subscription_duration", value: null});
  eventPropertiesArray.push({id: "Ak0bD3528L", name: "ep_user_subscription_plan", value: properties.epUserSubscriptionPlan});
  properties.epUserSubscriptionIsActive !== undefined && properties.epUserSubscriptionIsActive !== null ?
    eventPropertiesArray.push({id: "P2zcEByfWK", name: "ep_user_subscription_is_active", value: properties.epUserSubscriptionIsActive}) :
    eventPropertiesArray.push({id: "P2zcEByfWK", name: "ep_user_subscription_is_active", value: null});
  properties.epUserIsMobileAppUser !== undefined && properties.epUserIsMobileAppUser !== null ?
    eventPropertiesArray.push({id: "gkaSZCbXw8", name: "ep_user_is_mobile_app_user", value: properties.epUserIsMobileAppUser}) :
    eventPropertiesArray.push({id: "gkaSZCbXw8", name: "ep_user_is_mobile_app_user", value: null});
  properties.epUserIsAdmin !== undefined && properties.epUserIsAdmin !== null ?
    eventPropertiesArray.push({id: "1NHsnnGVd0", name: "ep_user_is_admin", value: properties.epUserIsAdmin}) :
    eventPropertiesArray.push({id: "1NHsnnGVd0", name: "ep_user_is_admin", value: null});
  properties.epUserIsTelegramConnected !== undefined && properties.epUserIsTelegramConnected !== null ?
    eventPropertiesArray.push({id: "QBh1Ik3rEm", name: "ep_user_is_telegram_connected", value: properties.epUserIsTelegramConnected}) :
    eventPropertiesArray.push({id: "QBh1Ik3rEm", name: "ep_user_is_telegram_connected", value: null});
  properties.epUserIsDiscordConnected !== undefined && properties.epUserIsDiscordConnected !== null ?
    eventPropertiesArray.push({id: "Z5anKuo4On", name: "ep_user_is_discord_connected", value: properties.epUserIsDiscordConnected}) :
    eventPropertiesArray.push({id: "Z5anKuo4On", name: "ep_user_is_discord_connected", value: null});
  properties.epUserFeatureFlags !== undefined && properties.epUserFeatureFlags !== null ?
    eventPropertiesArray.push({id: "ZkS2YBJULL", name: "ep_user_feature_flags", value: properties.epUserFeatureFlags}) :
    eventPropertiesArray.push({id: "ZkS2YBJULL", name: "ep_user_feature_flags", value: null});
  properties.epUserIsDarkMode !== undefined && properties.epUserIsDarkMode !== null ?
    eventPropertiesArray.push({id: "pZYzhjQhIW", name: "ep_user_is_dark_mode", value: properties.epUserIsDarkMode}) :
    eventPropertiesArray.push({id: "pZYzhjQhIW", name: "ep_user_is_dark_mode", value: null});
  properties.isTelegramMiniApp !== undefined && properties.isTelegramMiniApp !== null ?
    eventPropertiesArray.push({id: "vh-KiP-5Q", name: "is_telegram_mini_app", value: properties.isTelegramMiniApp}) :
    eventPropertiesArray.push({id: "vh-KiP-5Q", name: "is_telegram_mini_app", value: null});
  eventPropertiesArray.push({id: "H1YgxGowRc", name: "subscription_invoice_type", value: properties.subscriptionInvoiceType});
  properties.subscriptionInvoicePlan !== undefined && properties.subscriptionInvoicePlan !== null ?
    eventPropertiesArray.push({id: "l6Fv17-9l_", name: "subscription_invoice_plan", value: properties.subscriptionInvoicePlan}) :
    eventPropertiesArray.push({id: "l6Fv17-9l_", name: "subscription_invoice_plan", value: null});
  eventPropertiesArray.push({id: "WN7yP-IxTA", name: "platform", value: sysPlatform});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "pU5SQFg8Mr", "fd4a69318527d97f0a92f09977de4920824afc5239bb13009ef9897f3d185d7c", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Purchase Plan - Duration Page View", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("pU5SQFg8Mr", "Purchase Plan - Duration Page View", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Purchase Plan - Duration Page View", eventProperties, "pU5SQFg8Mr", "fd4a69318527d97f0a92f09977de4920824afc5239bb13009ef9897f3d185d7c");
    }
    // destination Mixpanel
    Mixpanel.logEvent("Purchase Plan - Duration Page View", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface AffiliationMinusReferralLinksViewProperties {
  epUserSubscriptionDuration: number | null | undefined;
  epUserSubscriptionPlan: EpUserSubscriptionPlanValueType;
  epUserSubscriptionIsActive: boolean | null | undefined;
  epUserIsMobileAppUser: boolean | null | undefined;
  epUserIsAdmin: boolean | null | undefined;
  epUserIsTelegramConnected: boolean | null | undefined;
  epUserIsDiscordConnected: boolean | null | undefined;
  epUserFeatureFlags: string[] | null | undefined;
  epUserIsDarkMode: boolean | null | undefined;
  isTelegramMiniApp: boolean | null | undefined;
}
/**
 * Affiliation - Referral Links View: User clicked the referral links view
 * 
 * @param properties the properties associatied with this event
 * @param properties.epUserSubscriptionDuration: The current subscription duration for the user, in days. Not sent for users with Expired or Trial subscription plans.
 * @param properties.epUserSubscriptionPlan: The current subscription plan for the user. Users without an active subscription should have the value set to Expired.
 * @param properties.epUserSubscriptionIsActive: Set to True if the user has an active subscription (the last subscription expiration date is smaller than the current date).
 * @param properties.epUserIsMobileAppUser: no description
 * @param properties.epUserIsAdmin: no description
 * @param properties.epUserIsTelegramConnected: no description
 * @param properties.epUserIsDiscordConnected: no description
 * @param properties.epUserFeatureFlags: no description
 * @param properties.epUserIsDarkMode: no description
 * @param properties.isTelegramMiniApp: no description
 * 
 * @see {@link https://www.avo.app/schemas/Zba2v6MXsSx1EdxPIQKm/events/cUwGx2Zcc9}
 */
export function affiliationReferralLinksView(properties: AffiliationMinusReferralLinksViewProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  properties.epUserSubscriptionDuration !== undefined && properties.epUserSubscriptionDuration !== null ?
    eventPropertiesArray.push({id: "BrNPvrBkq", name: "ep_user_subscription_duration", value: properties.epUserSubscriptionDuration}) :
    eventPropertiesArray.push({id: "BrNPvrBkq", name: "ep_user_subscription_duration", value: null});
  eventPropertiesArray.push({id: "Ak0bD3528L", name: "ep_user_subscription_plan", value: properties.epUserSubscriptionPlan});
  properties.epUserSubscriptionIsActive !== undefined && properties.epUserSubscriptionIsActive !== null ?
    eventPropertiesArray.push({id: "P2zcEByfWK", name: "ep_user_subscription_is_active", value: properties.epUserSubscriptionIsActive}) :
    eventPropertiesArray.push({id: "P2zcEByfWK", name: "ep_user_subscription_is_active", value: null});
  properties.epUserIsMobileAppUser !== undefined && properties.epUserIsMobileAppUser !== null ?
    eventPropertiesArray.push({id: "gkaSZCbXw8", name: "ep_user_is_mobile_app_user", value: properties.epUserIsMobileAppUser}) :
    eventPropertiesArray.push({id: "gkaSZCbXw8", name: "ep_user_is_mobile_app_user", value: null});
  properties.epUserIsAdmin !== undefined && properties.epUserIsAdmin !== null ?
    eventPropertiesArray.push({id: "1NHsnnGVd0", name: "ep_user_is_admin", value: properties.epUserIsAdmin}) :
    eventPropertiesArray.push({id: "1NHsnnGVd0", name: "ep_user_is_admin", value: null});
  properties.epUserIsTelegramConnected !== undefined && properties.epUserIsTelegramConnected !== null ?
    eventPropertiesArray.push({id: "QBh1Ik3rEm", name: "ep_user_is_telegram_connected", value: properties.epUserIsTelegramConnected}) :
    eventPropertiesArray.push({id: "QBh1Ik3rEm", name: "ep_user_is_telegram_connected", value: null});
  properties.epUserIsDiscordConnected !== undefined && properties.epUserIsDiscordConnected !== null ?
    eventPropertiesArray.push({id: "Z5anKuo4On", name: "ep_user_is_discord_connected", value: properties.epUserIsDiscordConnected}) :
    eventPropertiesArray.push({id: "Z5anKuo4On", name: "ep_user_is_discord_connected", value: null});
  properties.epUserFeatureFlags !== undefined && properties.epUserFeatureFlags !== null ?
    eventPropertiesArray.push({id: "ZkS2YBJULL", name: "ep_user_feature_flags", value: properties.epUserFeatureFlags}) :
    eventPropertiesArray.push({id: "ZkS2YBJULL", name: "ep_user_feature_flags", value: null});
  properties.epUserIsDarkMode !== undefined && properties.epUserIsDarkMode !== null ?
    eventPropertiesArray.push({id: "pZYzhjQhIW", name: "ep_user_is_dark_mode", value: properties.epUserIsDarkMode}) :
    eventPropertiesArray.push({id: "pZYzhjQhIW", name: "ep_user_is_dark_mode", value: null});
  properties.isTelegramMiniApp !== undefined && properties.isTelegramMiniApp !== null ?
    eventPropertiesArray.push({id: "vh-KiP-5Q", name: "is_telegram_mini_app", value: properties.isTelegramMiniApp}) :
    eventPropertiesArray.push({id: "vh-KiP-5Q", name: "is_telegram_mini_app", value: null});
  eventPropertiesArray.push({id: "WN7yP-IxTA", name: "platform", value: sysPlatform});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "cUwGx2Zcc9", "f1f7bc47794ca30b1b72963da17e0fc35353cdfc805dc9962957a13de290e03b", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Affiliation - Referral Links View", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("cUwGx2Zcc9", "Affiliation - Referral Links View", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Affiliation - Referral Links View", eventProperties, "cUwGx2Zcc9", "f1f7bc47794ca30b1b72963da17e0fc35353cdfc805dc9962957a13de290e03b");
    }
    // destination Mixpanel
    Mixpanel.logEvent("Affiliation - Referral Links View", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface AffiliationMinusReferredUsersViewProperties {
  epUserSubscriptionDuration: number | null | undefined;
  epUserSubscriptionPlan: EpUserSubscriptionPlanValueType;
  epUserSubscriptionIsActive: boolean | null | undefined;
  epUserIsMobileAppUser: boolean | null | undefined;
  epUserIsAdmin: boolean | null | undefined;
  epUserIsTelegramConnected: boolean | null | undefined;
  epUserIsDiscordConnected: boolean | null | undefined;
  epUserFeatureFlags: string[] | null | undefined;
  epUserIsDarkMode: boolean | null | undefined;
  isTelegramMiniApp: boolean | null | undefined;
}
/**
 * Affiliation - Referred Users View: User clicked the referred users view
 * 
 * @param properties the properties associatied with this event
 * @param properties.epUserSubscriptionDuration: The current subscription duration for the user, in days. Not sent for users with Expired or Trial subscription plans.
 * @param properties.epUserSubscriptionPlan: The current subscription plan for the user. Users without an active subscription should have the value set to Expired.
 * @param properties.epUserSubscriptionIsActive: Set to True if the user has an active subscription (the last subscription expiration date is smaller than the current date).
 * @param properties.epUserIsMobileAppUser: no description
 * @param properties.epUserIsAdmin: no description
 * @param properties.epUserIsTelegramConnected: no description
 * @param properties.epUserIsDiscordConnected: no description
 * @param properties.epUserFeatureFlags: no description
 * @param properties.epUserIsDarkMode: no description
 * @param properties.isTelegramMiniApp: no description
 * 
 * @see {@link https://www.avo.app/schemas/Zba2v6MXsSx1EdxPIQKm/events/REpcQWDTi5}
 */
export function affiliationReferredUsersView(properties: AffiliationMinusReferredUsersViewProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  properties.epUserSubscriptionDuration !== undefined && properties.epUserSubscriptionDuration !== null ?
    eventPropertiesArray.push({id: "BrNPvrBkq", name: "ep_user_subscription_duration", value: properties.epUserSubscriptionDuration}) :
    eventPropertiesArray.push({id: "BrNPvrBkq", name: "ep_user_subscription_duration", value: null});
  eventPropertiesArray.push({id: "Ak0bD3528L", name: "ep_user_subscription_plan", value: properties.epUserSubscriptionPlan});
  properties.epUserSubscriptionIsActive !== undefined && properties.epUserSubscriptionIsActive !== null ?
    eventPropertiesArray.push({id: "P2zcEByfWK", name: "ep_user_subscription_is_active", value: properties.epUserSubscriptionIsActive}) :
    eventPropertiesArray.push({id: "P2zcEByfWK", name: "ep_user_subscription_is_active", value: null});
  properties.epUserIsMobileAppUser !== undefined && properties.epUserIsMobileAppUser !== null ?
    eventPropertiesArray.push({id: "gkaSZCbXw8", name: "ep_user_is_mobile_app_user", value: properties.epUserIsMobileAppUser}) :
    eventPropertiesArray.push({id: "gkaSZCbXw8", name: "ep_user_is_mobile_app_user", value: null});
  properties.epUserIsAdmin !== undefined && properties.epUserIsAdmin !== null ?
    eventPropertiesArray.push({id: "1NHsnnGVd0", name: "ep_user_is_admin", value: properties.epUserIsAdmin}) :
    eventPropertiesArray.push({id: "1NHsnnGVd0", name: "ep_user_is_admin", value: null});
  properties.epUserIsTelegramConnected !== undefined && properties.epUserIsTelegramConnected !== null ?
    eventPropertiesArray.push({id: "QBh1Ik3rEm", name: "ep_user_is_telegram_connected", value: properties.epUserIsTelegramConnected}) :
    eventPropertiesArray.push({id: "QBh1Ik3rEm", name: "ep_user_is_telegram_connected", value: null});
  properties.epUserIsDiscordConnected !== undefined && properties.epUserIsDiscordConnected !== null ?
    eventPropertiesArray.push({id: "Z5anKuo4On", name: "ep_user_is_discord_connected", value: properties.epUserIsDiscordConnected}) :
    eventPropertiesArray.push({id: "Z5anKuo4On", name: "ep_user_is_discord_connected", value: null});
  properties.epUserFeatureFlags !== undefined && properties.epUserFeatureFlags !== null ?
    eventPropertiesArray.push({id: "ZkS2YBJULL", name: "ep_user_feature_flags", value: properties.epUserFeatureFlags}) :
    eventPropertiesArray.push({id: "ZkS2YBJULL", name: "ep_user_feature_flags", value: null});
  properties.epUserIsDarkMode !== undefined && properties.epUserIsDarkMode !== null ?
    eventPropertiesArray.push({id: "pZYzhjQhIW", name: "ep_user_is_dark_mode", value: properties.epUserIsDarkMode}) :
    eventPropertiesArray.push({id: "pZYzhjQhIW", name: "ep_user_is_dark_mode", value: null});
  properties.isTelegramMiniApp !== undefined && properties.isTelegramMiniApp !== null ?
    eventPropertiesArray.push({id: "vh-KiP-5Q", name: "is_telegram_mini_app", value: properties.isTelegramMiniApp}) :
    eventPropertiesArray.push({id: "vh-KiP-5Q", name: "is_telegram_mini_app", value: null});
  eventPropertiesArray.push({id: "WN7yP-IxTA", name: "platform", value: sysPlatform});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "REpcQWDTi5", "d62a100ce30adc6fd920fd621460d0fe48398b9792d8df6465315524d6542ea2", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Affiliation - Referred Users View", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("REpcQWDTi5", "Affiliation - Referred Users View", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Affiliation - Referred Users View", eventProperties, "REpcQWDTi5", "d62a100ce30adc6fd920fd621460d0fe48398b9792d8df6465315524d6542ea2");
    }
    // destination Mixpanel
    Mixpanel.logEvent("Affiliation - Referred Users View", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface AffiliationMinusEarningsViewProperties {
  epUserSubscriptionDuration: number | null | undefined;
  epUserSubscriptionPlan: EpUserSubscriptionPlanValueType;
  epUserSubscriptionIsActive: boolean | null | undefined;
  epUserIsMobileAppUser: boolean | null | undefined;
  epUserIsAdmin: boolean | null | undefined;
  epUserIsTelegramConnected: boolean | null | undefined;
  epUserIsDiscordConnected: boolean | null | undefined;
  epUserFeatureFlags: string[] | null | undefined;
  epUserIsDarkMode: boolean | null | undefined;
  isTelegramMiniApp: boolean | null | undefined;
}
/**
 * Affiliation - Earnings View: User Clicked the Earnings View
 * 
 * @param properties the properties associatied with this event
 * @param properties.epUserSubscriptionDuration: The current subscription duration for the user, in days. Not sent for users with Expired or Trial subscription plans.
 * @param properties.epUserSubscriptionPlan: The current subscription plan for the user. Users without an active subscription should have the value set to Expired.
 * @param properties.epUserSubscriptionIsActive: Set to True if the user has an active subscription (the last subscription expiration date is smaller than the current date).
 * @param properties.epUserIsMobileAppUser: no description
 * @param properties.epUserIsAdmin: no description
 * @param properties.epUserIsTelegramConnected: no description
 * @param properties.epUserIsDiscordConnected: no description
 * @param properties.epUserFeatureFlags: no description
 * @param properties.epUserIsDarkMode: no description
 * @param properties.isTelegramMiniApp: no description
 * 
 * @see {@link https://www.avo.app/schemas/Zba2v6MXsSx1EdxPIQKm/events/LjYA0a2NuR}
 */
export function affiliationEarningsView(properties: AffiliationMinusEarningsViewProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  properties.epUserSubscriptionDuration !== undefined && properties.epUserSubscriptionDuration !== null ?
    eventPropertiesArray.push({id: "BrNPvrBkq", name: "ep_user_subscription_duration", value: properties.epUserSubscriptionDuration}) :
    eventPropertiesArray.push({id: "BrNPvrBkq", name: "ep_user_subscription_duration", value: null});
  eventPropertiesArray.push({id: "Ak0bD3528L", name: "ep_user_subscription_plan", value: properties.epUserSubscriptionPlan});
  properties.epUserSubscriptionIsActive !== undefined && properties.epUserSubscriptionIsActive !== null ?
    eventPropertiesArray.push({id: "P2zcEByfWK", name: "ep_user_subscription_is_active", value: properties.epUserSubscriptionIsActive}) :
    eventPropertiesArray.push({id: "P2zcEByfWK", name: "ep_user_subscription_is_active", value: null});
  properties.epUserIsMobileAppUser !== undefined && properties.epUserIsMobileAppUser !== null ?
    eventPropertiesArray.push({id: "gkaSZCbXw8", name: "ep_user_is_mobile_app_user", value: properties.epUserIsMobileAppUser}) :
    eventPropertiesArray.push({id: "gkaSZCbXw8", name: "ep_user_is_mobile_app_user", value: null});
  properties.epUserIsAdmin !== undefined && properties.epUserIsAdmin !== null ?
    eventPropertiesArray.push({id: "1NHsnnGVd0", name: "ep_user_is_admin", value: properties.epUserIsAdmin}) :
    eventPropertiesArray.push({id: "1NHsnnGVd0", name: "ep_user_is_admin", value: null});
  properties.epUserIsTelegramConnected !== undefined && properties.epUserIsTelegramConnected !== null ?
    eventPropertiesArray.push({id: "QBh1Ik3rEm", name: "ep_user_is_telegram_connected", value: properties.epUserIsTelegramConnected}) :
    eventPropertiesArray.push({id: "QBh1Ik3rEm", name: "ep_user_is_telegram_connected", value: null});
  properties.epUserIsDiscordConnected !== undefined && properties.epUserIsDiscordConnected !== null ?
    eventPropertiesArray.push({id: "Z5anKuo4On", name: "ep_user_is_discord_connected", value: properties.epUserIsDiscordConnected}) :
    eventPropertiesArray.push({id: "Z5anKuo4On", name: "ep_user_is_discord_connected", value: null});
  properties.epUserFeatureFlags !== undefined && properties.epUserFeatureFlags !== null ?
    eventPropertiesArray.push({id: "ZkS2YBJULL", name: "ep_user_feature_flags", value: properties.epUserFeatureFlags}) :
    eventPropertiesArray.push({id: "ZkS2YBJULL", name: "ep_user_feature_flags", value: null});
  properties.epUserIsDarkMode !== undefined && properties.epUserIsDarkMode !== null ?
    eventPropertiesArray.push({id: "pZYzhjQhIW", name: "ep_user_is_dark_mode", value: properties.epUserIsDarkMode}) :
    eventPropertiesArray.push({id: "pZYzhjQhIW", name: "ep_user_is_dark_mode", value: null});
  properties.isTelegramMiniApp !== undefined && properties.isTelegramMiniApp !== null ?
    eventPropertiesArray.push({id: "vh-KiP-5Q", name: "is_telegram_mini_app", value: properties.isTelegramMiniApp}) :
    eventPropertiesArray.push({id: "vh-KiP-5Q", name: "is_telegram_mini_app", value: null});
  eventPropertiesArray.push({id: "WN7yP-IxTA", name: "platform", value: sysPlatform});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "LjYA0a2NuR", "579bc7688e4a94f8bae749d0e35c6bec48de81fff6d16021b51e6da76982c30b", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Affiliation - Earnings View", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("LjYA0a2NuR", "Affiliation - Earnings View", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Affiliation - Earnings View", eventProperties, "LjYA0a2NuR", "579bc7688e4a94f8bae749d0e35c6bec48de81fff6d16021b51e6da76982c30b");
    }
    // destination Mixpanel
    Mixpanel.logEvent("Affiliation - Earnings View", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface AffiliationMinusPayoutsViewProperties {
  epUserSubscriptionDuration: number | null | undefined;
  epUserSubscriptionPlan: EpUserSubscriptionPlanValueType;
  epUserSubscriptionIsActive: boolean | null | undefined;
  epUserIsMobileAppUser: boolean | null | undefined;
  epUserIsAdmin: boolean | null | undefined;
  epUserIsTelegramConnected: boolean | null | undefined;
  epUserIsDiscordConnected: boolean | null | undefined;
  epUserFeatureFlags: string[] | null | undefined;
  epUserIsDarkMode: boolean | null | undefined;
  isTelegramMiniApp: boolean | null | undefined;
}
/**
 * Affiliation - Payouts View: User clicked the Payouts page
 * 
 * @param properties the properties associatied with this event
 * @param properties.epUserSubscriptionDuration: The current subscription duration for the user, in days. Not sent for users with Expired or Trial subscription plans.
 * @param properties.epUserSubscriptionPlan: The current subscription plan for the user. Users without an active subscription should have the value set to Expired.
 * @param properties.epUserSubscriptionIsActive: Set to True if the user has an active subscription (the last subscription expiration date is smaller than the current date).
 * @param properties.epUserIsMobileAppUser: no description
 * @param properties.epUserIsAdmin: no description
 * @param properties.epUserIsTelegramConnected: no description
 * @param properties.epUserIsDiscordConnected: no description
 * @param properties.epUserFeatureFlags: no description
 * @param properties.epUserIsDarkMode: no description
 * @param properties.isTelegramMiniApp: no description
 * 
 * @see {@link https://www.avo.app/schemas/Zba2v6MXsSx1EdxPIQKm/events/u-i6nX_Y63}
 */
export function affiliationPayoutsView(properties: AffiliationMinusPayoutsViewProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  properties.epUserSubscriptionDuration !== undefined && properties.epUserSubscriptionDuration !== null ?
    eventPropertiesArray.push({id: "BrNPvrBkq", name: "ep_user_subscription_duration", value: properties.epUserSubscriptionDuration}) :
    eventPropertiesArray.push({id: "BrNPvrBkq", name: "ep_user_subscription_duration", value: null});
  eventPropertiesArray.push({id: "Ak0bD3528L", name: "ep_user_subscription_plan", value: properties.epUserSubscriptionPlan});
  properties.epUserSubscriptionIsActive !== undefined && properties.epUserSubscriptionIsActive !== null ?
    eventPropertiesArray.push({id: "P2zcEByfWK", name: "ep_user_subscription_is_active", value: properties.epUserSubscriptionIsActive}) :
    eventPropertiesArray.push({id: "P2zcEByfWK", name: "ep_user_subscription_is_active", value: null});
  properties.epUserIsMobileAppUser !== undefined && properties.epUserIsMobileAppUser !== null ?
    eventPropertiesArray.push({id: "gkaSZCbXw8", name: "ep_user_is_mobile_app_user", value: properties.epUserIsMobileAppUser}) :
    eventPropertiesArray.push({id: "gkaSZCbXw8", name: "ep_user_is_mobile_app_user", value: null});
  properties.epUserIsAdmin !== undefined && properties.epUserIsAdmin !== null ?
    eventPropertiesArray.push({id: "1NHsnnGVd0", name: "ep_user_is_admin", value: properties.epUserIsAdmin}) :
    eventPropertiesArray.push({id: "1NHsnnGVd0", name: "ep_user_is_admin", value: null});
  properties.epUserIsTelegramConnected !== undefined && properties.epUserIsTelegramConnected !== null ?
    eventPropertiesArray.push({id: "QBh1Ik3rEm", name: "ep_user_is_telegram_connected", value: properties.epUserIsTelegramConnected}) :
    eventPropertiesArray.push({id: "QBh1Ik3rEm", name: "ep_user_is_telegram_connected", value: null});
  properties.epUserIsDiscordConnected !== undefined && properties.epUserIsDiscordConnected !== null ?
    eventPropertiesArray.push({id: "Z5anKuo4On", name: "ep_user_is_discord_connected", value: properties.epUserIsDiscordConnected}) :
    eventPropertiesArray.push({id: "Z5anKuo4On", name: "ep_user_is_discord_connected", value: null});
  properties.epUserFeatureFlags !== undefined && properties.epUserFeatureFlags !== null ?
    eventPropertiesArray.push({id: "ZkS2YBJULL", name: "ep_user_feature_flags", value: properties.epUserFeatureFlags}) :
    eventPropertiesArray.push({id: "ZkS2YBJULL", name: "ep_user_feature_flags", value: null});
  properties.epUserIsDarkMode !== undefined && properties.epUserIsDarkMode !== null ?
    eventPropertiesArray.push({id: "pZYzhjQhIW", name: "ep_user_is_dark_mode", value: properties.epUserIsDarkMode}) :
    eventPropertiesArray.push({id: "pZYzhjQhIW", name: "ep_user_is_dark_mode", value: null});
  properties.isTelegramMiniApp !== undefined && properties.isTelegramMiniApp !== null ?
    eventPropertiesArray.push({id: "vh-KiP-5Q", name: "is_telegram_mini_app", value: properties.isTelegramMiniApp}) :
    eventPropertiesArray.push({id: "vh-KiP-5Q", name: "is_telegram_mini_app", value: null});
  eventPropertiesArray.push({id: "WN7yP-IxTA", name: "platform", value: sysPlatform});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "u-i6nX_Y63", "1acb5b06ee1bbb08c818e003f242e5a80a45acc9864fb0d7d715bac6f56e8524", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Affiliation - Payouts View", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("u-i6nX_Y63", "Affiliation - Payouts View", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Affiliation - Payouts View", eventProperties, "u-i6nX_Y63", "1acb5b06ee1bbb08c818e003f242e5a80a45acc9864fb0d7d715bac6f56e8524");
    }
    // destination Mixpanel
    Mixpanel.logEvent("Affiliation - Payouts View", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface AffiliationMinusNewReferralLinkClickedProperties {
  epUserSubscriptionDuration: number | null | undefined;
  epUserSubscriptionPlan: EpUserSubscriptionPlanValueType;
  epUserSubscriptionIsActive: boolean | null | undefined;
  epUserIsMobileAppUser: boolean | null | undefined;
  epUserIsAdmin: boolean | null | undefined;
  epUserIsTelegramConnected: boolean | null | undefined;
  epUserIsDiscordConnected: boolean | null | undefined;
  epUserFeatureFlags: string[] | null | undefined;
  epUserIsDarkMode: boolean | null | undefined;
  isTelegramMiniApp: boolean | null | undefined;
}
/**
 * Affiliation - New Referral Link Clicked: User clicked the new referral link button 
 * 
 * @param properties the properties associatied with this event
 * @param properties.epUserSubscriptionDuration: The current subscription duration for the user, in days. Not sent for users with Expired or Trial subscription plans.
 * @param properties.epUserSubscriptionPlan: The current subscription plan for the user. Users without an active subscription should have the value set to Expired.
 * @param properties.epUserSubscriptionIsActive: Set to True if the user has an active subscription (the last subscription expiration date is smaller than the current date).
 * @param properties.epUserIsMobileAppUser: no description
 * @param properties.epUserIsAdmin: no description
 * @param properties.epUserIsTelegramConnected: no description
 * @param properties.epUserIsDiscordConnected: no description
 * @param properties.epUserFeatureFlags: no description
 * @param properties.epUserIsDarkMode: no description
 * @param properties.isTelegramMiniApp: no description
 * 
 * @see {@link https://www.avo.app/schemas/Zba2v6MXsSx1EdxPIQKm/events/6w0uLOAI_j}
 */
export function affiliationNewReferralLinkClicked(properties: AffiliationMinusNewReferralLinkClickedProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  properties.epUserSubscriptionDuration !== undefined && properties.epUserSubscriptionDuration !== null ?
    eventPropertiesArray.push({id: "BrNPvrBkq", name: "ep_user_subscription_duration", value: properties.epUserSubscriptionDuration}) :
    eventPropertiesArray.push({id: "BrNPvrBkq", name: "ep_user_subscription_duration", value: null});
  eventPropertiesArray.push({id: "Ak0bD3528L", name: "ep_user_subscription_plan", value: properties.epUserSubscriptionPlan});
  properties.epUserSubscriptionIsActive !== undefined && properties.epUserSubscriptionIsActive !== null ?
    eventPropertiesArray.push({id: "P2zcEByfWK", name: "ep_user_subscription_is_active", value: properties.epUserSubscriptionIsActive}) :
    eventPropertiesArray.push({id: "P2zcEByfWK", name: "ep_user_subscription_is_active", value: null});
  properties.epUserIsMobileAppUser !== undefined && properties.epUserIsMobileAppUser !== null ?
    eventPropertiesArray.push({id: "gkaSZCbXw8", name: "ep_user_is_mobile_app_user", value: properties.epUserIsMobileAppUser}) :
    eventPropertiesArray.push({id: "gkaSZCbXw8", name: "ep_user_is_mobile_app_user", value: null});
  properties.epUserIsAdmin !== undefined && properties.epUserIsAdmin !== null ?
    eventPropertiesArray.push({id: "1NHsnnGVd0", name: "ep_user_is_admin", value: properties.epUserIsAdmin}) :
    eventPropertiesArray.push({id: "1NHsnnGVd0", name: "ep_user_is_admin", value: null});
  properties.epUserIsTelegramConnected !== undefined && properties.epUserIsTelegramConnected !== null ?
    eventPropertiesArray.push({id: "QBh1Ik3rEm", name: "ep_user_is_telegram_connected", value: properties.epUserIsTelegramConnected}) :
    eventPropertiesArray.push({id: "QBh1Ik3rEm", name: "ep_user_is_telegram_connected", value: null});
  properties.epUserIsDiscordConnected !== undefined && properties.epUserIsDiscordConnected !== null ?
    eventPropertiesArray.push({id: "Z5anKuo4On", name: "ep_user_is_discord_connected", value: properties.epUserIsDiscordConnected}) :
    eventPropertiesArray.push({id: "Z5anKuo4On", name: "ep_user_is_discord_connected", value: null});
  properties.epUserFeatureFlags !== undefined && properties.epUserFeatureFlags !== null ?
    eventPropertiesArray.push({id: "ZkS2YBJULL", name: "ep_user_feature_flags", value: properties.epUserFeatureFlags}) :
    eventPropertiesArray.push({id: "ZkS2YBJULL", name: "ep_user_feature_flags", value: null});
  properties.epUserIsDarkMode !== undefined && properties.epUserIsDarkMode !== null ?
    eventPropertiesArray.push({id: "pZYzhjQhIW", name: "ep_user_is_dark_mode", value: properties.epUserIsDarkMode}) :
    eventPropertiesArray.push({id: "pZYzhjQhIW", name: "ep_user_is_dark_mode", value: null});
  properties.isTelegramMiniApp !== undefined && properties.isTelegramMiniApp !== null ?
    eventPropertiesArray.push({id: "vh-KiP-5Q", name: "is_telegram_mini_app", value: properties.isTelegramMiniApp}) :
    eventPropertiesArray.push({id: "vh-KiP-5Q", name: "is_telegram_mini_app", value: null});
  eventPropertiesArray.push({id: "WN7yP-IxTA", name: "platform", value: sysPlatform});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "6w0uLOAI_j", "5fc20b317e6c208cb828faaa60a6428f7c992d11def1c89a6401d749b343c1af", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Affiliation - New Referral Link Clicked", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("6w0uLOAI_j", "Affiliation - New Referral Link Clicked", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Affiliation - New Referral Link Clicked", eventProperties, "6w0uLOAI_j", "5fc20b317e6c208cb828faaa60a6428f7c992d11def1c89a6401d749b343c1af");
    }
    // destination Mixpanel
    Mixpanel.logEvent("Affiliation - New Referral Link Clicked", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface AffiliationMinusManagePayoutMethodsClickedProperties {
  epUserSubscriptionDuration: number | null | undefined;
  epUserSubscriptionPlan: EpUserSubscriptionPlanValueType;
  epUserSubscriptionIsActive: boolean | null | undefined;
  epUserIsMobileAppUser: boolean | null | undefined;
  epUserIsAdmin: boolean | null | undefined;
  epUserIsTelegramConnected: boolean | null | undefined;
  epUserIsDiscordConnected: boolean | null | undefined;
  epUserFeatureFlags: string[] | null | undefined;
  epUserIsDarkMode: boolean | null | undefined;
  isTelegramMiniApp: boolean | null | undefined;
}
/**
 * Affiliation - Manage Payout Methods Clicked: User clicked the 'Manage Payout Methods' button on the Payouts page
 * 
 * @param properties the properties associatied with this event
 * @param properties.epUserSubscriptionDuration: The current subscription duration for the user, in days. Not sent for users with Expired or Trial subscription plans.
 * @param properties.epUserSubscriptionPlan: The current subscription plan for the user. Users without an active subscription should have the value set to Expired.
 * @param properties.epUserSubscriptionIsActive: Set to True if the user has an active subscription (the last subscription expiration date is smaller than the current date).
 * @param properties.epUserIsMobileAppUser: no description
 * @param properties.epUserIsAdmin: no description
 * @param properties.epUserIsTelegramConnected: no description
 * @param properties.epUserIsDiscordConnected: no description
 * @param properties.epUserFeatureFlags: no description
 * @param properties.epUserIsDarkMode: no description
 * @param properties.isTelegramMiniApp: no description
 * 
 * @see {@link https://www.avo.app/schemas/Zba2v6MXsSx1EdxPIQKm/events/aTdiKaavUa}
 */
export function affiliationManagePayoutMethodsClicked(properties: AffiliationMinusManagePayoutMethodsClickedProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  properties.epUserSubscriptionDuration !== undefined && properties.epUserSubscriptionDuration !== null ?
    eventPropertiesArray.push({id: "BrNPvrBkq", name: "ep_user_subscription_duration", value: properties.epUserSubscriptionDuration}) :
    eventPropertiesArray.push({id: "BrNPvrBkq", name: "ep_user_subscription_duration", value: null});
  eventPropertiesArray.push({id: "Ak0bD3528L", name: "ep_user_subscription_plan", value: properties.epUserSubscriptionPlan});
  properties.epUserSubscriptionIsActive !== undefined && properties.epUserSubscriptionIsActive !== null ?
    eventPropertiesArray.push({id: "P2zcEByfWK", name: "ep_user_subscription_is_active", value: properties.epUserSubscriptionIsActive}) :
    eventPropertiesArray.push({id: "P2zcEByfWK", name: "ep_user_subscription_is_active", value: null});
  properties.epUserIsMobileAppUser !== undefined && properties.epUserIsMobileAppUser !== null ?
    eventPropertiesArray.push({id: "gkaSZCbXw8", name: "ep_user_is_mobile_app_user", value: properties.epUserIsMobileAppUser}) :
    eventPropertiesArray.push({id: "gkaSZCbXw8", name: "ep_user_is_mobile_app_user", value: null});
  properties.epUserIsAdmin !== undefined && properties.epUserIsAdmin !== null ?
    eventPropertiesArray.push({id: "1NHsnnGVd0", name: "ep_user_is_admin", value: properties.epUserIsAdmin}) :
    eventPropertiesArray.push({id: "1NHsnnGVd0", name: "ep_user_is_admin", value: null});
  properties.epUserIsTelegramConnected !== undefined && properties.epUserIsTelegramConnected !== null ?
    eventPropertiesArray.push({id: "QBh1Ik3rEm", name: "ep_user_is_telegram_connected", value: properties.epUserIsTelegramConnected}) :
    eventPropertiesArray.push({id: "QBh1Ik3rEm", name: "ep_user_is_telegram_connected", value: null});
  properties.epUserIsDiscordConnected !== undefined && properties.epUserIsDiscordConnected !== null ?
    eventPropertiesArray.push({id: "Z5anKuo4On", name: "ep_user_is_discord_connected", value: properties.epUserIsDiscordConnected}) :
    eventPropertiesArray.push({id: "Z5anKuo4On", name: "ep_user_is_discord_connected", value: null});
  properties.epUserFeatureFlags !== undefined && properties.epUserFeatureFlags !== null ?
    eventPropertiesArray.push({id: "ZkS2YBJULL", name: "ep_user_feature_flags", value: properties.epUserFeatureFlags}) :
    eventPropertiesArray.push({id: "ZkS2YBJULL", name: "ep_user_feature_flags", value: null});
  properties.epUserIsDarkMode !== undefined && properties.epUserIsDarkMode !== null ?
    eventPropertiesArray.push({id: "pZYzhjQhIW", name: "ep_user_is_dark_mode", value: properties.epUserIsDarkMode}) :
    eventPropertiesArray.push({id: "pZYzhjQhIW", name: "ep_user_is_dark_mode", value: null});
  properties.isTelegramMiniApp !== undefined && properties.isTelegramMiniApp !== null ?
    eventPropertiesArray.push({id: "vh-KiP-5Q", name: "is_telegram_mini_app", value: properties.isTelegramMiniApp}) :
    eventPropertiesArray.push({id: "vh-KiP-5Q", name: "is_telegram_mini_app", value: null});
  eventPropertiesArray.push({id: "WN7yP-IxTA", name: "platform", value: sysPlatform});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "aTdiKaavUa", "be033dd62985590956b3e19f3a76a46ec08c1bae99f78ccfce07dece1af08cba", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Affiliation - Manage Payout Methods Clicked", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("aTdiKaavUa", "Affiliation - Manage Payout Methods Clicked", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Affiliation - Manage Payout Methods Clicked", eventProperties, "aTdiKaavUa", "be033dd62985590956b3e19f3a76a46ec08c1bae99f78ccfce07dece1af08cba");
    }
    // destination Mixpanel
    Mixpanel.logEvent("Affiliation - Manage Payout Methods Clicked", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface AffiliationMinusNewPayoutClickedProperties {
  epUserSubscriptionDuration: number | null | undefined;
  epUserSubscriptionPlan: EpUserSubscriptionPlanValueType;
  epUserSubscriptionIsActive: boolean | null | undefined;
  epUserIsMobileAppUser: boolean | null | undefined;
  epUserIsAdmin: boolean | null | undefined;
  epUserIsTelegramConnected: boolean | null | undefined;
  epUserIsDiscordConnected: boolean | null | undefined;
  epUserFeatureFlags: string[] | null | undefined;
  epUserIsDarkMode: boolean | null | undefined;
  isTelegramMiniApp: boolean | null | undefined;
}
/**
 * Affiliation - New Payout Clicked: User clicked the new payout button on the payouts page
 * 
 * @param properties the properties associatied with this event
 * @param properties.epUserSubscriptionDuration: The current subscription duration for the user, in days. Not sent for users with Expired or Trial subscription plans.
 * @param properties.epUserSubscriptionPlan: The current subscription plan for the user. Users without an active subscription should have the value set to Expired.
 * @param properties.epUserSubscriptionIsActive: Set to True if the user has an active subscription (the last subscription expiration date is smaller than the current date).
 * @param properties.epUserIsMobileAppUser: no description
 * @param properties.epUserIsAdmin: no description
 * @param properties.epUserIsTelegramConnected: no description
 * @param properties.epUserIsDiscordConnected: no description
 * @param properties.epUserFeatureFlags: no description
 * @param properties.epUserIsDarkMode: no description
 * @param properties.isTelegramMiniApp: no description
 * 
 * @see {@link https://www.avo.app/schemas/Zba2v6MXsSx1EdxPIQKm/events/Qj5CipEXO4}
 */
export function affiliationNewPayoutClicked(properties: AffiliationMinusNewPayoutClickedProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  properties.epUserSubscriptionDuration !== undefined && properties.epUserSubscriptionDuration !== null ?
    eventPropertiesArray.push({id: "BrNPvrBkq", name: "ep_user_subscription_duration", value: properties.epUserSubscriptionDuration}) :
    eventPropertiesArray.push({id: "BrNPvrBkq", name: "ep_user_subscription_duration", value: null});
  eventPropertiesArray.push({id: "Ak0bD3528L", name: "ep_user_subscription_plan", value: properties.epUserSubscriptionPlan});
  properties.epUserSubscriptionIsActive !== undefined && properties.epUserSubscriptionIsActive !== null ?
    eventPropertiesArray.push({id: "P2zcEByfWK", name: "ep_user_subscription_is_active", value: properties.epUserSubscriptionIsActive}) :
    eventPropertiesArray.push({id: "P2zcEByfWK", name: "ep_user_subscription_is_active", value: null});
  properties.epUserIsMobileAppUser !== undefined && properties.epUserIsMobileAppUser !== null ?
    eventPropertiesArray.push({id: "gkaSZCbXw8", name: "ep_user_is_mobile_app_user", value: properties.epUserIsMobileAppUser}) :
    eventPropertiesArray.push({id: "gkaSZCbXw8", name: "ep_user_is_mobile_app_user", value: null});
  properties.epUserIsAdmin !== undefined && properties.epUserIsAdmin !== null ?
    eventPropertiesArray.push({id: "1NHsnnGVd0", name: "ep_user_is_admin", value: properties.epUserIsAdmin}) :
    eventPropertiesArray.push({id: "1NHsnnGVd0", name: "ep_user_is_admin", value: null});
  properties.epUserIsTelegramConnected !== undefined && properties.epUserIsTelegramConnected !== null ?
    eventPropertiesArray.push({id: "QBh1Ik3rEm", name: "ep_user_is_telegram_connected", value: properties.epUserIsTelegramConnected}) :
    eventPropertiesArray.push({id: "QBh1Ik3rEm", name: "ep_user_is_telegram_connected", value: null});
  properties.epUserIsDiscordConnected !== undefined && properties.epUserIsDiscordConnected !== null ?
    eventPropertiesArray.push({id: "Z5anKuo4On", name: "ep_user_is_discord_connected", value: properties.epUserIsDiscordConnected}) :
    eventPropertiesArray.push({id: "Z5anKuo4On", name: "ep_user_is_discord_connected", value: null});
  properties.epUserFeatureFlags !== undefined && properties.epUserFeatureFlags !== null ?
    eventPropertiesArray.push({id: "ZkS2YBJULL", name: "ep_user_feature_flags", value: properties.epUserFeatureFlags}) :
    eventPropertiesArray.push({id: "ZkS2YBJULL", name: "ep_user_feature_flags", value: null});
  properties.epUserIsDarkMode !== undefined && properties.epUserIsDarkMode !== null ?
    eventPropertiesArray.push({id: "pZYzhjQhIW", name: "ep_user_is_dark_mode", value: properties.epUserIsDarkMode}) :
    eventPropertiesArray.push({id: "pZYzhjQhIW", name: "ep_user_is_dark_mode", value: null});
  properties.isTelegramMiniApp !== undefined && properties.isTelegramMiniApp !== null ?
    eventPropertiesArray.push({id: "vh-KiP-5Q", name: "is_telegram_mini_app", value: properties.isTelegramMiniApp}) :
    eventPropertiesArray.push({id: "vh-KiP-5Q", name: "is_telegram_mini_app", value: null});
  eventPropertiesArray.push({id: "WN7yP-IxTA", name: "platform", value: sysPlatform});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "Qj5CipEXO4", "4f3d0d7acac30d74ba84faeb3a92e68735af9bf9ab2fc7dec9b2f046ceab4a09", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Affiliation - New Payout Clicked", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("Qj5CipEXO4", "Affiliation - New Payout Clicked", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Affiliation - New Payout Clicked", eventProperties, "Qj5CipEXO4", "4f3d0d7acac30d74ba84faeb3a92e68735af9bf9ab2fc7dec9b2f046ceab4a09");
    }
    // destination Mixpanel
    Mixpanel.logEvent("Affiliation - New Payout Clicked", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

/**
 * Admin Panel - My Groups View: User clicked the my group pages in the admin panel
 * 
 * @see {@link https://www.avo.app/schemas/Zba2v6MXsSx1EdxPIQKm/events/v2APdV1BLR}
 */
export function adminPanelMyGroupsView() {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({id: "WN7yP-IxTA", name: "platform", value: sysPlatform});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "v2APdV1BLR", "94dba62069d884250e8ed741c22aeade2c2498ee395c6f87ce322564619b6a4b", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Admin Panel - My Groups View", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("v2APdV1BLR", "Admin Panel - My Groups View", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Admin Panel - My Groups View", eventProperties, "v2APdV1BLR", "94dba62069d884250e8ed741c22aeade2c2498ee395c6f87ce322564619b6a4b");
    }
    // destination Mixpanel
    Mixpanel.logEvent("Admin Panel - My Groups View", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface AdminPanelMinusOpenSignalsViewProperties {
  groupChannelId: number;
}
/**
 * Admin Panel - Open Signals View: User clicked the Signals View page in the admin panel
 * 
 * @param properties the properties associatied with this event
 * @param properties.groupChannelId: The current channel/group id that was recorded as part of the event
 * 
 * @see {@link https://www.avo.app/schemas/Zba2v6MXsSx1EdxPIQKm/events/8SG4qhnElH}
 */
export function adminPanelOpenSignalsView(properties: AdminPanelMinusOpenSignalsViewProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({id: "dcXTMVDlJn", name: "group_channel_id", value: properties.groupChannelId});
  eventPropertiesArray.push({id: "WN7yP-IxTA", name: "platform", value: sysPlatform});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "8SG4qhnElH", "8f20f77d9770a87bf14f70353ac210165c14cba18432902c164b84516347f78f", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Admin Panel - Open Signals View", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("8SG4qhnElH", "Admin Panel - Open Signals View", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Admin Panel - Open Signals View", eventProperties, "8SG4qhnElH", "8f20f77d9770a87bf14f70353ac210165c14cba18432902c164b84516347f78f");
    }
    // destination Mixpanel
    Mixpanel.logEvent("Admin Panel - Open Signals View", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

/**
 * Admin Panel - Group Management Users View: No description
 * 
 * @see {@link https://www.avo.app/schemas/Zba2v6MXsSx1EdxPIQKm/events/UqdKPooFjX}
 */
export function adminPanelGroupManagementUsersView() {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({id: "WN7yP-IxTA", name: "platform", value: sysPlatform});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "UqdKPooFjX", "0bf865e294a6e015ee407580e24955a17e7fc3167742d94dbe13a10dcaf07c8b", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Admin Panel - Group Management Users View", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("UqdKPooFjX", "Admin Panel - Group Management Users View", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Admin Panel - Group Management Users View", eventProperties, "UqdKPooFjX", "0bf865e294a6e015ee407580e24955a17e7fc3167742d94dbe13a10dcaf07c8b");
    }
    // destination Mixpanel
    Mixpanel.logEvent("Admin Panel - Group Management Users View", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

/**
 * Admin Panel - Group Management Invitations View: User clicked the Group Management Invitations Page
 * 
 * @see {@link https://www.avo.app/schemas/Zba2v6MXsSx1EdxPIQKm/events/lZWLvmN5JU}
 */
export function adminPanelGroupManagementInvitationsView() {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({id: "WN7yP-IxTA", name: "platform", value: sysPlatform});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "lZWLvmN5JU", "b6a33e07e0d1bc91151f9c1554cc859327706b60b33a24db7e3b06dc1e02cba1", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Admin Panel - Group Management Invitations View", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("lZWLvmN5JU", "Admin Panel - Group Management Invitations View", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Admin Panel - Group Management Invitations View", eventProperties, "lZWLvmN5JU", "b6a33e07e0d1bc91151f9c1554cc859327706b60b33a24db7e3b06dc1e02cba1");
    }
    // destination Mixpanel
    Mixpanel.logEvent("Admin Panel - Group Management Invitations View", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

/**
 * Admin Panel - Group Management Configurations View: User clicked the group management configurations page
 * 
 * @see {@link https://www.avo.app/schemas/Zba2v6MXsSx1EdxPIQKm/events/RlYrT8uu1x}
 */
export function adminPanelGroupManagementConfigurationsView() {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({id: "WN7yP-IxTA", name: "platform", value: sysPlatform});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "RlYrT8uu1x", "0cb821579b7041332b814e2b1a8547879e7f9bd198304d727b74ac5627c61737", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Admin Panel - Group Management Configurations View", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("RlYrT8uu1x", "Admin Panel - Group Management Configurations View", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Admin Panel - Group Management Configurations View", eventProperties, "RlYrT8uu1x", "0cb821579b7041332b814e2b1a8547879e7f9bd198304d727b74ac5627c61737");
    }
    // destination Mixpanel
    Mixpanel.logEvent("Admin Panel - Group Management Configurations View", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface AdminPanelMinusClosedSignalsViewProperties {
  groupChannelId: number;
}
/**
 * Admin Panel - Closed Signals View: User clicked the Signals View page in the admin panel
 * 
 * @param properties the properties associatied with this event
 * @param properties.groupChannelId: The current channel/group id that was recorded as part of the event
 * 
 * @see {@link https://www.avo.app/schemas/Zba2v6MXsSx1EdxPIQKm/events/QRHp_WjDd}
 */
export function adminPanelClosedSignalsView(properties: AdminPanelMinusClosedSignalsViewProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({id: "dcXTMVDlJn", name: "group_channel_id", value: properties.groupChannelId});
  eventPropertiesArray.push({id: "WN7yP-IxTA", name: "platform", value: sysPlatform});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "QRHp_WjDd", "60c2b16d6206a31977328670a2b3b940283e775395a38800d3f96d87188b703a", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Admin Panel - Closed Signals View", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("QRHp_WjDd", "Admin Panel - Closed Signals View", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Admin Panel - Closed Signals View", eventProperties, "QRHp_WjDd", "60c2b16d6206a31977328670a2b3b940283e775395a38800d3f96d87188b703a");
    }
    // destination Mixpanel
    Mixpanel.logEvent("Admin Panel - Closed Signals View", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface OnboardingMinusConnectToExchangeClickedProperties {
  epUserSubscriptionDuration: number | null | undefined;
  epUserSubscriptionPlan: EpUserSubscriptionPlanValueType;
  epUserSubscriptionIsActive: boolean | null | undefined;
  epUserIsMobileAppUser: boolean | null | undefined;
  epUserIsAdmin: boolean | null | undefined;
  epUserIsTelegramConnected: boolean | null | undefined;
  epUserIsDiscordConnected: boolean | null | undefined;
  epUserFeatureFlags: string[] | null | undefined;
  epUserIsDarkMode: boolean | null | undefined;
  isTelegramMiniApp: boolean | null | undefined;
  onboardingStep: OnboardingStepValueType;
  epUserIsOnboarding: boolean;
  clientExchange: string;
  createClientIsQuickConnect: boolean | null | undefined;
}
/**
 * Onboarding - Connect to Exchange Clicked: The user clicked to connect his exchange during onboarding. Can be with quick connect or manual API input connection
 * 
 * @param properties the properties associatied with this event
 * @param properties.epUserSubscriptionDuration: The current subscription duration for the user, in days. Not sent for users with Expired or Trial subscription plans.
 * @param properties.epUserSubscriptionPlan: The current subscription plan for the user. Users without an active subscription should have the value set to Expired.
 * @param properties.epUserSubscriptionIsActive: Set to True if the user has an active subscription (the last subscription expiration date is smaller than the current date).
 * @param properties.epUserIsMobileAppUser: no description
 * @param properties.epUserIsAdmin: no description
 * @param properties.epUserIsTelegramConnected: no description
 * @param properties.epUserIsDiscordConnected: no description
 * @param properties.epUserFeatureFlags: no description
 * @param properties.epUserIsDarkMode: no description
 * @param properties.isTelegramMiniApp: no description
 * @param properties.onboardingStep: Contain the onboarding step - Email confirmation, Connect exchange, Trading method, Method settings, Overview
 * @param properties.epUserIsOnboarding: Used to track which events happened during onboarding 
 * @param properties.clientExchange: The client's exchange.
 * @param properties.createClientIsQuickConnect: A Boolean that is true if the client was created by using the quick connect feature (Logging in directly to the exchange instead of providing us with explicit API Key and Secret)
 * 
 * @see {@link https://www.avo.app/schemas/Zba2v6MXsSx1EdxPIQKm/events/3pw-IDk2ZG}
 */
export function onboardingConnectToExchangeClicked(properties: OnboardingMinusConnectToExchangeClickedProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  properties.epUserSubscriptionDuration !== undefined && properties.epUserSubscriptionDuration !== null ?
    eventPropertiesArray.push({id: "BrNPvrBkq", name: "ep_user_subscription_duration", value: properties.epUserSubscriptionDuration}) :
    eventPropertiesArray.push({id: "BrNPvrBkq", name: "ep_user_subscription_duration", value: null});
  eventPropertiesArray.push({id: "Ak0bD3528L", name: "ep_user_subscription_plan", value: properties.epUserSubscriptionPlan});
  properties.epUserSubscriptionIsActive !== undefined && properties.epUserSubscriptionIsActive !== null ?
    eventPropertiesArray.push({id: "P2zcEByfWK", name: "ep_user_subscription_is_active", value: properties.epUserSubscriptionIsActive}) :
    eventPropertiesArray.push({id: "P2zcEByfWK", name: "ep_user_subscription_is_active", value: null});
  properties.epUserIsMobileAppUser !== undefined && properties.epUserIsMobileAppUser !== null ?
    eventPropertiesArray.push({id: "gkaSZCbXw8", name: "ep_user_is_mobile_app_user", value: properties.epUserIsMobileAppUser}) :
    eventPropertiesArray.push({id: "gkaSZCbXw8", name: "ep_user_is_mobile_app_user", value: null});
  properties.epUserIsAdmin !== undefined && properties.epUserIsAdmin !== null ?
    eventPropertiesArray.push({id: "1NHsnnGVd0", name: "ep_user_is_admin", value: properties.epUserIsAdmin}) :
    eventPropertiesArray.push({id: "1NHsnnGVd0", name: "ep_user_is_admin", value: null});
  properties.epUserIsTelegramConnected !== undefined && properties.epUserIsTelegramConnected !== null ?
    eventPropertiesArray.push({id: "QBh1Ik3rEm", name: "ep_user_is_telegram_connected", value: properties.epUserIsTelegramConnected}) :
    eventPropertiesArray.push({id: "QBh1Ik3rEm", name: "ep_user_is_telegram_connected", value: null});
  properties.epUserIsDiscordConnected !== undefined && properties.epUserIsDiscordConnected !== null ?
    eventPropertiesArray.push({id: "Z5anKuo4On", name: "ep_user_is_discord_connected", value: properties.epUserIsDiscordConnected}) :
    eventPropertiesArray.push({id: "Z5anKuo4On", name: "ep_user_is_discord_connected", value: null});
  properties.epUserFeatureFlags !== undefined && properties.epUserFeatureFlags !== null ?
    eventPropertiesArray.push({id: "ZkS2YBJULL", name: "ep_user_feature_flags", value: properties.epUserFeatureFlags}) :
    eventPropertiesArray.push({id: "ZkS2YBJULL", name: "ep_user_feature_flags", value: null});
  properties.epUserIsDarkMode !== undefined && properties.epUserIsDarkMode !== null ?
    eventPropertiesArray.push({id: "pZYzhjQhIW", name: "ep_user_is_dark_mode", value: properties.epUserIsDarkMode}) :
    eventPropertiesArray.push({id: "pZYzhjQhIW", name: "ep_user_is_dark_mode", value: null});
  properties.isTelegramMiniApp !== undefined && properties.isTelegramMiniApp !== null ?
    eventPropertiesArray.push({id: "vh-KiP-5Q", name: "is_telegram_mini_app", value: properties.isTelegramMiniApp}) :
    eventPropertiesArray.push({id: "vh-KiP-5Q", name: "is_telegram_mini_app", value: null});
  eventPropertiesArray.push({id: "-sPjCGnFt", name: "onboarding_step", value: properties.onboardingStep});
  eventPropertiesArray.push({id: "01c5raMTE", name: "ep_user_is_onboarding", value: properties.epUserIsOnboarding});
  eventPropertiesArray.push({id: "y-0xKVXQIT", name: "client_exchange", value: properties.clientExchange});
  properties.createClientIsQuickConnect !== undefined && properties.createClientIsQuickConnect !== null ?
    eventPropertiesArray.push({id: "OAZdqCfOTb", name: "create_client_is_quick_connect", value: properties.createClientIsQuickConnect}) :
    eventPropertiesArray.push({id: "OAZdqCfOTb", name: "create_client_is_quick_connect", value: null});
  eventPropertiesArray.push({id: "WN7yP-IxTA", name: "platform", value: sysPlatform});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "3pw-IDk2ZG", "d0ee6afccdb5ed8bb291b558e1e6ade054416dc21ae748be5d23034161340a57", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Onboarding - Connect to Exchange Clicked", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("3pw-IDk2ZG", "Onboarding - Connect to Exchange Clicked", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Onboarding - Connect to Exchange Clicked", eventProperties, "3pw-IDk2ZG", "d0ee6afccdb5ed8bb291b558e1e6ade054416dc21ae748be5d23034161340a57");
    }
    // destination Mixpanel
    Mixpanel.logEvent("Onboarding - Connect to Exchange Clicked", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface ConnectExchangeTryAgainClickedProperties {
  onboardingStep: OnboardingStepValueType | null | undefined;
  clientExchange: string;
  epUserIsOnboarding: boolean;
}
/**
 * Connect Exchange Try Again Clicked: User clicked try again while connecting his exchange
 * 
 * @param properties the properties associatied with this event
 * @param properties.onboardingStep: Contain the onboarding step - Email confirmation, Connect exchange, Trading method, Method settings, Overview
 * @param properties.clientExchange: The client's exchange.
 * @param properties.epUserIsOnboarding: Used to track which events happened during onboarding 
 * 
 * @see {@link https://www.avo.app/schemas/Zba2v6MXsSx1EdxPIQKm/events/159_xJkilu}
 */
export function connectExchangeTryAgainClicked(properties: ConnectExchangeTryAgainClickedProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  properties.onboardingStep !== undefined && properties.onboardingStep !== null ?
    eventPropertiesArray.push({id: "-sPjCGnFt", name: "onboarding_step", value: properties.onboardingStep}) :
    eventPropertiesArray.push({id: "-sPjCGnFt", name: "onboarding_step", value: null});
  eventPropertiesArray.push({id: "y-0xKVXQIT", name: "client_exchange", value: properties.clientExchange});
  eventPropertiesArray.push({id: "01c5raMTE", name: "ep_user_is_onboarding", value: properties.epUserIsOnboarding});
  eventPropertiesArray.push({id: "WN7yP-IxTA", name: "platform", value: sysPlatform});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "159_xJkilu", "8052075ff7872314addedafbd887333454ca732aebecb46a41199e0633f2a1f8", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Connect Exchange Try Again Clicked", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("159_xJkilu", "Connect Exchange Try Again Clicked", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Connect Exchange Try Again Clicked", eventProperties, "159_xJkilu", "8052075ff7872314addedafbd887333454ca732aebecb46a41199e0633f2a1f8");
    }
    // destination Mixpanel
    Mixpanel.logEvent("Connect Exchange Try Again Clicked", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface OnboardingMinusTradingMethodViewedProperties {
  epUserSubscriptionDuration: number | null | undefined;
  epUserSubscriptionPlan: EpUserSubscriptionPlanValueType;
  epUserSubscriptionIsActive: boolean | null | undefined;
  epUserIsMobileAppUser: boolean | null | undefined;
  epUserIsAdmin: boolean | null | undefined;
  epUserIsTelegramConnected: boolean | null | undefined;
  epUserIsDiscordConnected: boolean | null | undefined;
  epUserFeatureFlags: string[] | null | undefined;
  epUserIsDarkMode: boolean | null | undefined;
  isTelegramMiniApp: boolean | null | undefined;
  onboardingStep: OnboardingStepValueType;
  epUserIsOnboarding: boolean;
  botSource: BotSourceValueType | null | undefined;
}
/**
 * Onboarding - Trading Method Viewed: User viewed the page to select how he wants to start, Follow a Signal or create a DCA bot
 * 
 * @param properties the properties associatied with this event
 * @param properties.epUserSubscriptionDuration: The current subscription duration for the user, in days. Not sent for users with Expired or Trial subscription plans.
 * @param properties.epUserSubscriptionPlan: The current subscription plan for the user. Users without an active subscription should have the value set to Expired.
 * @param properties.epUserSubscriptionIsActive: Set to True if the user has an active subscription (the last subscription expiration date is smaller than the current date).
 * @param properties.epUserIsMobileAppUser: no description
 * @param properties.epUserIsAdmin: no description
 * @param properties.epUserIsTelegramConnected: no description
 * @param properties.epUserIsDiscordConnected: no description
 * @param properties.epUserFeatureFlags: no description
 * @param properties.epUserIsDarkMode: no description
 * @param properties.isTelegramMiniApp: no description
 * @param properties.onboardingStep: Contain the onboarding step - Email confirmation, Connect exchange, Trading method, Method settings, Overview
 * @param properties.epUserIsOnboarding: Used to track which events happened during onboarding 
 * @param properties.botSource: Whether the user started the onboarding from the telegram or discord bot.
 * 
 * @see {@link https://www.avo.app/schemas/Zba2v6MXsSx1EdxPIQKm/events/4SV2Xl4tnQ}
 */
export function onboardingTradingMethodViewed(properties: OnboardingMinusTradingMethodViewedProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  properties.epUserSubscriptionDuration !== undefined && properties.epUserSubscriptionDuration !== null ?
    eventPropertiesArray.push({id: "BrNPvrBkq", name: "ep_user_subscription_duration", value: properties.epUserSubscriptionDuration}) :
    eventPropertiesArray.push({id: "BrNPvrBkq", name: "ep_user_subscription_duration", value: null});
  eventPropertiesArray.push({id: "Ak0bD3528L", name: "ep_user_subscription_plan", value: properties.epUserSubscriptionPlan});
  properties.epUserSubscriptionIsActive !== undefined && properties.epUserSubscriptionIsActive !== null ?
    eventPropertiesArray.push({id: "P2zcEByfWK", name: "ep_user_subscription_is_active", value: properties.epUserSubscriptionIsActive}) :
    eventPropertiesArray.push({id: "P2zcEByfWK", name: "ep_user_subscription_is_active", value: null});
  properties.epUserIsMobileAppUser !== undefined && properties.epUserIsMobileAppUser !== null ?
    eventPropertiesArray.push({id: "gkaSZCbXw8", name: "ep_user_is_mobile_app_user", value: properties.epUserIsMobileAppUser}) :
    eventPropertiesArray.push({id: "gkaSZCbXw8", name: "ep_user_is_mobile_app_user", value: null});
  properties.epUserIsAdmin !== undefined && properties.epUserIsAdmin !== null ?
    eventPropertiesArray.push({id: "1NHsnnGVd0", name: "ep_user_is_admin", value: properties.epUserIsAdmin}) :
    eventPropertiesArray.push({id: "1NHsnnGVd0", name: "ep_user_is_admin", value: null});
  properties.epUserIsTelegramConnected !== undefined && properties.epUserIsTelegramConnected !== null ?
    eventPropertiesArray.push({id: "QBh1Ik3rEm", name: "ep_user_is_telegram_connected", value: properties.epUserIsTelegramConnected}) :
    eventPropertiesArray.push({id: "QBh1Ik3rEm", name: "ep_user_is_telegram_connected", value: null});
  properties.epUserIsDiscordConnected !== undefined && properties.epUserIsDiscordConnected !== null ?
    eventPropertiesArray.push({id: "Z5anKuo4On", name: "ep_user_is_discord_connected", value: properties.epUserIsDiscordConnected}) :
    eventPropertiesArray.push({id: "Z5anKuo4On", name: "ep_user_is_discord_connected", value: null});
  properties.epUserFeatureFlags !== undefined && properties.epUserFeatureFlags !== null ?
    eventPropertiesArray.push({id: "ZkS2YBJULL", name: "ep_user_feature_flags", value: properties.epUserFeatureFlags}) :
    eventPropertiesArray.push({id: "ZkS2YBJULL", name: "ep_user_feature_flags", value: null});
  properties.epUserIsDarkMode !== undefined && properties.epUserIsDarkMode !== null ?
    eventPropertiesArray.push({id: "pZYzhjQhIW", name: "ep_user_is_dark_mode", value: properties.epUserIsDarkMode}) :
    eventPropertiesArray.push({id: "pZYzhjQhIW", name: "ep_user_is_dark_mode", value: null});
  properties.isTelegramMiniApp !== undefined && properties.isTelegramMiniApp !== null ?
    eventPropertiesArray.push({id: "vh-KiP-5Q", name: "is_telegram_mini_app", value: properties.isTelegramMiniApp}) :
    eventPropertiesArray.push({id: "vh-KiP-5Q", name: "is_telegram_mini_app", value: null});
  eventPropertiesArray.push({id: "-sPjCGnFt", name: "onboarding_step", value: properties.onboardingStep});
  eventPropertiesArray.push({id: "01c5raMTE", name: "ep_user_is_onboarding", value: properties.epUserIsOnboarding});
  properties.botSource !== undefined && properties.botSource !== null ?
    eventPropertiesArray.push({id: "77pb0xYM-Q", name: "bot_source", value: properties.botSource}) :
    eventPropertiesArray.push({id: "77pb0xYM-Q", name: "bot_source", value: null});
  eventPropertiesArray.push({id: "WN7yP-IxTA", name: "platform", value: sysPlatform});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "4SV2Xl4tnQ", "dc6a274fb9b989307c9a101447b2019bdcb3eb718c6c53456ff04437f0fca5e2", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Onboarding - Trading Method Viewed", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("4SV2Xl4tnQ", "Onboarding - Trading Method Viewed", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Onboarding - Trading Method Viewed", eventProperties, "4SV2Xl4tnQ", "dc6a274fb9b989307c9a101447b2019bdcb3eb718c6c53456ff04437f0fca5e2");
    }
    // destination Mixpanel
    Mixpanel.logEvent("Onboarding - Trading Method Viewed", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface OnboardingMinusOverviewViewProperties {
  epUserSubscriptionDuration: number | null | undefined;
  epUserSubscriptionPlan: EpUserSubscriptionPlanValueType;
  epUserSubscriptionIsActive: boolean | null | undefined;
  epUserIsMobileAppUser: boolean | null | undefined;
  epUserIsAdmin: boolean | null | undefined;
  epUserIsTelegramConnected: boolean | null | undefined;
  epUserIsDiscordConnected: boolean | null | undefined;
  epUserFeatureFlags: string[] | null | undefined;
  epUserIsDarkMode: boolean | null | undefined;
  isTelegramMiniApp: boolean | null | undefined;
  onboardingStep: OnboardingStepValueType;
  tradingMethodType: TradingMethodTypeValueType;
  marketplaceGroupId: number | null | undefined;
  groupName: string | null | undefined;
  clientExchange: string;
  copiedBotLeverage: number | null | undefined;
  copiedBotSymbol: string | null | undefined;
  epUserIsOnboarding: boolean;
  tradingMethodCategory: TradingMethodCategoryValueType | null | undefined;
  botSource: BotSourceValueType | null | undefined;
  botRank: number | null | undefined;
  marketplaceGroupPagePosition: number | null | undefined;
}
/**
 * Onboarding - Overview View: User clicked Follow button OR Copy bot button during onboarding
 * 
 * @param properties the properties associatied with this event
 * @param properties.epUserSubscriptionDuration: The current subscription duration for the user, in days. Not sent for users with Expired or Trial subscription plans.
 * @param properties.epUserSubscriptionPlan: The current subscription plan for the user. Users without an active subscription should have the value set to Expired.
 * @param properties.epUserSubscriptionIsActive: Set to True if the user has an active subscription (the last subscription expiration date is smaller than the current date).
 * @param properties.epUserIsMobileAppUser: no description
 * @param properties.epUserIsAdmin: no description
 * @param properties.epUserIsTelegramConnected: no description
 * @param properties.epUserIsDiscordConnected: no description
 * @param properties.epUserFeatureFlags: no description
 * @param properties.epUserIsDarkMode: no description
 * @param properties.isTelegramMiniApp: no description
 * @param properties.onboardingStep: Contain the onboarding step - Email confirmation, Connect exchange, Trading method, Method settings, Overview
 * @param properties.tradingMethodType: Onboarding trading method type. Follow signals group or Copy DCA bot
 * @param properties.marketplaceGroupId: The relevant group_id coming from the backend
 * @param properties.groupName: The name of the group's Telegram channel.
 * @param properties.clientExchange: The client's exchange.
 * @param properties.copiedBotLeverage: no description
 * @param properties.copiedBotSymbol: no description
 * @param properties.epUserIsOnboarding: Used to track which events happened during onboarding 
 * @param properties.tradingMethodCategory: Category of the selected bot in the list of bots in onboarding
 * @param properties.botSource: Whether the user started the onboarding from the telegram or discord bot.
 * @param properties.botRank: Rank of selected bot in list of bots in onboarding
 * @param properties.marketplaceGroupPagePosition: The position of the group in the page. The group on the first row on the left, the right is 2, second row left is 3 etc.
 * 
 * @see {@link https://www.avo.app/schemas/Zba2v6MXsSx1EdxPIQKm/events/LPwClwZa53}
 */
export function onboardingOverviewView(properties: OnboardingMinusOverviewViewProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  properties.epUserSubscriptionDuration !== undefined && properties.epUserSubscriptionDuration !== null ?
    eventPropertiesArray.push({id: "BrNPvrBkq", name: "ep_user_subscription_duration", value: properties.epUserSubscriptionDuration}) :
    eventPropertiesArray.push({id: "BrNPvrBkq", name: "ep_user_subscription_duration", value: null});
  eventPropertiesArray.push({id: "Ak0bD3528L", name: "ep_user_subscription_plan", value: properties.epUserSubscriptionPlan});
  properties.epUserSubscriptionIsActive !== undefined && properties.epUserSubscriptionIsActive !== null ?
    eventPropertiesArray.push({id: "P2zcEByfWK", name: "ep_user_subscription_is_active", value: properties.epUserSubscriptionIsActive}) :
    eventPropertiesArray.push({id: "P2zcEByfWK", name: "ep_user_subscription_is_active", value: null});
  properties.epUserIsMobileAppUser !== undefined && properties.epUserIsMobileAppUser !== null ?
    eventPropertiesArray.push({id: "gkaSZCbXw8", name: "ep_user_is_mobile_app_user", value: properties.epUserIsMobileAppUser}) :
    eventPropertiesArray.push({id: "gkaSZCbXw8", name: "ep_user_is_mobile_app_user", value: null});
  properties.epUserIsAdmin !== undefined && properties.epUserIsAdmin !== null ?
    eventPropertiesArray.push({id: "1NHsnnGVd0", name: "ep_user_is_admin", value: properties.epUserIsAdmin}) :
    eventPropertiesArray.push({id: "1NHsnnGVd0", name: "ep_user_is_admin", value: null});
  properties.epUserIsTelegramConnected !== undefined && properties.epUserIsTelegramConnected !== null ?
    eventPropertiesArray.push({id: "QBh1Ik3rEm", name: "ep_user_is_telegram_connected", value: properties.epUserIsTelegramConnected}) :
    eventPropertiesArray.push({id: "QBh1Ik3rEm", name: "ep_user_is_telegram_connected", value: null});
  properties.epUserIsDiscordConnected !== undefined && properties.epUserIsDiscordConnected !== null ?
    eventPropertiesArray.push({id: "Z5anKuo4On", name: "ep_user_is_discord_connected", value: properties.epUserIsDiscordConnected}) :
    eventPropertiesArray.push({id: "Z5anKuo4On", name: "ep_user_is_discord_connected", value: null});
  properties.epUserFeatureFlags !== undefined && properties.epUserFeatureFlags !== null ?
    eventPropertiesArray.push({id: "ZkS2YBJULL", name: "ep_user_feature_flags", value: properties.epUserFeatureFlags}) :
    eventPropertiesArray.push({id: "ZkS2YBJULL", name: "ep_user_feature_flags", value: null});
  properties.epUserIsDarkMode !== undefined && properties.epUserIsDarkMode !== null ?
    eventPropertiesArray.push({id: "pZYzhjQhIW", name: "ep_user_is_dark_mode", value: properties.epUserIsDarkMode}) :
    eventPropertiesArray.push({id: "pZYzhjQhIW", name: "ep_user_is_dark_mode", value: null});
  properties.isTelegramMiniApp !== undefined && properties.isTelegramMiniApp !== null ?
    eventPropertiesArray.push({id: "vh-KiP-5Q", name: "is_telegram_mini_app", value: properties.isTelegramMiniApp}) :
    eventPropertiesArray.push({id: "vh-KiP-5Q", name: "is_telegram_mini_app", value: null});
  eventPropertiesArray.push({id: "-sPjCGnFt", name: "onboarding_step", value: properties.onboardingStep});
  eventPropertiesArray.push({id: "i1_PQ0kbg", name: "trading_method_type", value: properties.tradingMethodType});
  properties.marketplaceGroupId !== undefined && properties.marketplaceGroupId !== null ?
    eventPropertiesArray.push({id: "y40_UtBI0", name: "marketplace_group_id", value: properties.marketplaceGroupId}) :
    eventPropertiesArray.push({id: "y40_UtBI0", name: "marketplace_group_id", value: null});
  properties.groupName !== undefined && properties.groupName !== null ?
    eventPropertiesArray.push({id: "8EjjjU85L9", name: "group_name", value: properties.groupName}) :
    eventPropertiesArray.push({id: "8EjjjU85L9", name: "group_name", value: null});
  eventPropertiesArray.push({id: "y-0xKVXQIT", name: "client_exchange", value: properties.clientExchange});
  properties.copiedBotLeverage !== undefined && properties.copiedBotLeverage !== null ?
    eventPropertiesArray.push({id: "D7cDhL784", name: "copied_bot_leverage", value: properties.copiedBotLeverage}) :
    eventPropertiesArray.push({id: "D7cDhL784", name: "copied_bot_leverage", value: null});
  properties.copiedBotSymbol !== undefined && properties.copiedBotSymbol !== null ?
    eventPropertiesArray.push({id: "69nlUdml5", name: "copied_bot_symbol", value: properties.copiedBotSymbol}) :
    eventPropertiesArray.push({id: "69nlUdml5", name: "copied_bot_symbol", value: null});
  eventPropertiesArray.push({id: "01c5raMTE", name: "ep_user_is_onboarding", value: properties.epUserIsOnboarding});
  properties.tradingMethodCategory !== undefined && properties.tradingMethodCategory !== null ?
    eventPropertiesArray.push({id: "TWj16Ybpf", name: "trading_method_category", value: properties.tradingMethodCategory}) :
    eventPropertiesArray.push({id: "TWj16Ybpf", name: "trading_method_category", value: null});
  properties.botSource !== undefined && properties.botSource !== null ?
    eventPropertiesArray.push({id: "77pb0xYM-Q", name: "bot_source", value: properties.botSource}) :
    eventPropertiesArray.push({id: "77pb0xYM-Q", name: "bot_source", value: null});
  properties.botRank !== undefined && properties.botRank !== null ?
    eventPropertiesArray.push({id: "grtY72q2w", name: "bot_rank", value: properties.botRank}) :
    eventPropertiesArray.push({id: "grtY72q2w", name: "bot_rank", value: null});
  properties.marketplaceGroupPagePosition !== undefined && properties.marketplaceGroupPagePosition !== null ?
    eventPropertiesArray.push({id: "dwPshDL5Rt", name: "marketplace_group_page_position", value: properties.marketplaceGroupPagePosition}) :
    eventPropertiesArray.push({id: "dwPshDL5Rt", name: "marketplace_group_page_position", value: null});
  eventPropertiesArray.push({id: "WN7yP-IxTA", name: "platform", value: sysPlatform});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "LPwClwZa53", "320692a814a220b955638056a6d3a33da4012e7ffaa4e86666be52ca54d81f64", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Onboarding - Overview View", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("LPwClwZa53", "Onboarding - Overview View", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Onboarding - Overview View", eventProperties, "LPwClwZa53", "320692a814a220b955638056a6d3a33da4012e7ffaa4e86666be52ca54d81f64");
    }
    // destination Mixpanel
    Mixpanel.logEvent("Onboarding - Overview View", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface OnboardingMinusSkipExternalAccountClickedProperties {
  epUserSubscriptionDuration: number | null | undefined;
  epUserSubscriptionPlan: EpUserSubscriptionPlanValueType;
  epUserSubscriptionIsActive: boolean | null | undefined;
  epUserIsMobileAppUser: boolean | null | undefined;
  epUserIsAdmin: boolean | null | undefined;
  epUserIsTelegramConnected: boolean | null | undefined;
  epUserIsDiscordConnected: boolean | null | undefined;
  epUserFeatureFlags: string[] | null | undefined;
  epUserIsDarkMode: boolean | null | undefined;
  isTelegramMiniApp: boolean | null | undefined;
  onboardingStep: OnboardingStepValueType;
  epUserIsOnboarding: boolean;
  externalAccountType: ExternalAccountTypeValueType;
}
/**
 * Onboarding - Skip External Account Clicked: User skipped connection Telegram or Discord during onboarding
 * 
 * @param properties the properties associatied with this event
 * @param properties.epUserSubscriptionDuration: The current subscription duration for the user, in days. Not sent for users with Expired or Trial subscription plans.
 * @param properties.epUserSubscriptionPlan: The current subscription plan for the user. Users without an active subscription should have the value set to Expired.
 * @param properties.epUserSubscriptionIsActive: Set to True if the user has an active subscription (the last subscription expiration date is smaller than the current date).
 * @param properties.epUserIsMobileAppUser: no description
 * @param properties.epUserIsAdmin: no description
 * @param properties.epUserIsTelegramConnected: no description
 * @param properties.epUserIsDiscordConnected: no description
 * @param properties.epUserFeatureFlags: no description
 * @param properties.epUserIsDarkMode: no description
 * @param properties.isTelegramMiniApp: no description
 * @param properties.onboardingStep: Contain the onboarding step - Email confirmation, Connect exchange, Trading method, Method settings, Overview
 * @param properties.epUserIsOnboarding: Used to track which events happened during onboarding 
 * @param properties.externalAccountType: discord or telegram
 * 
 * @see {@link https://www.avo.app/schemas/Zba2v6MXsSx1EdxPIQKm/events/HYFmahsTYf}
 */
export function onboardingSkipExternalAccountClicked(properties: OnboardingMinusSkipExternalAccountClickedProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  properties.epUserSubscriptionDuration !== undefined && properties.epUserSubscriptionDuration !== null ?
    eventPropertiesArray.push({id: "BrNPvrBkq", name: "ep_user_subscription_duration", value: properties.epUserSubscriptionDuration}) :
    eventPropertiesArray.push({id: "BrNPvrBkq", name: "ep_user_subscription_duration", value: null});
  eventPropertiesArray.push({id: "Ak0bD3528L", name: "ep_user_subscription_plan", value: properties.epUserSubscriptionPlan});
  properties.epUserSubscriptionIsActive !== undefined && properties.epUserSubscriptionIsActive !== null ?
    eventPropertiesArray.push({id: "P2zcEByfWK", name: "ep_user_subscription_is_active", value: properties.epUserSubscriptionIsActive}) :
    eventPropertiesArray.push({id: "P2zcEByfWK", name: "ep_user_subscription_is_active", value: null});
  properties.epUserIsMobileAppUser !== undefined && properties.epUserIsMobileAppUser !== null ?
    eventPropertiesArray.push({id: "gkaSZCbXw8", name: "ep_user_is_mobile_app_user", value: properties.epUserIsMobileAppUser}) :
    eventPropertiesArray.push({id: "gkaSZCbXw8", name: "ep_user_is_mobile_app_user", value: null});
  properties.epUserIsAdmin !== undefined && properties.epUserIsAdmin !== null ?
    eventPropertiesArray.push({id: "1NHsnnGVd0", name: "ep_user_is_admin", value: properties.epUserIsAdmin}) :
    eventPropertiesArray.push({id: "1NHsnnGVd0", name: "ep_user_is_admin", value: null});
  properties.epUserIsTelegramConnected !== undefined && properties.epUserIsTelegramConnected !== null ?
    eventPropertiesArray.push({id: "QBh1Ik3rEm", name: "ep_user_is_telegram_connected", value: properties.epUserIsTelegramConnected}) :
    eventPropertiesArray.push({id: "QBh1Ik3rEm", name: "ep_user_is_telegram_connected", value: null});
  properties.epUserIsDiscordConnected !== undefined && properties.epUserIsDiscordConnected !== null ?
    eventPropertiesArray.push({id: "Z5anKuo4On", name: "ep_user_is_discord_connected", value: properties.epUserIsDiscordConnected}) :
    eventPropertiesArray.push({id: "Z5anKuo4On", name: "ep_user_is_discord_connected", value: null});
  properties.epUserFeatureFlags !== undefined && properties.epUserFeatureFlags !== null ?
    eventPropertiesArray.push({id: "ZkS2YBJULL", name: "ep_user_feature_flags", value: properties.epUserFeatureFlags}) :
    eventPropertiesArray.push({id: "ZkS2YBJULL", name: "ep_user_feature_flags", value: null});
  properties.epUserIsDarkMode !== undefined && properties.epUserIsDarkMode !== null ?
    eventPropertiesArray.push({id: "pZYzhjQhIW", name: "ep_user_is_dark_mode", value: properties.epUserIsDarkMode}) :
    eventPropertiesArray.push({id: "pZYzhjQhIW", name: "ep_user_is_dark_mode", value: null});
  properties.isTelegramMiniApp !== undefined && properties.isTelegramMiniApp !== null ?
    eventPropertiesArray.push({id: "vh-KiP-5Q", name: "is_telegram_mini_app", value: properties.isTelegramMiniApp}) :
    eventPropertiesArray.push({id: "vh-KiP-5Q", name: "is_telegram_mini_app", value: null});
  eventPropertiesArray.push({id: "-sPjCGnFt", name: "onboarding_step", value: properties.onboardingStep});
  eventPropertiesArray.push({id: "01c5raMTE", name: "ep_user_is_onboarding", value: properties.epUserIsOnboarding});
  eventPropertiesArray.push({id: "CENUd3PxB", name: "external_account_type", value: properties.externalAccountType});
  eventPropertiesArray.push({id: "WN7yP-IxTA", name: "platform", value: sysPlatform});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "HYFmahsTYf", "f6b6046847ef26a3015abe554f366ca517e4069f5d20d22a81c3d45c83902f60", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Onboarding - Skip External Account Clicked", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("HYFmahsTYf", "Onboarding - Skip External Account Clicked", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Onboarding - Skip External Account Clicked", eventProperties, "HYFmahsTYf", "f6b6046847ef26a3015abe554f366ca517e4069f5d20d22a81c3d45c83902f60");
    }
    // destination Mixpanel
    Mixpanel.logEvent("Onboarding - Skip External Account Clicked", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface ConnectToExternalAccountClickedProperties {
  epUserSubscriptionDuration: number | null | undefined;
  epUserSubscriptionPlan: EpUserSubscriptionPlanValueType;
  epUserSubscriptionIsActive: boolean | null | undefined;
  epUserIsMobileAppUser: boolean | null | undefined;
  epUserIsAdmin: boolean | null | undefined;
  epUserIsTelegramConnected: boolean | null | undefined;
  epUserIsDiscordConnected: boolean | null | undefined;
  epUserFeatureFlags: string[] | null | undefined;
  epUserIsDarkMode: boolean | null | undefined;
  isTelegramMiniApp: boolean | null | undefined;
  onboardingStep: OnboardingStepValueType | null | undefined;
  epUserIsOnboarding: boolean;
  externalAccountType: ExternalAccountTypeValueType;
}
/**
 * Connect to External Account Clicked: User clicked Connect to connect to Telegram or Discord during Onboarding
 * 
 * @param properties the properties associatied with this event
 * @param properties.epUserSubscriptionDuration: The current subscription duration for the user, in days. Not sent for users with Expired or Trial subscription plans.
 * @param properties.epUserSubscriptionPlan: The current subscription plan for the user. Users without an active subscription should have the value set to Expired.
 * @param properties.epUserSubscriptionIsActive: Set to True if the user has an active subscription (the last subscription expiration date is smaller than the current date).
 * @param properties.epUserIsMobileAppUser: no description
 * @param properties.epUserIsAdmin: no description
 * @param properties.epUserIsTelegramConnected: no description
 * @param properties.epUserIsDiscordConnected: no description
 * @param properties.epUserFeatureFlags: no description
 * @param properties.epUserIsDarkMode: no description
 * @param properties.isTelegramMiniApp: no description
 * @param properties.onboardingStep: Contain the onboarding step - Email confirmation, Connect exchange, Trading method, Method settings, Overview
 * @param properties.epUserIsOnboarding: Used to track which events happened during onboarding 
 * @param properties.externalAccountType: discord or telegram
 * 
 * @see {@link https://www.avo.app/schemas/Zba2v6MXsSx1EdxPIQKm/events/1KNwN1Wmmt}
 */
export function connectToExternalAccountClicked(properties: ConnectToExternalAccountClickedProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  properties.epUserSubscriptionDuration !== undefined && properties.epUserSubscriptionDuration !== null ?
    eventPropertiesArray.push({id: "BrNPvrBkq", name: "ep_user_subscription_duration", value: properties.epUserSubscriptionDuration}) :
    eventPropertiesArray.push({id: "BrNPvrBkq", name: "ep_user_subscription_duration", value: null});
  eventPropertiesArray.push({id: "Ak0bD3528L", name: "ep_user_subscription_plan", value: properties.epUserSubscriptionPlan});
  properties.epUserSubscriptionIsActive !== undefined && properties.epUserSubscriptionIsActive !== null ?
    eventPropertiesArray.push({id: "P2zcEByfWK", name: "ep_user_subscription_is_active", value: properties.epUserSubscriptionIsActive}) :
    eventPropertiesArray.push({id: "P2zcEByfWK", name: "ep_user_subscription_is_active", value: null});
  properties.epUserIsMobileAppUser !== undefined && properties.epUserIsMobileAppUser !== null ?
    eventPropertiesArray.push({id: "gkaSZCbXw8", name: "ep_user_is_mobile_app_user", value: properties.epUserIsMobileAppUser}) :
    eventPropertiesArray.push({id: "gkaSZCbXw8", name: "ep_user_is_mobile_app_user", value: null});
  properties.epUserIsAdmin !== undefined && properties.epUserIsAdmin !== null ?
    eventPropertiesArray.push({id: "1NHsnnGVd0", name: "ep_user_is_admin", value: properties.epUserIsAdmin}) :
    eventPropertiesArray.push({id: "1NHsnnGVd0", name: "ep_user_is_admin", value: null});
  properties.epUserIsTelegramConnected !== undefined && properties.epUserIsTelegramConnected !== null ?
    eventPropertiesArray.push({id: "QBh1Ik3rEm", name: "ep_user_is_telegram_connected", value: properties.epUserIsTelegramConnected}) :
    eventPropertiesArray.push({id: "QBh1Ik3rEm", name: "ep_user_is_telegram_connected", value: null});
  properties.epUserIsDiscordConnected !== undefined && properties.epUserIsDiscordConnected !== null ?
    eventPropertiesArray.push({id: "Z5anKuo4On", name: "ep_user_is_discord_connected", value: properties.epUserIsDiscordConnected}) :
    eventPropertiesArray.push({id: "Z5anKuo4On", name: "ep_user_is_discord_connected", value: null});
  properties.epUserFeatureFlags !== undefined && properties.epUserFeatureFlags !== null ?
    eventPropertiesArray.push({id: "ZkS2YBJULL", name: "ep_user_feature_flags", value: properties.epUserFeatureFlags}) :
    eventPropertiesArray.push({id: "ZkS2YBJULL", name: "ep_user_feature_flags", value: null});
  properties.epUserIsDarkMode !== undefined && properties.epUserIsDarkMode !== null ?
    eventPropertiesArray.push({id: "pZYzhjQhIW", name: "ep_user_is_dark_mode", value: properties.epUserIsDarkMode}) :
    eventPropertiesArray.push({id: "pZYzhjQhIW", name: "ep_user_is_dark_mode", value: null});
  properties.isTelegramMiniApp !== undefined && properties.isTelegramMiniApp !== null ?
    eventPropertiesArray.push({id: "vh-KiP-5Q", name: "is_telegram_mini_app", value: properties.isTelegramMiniApp}) :
    eventPropertiesArray.push({id: "vh-KiP-5Q", name: "is_telegram_mini_app", value: null});
  properties.onboardingStep !== undefined && properties.onboardingStep !== null ?
    eventPropertiesArray.push({id: "-sPjCGnFt", name: "onboarding_step", value: properties.onboardingStep}) :
    eventPropertiesArray.push({id: "-sPjCGnFt", name: "onboarding_step", value: null});
  eventPropertiesArray.push({id: "01c5raMTE", name: "ep_user_is_onboarding", value: properties.epUserIsOnboarding});
  eventPropertiesArray.push({id: "CENUd3PxB", name: "external_account_type", value: properties.externalAccountType});
  eventPropertiesArray.push({id: "WN7yP-IxTA", name: "platform", value: sysPlatform});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "1KNwN1Wmmt", "7be02969e384c2bba261f8075512202194801f5f185e361cca6dad2380ec2672", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Connect to External Account Clicked", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("1KNwN1Wmmt", "Connect to External Account Clicked", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Connect to External Account Clicked", eventProperties, "1KNwN1Wmmt", "7be02969e384c2bba261f8075512202194801f5f185e361cca6dad2380ec2672");
    }
    // destination Mixpanel
    Mixpanel.logEvent("Connect to External Account Clicked", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface MissingAGroupClickedProperties {
  epUserSubscriptionDuration: number | null | undefined;
  epUserSubscriptionPlan: EpUserSubscriptionPlanValueType;
  epUserSubscriptionIsActive: boolean | null | undefined;
  epUserIsMobileAppUser: boolean | null | undefined;
  epUserIsAdmin: boolean | null | undefined;
  epUserIsTelegramConnected: boolean | null | undefined;
  epUserIsDiscordConnected: boolean | null | undefined;
  epUserFeatureFlags: string[] | null | undefined;
  epUserIsDarkMode: boolean | null | undefined;
  isTelegramMiniApp: boolean | null | undefined;
  onboardingStep: OnboardingStepValueType | null | undefined;
  epUserIsOnboarding: boolean;
}
/**
 * Missing a Group Clicked: user clicked missing a group in onboarding or account&groups page
 * 
 * @param properties the properties associatied with this event
 * @param properties.epUserSubscriptionDuration: The current subscription duration for the user, in days. Not sent for users with Expired or Trial subscription plans.
 * @param properties.epUserSubscriptionPlan: The current subscription plan for the user. Users without an active subscription should have the value set to Expired.
 * @param properties.epUserSubscriptionIsActive: Set to True if the user has an active subscription (the last subscription expiration date is smaller than the current date).
 * @param properties.epUserIsMobileAppUser: no description
 * @param properties.epUserIsAdmin: no description
 * @param properties.epUserIsTelegramConnected: no description
 * @param properties.epUserIsDiscordConnected: no description
 * @param properties.epUserFeatureFlags: no description
 * @param properties.epUserIsDarkMode: no description
 * @param properties.isTelegramMiniApp: no description
 * @param properties.onboardingStep: Contain the onboarding step - Email confirmation, Connect exchange, Trading method, Method settings, Overview
 * @param properties.epUserIsOnboarding: Used to track which events happened during onboarding 
 * 
 * @see {@link https://www.avo.app/schemas/Zba2v6MXsSx1EdxPIQKm/events/g1t6ZCbSih}
 */
export function missingAGroupClicked(properties: MissingAGroupClickedProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  properties.epUserSubscriptionDuration !== undefined && properties.epUserSubscriptionDuration !== null ?
    eventPropertiesArray.push({id: "BrNPvrBkq", name: "ep_user_subscription_duration", value: properties.epUserSubscriptionDuration}) :
    eventPropertiesArray.push({id: "BrNPvrBkq", name: "ep_user_subscription_duration", value: null});
  eventPropertiesArray.push({id: "Ak0bD3528L", name: "ep_user_subscription_plan", value: properties.epUserSubscriptionPlan});
  properties.epUserSubscriptionIsActive !== undefined && properties.epUserSubscriptionIsActive !== null ?
    eventPropertiesArray.push({id: "P2zcEByfWK", name: "ep_user_subscription_is_active", value: properties.epUserSubscriptionIsActive}) :
    eventPropertiesArray.push({id: "P2zcEByfWK", name: "ep_user_subscription_is_active", value: null});
  properties.epUserIsMobileAppUser !== undefined && properties.epUserIsMobileAppUser !== null ?
    eventPropertiesArray.push({id: "gkaSZCbXw8", name: "ep_user_is_mobile_app_user", value: properties.epUserIsMobileAppUser}) :
    eventPropertiesArray.push({id: "gkaSZCbXw8", name: "ep_user_is_mobile_app_user", value: null});
  properties.epUserIsAdmin !== undefined && properties.epUserIsAdmin !== null ?
    eventPropertiesArray.push({id: "1NHsnnGVd0", name: "ep_user_is_admin", value: properties.epUserIsAdmin}) :
    eventPropertiesArray.push({id: "1NHsnnGVd0", name: "ep_user_is_admin", value: null});
  properties.epUserIsTelegramConnected !== undefined && properties.epUserIsTelegramConnected !== null ?
    eventPropertiesArray.push({id: "QBh1Ik3rEm", name: "ep_user_is_telegram_connected", value: properties.epUserIsTelegramConnected}) :
    eventPropertiesArray.push({id: "QBh1Ik3rEm", name: "ep_user_is_telegram_connected", value: null});
  properties.epUserIsDiscordConnected !== undefined && properties.epUserIsDiscordConnected !== null ?
    eventPropertiesArray.push({id: "Z5anKuo4On", name: "ep_user_is_discord_connected", value: properties.epUserIsDiscordConnected}) :
    eventPropertiesArray.push({id: "Z5anKuo4On", name: "ep_user_is_discord_connected", value: null});
  properties.epUserFeatureFlags !== undefined && properties.epUserFeatureFlags !== null ?
    eventPropertiesArray.push({id: "ZkS2YBJULL", name: "ep_user_feature_flags", value: properties.epUserFeatureFlags}) :
    eventPropertiesArray.push({id: "ZkS2YBJULL", name: "ep_user_feature_flags", value: null});
  properties.epUserIsDarkMode !== undefined && properties.epUserIsDarkMode !== null ?
    eventPropertiesArray.push({id: "pZYzhjQhIW", name: "ep_user_is_dark_mode", value: properties.epUserIsDarkMode}) :
    eventPropertiesArray.push({id: "pZYzhjQhIW", name: "ep_user_is_dark_mode", value: null});
  properties.isTelegramMiniApp !== undefined && properties.isTelegramMiniApp !== null ?
    eventPropertiesArray.push({id: "vh-KiP-5Q", name: "is_telegram_mini_app", value: properties.isTelegramMiniApp}) :
    eventPropertiesArray.push({id: "vh-KiP-5Q", name: "is_telegram_mini_app", value: null});
  properties.onboardingStep !== undefined && properties.onboardingStep !== null ?
    eventPropertiesArray.push({id: "-sPjCGnFt", name: "onboarding_step", value: properties.onboardingStep}) :
    eventPropertiesArray.push({id: "-sPjCGnFt", name: "onboarding_step", value: null});
  eventPropertiesArray.push({id: "01c5raMTE", name: "ep_user_is_onboarding", value: properties.epUserIsOnboarding});
  eventPropertiesArray.push({id: "WN7yP-IxTA", name: "platform", value: sysPlatform});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "g1t6ZCbSih", "8b299228b6cc193363026598068db4fe1f44ece5ae82ce6219e92f176663d7d0", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Missing a Group Clicked", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("g1t6ZCbSih", "Missing a Group Clicked", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Missing a Group Clicked", eventProperties, "g1t6ZCbSih", "8b299228b6cc193363026598068db4fe1f44ece5ae82ce6219e92f176663d7d0");
    }
    // destination Mixpanel
    Mixpanel.logEvent("Missing a Group Clicked", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface OnboardingMinusSelectConfigurationClickProperties {
  epUserSubscriptionDuration: number | null | undefined;
  epUserSubscriptionPlan: EpUserSubscriptionPlanValueType;
  epUserSubscriptionIsActive: boolean | null | undefined;
  epUserIsMobileAppUser: boolean | null | undefined;
  epUserIsAdmin: boolean | null | undefined;
  epUserIsTelegramConnected: boolean | null | undefined;
  epUserIsDiscordConnected: boolean | null | undefined;
  epUserFeatureFlags: string[] | null | undefined;
  epUserIsDarkMode: boolean | null | undefined;
  isTelegramMiniApp: boolean | null | undefined;
  onboardingStep: OnboardingStepValueType;
  epUserIsOnboarding: boolean;
  signalsAutoTradingConfiguration: SignalsAutoTradingConfigurationValueType | null | undefined;
  tradingMethodCategory: TradingMethodCategoryValueType | null | undefined;
}
/**
 * Onboarding - Select Configuration Click: User selects another configuration in Onboarding overview page
 * 
 * @param properties the properties associatied with this event
 * @param properties.epUserSubscriptionDuration: The current subscription duration for the user, in days. Not sent for users with Expired or Trial subscription plans.
 * @param properties.epUserSubscriptionPlan: The current subscription plan for the user. Users without an active subscription should have the value set to Expired.
 * @param properties.epUserSubscriptionIsActive: Set to True if the user has an active subscription (the last subscription expiration date is smaller than the current date).
 * @param properties.epUserIsMobileAppUser: no description
 * @param properties.epUserIsAdmin: no description
 * @param properties.epUserIsTelegramConnected: no description
 * @param properties.epUserIsDiscordConnected: no description
 * @param properties.epUserFeatureFlags: no description
 * @param properties.epUserIsDarkMode: no description
 * @param properties.isTelegramMiniApp: no description
 * @param properties.onboardingStep: Contain the onboarding step - Email confirmation, Connect exchange, Trading method, Method settings, Overview
 * @param properties.epUserIsOnboarding: Used to track which events happened during onboarding 
 * @param properties.signalsAutoTradingConfiguration: Keep the type of configuration the user selected
User can select a config provided by the group admin or the default config (empty)
In case there is not custom config, he will not see an option to select a configuration
 * @param properties.tradingMethodCategory: Category of the selected bot in the list of bots in onboarding
 * 
 * @see {@link https://www.avo.app/schemas/Zba2v6MXsSx1EdxPIQKm/events/aOYVjnS19}
 */
export function onboardingSelectConfigurationClick(properties: OnboardingMinusSelectConfigurationClickProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  properties.epUserSubscriptionDuration !== undefined && properties.epUserSubscriptionDuration !== null ?
    eventPropertiesArray.push({id: "BrNPvrBkq", name: "ep_user_subscription_duration", value: properties.epUserSubscriptionDuration}) :
    eventPropertiesArray.push({id: "BrNPvrBkq", name: "ep_user_subscription_duration", value: null});
  eventPropertiesArray.push({id: "Ak0bD3528L", name: "ep_user_subscription_plan", value: properties.epUserSubscriptionPlan});
  properties.epUserSubscriptionIsActive !== undefined && properties.epUserSubscriptionIsActive !== null ?
    eventPropertiesArray.push({id: "P2zcEByfWK", name: "ep_user_subscription_is_active", value: properties.epUserSubscriptionIsActive}) :
    eventPropertiesArray.push({id: "P2zcEByfWK", name: "ep_user_subscription_is_active", value: null});
  properties.epUserIsMobileAppUser !== undefined && properties.epUserIsMobileAppUser !== null ?
    eventPropertiesArray.push({id: "gkaSZCbXw8", name: "ep_user_is_mobile_app_user", value: properties.epUserIsMobileAppUser}) :
    eventPropertiesArray.push({id: "gkaSZCbXw8", name: "ep_user_is_mobile_app_user", value: null});
  properties.epUserIsAdmin !== undefined && properties.epUserIsAdmin !== null ?
    eventPropertiesArray.push({id: "1NHsnnGVd0", name: "ep_user_is_admin", value: properties.epUserIsAdmin}) :
    eventPropertiesArray.push({id: "1NHsnnGVd0", name: "ep_user_is_admin", value: null});
  properties.epUserIsTelegramConnected !== undefined && properties.epUserIsTelegramConnected !== null ?
    eventPropertiesArray.push({id: "QBh1Ik3rEm", name: "ep_user_is_telegram_connected", value: properties.epUserIsTelegramConnected}) :
    eventPropertiesArray.push({id: "QBh1Ik3rEm", name: "ep_user_is_telegram_connected", value: null});
  properties.epUserIsDiscordConnected !== undefined && properties.epUserIsDiscordConnected !== null ?
    eventPropertiesArray.push({id: "Z5anKuo4On", name: "ep_user_is_discord_connected", value: properties.epUserIsDiscordConnected}) :
    eventPropertiesArray.push({id: "Z5anKuo4On", name: "ep_user_is_discord_connected", value: null});
  properties.epUserFeatureFlags !== undefined && properties.epUserFeatureFlags !== null ?
    eventPropertiesArray.push({id: "ZkS2YBJULL", name: "ep_user_feature_flags", value: properties.epUserFeatureFlags}) :
    eventPropertiesArray.push({id: "ZkS2YBJULL", name: "ep_user_feature_flags", value: null});
  properties.epUserIsDarkMode !== undefined && properties.epUserIsDarkMode !== null ?
    eventPropertiesArray.push({id: "pZYzhjQhIW", name: "ep_user_is_dark_mode", value: properties.epUserIsDarkMode}) :
    eventPropertiesArray.push({id: "pZYzhjQhIW", name: "ep_user_is_dark_mode", value: null});
  properties.isTelegramMiniApp !== undefined && properties.isTelegramMiniApp !== null ?
    eventPropertiesArray.push({id: "vh-KiP-5Q", name: "is_telegram_mini_app", value: properties.isTelegramMiniApp}) :
    eventPropertiesArray.push({id: "vh-KiP-5Q", name: "is_telegram_mini_app", value: null});
  eventPropertiesArray.push({id: "-sPjCGnFt", name: "onboarding_step", value: properties.onboardingStep});
  eventPropertiesArray.push({id: "01c5raMTE", name: "ep_user_is_onboarding", value: properties.epUserIsOnboarding});
  properties.signalsAutoTradingConfiguration !== undefined && properties.signalsAutoTradingConfiguration !== null ?
    eventPropertiesArray.push({id: "mG2xJ7i7B", name: "signals_auto_trading_configuration", value: properties.signalsAutoTradingConfiguration}) :
    eventPropertiesArray.push({id: "mG2xJ7i7B", name: "signals_auto_trading_configuration", value: null});
  properties.tradingMethodCategory !== undefined && properties.tradingMethodCategory !== null ?
    eventPropertiesArray.push({id: "TWj16Ybpf", name: "trading_method_category", value: properties.tradingMethodCategory}) :
    eventPropertiesArray.push({id: "TWj16Ybpf", name: "trading_method_category", value: null});
  eventPropertiesArray.push({id: "WN7yP-IxTA", name: "platform", value: sysPlatform});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "aOYVjnS19", "791551b7a2a908a0e5f143201eaa27be6bf52b9ad6474889dfdd9fa7eb16eac7", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Onboarding - Select Configuration Click", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("aOYVjnS19", "Onboarding - Select Configuration Click", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Onboarding - Select Configuration Click", eventProperties, "aOYVjnS19", "791551b7a2a908a0e5f143201eaa27be6bf52b9ad6474889dfdd9fa7eb16eac7");
    }
    // destination Mixpanel
    Mixpanel.logEvent("Onboarding - Select Configuration Click", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface OnboardingMinusStartTradingClickedProperties {
  epUserSubscriptionDuration: number | null | undefined;
  epUserSubscriptionPlan: EpUserSubscriptionPlanValueType;
  epUserSubscriptionIsActive: boolean | null | undefined;
  epUserIsMobileAppUser: boolean | null | undefined;
  epUserIsAdmin: boolean | null | undefined;
  epUserIsTelegramConnected: boolean | null | undefined;
  epUserIsDiscordConnected: boolean | null | undefined;
  epUserFeatureFlags: string[] | null | undefined;
  epUserIsDarkMode: boolean | null | undefined;
  isTelegramMiniApp: boolean | null | undefined;
  onboardingStep: OnboardingStepValueType;
  tradingMethodType: TradingMethodTypeValueType;
  signalsAutoTradingConfiguration: SignalsAutoTradingConfigurationValueType | null | undefined;
  marketplaceGroupId: number | null | undefined;
  marketplaceGroupOffersFreeTrial: boolean | null | undefined;
  groupName: string | null | undefined;
  amountPerTradeType: AmountPerTradeTypeValueType;
  clientExchange: string;
  copiedBotLeverage: number | null | undefined;
  copiedBotSymbol: string | null | undefined;
  epUserIsOnboarding: boolean;
  amountPerTradeIsDefault: boolean | null | undefined;
  tradingMethodCategory: TradingMethodCategoryValueType | null | undefined;
  botSource: BotSourceValueType | null | undefined;
  botRank: number | null | undefined;
  marketplaceGroupPagePosition: number | null | undefined;
}
/**
 * Onboarding - Start Trading Clicked: User clicked Start Auto Trading in Overview during onboarding 
 * 
 * @param properties the properties associatied with this event
 * @param properties.epUserSubscriptionDuration: The current subscription duration for the user, in days. Not sent for users with Expired or Trial subscription plans.
 * @param properties.epUserSubscriptionPlan: The current subscription plan for the user. Users without an active subscription should have the value set to Expired.
 * @param properties.epUserSubscriptionIsActive: Set to True if the user has an active subscription (the last subscription expiration date is smaller than the current date).
 * @param properties.epUserIsMobileAppUser: no description
 * @param properties.epUserIsAdmin: no description
 * @param properties.epUserIsTelegramConnected: no description
 * @param properties.epUserIsDiscordConnected: no description
 * @param properties.epUserFeatureFlags: no description
 * @param properties.epUserIsDarkMode: no description
 * @param properties.isTelegramMiniApp: no description
 * @param properties.onboardingStep: Contain the onboarding step - Email confirmation, Connect exchange, Trading method, Method settings, Overview
 * @param properties.tradingMethodType: Onboarding trading method type. Follow signals group or Copy DCA bot
 * @param properties.signalsAutoTradingConfiguration: Keep the type of configuration the user selected
User can select a config provided by the group admin or the default config (empty)
In case there is not custom config, he will not see an option to select a configuration
 * @param properties.marketplaceGroupId: The relevant group_id coming from the backend
 * @param properties.marketplaceGroupOffersFreeTrial: True if the group offers free trial.
 * @param properties.groupName: The name of the group's Telegram channel.
 * @param properties.amountPerTradeType: Amount per Trade type - Fixed USD, Fixed BTC, Percentage, Risk Percentage
 * @param properties.clientExchange: The client's exchange.
 * @param properties.copiedBotLeverage: no description
 * @param properties.copiedBotSymbol: no description
 * @param properties.epUserIsOnboarding: Used to track which events happened during onboarding 
 * @param properties.amountPerTradeIsDefault: the onboarding amount per trade is the default value set by us and was not changed by the user.
 * @param properties.tradingMethodCategory: Category of the selected bot in the list of bots in onboarding
 * @param properties.botSource: Whether the user started the onboarding from the telegram or discord bot.
 * @param properties.botRank: Rank of selected bot in list of bots in onboarding
 * @param properties.marketplaceGroupPagePosition: The position of the group in the page. The group on the first row on the left, the right is 2, second row left is 3 etc.
 * 
 * @see {@link https://www.avo.app/schemas/Zba2v6MXsSx1EdxPIQKm/events/i1_o-K2QK}
 */
export function onboardingStartTradingClicked(properties: OnboardingMinusStartTradingClickedProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  properties.epUserSubscriptionDuration !== undefined && properties.epUserSubscriptionDuration !== null ?
    eventPropertiesArray.push({id: "BrNPvrBkq", name: "ep_user_subscription_duration", value: properties.epUserSubscriptionDuration}) :
    eventPropertiesArray.push({id: "BrNPvrBkq", name: "ep_user_subscription_duration", value: null});
  eventPropertiesArray.push({id: "Ak0bD3528L", name: "ep_user_subscription_plan", value: properties.epUserSubscriptionPlan});
  properties.epUserSubscriptionIsActive !== undefined && properties.epUserSubscriptionIsActive !== null ?
    eventPropertiesArray.push({id: "P2zcEByfWK", name: "ep_user_subscription_is_active", value: properties.epUserSubscriptionIsActive}) :
    eventPropertiesArray.push({id: "P2zcEByfWK", name: "ep_user_subscription_is_active", value: null});
  properties.epUserIsMobileAppUser !== undefined && properties.epUserIsMobileAppUser !== null ?
    eventPropertiesArray.push({id: "gkaSZCbXw8", name: "ep_user_is_mobile_app_user", value: properties.epUserIsMobileAppUser}) :
    eventPropertiesArray.push({id: "gkaSZCbXw8", name: "ep_user_is_mobile_app_user", value: null});
  properties.epUserIsAdmin !== undefined && properties.epUserIsAdmin !== null ?
    eventPropertiesArray.push({id: "1NHsnnGVd0", name: "ep_user_is_admin", value: properties.epUserIsAdmin}) :
    eventPropertiesArray.push({id: "1NHsnnGVd0", name: "ep_user_is_admin", value: null});
  properties.epUserIsTelegramConnected !== undefined && properties.epUserIsTelegramConnected !== null ?
    eventPropertiesArray.push({id: "QBh1Ik3rEm", name: "ep_user_is_telegram_connected", value: properties.epUserIsTelegramConnected}) :
    eventPropertiesArray.push({id: "QBh1Ik3rEm", name: "ep_user_is_telegram_connected", value: null});
  properties.epUserIsDiscordConnected !== undefined && properties.epUserIsDiscordConnected !== null ?
    eventPropertiesArray.push({id: "Z5anKuo4On", name: "ep_user_is_discord_connected", value: properties.epUserIsDiscordConnected}) :
    eventPropertiesArray.push({id: "Z5anKuo4On", name: "ep_user_is_discord_connected", value: null});
  properties.epUserFeatureFlags !== undefined && properties.epUserFeatureFlags !== null ?
    eventPropertiesArray.push({id: "ZkS2YBJULL", name: "ep_user_feature_flags", value: properties.epUserFeatureFlags}) :
    eventPropertiesArray.push({id: "ZkS2YBJULL", name: "ep_user_feature_flags", value: null});
  properties.epUserIsDarkMode !== undefined && properties.epUserIsDarkMode !== null ?
    eventPropertiesArray.push({id: "pZYzhjQhIW", name: "ep_user_is_dark_mode", value: properties.epUserIsDarkMode}) :
    eventPropertiesArray.push({id: "pZYzhjQhIW", name: "ep_user_is_dark_mode", value: null});
  properties.isTelegramMiniApp !== undefined && properties.isTelegramMiniApp !== null ?
    eventPropertiesArray.push({id: "vh-KiP-5Q", name: "is_telegram_mini_app", value: properties.isTelegramMiniApp}) :
    eventPropertiesArray.push({id: "vh-KiP-5Q", name: "is_telegram_mini_app", value: null});
  eventPropertiesArray.push({id: "-sPjCGnFt", name: "onboarding_step", value: properties.onboardingStep});
  eventPropertiesArray.push({id: "i1_PQ0kbg", name: "trading_method_type", value: properties.tradingMethodType});
  properties.signalsAutoTradingConfiguration !== undefined && properties.signalsAutoTradingConfiguration !== null ?
    eventPropertiesArray.push({id: "mG2xJ7i7B", name: "signals_auto_trading_configuration", value: properties.signalsAutoTradingConfiguration}) :
    eventPropertiesArray.push({id: "mG2xJ7i7B", name: "signals_auto_trading_configuration", value: null});
  properties.marketplaceGroupId !== undefined && properties.marketplaceGroupId !== null ?
    eventPropertiesArray.push({id: "y40_UtBI0", name: "marketplace_group_id", value: properties.marketplaceGroupId}) :
    eventPropertiesArray.push({id: "y40_UtBI0", name: "marketplace_group_id", value: null});
  properties.marketplaceGroupOffersFreeTrial !== undefined && properties.marketplaceGroupOffersFreeTrial !== null ?
    eventPropertiesArray.push({id: "DSQiHZlxb2", name: "marketplace_group_offers_free_trial", value: properties.marketplaceGroupOffersFreeTrial}) :
    eventPropertiesArray.push({id: "DSQiHZlxb2", name: "marketplace_group_offers_free_trial", value: null});
  properties.groupName !== undefined && properties.groupName !== null ?
    eventPropertiesArray.push({id: "8EjjjU85L9", name: "group_name", value: properties.groupName}) :
    eventPropertiesArray.push({id: "8EjjjU85L9", name: "group_name", value: null});
  eventPropertiesArray.push({id: "teABERbN1", name: "amount_per_trade_type", value: properties.amountPerTradeType});
  eventPropertiesArray.push({id: "y-0xKVXQIT", name: "client_exchange", value: properties.clientExchange});
  properties.copiedBotLeverage !== undefined && properties.copiedBotLeverage !== null ?
    eventPropertiesArray.push({id: "D7cDhL784", name: "copied_bot_leverage", value: properties.copiedBotLeverage}) :
    eventPropertiesArray.push({id: "D7cDhL784", name: "copied_bot_leverage", value: null});
  properties.copiedBotSymbol !== undefined && properties.copiedBotSymbol !== null ?
    eventPropertiesArray.push({id: "69nlUdml5", name: "copied_bot_symbol", value: properties.copiedBotSymbol}) :
    eventPropertiesArray.push({id: "69nlUdml5", name: "copied_bot_symbol", value: null});
  eventPropertiesArray.push({id: "01c5raMTE", name: "ep_user_is_onboarding", value: properties.epUserIsOnboarding});
  properties.amountPerTradeIsDefault !== undefined && properties.amountPerTradeIsDefault !== null ?
    eventPropertiesArray.push({id: "UV_cgycL5", name: "amount_per_trade_is_default", value: properties.amountPerTradeIsDefault}) :
    eventPropertiesArray.push({id: "UV_cgycL5", name: "amount_per_trade_is_default", value: null});
  properties.tradingMethodCategory !== undefined && properties.tradingMethodCategory !== null ?
    eventPropertiesArray.push({id: "TWj16Ybpf", name: "trading_method_category", value: properties.tradingMethodCategory}) :
    eventPropertiesArray.push({id: "TWj16Ybpf", name: "trading_method_category", value: null});
  properties.botSource !== undefined && properties.botSource !== null ?
    eventPropertiesArray.push({id: "77pb0xYM-Q", name: "bot_source", value: properties.botSource}) :
    eventPropertiesArray.push({id: "77pb0xYM-Q", name: "bot_source", value: null});
  properties.botRank !== undefined && properties.botRank !== null ?
    eventPropertiesArray.push({id: "grtY72q2w", name: "bot_rank", value: properties.botRank}) :
    eventPropertiesArray.push({id: "grtY72q2w", name: "bot_rank", value: null});
  properties.marketplaceGroupPagePosition !== undefined && properties.marketplaceGroupPagePosition !== null ?
    eventPropertiesArray.push({id: "dwPshDL5Rt", name: "marketplace_group_page_position", value: properties.marketplaceGroupPagePosition}) :
    eventPropertiesArray.push({id: "dwPshDL5Rt", name: "marketplace_group_page_position", value: null});
  eventPropertiesArray.push({id: "WN7yP-IxTA", name: "platform", value: sysPlatform});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "i1_o-K2QK", "2a51f91e116d33d6d72b62e27698bfcca2cae351ba200a9d5fd5daba735ef94c", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Onboarding - Start Trading Clicked", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("i1_o-K2QK", "Onboarding - Start Trading Clicked", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Onboarding - Start Trading Clicked", eventProperties, "i1_o-K2QK", "2a51f91e116d33d6d72b62e27698bfcca2cae351ba200a9d5fd5daba735ef94c");
    }
    // destination Mixpanel
    Mixpanel.logEvent("Onboarding - Start Trading Clicked", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface OnboardingMinusStartTradingWarningViewProperties {
  epUserSubscriptionDuration: number | null | undefined;
  epUserSubscriptionPlan: EpUserSubscriptionPlanValueType;
  epUserSubscriptionIsActive: boolean | null | undefined;
  epUserIsMobileAppUser: boolean | null | undefined;
  epUserIsAdmin: boolean | null | undefined;
  epUserIsTelegramConnected: boolean | null | undefined;
  epUserIsDiscordConnected: boolean | null | undefined;
  epUserFeatureFlags: string[] | null | undefined;
  epUserIsDarkMode: boolean | null | undefined;
  isTelegramMiniApp: boolean | null | undefined;
  onboardingStep: OnboardingStepValueType;
  epUserIsOnboarding: boolean;
  amountPerTradeType: AmountPerTradeTypeValueType;
  tradingMethodType: TradingMethodTypeValueType;
  tradingMethodCategory: TradingMethodCategoryValueType | null | undefined;
}
/**
 * Onboarding - Start Trading Warning View: User clicked start trading in the overview page with warning and got a warning popup
 * 
 * @param properties the properties associatied with this event
 * @param properties.epUserSubscriptionDuration: The current subscription duration for the user, in days. Not sent for users with Expired or Trial subscription plans.
 * @param properties.epUserSubscriptionPlan: The current subscription plan for the user. Users without an active subscription should have the value set to Expired.
 * @param properties.epUserSubscriptionIsActive: Set to True if the user has an active subscription (the last subscription expiration date is smaller than the current date).
 * @param properties.epUserIsMobileAppUser: no description
 * @param properties.epUserIsAdmin: no description
 * @param properties.epUserIsTelegramConnected: no description
 * @param properties.epUserIsDiscordConnected: no description
 * @param properties.epUserFeatureFlags: no description
 * @param properties.epUserIsDarkMode: no description
 * @param properties.isTelegramMiniApp: no description
 * @param properties.onboardingStep: Contain the onboarding step - Email confirmation, Connect exchange, Trading method, Method settings, Overview
 * @param properties.epUserIsOnboarding: Used to track which events happened during onboarding 
 * @param properties.amountPerTradeType: Amount per Trade type - Fixed USD, Fixed BTC, Percentage, Risk Percentage
 * @param properties.tradingMethodType: Onboarding trading method type. Follow signals group or Copy DCA bot
 * @param properties.tradingMethodCategory: Category of the selected bot in the list of bots in onboarding
 * 
 * @see {@link https://www.avo.app/schemas/Zba2v6MXsSx1EdxPIQKm/events/WBUltyehs6}
 */
export function onboardingStartTradingWarningView(properties: OnboardingMinusStartTradingWarningViewProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  properties.epUserSubscriptionDuration !== undefined && properties.epUserSubscriptionDuration !== null ?
    eventPropertiesArray.push({id: "BrNPvrBkq", name: "ep_user_subscription_duration", value: properties.epUserSubscriptionDuration}) :
    eventPropertiesArray.push({id: "BrNPvrBkq", name: "ep_user_subscription_duration", value: null});
  eventPropertiesArray.push({id: "Ak0bD3528L", name: "ep_user_subscription_plan", value: properties.epUserSubscriptionPlan});
  properties.epUserSubscriptionIsActive !== undefined && properties.epUserSubscriptionIsActive !== null ?
    eventPropertiesArray.push({id: "P2zcEByfWK", name: "ep_user_subscription_is_active", value: properties.epUserSubscriptionIsActive}) :
    eventPropertiesArray.push({id: "P2zcEByfWK", name: "ep_user_subscription_is_active", value: null});
  properties.epUserIsMobileAppUser !== undefined && properties.epUserIsMobileAppUser !== null ?
    eventPropertiesArray.push({id: "gkaSZCbXw8", name: "ep_user_is_mobile_app_user", value: properties.epUserIsMobileAppUser}) :
    eventPropertiesArray.push({id: "gkaSZCbXw8", name: "ep_user_is_mobile_app_user", value: null});
  properties.epUserIsAdmin !== undefined && properties.epUserIsAdmin !== null ?
    eventPropertiesArray.push({id: "1NHsnnGVd0", name: "ep_user_is_admin", value: properties.epUserIsAdmin}) :
    eventPropertiesArray.push({id: "1NHsnnGVd0", name: "ep_user_is_admin", value: null});
  properties.epUserIsTelegramConnected !== undefined && properties.epUserIsTelegramConnected !== null ?
    eventPropertiesArray.push({id: "QBh1Ik3rEm", name: "ep_user_is_telegram_connected", value: properties.epUserIsTelegramConnected}) :
    eventPropertiesArray.push({id: "QBh1Ik3rEm", name: "ep_user_is_telegram_connected", value: null});
  properties.epUserIsDiscordConnected !== undefined && properties.epUserIsDiscordConnected !== null ?
    eventPropertiesArray.push({id: "Z5anKuo4On", name: "ep_user_is_discord_connected", value: properties.epUserIsDiscordConnected}) :
    eventPropertiesArray.push({id: "Z5anKuo4On", name: "ep_user_is_discord_connected", value: null});
  properties.epUserFeatureFlags !== undefined && properties.epUserFeatureFlags !== null ?
    eventPropertiesArray.push({id: "ZkS2YBJULL", name: "ep_user_feature_flags", value: properties.epUserFeatureFlags}) :
    eventPropertiesArray.push({id: "ZkS2YBJULL", name: "ep_user_feature_flags", value: null});
  properties.epUserIsDarkMode !== undefined && properties.epUserIsDarkMode !== null ?
    eventPropertiesArray.push({id: "pZYzhjQhIW", name: "ep_user_is_dark_mode", value: properties.epUserIsDarkMode}) :
    eventPropertiesArray.push({id: "pZYzhjQhIW", name: "ep_user_is_dark_mode", value: null});
  properties.isTelegramMiniApp !== undefined && properties.isTelegramMiniApp !== null ?
    eventPropertiesArray.push({id: "vh-KiP-5Q", name: "is_telegram_mini_app", value: properties.isTelegramMiniApp}) :
    eventPropertiesArray.push({id: "vh-KiP-5Q", name: "is_telegram_mini_app", value: null});
  eventPropertiesArray.push({id: "-sPjCGnFt", name: "onboarding_step", value: properties.onboardingStep});
  eventPropertiesArray.push({id: "01c5raMTE", name: "ep_user_is_onboarding", value: properties.epUserIsOnboarding});
  eventPropertiesArray.push({id: "teABERbN1", name: "amount_per_trade_type", value: properties.amountPerTradeType});
  eventPropertiesArray.push({id: "i1_PQ0kbg", name: "trading_method_type", value: properties.tradingMethodType});
  properties.tradingMethodCategory !== undefined && properties.tradingMethodCategory !== null ?
    eventPropertiesArray.push({id: "TWj16Ybpf", name: "trading_method_category", value: properties.tradingMethodCategory}) :
    eventPropertiesArray.push({id: "TWj16Ybpf", name: "trading_method_category", value: null});
  eventPropertiesArray.push({id: "WN7yP-IxTA", name: "platform", value: sysPlatform});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "WBUltyehs6", "28d25d33a59d2dbe27be16b3359274f1ea82db903a64411c84642cccdf467c9e", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Onboarding - Start Trading Warning View", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("WBUltyehs6", "Onboarding - Start Trading Warning View", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Onboarding - Start Trading Warning View", eventProperties, "WBUltyehs6", "28d25d33a59d2dbe27be16b3359274f1ea82db903a64411c84642cccdf467c9e");
    }
    // destination Mixpanel
    Mixpanel.logEvent("Onboarding - Start Trading Warning View", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface OnboardingMinusPublicBotsViewProperties {
  epUserIsOnboarding: boolean;
  onboardingStep: OnboardingStepValueType;
}
/**
 * Onboarding - Public Bots View: User selected a trading method and view the public bots page
 * 
 * @param properties the properties associatied with this event
 * @param properties.epUserIsOnboarding: Used to track which events happened during onboarding 
 * @param properties.onboardingStep: Contain the onboarding step - Email confirmation, Connect exchange, Trading method, Method settings, Overview
 * 
 * @see {@link https://www.avo.app/schemas/Zba2v6MXsSx1EdxPIQKm/events/gyrNfoIl-O}
 */
export function onboardingPublicBotsView(properties: OnboardingMinusPublicBotsViewProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({id: "01c5raMTE", name: "ep_user_is_onboarding", value: properties.epUserIsOnboarding});
  eventPropertiesArray.push({id: "-sPjCGnFt", name: "onboarding_step", value: properties.onboardingStep});
  eventPropertiesArray.push({id: "WN7yP-IxTA", name: "platform", value: sysPlatform});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "gyrNfoIl-O", "b3fb5de5d1ac8f76b1c01dea14b3a6d04bc0711f6df239262bb7abbe02825a2c", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Onboarding - Public Bots View", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("gyrNfoIl-O", "Onboarding - Public Bots View", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Onboarding - Public Bots View", eventProperties, "gyrNfoIl-O", "b3fb5de5d1ac8f76b1c01dea14b3a6d04bc0711f6df239262bb7abbe02825a2c");
    }
    // destination Mixpanel
    Mixpanel.logEvent("Onboarding - Public Bots View", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface OnboardingMinusSkippedProperties {
  epUserIsOnboarding: boolean;
  onboardingStep: OnboardingStepValueType;
  tradingMethodType: TradingMethodTypeValueType | null | undefined;
  botSource: BotSourceValueType | null | undefined;
}
/**
 * Onboarding - Skipped: The user clicked skip anywhere on the onboarding to go directly to the platform.
 * 
 * @param properties the properties associatied with this event
 * @param properties.epUserIsOnboarding: Used to track which events happened during onboarding 
 * @param properties.onboardingStep: Contain the onboarding step - Email confirmation, Connect exchange, Trading method, Method settings, Overview
 * @param properties.tradingMethodType: Onboarding trading method type. Follow signals group or Copy DCA bot
 * @param properties.botSource: Whether the user started the onboarding from the telegram or discord bot.
 * 
 * @see {@link https://www.avo.app/schemas/Zba2v6MXsSx1EdxPIQKm/events/OKjn01P4P-}
 */
export function onboardingSkipped(properties: OnboardingMinusSkippedProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({id: "01c5raMTE", name: "ep_user_is_onboarding", value: properties.epUserIsOnboarding});
  eventPropertiesArray.push({id: "-sPjCGnFt", name: "onboarding_step", value: properties.onboardingStep});
  properties.tradingMethodType !== undefined && properties.tradingMethodType !== null ?
    eventPropertiesArray.push({id: "i1_PQ0kbg", name: "trading_method_type", value: properties.tradingMethodType}) :
    eventPropertiesArray.push({id: "i1_PQ0kbg", name: "trading_method_type", value: null});
  properties.botSource !== undefined && properties.botSource !== null ?
    eventPropertiesArray.push({id: "77pb0xYM-Q", name: "bot_source", value: properties.botSource}) :
    eventPropertiesArray.push({id: "77pb0xYM-Q", name: "bot_source", value: null});
  eventPropertiesArray.push({id: "WN7yP-IxTA", name: "platform", value: sysPlatform});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "OKjn01P4P-", "e0cfb1ce680e17b9957eb1c0a1821438df046fcb9f26c9f34ce703848b3085c7", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Onboarding - Skipped", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("OKjn01P4P-", "Onboarding - Skipped", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Onboarding - Skipped", eventProperties, "OKjn01P4P-", "e0cfb1ce680e17b9957eb1c0a1821438df046fcb9f26c9f34ce703848b3085c7");
    }
    // destination Mixpanel
    Mixpanel.logEvent("Onboarding - Skipped", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface AffiliationMinusExistingUsersViewProperties {
  epUserSubscriptionDuration: number | null | undefined;
  epUserSubscriptionPlan: EpUserSubscriptionPlanValueType;
  epUserSubscriptionIsActive: boolean | null | undefined;
  epUserIsMobileAppUser: boolean | null | undefined;
  epUserIsAdmin: boolean | null | undefined;
  epUserIsTelegramConnected: boolean | null | undefined;
  epUserIsDiscordConnected: boolean | null | undefined;
  epUserFeatureFlags: string[] | null | undefined;
  epUserIsDarkMode: boolean | null | undefined;
  isTelegramMiniApp: boolean | null | undefined;
}
/**
 * Affiliation - Existing Users View: No description
 * 
 * @param properties the properties associatied with this event
 * @param properties.epUserSubscriptionDuration: The current subscription duration for the user, in days. Not sent for users with Expired or Trial subscription plans.
 * @param properties.epUserSubscriptionPlan: The current subscription plan for the user. Users without an active subscription should have the value set to Expired.
 * @param properties.epUserSubscriptionIsActive: Set to True if the user has an active subscription (the last subscription expiration date is smaller than the current date).
 * @param properties.epUserIsMobileAppUser: no description
 * @param properties.epUserIsAdmin: no description
 * @param properties.epUserIsTelegramConnected: no description
 * @param properties.epUserIsDiscordConnected: no description
 * @param properties.epUserFeatureFlags: no description
 * @param properties.epUserIsDarkMode: no description
 * @param properties.isTelegramMiniApp: no description
 * 
 * @see {@link https://www.avo.app/schemas/Zba2v6MXsSx1EdxPIQKm/events/beaVaaadaP}
 */
export function affiliationExistingUsersView(properties: AffiliationMinusExistingUsersViewProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  properties.epUserSubscriptionDuration !== undefined && properties.epUserSubscriptionDuration !== null ?
    eventPropertiesArray.push({id: "BrNPvrBkq", name: "ep_user_subscription_duration", value: properties.epUserSubscriptionDuration}) :
    eventPropertiesArray.push({id: "BrNPvrBkq", name: "ep_user_subscription_duration", value: null});
  eventPropertiesArray.push({id: "Ak0bD3528L", name: "ep_user_subscription_plan", value: properties.epUserSubscriptionPlan});
  properties.epUserSubscriptionIsActive !== undefined && properties.epUserSubscriptionIsActive !== null ?
    eventPropertiesArray.push({id: "P2zcEByfWK", name: "ep_user_subscription_is_active", value: properties.epUserSubscriptionIsActive}) :
    eventPropertiesArray.push({id: "P2zcEByfWK", name: "ep_user_subscription_is_active", value: null});
  properties.epUserIsMobileAppUser !== undefined && properties.epUserIsMobileAppUser !== null ?
    eventPropertiesArray.push({id: "gkaSZCbXw8", name: "ep_user_is_mobile_app_user", value: properties.epUserIsMobileAppUser}) :
    eventPropertiesArray.push({id: "gkaSZCbXw8", name: "ep_user_is_mobile_app_user", value: null});
  properties.epUserIsAdmin !== undefined && properties.epUserIsAdmin !== null ?
    eventPropertiesArray.push({id: "1NHsnnGVd0", name: "ep_user_is_admin", value: properties.epUserIsAdmin}) :
    eventPropertiesArray.push({id: "1NHsnnGVd0", name: "ep_user_is_admin", value: null});
  properties.epUserIsTelegramConnected !== undefined && properties.epUserIsTelegramConnected !== null ?
    eventPropertiesArray.push({id: "QBh1Ik3rEm", name: "ep_user_is_telegram_connected", value: properties.epUserIsTelegramConnected}) :
    eventPropertiesArray.push({id: "QBh1Ik3rEm", name: "ep_user_is_telegram_connected", value: null});
  properties.epUserIsDiscordConnected !== undefined && properties.epUserIsDiscordConnected !== null ?
    eventPropertiesArray.push({id: "Z5anKuo4On", name: "ep_user_is_discord_connected", value: properties.epUserIsDiscordConnected}) :
    eventPropertiesArray.push({id: "Z5anKuo4On", name: "ep_user_is_discord_connected", value: null});
  properties.epUserFeatureFlags !== undefined && properties.epUserFeatureFlags !== null ?
    eventPropertiesArray.push({id: "ZkS2YBJULL", name: "ep_user_feature_flags", value: properties.epUserFeatureFlags}) :
    eventPropertiesArray.push({id: "ZkS2YBJULL", name: "ep_user_feature_flags", value: null});
  properties.epUserIsDarkMode !== undefined && properties.epUserIsDarkMode !== null ?
    eventPropertiesArray.push({id: "pZYzhjQhIW", name: "ep_user_is_dark_mode", value: properties.epUserIsDarkMode}) :
    eventPropertiesArray.push({id: "pZYzhjQhIW", name: "ep_user_is_dark_mode", value: null});
  properties.isTelegramMiniApp !== undefined && properties.isTelegramMiniApp !== null ?
    eventPropertiesArray.push({id: "vh-KiP-5Q", name: "is_telegram_mini_app", value: properties.isTelegramMiniApp}) :
    eventPropertiesArray.push({id: "vh-KiP-5Q", name: "is_telegram_mini_app", value: null});
  eventPropertiesArray.push({id: "WN7yP-IxTA", name: "platform", value: sysPlatform});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "beaVaaadaP", "d9ee5cabd0944a60696ec7490774930b0c30d87abc8b1b5ec7cceea42e69ed73", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Affiliation - Existing Users View", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("beaVaaadaP", "Affiliation - Existing Users View", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Affiliation - Existing Users View", eventProperties, "beaVaaadaP", "d9ee5cabd0944a60696ec7490774930b0c30d87abc8b1b5ec7cceea42e69ed73");
    }
    // destination Mixpanel
    Mixpanel.logEvent("Affiliation - Existing Users View", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface AffiliationMinusCopyPromoCodeClickedProperties {
  epUserSubscriptionDuration: number | null | undefined;
  epUserSubscriptionPlan: EpUserSubscriptionPlanValueType;
  epUserSubscriptionIsActive: boolean | null | undefined;
  epUserIsMobileAppUser: boolean | null | undefined;
  epUserIsAdmin: boolean | null | undefined;
  epUserIsTelegramConnected: boolean | null | undefined;
  epUserIsDiscordConnected: boolean | null | undefined;
  epUserFeatureFlags: string[] | null | undefined;
  epUserIsDarkMode: boolean | null | undefined;
  isTelegramMiniApp: boolean | null | undefined;
}
/**
 * Affiliation - Copy Promo Code Clicked: No description
 * 
 * @param properties the properties associatied with this event
 * @param properties.epUserSubscriptionDuration: The current subscription duration for the user, in days. Not sent for users with Expired or Trial subscription plans.
 * @param properties.epUserSubscriptionPlan: The current subscription plan for the user. Users without an active subscription should have the value set to Expired.
 * @param properties.epUserSubscriptionIsActive: Set to True if the user has an active subscription (the last subscription expiration date is smaller than the current date).
 * @param properties.epUserIsMobileAppUser: no description
 * @param properties.epUserIsAdmin: no description
 * @param properties.epUserIsTelegramConnected: no description
 * @param properties.epUserIsDiscordConnected: no description
 * @param properties.epUserFeatureFlags: no description
 * @param properties.epUserIsDarkMode: no description
 * @param properties.isTelegramMiniApp: no description
 * 
 * @see {@link https://www.avo.app/schemas/Zba2v6MXsSx1EdxPIQKm/events/D36kIS7LiA}
 */
export function affiliationCopyPromoCodeClicked(properties: AffiliationMinusCopyPromoCodeClickedProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  properties.epUserSubscriptionDuration !== undefined && properties.epUserSubscriptionDuration !== null ?
    eventPropertiesArray.push({id: "BrNPvrBkq", name: "ep_user_subscription_duration", value: properties.epUserSubscriptionDuration}) :
    eventPropertiesArray.push({id: "BrNPvrBkq", name: "ep_user_subscription_duration", value: null});
  eventPropertiesArray.push({id: "Ak0bD3528L", name: "ep_user_subscription_plan", value: properties.epUserSubscriptionPlan});
  properties.epUserSubscriptionIsActive !== undefined && properties.epUserSubscriptionIsActive !== null ?
    eventPropertiesArray.push({id: "P2zcEByfWK", name: "ep_user_subscription_is_active", value: properties.epUserSubscriptionIsActive}) :
    eventPropertiesArray.push({id: "P2zcEByfWK", name: "ep_user_subscription_is_active", value: null});
  properties.epUserIsMobileAppUser !== undefined && properties.epUserIsMobileAppUser !== null ?
    eventPropertiesArray.push({id: "gkaSZCbXw8", name: "ep_user_is_mobile_app_user", value: properties.epUserIsMobileAppUser}) :
    eventPropertiesArray.push({id: "gkaSZCbXw8", name: "ep_user_is_mobile_app_user", value: null});
  properties.epUserIsAdmin !== undefined && properties.epUserIsAdmin !== null ?
    eventPropertiesArray.push({id: "1NHsnnGVd0", name: "ep_user_is_admin", value: properties.epUserIsAdmin}) :
    eventPropertiesArray.push({id: "1NHsnnGVd0", name: "ep_user_is_admin", value: null});
  properties.epUserIsTelegramConnected !== undefined && properties.epUserIsTelegramConnected !== null ?
    eventPropertiesArray.push({id: "QBh1Ik3rEm", name: "ep_user_is_telegram_connected", value: properties.epUserIsTelegramConnected}) :
    eventPropertiesArray.push({id: "QBh1Ik3rEm", name: "ep_user_is_telegram_connected", value: null});
  properties.epUserIsDiscordConnected !== undefined && properties.epUserIsDiscordConnected !== null ?
    eventPropertiesArray.push({id: "Z5anKuo4On", name: "ep_user_is_discord_connected", value: properties.epUserIsDiscordConnected}) :
    eventPropertiesArray.push({id: "Z5anKuo4On", name: "ep_user_is_discord_connected", value: null});
  properties.epUserFeatureFlags !== undefined && properties.epUserFeatureFlags !== null ?
    eventPropertiesArray.push({id: "ZkS2YBJULL", name: "ep_user_feature_flags", value: properties.epUserFeatureFlags}) :
    eventPropertiesArray.push({id: "ZkS2YBJULL", name: "ep_user_feature_flags", value: null});
  properties.epUserIsDarkMode !== undefined && properties.epUserIsDarkMode !== null ?
    eventPropertiesArray.push({id: "pZYzhjQhIW", name: "ep_user_is_dark_mode", value: properties.epUserIsDarkMode}) :
    eventPropertiesArray.push({id: "pZYzhjQhIW", name: "ep_user_is_dark_mode", value: null});
  properties.isTelegramMiniApp !== undefined && properties.isTelegramMiniApp !== null ?
    eventPropertiesArray.push({id: "vh-KiP-5Q", name: "is_telegram_mini_app", value: properties.isTelegramMiniApp}) :
    eventPropertiesArray.push({id: "vh-KiP-5Q", name: "is_telegram_mini_app", value: null});
  eventPropertiesArray.push({id: "WN7yP-IxTA", name: "platform", value: sysPlatform});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "D36kIS7LiA", "a587f730986531613dac30493be5ee9adbc50f2d076e4ca04cc657bae3245aca", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Affiliation - Copy Promo Code Clicked", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("D36kIS7LiA", "Affiliation - Copy Promo Code Clicked", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Affiliation - Copy Promo Code Clicked", eventProperties, "D36kIS7LiA", "a587f730986531613dac30493be5ee9adbc50f2d076e4ca04cc657bae3245aca");
    }
    // destination Mixpanel
    Mixpanel.logEvent("Affiliation - Copy Promo Code Clicked", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface TradingTerminalViewProperties {
  epUserIsDarkMode: boolean;
}
/**
 * Trading Terminal View: No description
 * 
 * @param properties the properties associatied with this event
 * @param properties.epUserIsDarkMode: no description
 * 
 * @see {@link https://www.avo.app/schemas/Zba2v6MXsSx1EdxPIQKm/events/svw4EOS3Hd}
 */
export function tradingTerminalView(properties: TradingTerminalViewProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({id: "pZYzhjQhIW", name: "ep_user_is_dark_mode", value: properties.epUserIsDarkMode});
  eventPropertiesArray.push({id: "WN7yP-IxTA", name: "platform", value: sysPlatform});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "svw4EOS3Hd", "6dc970d5a13d9228856b6806e4fea89e060a454bfb8696faecdb58683c1d0b19", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Trading Terminal View", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("svw4EOS3Hd", "Trading Terminal View", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Trading Terminal View", eventProperties, "svw4EOS3Hd", "6dc970d5a13d9228856b6806e4fea89e060a454bfb8696faecdb58683c1d0b19");
    }
    // destination Mixpanel
    Mixpanel.logEvent("Trading Terminal View", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface AccountAndGroupsViewProperties {
  epUserIsDarkMode: boolean;
}
/**
 * Account and Groups View: No description
 * 
 * @param properties the properties associatied with this event
 * @param properties.epUserIsDarkMode: no description
 * 
 * @see {@link https://www.avo.app/schemas/Zba2v6MXsSx1EdxPIQKm/events/TiKs0VhIr7}
 */
export function accountAndGroupsView(properties: AccountAndGroupsViewProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({id: "pZYzhjQhIW", name: "ep_user_is_dark_mode", value: properties.epUserIsDarkMode});
  eventPropertiesArray.push({id: "WN7yP-IxTA", name: "platform", value: sysPlatform});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "TiKs0VhIr7", "7e1f620d181daeb68d05dd8a024b2d9b14cb4064868db1a380dd11ff09a14c91", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Account and Groups View", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("TiKs0VhIr7", "Account and Groups View", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Account and Groups View", eventProperties, "TiKs0VhIr7", "7e1f620d181daeb68d05dd8a024b2d9b14cb4064868db1a380dd11ff09a14c91");
    }
    // destination Mixpanel
    Mixpanel.logEvent("Account and Groups View", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface SettingsMinusBillingViewProperties {
  epUserIsDarkMode: boolean;
}
/**
 * Settings  - Billing View: No description
 * 
 * @param properties the properties associatied with this event
 * @param properties.epUserIsDarkMode: no description
 * 
 * @see {@link https://www.avo.app/schemas/Zba2v6MXsSx1EdxPIQKm/events/UXZMM9h0XK}
 */
export function settingsBillingView(properties: SettingsMinusBillingViewProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({id: "pZYzhjQhIW", name: "ep_user_is_dark_mode", value: properties.epUserIsDarkMode});
  eventPropertiesArray.push({id: "WN7yP-IxTA", name: "platform", value: sysPlatform});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "UXZMM9h0XK", "c9d7d60aab472ba7122481f1d244d8de58f18b19a4a0ca19e7e27568d27ad86f", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Settings  - Billing View", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("UXZMM9h0XK", "Settings  - Billing View", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Settings  - Billing View", eventProperties, "UXZMM9h0XK", "c9d7d60aab472ba7122481f1d244d8de58f18b19a4a0ca19e7e27568d27ad86f");
    }
    // destination Mixpanel
    Mixpanel.logEvent("Settings  - Billing View", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface SettingsMinusUserSettingsViewProperties {
  epUserIsDarkMode: boolean;
}
/**
 * Settings - User Settings View: No description
 * 
 * @param properties the properties associatied with this event
 * @param properties.epUserIsDarkMode: no description
 * 
 * @see {@link https://www.avo.app/schemas/Zba2v6MXsSx1EdxPIQKm/events/Z1CUl4PElx}
 */
export function settingsUserSettingsView(properties: SettingsMinusUserSettingsViewProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({id: "pZYzhjQhIW", name: "ep_user_is_dark_mode", value: properties.epUserIsDarkMode});
  eventPropertiesArray.push({id: "WN7yP-IxTA", name: "platform", value: sysPlatform});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "Z1CUl4PElx", "d0160cb2986f9b5596e7051ce1da050173f4b0060d56d431af7a570a0f0138b2", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Settings - User Settings View", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("Z1CUl4PElx", "Settings - User Settings View", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Settings - User Settings View", eventProperties, "Z1CUl4PElx", "d0160cb2986f9b5596e7051ce1da050173f4b0060d56d431af7a570a0f0138b2");
    }
    // destination Mixpanel
    Mixpanel.logEvent("Settings - User Settings View", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export default {
  AvoEnv,
  initAvo,
  setSystemProperties,
  avoInspectorApiKey,
  OnboardingStep,
  BotType,
  BotSource,
  EpUserSubscriptionPlan,
  ExternalAccountType,
  SubscriptionInvoiceType,
  DcaBotCreateeditOrigin,
  NotificationPartClicked,
  TradingMethodCategory,
  Platform,
  SubscriptionInvoicePaymentMethod,
  WebsiteOriginTimeOfAction,
  TradingMethodType,
  MarketsTableView,
  SubscriptionInvoicePlan,
  SignalsAutoTradingConfiguration,
  FollowSignalModalType,
  AmountPerTradeType,
  portfolioAccountsView,
  onboardingLoginView,
  forgotPasswordView,
  telegramUuidSent,
  onboardingVerifyEmailView,
  registrationSendVerifyEmailAgainClicked,
  dashboardViewAppWeb,
  marketplaceView,
  marketplaceGroupClicked,
  marketplaceGroupJoinGroupClicked,
  openTradesView,
  createAccountView,
  accountTradingConfigView,
  resetPasswordView,
  connectExternalAccountView,
  validateTelegramView,
  onboardingConnectGroupView,
  onboardingGroupConfigurationDetailsView,
  userLoggedIn,
  userLoggedOut,
  onboardingJoinFreeGroupView,
  watchlistMarketsViewWebsite,
  closedTradesView,
  portfolioCoinsView,
  signalChannelsView,
  openSignalsView,
  closedSignalsView,
  oneClickFollowSignalClicked,
  updateTradeBasedOnSignalClicked,
  closeTradeBasedOnSignalClicked,
  signalFollowupdatecloseModalSubmitAction,
  signalDetailsViewClicked,
  miscMessagingPlatformConnected,
  infoTooltipReviewed,
  tradingviewScriptsViewWeb,
  botCreateSaveChangesClicked,
  botMyBotsViewWeb,
  dcaBotExplorePublicBotsViewWeb,
  dcaBotPublicBotCopyViewWeb,
  dcaBotCopyBotConfigurationViewClicked,
  dcaBotEditBeforeCopyClicked,
  botBotFormViewWeb,
  showNotificationsClicked,
  closeNotificationsClicked,
  notificationMarkAllAsRead,
  singleNotificationClicked,
  dashboardMarketsTableViewChanged,
  purchasePlanChoosePlanPageView,
  purchasePlanPaymentPageView,
  purchasePlanPayButtonClicked,
  purchasePlanDurationPageView,
  affiliationReferralLinksView,
  affiliationReferredUsersView,
  affiliationEarningsView,
  affiliationPayoutsView,
  affiliationNewReferralLinkClicked,
  affiliationManagePayoutMethodsClicked,
  affiliationNewPayoutClicked,
  adminPanelMyGroupsView,
  adminPanelOpenSignalsView,
  adminPanelGroupManagementUsersView,
  adminPanelGroupManagementInvitationsView,
  adminPanelGroupManagementConfigurationsView,
  adminPanelClosedSignalsView,
  onboardingConnectToExchangeClicked,
  connectExchangeTryAgainClicked,
  onboardingTradingMethodViewed,
  onboardingOverviewView,
  onboardingSkipExternalAccountClicked,
  connectToExternalAccountClicked,
  missingAGroupClicked,
  onboardingSelectConfigurationClick,
  onboardingStartTradingClicked,
  onboardingStartTradingWarningView,
  onboardingPublicBotsView,
  onboardingSkipped,
  affiliationExistingUsersView,
  affiliationCopyPromoCodeClicked,
  tradingTerminalView,
  accountAndGroupsView,
  settingsBillingView,
  settingsUserSettingsView,
}

// AVOMODULEMAP:"Avo"
// AVOEVENTMAP:["portfolioAccountsView","onboardingLoginView","forgotPasswordView","telegramUuidSent","onboardingVerifyEmailView","registrationSendVerifyEmailAgainClicked","dashboardViewAppWeb","marketplaceView","marketplaceGroupClicked","marketplaceGroupJoinGroupClicked","openTradesView","createAccountView","accountTradingConfigView","resetPasswordView","connectExternalAccountView","validateTelegramView","onboardingConnectGroupView","onboardingGroupConfigurationDetailsView","userLoggedIn","userLoggedOut","onboardingJoinFreeGroupView","watchlistMarketsViewWebsite","closedTradesView","portfolioCoinsView","signalChannelsView","openSignalsView","closedSignalsView","oneClickFollowSignalClicked","updateTradeBasedOnSignalClicked","closeTradeBasedOnSignalClicked","signalFollowupdatecloseModalSubmitAction","signalDetailsViewClicked","miscMessagingPlatformConnected","infoTooltipReviewed","tradingviewScriptsViewWeb","botCreateSaveChangesClicked","botMyBotsViewWeb","dcaBotExplorePublicBotsViewWeb","dcaBotPublicBotCopyViewWeb","dcaBotCopyBotConfigurationViewClicked","dcaBotEditBeforeCopyClicked","botBotFormViewWeb","showNotificationsClicked","closeNotificationsClicked","notificationMarkAllAsRead","singleNotificationClicked","dashboardMarketsTableViewChanged","purchasePlanChoosePlanPageView","purchasePlanPaymentPageView","purchasePlanPayButtonClicked","purchasePlanDurationPageView","affiliationReferralLinksView","affiliationReferredUsersView","affiliationEarningsView","affiliationPayoutsView","affiliationNewReferralLinkClicked","affiliationManagePayoutMethodsClicked","affiliationNewPayoutClicked","adminPanelMyGroupsView","adminPanelOpenSignalsView","adminPanelGroupManagementUsersView","adminPanelGroupManagementInvitationsView","adminPanelGroupManagementConfigurationsView","adminPanelClosedSignalsView","onboardingConnectToExchangeClicked","connectExchangeTryAgainClicked","onboardingTradingMethodViewed","onboardingOverviewView","onboardingSkipExternalAccountClicked","connectToExternalAccountClicked","missingAGroupClicked","onboardingSelectConfigurationClick","onboardingStartTradingClicked","onboardingStartTradingWarningView","onboardingPublicBotsView","onboardingSkipped","affiliationExistingUsersView","affiliationCopyPromoCodeClicked","tradingTerminalView","accountAndGroupsView","settingsBillingView","settingsUserSettingsView"]
